// // import React, {
// //   useState,
// //   useEffect,
// //   useMemo,
// //   useRef,
// //   useCallback,
// //   forwardRef,
// //   useImperativeHandle,
// // } from 'react';
// // import uniqBy from 'lodash.uniqby';
// // import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
// // import {
// //   MdAspectRatio,
// //   MdCancel,
// //   MdCheckBoxOutlineBlank,
// //   MdCenterFocusStrong,
// //   MdClose,
// //   MdCropFree,
// //   MdDelete,
// //   MdDone,
// //   MdHelpOutline,
// //   MdZoomOutMap,
// //   MdExposureNeg1,
// //   MdExposurePlus1,
// //   MdKeyboardArrowDown,
// //   MdKeyboardArrowLeft,
// //   MdKeyboardArrowRight,
// //   MdKeyboardArrowUp,
// //   MdOutlineFilter1,
// //   MdOutlineFilter2,
// //   MdOutlineFilter3,
// //   MdOutlineFilter4,
// //   MdOutlineFilter5,
// //   MdOutlineLayersClear,
// //   MdLink,
// //   MdLabelOutline,
// //   MdLabelOff,
// //   MdLabel,
// //   MdPlaylistAddCheck,
// //   MdUndo,
// //   MdRedo,
// //   MdUnfoldLess,
// //   MdUnfoldMore,
// //   MdRadioButtonUnchecked,
// //   MdRotateLeft,
// //   MdRotateRight,
// //   MdStayPrimaryLandscape,
// //   MdStayPrimaryPortrait,
// //   MdYoutubeSearchedFor,
// //   MdZoomIn,
// //   MdZoomOut,
// // } from 'react-icons/md';
// // import { toast } from 'react-toastify';
// // import PropTypes from 'prop-types';

// // import {
// //   opEditorAssociarTipoExtracao,
// //   opPaginaCatalogoSituacao,
// //   opSimNao,
// //   opLinkForma,
// //   opLinkRotulo,
// //   opLinkPapel,
// //   opLinkTamanho,
// //   opLinkEstilo,
// // } from '../../lib/const';

// // import {
// //   getSvgCoordinates,
// //   createOcrGroup,
// //   createSvgLinkPdfProcess,
// //   centerCalculation,
// //   updateSvgPositionProcessPdf,
// //   centerSvgPdfProcess,
// //   scaleSvgProcessPdf,
// //   getNomeLocalSvg,
// //   isFormaLink,
// //   getPapelLink,
// //   getFormaPrincipal,
// //   getCaixaForma,
// //   criarLinhaChamada,
// //   atualizarLinhaChamada,
// //   transladarLink,
// //   transladarElementoSvg,
// //   calcularAncoraChamada,
// //   larguraEstimadaRotulo,
// // } from '../../lib/mapeamentoUtils';

// // import api from '../../services/api';

// // import { Form } from '../Form';
// // import Input from '../Form/Input';

// // import {
// //   Container,
// //   Wrapper,
// //   EditorWrapper,
// //   ControlWrapper,
// //   Control,
// //   ToolBar,
// //   SVG,
// //   Atalhos,
// // } from './styles';

// // /**
// //  * =====================================================================
// //  * CONTEÚDO DA LEGENDA DE ATALHOS
// //  * ---------------------------------------------------------------------
// //  * Espelha exatamente o que handleMouseDown / handleMouseMove /
// //  * handleKeyDown tratam hoje. Ao criar ou alterar um atalho, atualize
// //  * também esta lista — é o único lugar em que o usuário consegue
// //  * descobrir os comandos.
// //  * =====================================================================
// //  */
// // const ATALHOS_EDITOR = [
// //   {
// //     grupo: 'Mouse',
// //     itens: [
// //       {
// //         teclas: ['Clique'],
// //         texto: 'Seleciona o link; no vazio, limpa a seleção',
// //       },
// //       { teclas: ['Shift', 'Clique'], texto: 'Acrescenta o link à seleção' },
// //       { teclas: ['Shift', 'Alt', 'Clique'], texto: 'Retira o link da seleção' },
// //       {
// //         teclas: ['Arraste'],
// //         texto:
// //           'Sobre um link, move o link; sobre a etiqueta, move só a etiqueta',
// //       },
// //       { teclas: ['Alt', 'Arraste'], texto: 'Move apenas o link sob o cursor' },
// //       {
// //         teclas: ['Ctrl', 'Arraste'],
// //         texto: 'Seleção por área (também usada no OCR)',
// //       },
// //       {
// //         teclas: ['Arraste'],
// //         texto: 'Com a forma "área" ativa, desenha o contorno do novo link',
// //       },
// //       { teclas: ['Roda'], texto: 'Zoom do desenho' },
// //     ],
// //   },
// //   {
// //     grupo: 'Links',
// //     itens: [
// //       { teclas: ['Del'], texto: 'Remove os links selecionados' },
// //       { teclas: ['Backspace'], texto: 'Mesmo efeito do Del' },
// //       { teclas: ['←', '↑', '→', '↓'], texto: 'Ajuste fino da seleção (1 px)' },
// //       { teclas: ['Ctrl', 'setas'], texto: 'Ajuste fino da seleção (5 px)' },
// //       {
// //         teclas: ['Alt', 'S'],
// //         texto: 'Abre/fecha a edição de tamanho (H/W) do link',
// //       },
// //       { teclas: ['Alt', 'A'], texto: 'Liga/desliga o modo sequência' },
// //       {
// //         teclas: ['Esc'],
// //         texto: 'Limpa a seleção (e sai do modo tela cheia, quando ativo)',
// //       },
// //     ],
// //   },
// //   {
// //     grupo: 'Página',
// //     itens: [
// //       {
// //         teclas: ['Alt', 'Z'],
// //         texto: 'Liga/desliga o modo zoom (ao sair, volta à escala original)',
// //       },
// //       { teclas: ['Shift', 'setas'], texto: 'Move a página (10 px)' },
// //       { teclas: ['Shift', '+'], texto: 'Aumenta a escala da página' },
// //       { teclas: ['Shift', '-'], texto: 'Reduz a escala da página' },
// //     ],
// //   },
// //   {
// //     grupo: 'Histórico e ajuda',
// //     itens: [
// //       { teclas: ['Ctrl', 'Z'], texto: 'Desfazer' },
// //       { teclas: ['Ctrl', 'Shift', 'Z'], texto: 'Refazer' },
// //       { teclas: ['Ctrl', 'Y'], texto: 'Refazer' },
// //       { teclas: ['?'], texto: 'Mostra/oculta esta legenda (F1 também)' },
// //     ],
// //   },
// // ];

// // const EditorArea = forwardRef(
// //   (
// //     {
// //       catalogo,
// //       pagina,
// //       itensPagina,
// //       onSave,
// //       onCancel,
// //       onBeforeOCR,
// //       onAfterOCR,
// //       onAssociate,
// //       onLinkHighlight,
// //     },
// //     ref
// //   ) => {
// //     /** controles de posicionamento e seleção */
// //     const selectingRef = useRef(false);
// //     const selectedRef = useRef([]);
// //     const focusRef = useRef(null);
// //     const controlRef = useRef(null);

// //     const startCoordRef = useRef({ x: 0, y: 0 });
// //     const finishCoordRef = useRef({ x: 0, y: 0 });
// //     const minCoordRef = useRef({ x: 0, y: 0 });
// //     const maxCoordRef = useRef({ x: 0, y: 0 });

// //     const actionRef = useRef();
// //     const linkRef = useRef();

// //     const zoomRef = useRef();
// //     const zoomInRef = useRef(HTMLButtonElement);
// //     const zoomOutRef = useRef(HTMLButtonElement);
// //     const zoomResetRef = useRef(HTMLButtonElement);
// //     const zoomScaleRef = useRef(1);

// //     const sizeRef = useRef();
// //     const formSizeRef = useRef();

// //     const ocrMapperRef = useRef();
// //     const ocrMappingRef = useRef([]);
// //     const linkMappingRef = useRef([]);

// //     const svgRef = useRef();
// //     const rootRef = useRef();
// //     const selectorRef = useRef();

// //     const rootXRef = useRef(0);
// //     const rootYRef = useRef(0);
// //     const rootScaleRef = useRef(1);
// //     const rootRotateRef = useRef(0);

// //     /** NOVO: refs/estado para input rápido de link */
// //     const editorAreaRef = useRef(null);
// //     const quickInputRef = useRef(null);
// //     const [quickInput, setQuickInput] = useState({
// //       open: false,
// //       x: 0,
// //       y: 0,
// //       svgX: 0,
// //       svgY: 0,
// //       value: '',
// //     });

// //     useEffect(() => {
// //       if (quickInput.open && quickInputRef.current) {
// //         setTimeout(() => {
// //           if (quickInputRef.current) {
// //             quickInputRef.current.focus({ preventScroll: true });
// //             try {
// //               quickInputRef.current.select();
// //             } catch {}
// //           }
// //         }, 0);
// //       }
// //     }, [quickInput.open]);

// //     const ACTION_STATE = {
// //       select: 'SELECT',
// //       deselect: 'DESELECT',
// //       move: 'MOVE',
// //       moveOne: 'MOVEONE',
// //       selectArea: 'SELECTAREA',
// //       /** arraste que desenha a área de um novo link (modo sequência) */
// //       createArea: 'CREATEAREA',
// //       /** arraste da etiqueta, sem mover a área do link */
// //       moveRotulo: 'MOVEROTULO',
// //     };

// //     const INITIAL_STATE = {
// //       catalogId: 0,
// //       path: '',
// //       pageNum: 0,
// //       state: 0,
// //       type: 0,
// //       inDesign: false,
// //     };

// //     /**
// //      * Alias com as chaves em minúsculo para não reescrever as dezenas de
// //      * usos já existentes neste arquivo. A fonte única dos valores é
// //      * opLinkForma em lib/const.js.
// //      */
// //     const LINK_FORM_TYPES = {
// //       circle: opLinkForma.CIRCULO,
// //       rect: opLinkForma.RETANGULO,
// //       ocr: opLinkForma.OCR,
// //       area: opLinkForma.AREA,
// //     };

// //     const INITIAL_LINK_CIRCLE = {
// //       id: LINK_FORM_TYPES.circle,
// //       fontSize: 10,
// //       height: 10,
// //       width: 0,
// //     };

// //     const INITIAL_LINK_RECT = {
// //       id: LINK_FORM_TYPES.rect,
// //       fontSize: 10,
// //       height: 20,
// //       width: 20,
// //     };

// //     /**
// //      * Área: tamanho inicial usado quando o link é criado por clique
// //      * (sem arraste) ou a partir de um marcador de OCR. Quando o usuário
// //      * arrasta, o tamanho vem do próprio retângulo desenhado.
// //      */
// //     const INITIAL_LINK_AREA = {
// //       id: LINK_FORM_TYPES.area,
// //       fontSize: 7,
// //       height: 14,
// //       width: 28,
// //     };

// //     /** limites das formas legadas (círculo e retângulo) */
// //     const LINK_SIZE_LIMIT = opLinkTamanho[opLinkForma.CIRCULO];

// //     /** limites da área, que precisa cobrir de componentes pequenos a réguas */
// //     const LINK_AREA_SIZE_LIMIT = opLinkTamanho[opLinkForma.AREA];

// //     const [editor, setEditor] = useState(INITIAL_STATE);
// //     const [table, setTable] = useState([]);

// //     const [zoomControl, setZoomControl] = useState(false);
// //     const [zoomCanMove, setZoomCanMove] = useState(true);
// //     const [sizeControl, setSizeControl] = useState(false);

// //     /**
// //      * Espelhos dos dois modos alternados por atalho (Alt+Z e Alt+S).
// //      *
// //      * Os handlers de teclado precisam ler o valor ATUAL sem depender do
// //      * fechamento da renderização — ver a indireção de onKeyDown mais
// //      * abaixo — e também permitem alternar sem efeito colateral dentro do
// //      * atualizador de estado.
// //      */
// //     const zoomControlRef = useRef(false);
// //     const sizeControlRef = useRef(false);

// //     /**
// //      * Legenda de atalhos: fica oculta e é chamada pelo botão "?" da barra
// //      * ou pelas teclas "?" / F1. Nunca abre sozinha, para não roubar área
// //      * de desenho de quem já conhece os atalhos.
// //      */
// //     const [atalhosAberto, setAtalhosAberto] = useState(false);
// //     const atalhosAbertoRef = useRef(false);

// //     /**
// //      * Alinha os espelhos com o estado. Feito por efeito para não precisar
// //      * alterar todos os pontos que já chamam setZoomControl/setSizeControl
// //      * (handleControlClose, troca de forma do link, carga de página).
// //      */
// //     useEffect(() => {
// //       zoomControlRef.current = zoomControl;
// //     }, [zoomControl]);

// //     useEffect(() => {
// //       sizeControlRef.current = sizeControl;
// //     }, [sizeControl]);

// //     useEffect(() => {
// //       atalhosAbertoRef.current = atalhosAberto;
// //     }, [atalhosAberto]);

// //     const [centralizacaoX, setCentralizacaoX] = useState(0);
// //     const [centralizacaoY, setCentralizacaoY] = useState(0);
// //     const [pdfTool, setPdfTool] = useState(false);

// //     const [currLinkType, setCurrLinkType] = useState(0);
// //     const currLinkTypeRef = useRef(INITIAL_LINK_CIRCLE);

// //     /**
// //      * Rótulo aplicado aos novos links:
// //      *  - codigo   : texto do IDITEM dentro da própria forma (legado)
// //      *  - nenhum   : sem texto, descrição só no hover e na tabela
// //      *  - etiqueta : balão externo com o código + linha de chamada
// //      */
// //     const [currLinkRotulo, setCurrLinkRotulo] = useState(opLinkRotulo.CODIGO);
// //     const currLinkRotuloRef = useRef(opLinkRotulo.CODIGO);

// //     /**
// //      * Modo criação/sequência: quando ativo, arrastar sobre o desenho cria
// //      * a área do próximo item pendente e avança para o seguinte. Enquanto
// //      * inativo, todas as interações permanecem idênticas às atuais.
// //      */
// //     const [modoSequencia, setModoSequencia] = useState(false);
// //     const modoSequenciaRef = useRef(false);
// //     const [itemSequencia, setItemSequencia] = useState(null);
// //     const itemSequenciaRef = useRef(null);

// //     /** espelho da tabela de itens, para uso dentro dos handlers de mouse */
// //     const tabelaRef = useRef([]);

// //     /**
// //      * Coordenada inicial do arraste que desenha a área do link.
// //      *
// //      * Precisa ser um ref PRÓPRIO, e não o startCoordRef compartilhado: o
// //      * handleMouseUp chama oClearSelector() ANTES do switch das ações, e
// //      * oClearSelector zera startCoordRef/finishCoordRef (eles pertencem ao
// //      * seletor do Ctrl+arraste do OCR). Lendo startCoordRef depois disso o
// //      * retângulo virava (0,0) -> ponto do mouse, criando o link muito maior
// //      * do que o demarcado.
// //      */
// //     const areaStartRef = useRef(null);

// //     /** retângulo temporário exibido durante o arraste de criação da área */
// //     const areaDraftRef = useRef(null);

// //     const defLinkSize = useRef({
// //       height: 0,
// //       width: 0,
// //     });

// //     const hasRunRef = useRef(false);
// //     const pagRef = useRef();
// //     const [svgReady, setSvgReady] = useState(false);

// //     // const [elementToZoom, setElementToZoom] = useState();

// //     const oLinkSizeMode = useCallback((height = 0, width = 0) => {
// //       setTimeout(() => {
// //         const newSizeH = Number(height) || currLinkTypeRef.current.height;
// //         const newSizeW = Number(width) || currLinkTypeRef.current.width;

// //         if (formSizeRef.current) {
// //           formSizeRef.current.setFieldValue('sizeInputH', newSizeH);
// //           formSizeRef.current.setFieldValue('sizeInputW', newSizeW);
// //         }
// //       }, 200);
// //     }, []);

// //     /** valida e define o tamanho padrão de um link */
// //     const oChangeDefLinkSize = useCallback(
// //       (height = 0, width = 0, updateDefault = false) => {
// //         /** atualiza o tamanho para os links */
// //         if (updateDefault) {
// //           defLinkSize.current = {
// //             height,
// //             width,
// //           };
// //         }
// //         /** atualiza informações do campo */
// //         oLinkSizeMode(height, width);
// //       },
// //       [oLinkSizeMode]
// //     );

// //     useEffect(
// //       () => {
// //         let currSizeW = 0;
// //         let currSizeH = 0;

// //         if (sizeControl) {
// //           if (focusRef.current) {
// //             switch (Number(focusRef.current.node.childNodes[0].dataset.id)) {
// //               case LINK_FORM_TYPES.circle:
// //                 currSizeW = focusRef.current.node.childNodes[0].getAttribute(
// //                   'r'
// //                 );
// //                 currSizeH = focusRef.current.node.childNodes[0].getAttribute(
// //                   'r'
// //                 );
// //                 break;
// //               case LINK_FORM_TYPES.rect:
// //               case LINK_FORM_TYPES.area:
// //                 currSizeW = focusRef.current.node.childNodes[0].getAttribute(
// //                   'width'
// //                 );
// //                 currSizeH = focusRef.current.node.childNodes[0].getAttribute(
// //                   'height'
// //                 );
// //                 break;
// //               default:
// //                 break;
// //             }
// //           }

// //           oChangeDefLinkSize(currSizeH, currSizeW);
// //         }
// //       },
// //       // eslint-disable-next-line react-hooks/exhaustive-deps
// //       [LINK_FORM_TYPES, sizeControl]
// //     );

// //     useEffect(() => {
// //       if (!pagina) return;

// //       const { idPagina, urlEdicao, situacao, tipo } = pagina;
// //       const { idCatalogo } = catalogo;

// //       setEditor({
// //         catalogId: idCatalogo,
// //         pageNum: idPagina,
// //         path: urlEdicao,
// //         state: situacao,
// //         type: tipo,
// //         inDesign: true,
// //       });

// //       setZoomControl(false);
// //       setSizeControl(false);

// //       // handleMapeamentoOCR();
// //     }, [catalogo, pagina]);

// //     useEffect(() => {
// //       if (!itensPagina) return;
// //       setTable(
// //         itensPagina.map((item) => ({
// //           ...item,
// //           quantidade: item.quantidade ? Number(item.quantidade) : 0,
// //         }))
// //       );
// //     }, [itensPagina]);

// //     const oCheckAssociation = useCallback(() => {
// //       onAssociate(linkMappingRef.current.map((item) => getIdItemLink(item)));
// //     }, [onAssociate, getIdItemLink]);

// //     useImperativeHandle(ref, () => ({
// //       highlightLinks: (links) => {
// //         linkMappingRef.current = linkMappingRef.current.map((node) => {
// //           const classes = node.getAttribute('class');

// //           if (links.includes(getIdItemLink(node))) {
// //             /** não aplica highlight se ja for um ou se estiver em conflito */
// //             if (!classes.includes('highlight') && !classes.includes('warning'))
// //               node.setAttribute('class', `${classes} highlight`.trim());
// //           } else if (classes && classes.includes('highlight'))
// //             node.setAttribute('class', classes.split('highlight')[0].trim());

// //           return node;
// //         });
// //       },
// //       getLinked: () => oCheckAssociation(),

// //       /** itens da página que ainda não têm link no desenho */
// //       getPendentes: () => itensPendentes,

// //       /**
// //        * Define manualmente o item alvo do modo sequência e liga o modo,
// //        * já selecionando a geometria de área — é o que se espera ao clicar
// //        * em "mapear este item agora" na tabela.
// //        */
// //       setItemSequencia: (item) => {
// //         handleSelecionarItemSequencia(item);

// //         if (!modoSequenciaRef.current) {
// //           modoSequenciaRef.current = true;
// //           setModoSequencia(true);
// //           currLinkTypeRef.current = INITIAL_LINK_AREA;
// //           setCurrLinkType(LINK_FORM_TYPES.area);
// //         }
// //       },

// //       /** rola o desenho até o link do item e o destaca */
// //       irParaLink: (idItem) => {
// //         const alvo = linkMappingRef.current.find(
// //           (node) => String(getIdItemLink(node)) === String(idItem)
// //         );

// //         if (!alvo) return false;

// //         handleHoverHighlight(String(idItem), true);

// //         if (typeof alvo.scrollIntoView === 'function') {
// //           alvo.scrollIntoView({
// //             behavior: 'smooth',
// //             block: 'center',
// //             inline: 'center',
// //           });
// //         }

// //         return true;
// //       },
// //     }));

// //     const handleOCRLimpar = useCallback(() => {
// //       /** limpa coleção e coordenadas */
// //       ocrMappingRef.current = [];

// //       selectorRef.current.setAttribute('x', 0);
// //       selectorRef.current.setAttribute('y', 0);
// //       selectorRef.current.setAttribute('width', 0);
// //       selectorRef.current.setAttribute('height', 0);

// //       /** remove grupo do SVG */
// //       const ocrMapper = Array.from(rootRef.current.childNodes).find(
// //         (attr) => attr.id === 'ocrGroup'
// //       );
// //       if (ocrMapper) {
// //         ocrMapper.remove();
// //       }
// //       ocrMapperRef.current = null;
// //     }, []);

// //     // const handleMappedAutom = useCallback(async () => {
// //     //   if (onBeforeOCR) {
// //     //     onBeforeOCR();
// //     //   }

// //     //   try {
// //     //     handleOCRLimpar();

// //     //     const ocrMapper = document.createElementNS(
// //     //       rootRef.current.namespaceURI,
// //     //       'g'
// //     //     );
// //     //     ocrMapper.setAttribute('id', 'ocrGroup');
// //     //     rootRef.current.appendChild(ocrMapper);
// //     //     ocrMapperRef.current = ocrMapper;

// //     //     const { idCatalogo } = catalogo;
// //     //     const { idPagina } = pagina;

// //     //     const { data } = await api.get(
// //     //       `/editor-associar-autom/${idCatalogo}/pagina/${idPagina}`
// //     //     );

// //     //     data.forEach((pt, index) => {
// //     //       const link = document.createElementNS(
// //     //         svgRef.current.namespaceURI,
// //     //         'a'
// //     //       );
// //     //       link.id = String(index);
// //     //       link.setAttribute('x', pt.x);
// //     //       link.setAttribute('y', pt.y - 5);
// //     //       link.setAttribute('class', '');
// //     //       link.addEventListener('click', (e) => e.preventDefault());
// //     //       ocrMapperRef.current.appendChild(link);

// //     //       const linkForm = document.createElementNS(
// //     //         svgRef.current.namespaceURI,
// //     //         'rect'
// //     //       );

// //     //       const linkText = document.createElementNS(
// //     //         svgRef.current.namespaceURI,
// //     //         'text'
// //     //       );

// //     //       const linkFormWidth = pt.text.length * 6;

// //     //       linkForm.setAttribute('x', pt.x + 10);
// //     //       linkForm.setAttribute('y', pt.y - 5);
// //     //       linkForm.setAttribute('height', '15');
// //     //       linkForm.setAttribute('width', `${linkFormWidth}`);
// //     //       linkForm.setAttribute('class', pt.conf > 70 ? 'success' : 'warning');
// //     //       linkForm.setAttribute('data-id', LINK_FORM_TYPES.ocr);
// //     //       link.appendChild(linkForm);

// //     //       linkText.setAttribute('x', pt.x + 10);
// //     //       linkText.setAttribute('y', pt.y + 5);
// //     //       linkText.setAttribute('font-size', '10');
// //     //       linkText.setAttribute('class', pt.conf > 70 ? 'success' : 'warning');
// //     //       linkText.textContent = pt.text;
// //     //       link.appendChild(linkText);

// //     //       ocrMappingRef.current.push({ attr: link, ocr: pt });
// //     //     });
// //     //   } catch (err) {
// //     //     toast.error(err);
// //     //   } finally {
// //     //     if (onAfterOCR) {
// //     //       onAfterOCR();
// //     //     }
// //     //   }
// //     // }, [onBeforeOCR, onAfterOCR, handleOCRLimpar, catalogo, pagina]);

// //     // useEffect(() => {
// //     //   handleMappedAutom();
// //     // }, [handleMappedAutom]);

// //     // useEffect(() => {
// //     //   // sem dados ainda? sai quietinho, e espera a próxima render
// //     //   if (!catalogo?.idCatalogo || !pagina?.idPagina) return;
// //     //   if (!rootRef.current || !svgRef.current) return;

// //     //   if (
// //     //     // hasRunRef.current &&
// //     //     pagRef.current === pagina.idPagina
// //     //   )
// //     //     return;

// //     //   // hasRunRef.current = true; // marca que já executou
// //     //   pagRef.current = pagina.idPagina;

// //     //   const handleMappedAutom = async () => {
// //     //     if (onBeforeOCR) {
// //     //       onBeforeOCR();
// //     //     }

// //     //     try {
// //     //       handleOCRLimpar();

// //     //       const ocrMapper = document.createElementNS(
// //     //         rootRef.current.namespaceURI,
// //     //         'g'
// //     //       );
// //     //       ocrMapper.setAttribute('id', 'ocrGroup');
// //     //       rootRef.current.appendChild(ocrMapper);
// //     //       ocrMapperRef.current = ocrMapper;

// //     //       const { idCatalogo } = catalogo;
// //     //       const { idPagina } = pagina;

// //     //       const { data } = await api.get(
// //     //         `/editor-associar-autom/${idCatalogo}/pagina/${idPagina}`
// //     //       );

// //     //       data.forEach((pt, index) => {
// //     //         const link = document.createElementNS(
// //     //           svgRef.current.namespaceURI,
// //     //           'a'
// //     //         );
// //     //         link.id = String(index);
// //     //         link.setAttribute('x', pt.x);
// //     //         link.setAttribute('y', pt.y - 5);
// //     //         link.setAttribute('class', '');
// //     //         link.addEventListener('click', (e) => e.preventDefault());
// //     //         ocrMapperRef.current.appendChild(link);

// //     //         const linkForm = document.createElementNS(
// //     //           svgRef.current.namespaceURI,
// //     //           'rect'
// //     //         );

// //     //         const linkText = document.createElementNS(
// //     //           svgRef.current.namespaceURI,
// //     //           'text'
// //     //         );

// //     //         const linkFormWidth = pt.text.length * 6;

// //     //         linkForm.setAttribute('x', pt.x + 10);
// //     //         linkForm.setAttribute('y', pt.y - 5);
// //     //         linkForm.setAttribute('height', '15');
// //     //         linkForm.setAttribute('width', `${linkFormWidth}`);
// //     //         linkForm.setAttribute(
// //     //           'class',
// //     //           pt.conf > 70 ? 'success' : 'warning'
// //     //         );
// //     //         linkForm.setAttribute('data-id', LINK_FORM_TYPES.ocr);
// //     //         link.appendChild(linkForm);

// //     //         linkText.setAttribute('x', pt.x + 10);
// //     //         linkText.setAttribute('y', pt.y + 5);
// //     //         linkText.setAttribute('font-size', '10');
// //     //         linkText.setAttribute(
// //     //           'class',
// //     //           pt.conf > 70 ? 'success' : 'warning'
// //     //         );
// //     //         linkText.textContent = pt.text;
// //     //         link.appendChild(linkText);

// //     //         ocrMappingRef.current.push({ attr: link, ocr: pt });
// //     //       });
// //     //     } catch (err) {
// //     //       toast.error(err);
// //     //     } finally {
// //     //       if (onAfterOCR) {
// //     //         onAfterOCR();
// //     //       }
// //     //     }
// //     //   };

// //     //   handleMappedAutom();
// //     // }, [
// //     //   catalogo?.idCatalogo,
// //     //   pagina?.idPagina,
// //     //   onBeforeOCR,
// //     //   onAfterOCR,
// //     //   handleOCRLimpar,
// //     // ]);

// //     // useEffect(() => {
// //     //   // ainda sem dados? espera a próxima render
// //     //   if (!catalogo?.idCatalogo || !pagina?.idPagina) return;

// //     //   // SVG ainda não foi carregado pra essa página
// //     //   if (!svgReady) return;

// //     //   if (!rootRef.current || !svgRef.current) return;

// //     //   // já rodou pra essa página? então não faz de novo
// //     //   if (pagRef.current === pagina.idPagina) return;

// //     //   pagRef.current = pagina.idPagina;

// //     //   const handleMappedAutom = async () => {
// //     //     if (onBeforeOCR) {
// //     //       onBeforeOCR();
// //     //     }

// //     //     try {
// //     //       handleOCRLimpar();

// //     //       const ocrMapper = document.createElementNS(
// //     //         rootRef.current.namespaceURI,
// //     //         'g'
// //     //       );
// //     //       ocrMapper.setAttribute('id', 'ocrGroup');
// //     //       rootRef.current.appendChild(ocrMapper);
// //     //       ocrMapperRef.current = ocrMapper;

// //     //       const { idCatalogo } = catalogo;
// //     //       const { idPagina } = pagina;

// //     //       const { data } = await api.get(
// //     //         `/editor-associar-autom/${idCatalogo}/pagina/${idPagina}`
// //     //       );

// //     //       data.forEach((pt, index) => {
// //     //         const link = document.createElementNS(
// //     //           svgRef.current.namespaceURI,
// //     //           'a'
// //     //         );
// //     //         link.id = String(index);
// //     //         link.setAttribute('x', pt.x);
// //     //         link.setAttribute('y', pt.y - 5);
// //     //         link.setAttribute('class', '');
// //     //         link.addEventListener('click', (e) => e.preventDefault());
// //     //         ocrMapperRef.current.appendChild(link);

// //     //         const linkForm = document.createElementNS(
// //     //           svgRef.current.namespaceURI,
// //     //           'rect'
// //     //         );

// //     //         const linkText = document.createElementNS(
// //     //           svgRef.current.namespaceURI,
// //     //           'text'
// //     //         );

// //     //         const linkFormWidth = pt.text.length * 6;

// //     //         linkForm.setAttribute('x', pt.x + 10);
// //     //         linkForm.setAttribute('y', pt.y - 5);
// //     //         linkForm.setAttribute('height', '15');
// //     //         linkForm.setAttribute('width', `${linkFormWidth}`);
// //     //         linkForm.setAttribute(
// //     //           'class',
// //     //           pt.conf > 70 ? 'success' : 'warning'
// //     //         );
// //     //         linkForm.setAttribute('data-id', LINK_FORM_TYPES.ocr);
// //     //         link.appendChild(linkForm);

// //     //         linkText.setAttribute('x', pt.x + 10);
// //     //         linkText.setAttribute('y', pt.y + 5);
// //     //         linkText.setAttribute('font-size', '10');
// //     //         linkText.setAttribute(
// //     //           'class',
// //     //           pt.conf > 70 ? 'success' : 'warning'
// //     //         );
// //     //         linkText.textContent = pt.text;
// //     //         link.appendChild(linkText);

// //     //         ocrMappingRef.current.push({ attr: link, ocr: pt });
// //     //       });
// //     //     } catch (err) {
// //     //       toast.error(err);
// //     //     } finally {
// //     //       if (onAfterOCR) {
// //     //         onAfterOCR();
// //     //       }
// //     //     }
// //     //   };

// //     //   handleMappedAutom();
// //     // }, [
// //     //   catalogo?.idCatalogo,
// //     //   pagina?.idPagina,
// //     //   svgReady, // NOVO: só roda quando o SVG dessa página estiver pronto
// //     //   onBeforeOCR,
// //     //   onAfterOCR,
// //     //   handleOCRLimpar,
// //     // ]);

// //     const handleOCRLocalizar = useCallback(
// //       async (tipoExtracao = opEditorAssociarTipoExtracao.TRADICIONAL) => {
// //         /** executa evento antes da consulta */
// //         if (onBeforeOCR) {
// //           onBeforeOCR();
// //         }

// //         try {
// //           const x = selectorRef.current.x.baseVal.value;
// //           const y = selectorRef.current.y.baseVal.value;
// //           const width = selectorRef.current.width.baseVal.value;
// //           const height = selectorRef.current.height.baseVal.value;

// //           /** limpa mapeamento anterior */
// //           handleOCRLimpar();

// //           /** cria grupo para mapeamento do serviço de OCR */
// //           const ocrMapper = document.createElementNS(
// //             rootRef.current.namespaceURI,
// //             'svg:g',
// //             rootRef.current
// //           );
// //           ocrMapper.setAttribute('id', 'ocrGroup');
// //           rootRef.current.appendChild(ocrMapper);

// //           ocrMapperRef.current = ocrMapper;

// //           const response = await api.post(
// //             `/editor-associar/${catalogo.idCatalogo}/pagina/${pagina.idPagina}`,
// //             { tipoExtracao, parametros: { x, y, width, height } }
// //           );

// //           /** cria links OCR */
// //           response.data.forEach((pt, index) => {
// //             /** cria elemento */
// //             const link = document.createElementNS(
// //               svgRef.current.namespaceURI,
// //               'a',
// //               svgRef.current
// //             );
// //             link.id = index;
// //             link.setAttribute('x', pt.x);
// //             link.setAttribute('y', pt.y - 5);
// //             link.setAttribute('class', '');
// //             // código preventivo para o link não ser executado no design
// //             link.addEventListener('click', (e) => e.preventDefault());
// //             ocrMapperRef.current.appendChild(link);

// //             /** cria retângulo ocr */
// //             const linkForm = document.createElementNS(
// //               svgRef.current.namespaceURI,
// //               'svg:rect',
// //               svgRef.current
// //             );

// //             /** cria texto */
// //             const linkText = document.createElementNS(
// //               svgRef.current.namespaceURI,
// //               'svg:text',
// //               svgRef.current
// //             );

// //             const linkFormWidth = pt.text.length * 6;

// //             linkForm.setAttribute('x', pt.x + 10);
// //             linkForm.setAttribute('y', pt.y - 5);
// //             linkForm.setAttribute('height', '15px');
// //             linkForm.setAttribute('width', `${linkFormWidth}px`);
// //             linkForm.setAttribute(
// //               'class',
// //               pt.conf > 70 ? 'success' : 'warning'
// //             );
// //             linkForm.setAttribute('data-id', LINK_FORM_TYPES.ocr);
// //             link.appendChild(linkForm);

// //             linkText.setAttribute('x', pt.x + 10);
// //             linkText.setAttribute('y', pt.y + 10 - 5);
// //             linkText.setAttribute('font-size', '10px');
// //             linkText.setAttribute(
// //               'class',
// //               pt.conf > 70 ? 'success' : 'warning'
// //             );
// //             linkText.textContent = pt.text;
// //             link.appendChild(linkText);

// //             ocrMappingRef.current.push({ attr: link, ocr: pt });
// //           });
// //         } catch (err) {
// //           toast.error(err);
// //         } finally {
// //           /** executa evento depois da consulta */
// //           if (onAfterOCR) {
// //             onAfterOCR();
// //           }
// //         }
// //       },
// //       [
// //         LINK_FORM_TYPES,
// //         svgRef,
// //         selectorRef,
// //         catalogo,
// //         pagina,
// //         handleOCRLimpar,
// //         onBeforeOCR,
// //         onAfterOCR,
// //       ]
// //     );

// //     const handlePDFLocalizar = useCallback(
// //       async (tipoExtracao = opEditorAssociarTipoExtracao.TRADICIONAL) => {
// //         /** executa evento antes da consulta */
// //         if (onBeforeOCR) {
// //           onBeforeOCR();
// //         }
// //         setPdfTool(true);
// //         try {
// //           const { x, y, width, height } = getSvgCoordinates(selectorRef);
// //           /** limpa mapeamento anterior */
// //           handleOCRLimpar();
// //           const ocrMapper = createOcrGroup(rootRef);
// //           ocrMapperRef.current = ocrMapper;

// //           const response = await api.post(
// //             `/editor-associar/${catalogo.idCatalogo}/pagina/${pagina.idPagina}`,
// //             { tipoExtracao, parametros: { x, y, width, height } }
// //           );

// //           /** cria links PDF */
// //           response.data.forEach((pt, index) => {
// //             const link = createSvgLinkPdfProcess(
// //               svgRef.current.namespaceURI,
// //               ocrMapperRef,
// //               pt,
// //               index
// //             );
// //             ocrMappingRef.current.push({ attr: link, ocr: pt });
// //           });

// //           const { centroX, centroY } = centerCalculation(
// //             pagina.orientacaoImagem,
// //             x,
// //             y,
// //             width,
// //             height
// //           );

// //           centerSvgPdfProcess(svgRef, rootRef, centroX, centroY);
// //           setCentralizacaoX(centroX);
// //           setCentralizacaoY(centroY);
// //         } catch (err) {
// //           toast.error(err);
// //         } finally {
// //           /** executa evento depois da consulta */
// //           if (onAfterOCR) {
// //             onAfterOCR();
// //           }
// //         }
// //       },
// //       [
// //         svgRef,
// //         selectorRef,
// //         catalogo,
// //         pagina,
// //         handleOCRLimpar,
// //         onBeforeOCR,
// //         onAfterOCR,
// //       ]
// //     );

// //     const handlePositionPdfProcess = useCallback((coordX, coordY) => {
// //       updateSvgPositionProcessPdf(svgRef, rootRef, coordX, coordY);
// //     }, []);

// //     const handleCenterPdfProcess = useCallback(() => {
// //       centerSvgPdfProcess(svgRef, rootRef, centralizacaoX, centralizacaoY);
// //     }, [centralizacaoX, centralizacaoY]);

// //     const handleScalePdfProcess = useCallback(
// //       (valor) => {
// //         scaleSvgProcessPdf(svgRef, rootRef, rootScaleRef, valor);
// //         centerSvgPdfProcess(svgRef, rootRef, centralizacaoX, centralizacaoY);
// //       },
// //       [centralizacaoX, centralizacaoY]
// //     );

// //     /**
// //      * IDITEM de um link, lido do href.
// //      *
// //      * Antes a associação item x link usava o textContent do <text> interno.
// //      * Isso deixou de funcionar com o rótulo "nenhum" (link sem texto) e com
// //      * o rótulo "etiqueta" (o textContent passa a ser o texto do balão).
// //      * O href tem o formato /{idCatalogo}/{idPagina}/{idItem} e é a mesma
// //      * fonte que a Home usa em Pagina/index.js -> handleLink, portanto é a
// //      * chave mais confiável. O textContent fica só como retrocompatibilidade
// //      * para eventuais links sem href.
// //      */
// //     const getIdItemLink = useCallback((node) => {
// //       if (!node) return '';

// //       const href =
// //         node.getAttribute('xlink:href') ||
// //         (node.href && node.href.baseVal) ||
// //         node.getAttribute('href') ||
// //         '';

// //       const partes = String(href)
// //         .split('/')
// //         .filter((parte) => parte !== '');
// //       const idItem = partes.length ? partes[partes.length - 1] : '';

// //       return idItem || String(node.textContent || '').trim();
// //     }, []);

// //     const handleHoverHighlight = useCallback(
// //       (id, state) => {
// //         linkMappingRef.current.forEach((node) => {
// //           const classes = node.getAttribute('class');

// //           if (getIdItemLink(node) === id)
// //             node.setAttribute(
// //               'class',
// //               (state
// //                 ? `${classes} highlight`
// //                 : classes.split('highlight')[0]
// //               ).trim()
// //             );
// //         });

// //         const highlightedItems = linkMappingRef.current
// //           .filter((node) => node.getAttribute('class').includes('highlight'))
// //           .map((node) => getIdItemLink(node));

// //         onLinkHighlight(highlightedItems, 'editor');
// //       },
// //       [onLinkHighlight, getIdItemLink]
// //     );

// //     const mappingElement = useCallback(
// //       (lstNode) => {
// //         Array.from(lstNode).map((node) => {
// //           if (
// //             node.nodeName === 'svg:path' ||
// //             node.nodeName === 'svg:rect' ||
// //             node.nodeName === 'svg:image' ||
// //             node.nodeName === 'a'
// //           ) {
// //             /** tratamento para links já carregados */
// //             if (node.nodeName === 'a') {
// //               /** coloca o nome do grupo do link */
// //               if (node.parentElement.nodeName === 'svg:g') {
// //                 node.parentElement.id = 'linkGroup';
// //               }
// //               node.setAttribute('class', '');
// //               node.addEventListener('click', (e) => e.preventDefault());
// //               node.addEventListener('mouseenter', () => {
// //                 handleHoverHighlight(getIdItemLink(node), true);
// //               });
// //               node.addEventListener('mouseleave', () => {
// //                 handleHoverHighlight(getIdItemLink(node), false);
// //               });

// //               linkMappingRef.current.push(node);
// //             }

// //             node.id = Math.random();
// //           }

// //           if (node.hasChildNodes()) {
// //             return mappingElement(node.childNodes);
// //           }

// //           return node;
// //         });
// //       },
// //       [handleHoverHighlight]
// //     );

// //     /**
// //      * Cria os elementos do rótulo de um link.
// //      *
// //      * - opLinkRotulo.CODIGO  : <text> centralizado na própria forma
// //      * - opLinkRotulo.NENHUM  : nada (descrição só no hover e na tabela)
// //      * - opLinkRotulo.ETIQUETA: <path data-role="chamada"> +
// //      *                          <rect data-role="rotulo"> +
// //      *                          <text data-role="rotulo-texto">
// //      *
// //      * A ordem de inserção importa: a forma principal continua sendo
// //      * childNodes[0], pois todo o restante do editor (seleção, conflito,
// //      * redimensionamento) depende disso.
// //      */
// //     const oCriarRotuloLink = useCallback(
// //       ({ link, forma, rotulo, texto, fontSize }) => {
// //         const ns = svgRef.current.namespaceURI;

// //         if (rotulo === opLinkRotulo.NENHUM) return;

// //         const caixa = getCaixaForma(forma);

// //         if (rotulo === opLinkRotulo.ETIQUETA) {
// //           const alturaRotulo = fontSize + 5;
// //           const larguraRotulo = larguraEstimadaRotulo(texto, fontSize);

// //           /**
// //            * Posição inicial da etiqueta: acima e à direita da área, com
// //            * um deslocamento proporcional à própria etiqueta. O usuário
// //            * reposiciona arrastando a etiqueta (a área não se move).
// //            */
// //           const caixaRotulo = {
// //             x: caixa.x + caixa.width + alturaRotulo,
// //             y: caixa.y - alturaRotulo * 1.6,
// //             width: larguraRotulo,
// //             height: alturaRotulo,
// //           };

// //           const ancora = calcularAncoraChamada(caixa, caixaRotulo);

// //           const chamada = criarLinhaChamada(
// //             ns,
// //             ancora.x1,
// //             ancora.y1,
// //             ancora.x2,
// //             ancora.y2
// //           );
// //           link.appendChild(chamada);

// //           const caixaEtiqueta = document.createElementNS(ns, 'svg:rect');
// //           caixaEtiqueta.setAttribute('data-role', opLinkPapel.ROTULO);
// //           caixaEtiqueta.setAttribute('x', caixaRotulo.x);
// //           caixaEtiqueta.setAttribute('y', caixaRotulo.y);
// //           caixaEtiqueta.setAttribute('width', caixaRotulo.width);
// //           caixaEtiqueta.setAttribute('height', caixaRotulo.height);
// //           /** rx/ry são obrigatórios: sem eles o svgo converte o rect em path */
// //           caixaEtiqueta.setAttribute('rx', '3');
// //           caixaEtiqueta.setAttribute('ry', '3');
// //           caixaEtiqueta.setAttribute('fill', opLinkEstilo.ROTULO_FILL);
// //           caixaEtiqueta.setAttribute(
// //             'fill-opacity',
// //             opLinkEstilo.ROTULO_FILL_OPACITY
// //           );
// //           caixaEtiqueta.setAttribute('stroke', opLinkEstilo.COR);
// //           caixaEtiqueta.setAttribute('stroke-width', opLinkEstilo.ESPESSURA);
// //           link.appendChild(caixaEtiqueta);

// //           const textoEtiqueta = document.createElementNS(ns, 'svg:text');
// //           textoEtiqueta.setAttribute('data-role', opLinkPapel.ROTULO_TEXTO);
// //           textoEtiqueta.setAttribute(
// //             'x',
// //             caixaRotulo.x + caixaRotulo.width / 2
// //           );
// //           textoEtiqueta.setAttribute(
// //             'y',
// //             caixaRotulo.y + caixaRotulo.height / 2
// //           );
// //           textoEtiqueta.setAttribute('text-anchor', 'middle');
// //           textoEtiqueta.setAttribute('alignment-baseline', 'middle');
// //           textoEtiqueta.setAttribute('font-size', `${fontSize}px`);
// //           textoEtiqueta.setAttribute('fill', opLinkEstilo.COR_TEXTO);
// //           textoEtiqueta.textContent = texto;
// //           link.appendChild(textoEtiqueta);

// //           return;
// //         }

// //         /**
// //          * opLinkRotulo.CODIGO: texto dentro da forma.
// //          *
// //          * Não define "fill" de propósito — os links legados nunca tiveram
// //          * esse atributo e o CSS da Home depende do fill herdado
// //          * (regra "text:hover { fill: #fff }" em Pagina/styles.js).
// //          */
// //         const textoInterno = document.createElementNS(ns, 'svg:text');
// //         textoInterno.setAttribute('x', caixa.x + caixa.width / 2);
// //         textoInterno.setAttribute('y', caixa.y + caixa.height / 2);
// //         textoInterno.setAttribute('text-anchor', 'middle');
// //         textoInterno.setAttribute('alignment-baseline', 'middle');
// //         textoInterno.setAttribute('font-size', `${fontSize}px`);
// //         textoInterno.textContent = texto;
// //         link.appendChild(textoInterno);
// //       },
// //       []
// //     );

// //     /** elementos internos de um link, por papel (data-role) */
// //     const getPartesLink = useCallback((link) => {
// //       const partes = {
// //         area: null,
// //         chamada: null,
// //         rotulo: null,
// //         rotuloTexto: null,
// //       };

// //       if (!link || !link.childNodes) return partes;

// //       Array.from(link.childNodes).forEach((filho) => {
// //         switch (getPapelLink(filho)) {
// //           case opLinkPapel.AREA:
// //             partes.area = filho;
// //             break;
// //           case opLinkPapel.CHAMADA:
// //             partes.chamada = filho;
// //             break;
// //           case opLinkPapel.ROTULO:
// //             partes.rotulo = filho;
// //             break;
// //           case opLinkPapel.ROTULO_TEXTO:
// //             partes.rotuloTexto = filho;
// //             break;
// //           default:
// //             break;
// //         }
// //       });

// //       /** formas legadas não têm data-role: a forma principal é a primeira */
// //       if (!partes.area) partes.area = getFormaPrincipal(link);

// //       return partes;
// //     }, []);

// //     /**
// //      * Recalcula a linha de chamada a partir das posições atuais da área e
// //      * da etiqueta. Necessário depois de arrastar só a etiqueta ou de
// //      * redimensionar a área.
// //      */
// //     const oReancorarChamada = useCallback(
// //       (link) => {
// //         const { area, chamada, rotulo } = getPartesLink(link);

// //         if (!area || !chamada || !rotulo) return;

// //         const ancora = calcularAncoraChamada(
// //           getCaixaForma(area),
// //           getCaixaForma(rotulo)
// //         );

// //         if (ancora) {
// //           atualizarLinhaChamada(
// //             chamada,
// //             ancora.x1,
// //             ancora.y1,
// //             ancora.x2,
// //             ancora.y2
// //           );
// //         }
// //       },
// //       [getPartesLink]
// //     );

// //     /**
// //      * true quando um arraste sobre o desenho deve DESENHAR a área de um
// //      * novo link.
// //      *
// //      * Vale tanto no modo sequência (o item alvo já está definido) quanto com
// //      * a geometria de ÁREA selecionada fora dele — nesse caso o ID do item é
// //      * pedido no input rápido ao terminar o arraste.
// //      */
// //     const podeDesenharArea = useCallback(() => {
// //       if (modoSequenciaRef.current && itemSequenciaRef.current) return true;

// //       return (
// //         Number(currLinkTypeRef.current && currLinkTypeRef.current.id) ===
// //         LINK_FORM_TYPES.area
// //       );
// //       // eslint-disable-next-line react-hooks/exhaustive-deps
// //     }, []);

// //     /** true quando o alvo do mouse é a etiqueta (caixa ou texto) do link */
// //     const isAlvoRotulo = useCallback((target) => {
// //       const papel = getPapelLink(target);
// //       return papel === opLinkPapel.ROTULO || papel === opLinkPapel.ROTULO_TEXTO;
// //     }, []);

// //     /**
// //      * true quando o alvo do mouse é uma forma clicável de link.
// //      *
// //      * Compara pelo nome LOCAL do elemento: o SVG das páginas usa prefixo de
// //      * namespace (svg:rect) mas nem toda origem de arquivo mantém o prefixo,
// //      * e agora também existe a elipse. A verificação antiga era
// //      * nodeName === 'svg:circle' || nodeName === 'svg:rect'.
// //      */
// //     const isAlvoLink = useCallback(
// //       (target) => {
// //         if (!target || !target.parentElement) return false;

// //         /** só conta se o pai for o próprio <a> do link */
// //         if (getNomeLocalSvg(target.parentElement) !== 'a') return false;

// //         return isFormaLink(target) || isAlvoRotulo(target);
// //       },
// //       [isAlvoRotulo]
// //     );

// //     /**
// //      * Retângulo temporário do arraste de área, criado sob demanda.
// //      * É recriado se tiver sido removido (por exemplo ao salvar), para o
// //      * arraste não deixar de funcionar depois de uma gravação.
// //      */
// //     const oGetAreaDraft = useCallback(() => {
// //       if (areaDraftRef.current && areaDraftRef.current.parentNode) {
// //         return areaDraftRef.current;
// //       }

// //       if (!rootRef.current) return null;

// //       const areaDraft = document.createElementNS(
// //         rootRef.current.namespaceURI,
// //         'rect',
// //         rootRef.current
// //       );
// //       areaDraft.setAttribute('id', 'areaDraft');
// //       areaDraft.setAttribute('stroke', opLinkEstilo.COR);
// //       areaDraft.setAttribute('stroke-width', '0.8');
// //       areaDraft.setAttribute('stroke-dasharray', '3 2');
// //       areaDraft.setAttribute('fill', opLinkEstilo.COR);
// //       areaDraft.setAttribute('fill-opacity', '0.18');
// //       areaDraft.setAttribute('pointer-events', 'none');
// //       areaDraft.setAttribute('x', 0);
// //       areaDraft.setAttribute('y', 0);
// //       areaDraft.setAttribute('width', 0);
// //       areaDraft.setAttribute('height', 0);
// //       rootRef.current.appendChild(areaDraft);
// //       areaDraftRef.current = areaDraft;

// //       return areaDraft;
// //     }, []);

// //     /** referência do link cuja etiqueta está sendo arrastada */
// //     const rotuloDragRef = useRef(null);

// //     /**
// //      * Retângulo já desenhado pelo usuário que está aguardando o ID do item.
// //      * Usado quando a geometria de ÁREA é arrastada FORA do modo sequência:
// //      * o tamanho vem do arraste e o item é informado no input rápido.
// //      */
// //     const areaPendenteRef = useRef(null);

// //     /**
// //      * Um link é "composto" quando tem mais de dois elementos internos:
// //      * área com etiqueta (área + chamada + caixa + texto) ou qualquer forma
// //      * sem rótulo. Nesses casos a regra legada de mover apenas
// //      * childNodes[0] (forma) e childNodes[1] (texto) não se aplica — é
// //      * preciso transladar todos os filhos.
// //      *
// //      * Links legados (círculo/retângulo com o código dentro) continuam
// //      * pelo caminho antigo, preservando o comportamento atual.
// //      */
// //     const oUsaTranslacaoGenerica = useCallback(
// //       (node, tipo) => {
// //         if (Number(tipo) === LINK_FORM_TYPES.area) return true;

// //         const rotuloAtual =
// //           (node && node.dataset && node.dataset.rotulo) || opLinkRotulo.CODIGO;

// //         return rotuloAtual !== opLinkRotulo.CODIGO;
// //       },
// //       // eslint-disable-next-line react-hooks/exhaustive-deps
// //       []
// //     );

// //     const createLink = useCallback(
// //       (
// //         type,
// //         x,
// //         y,
// //         radius,
// //         height,
// //         width,
// //         id,
// //         text,
// //         textSize,
// //         href,
// //         rotulo = opLinkRotulo.CODIGO
// //       ) => {
// //         /** verifica se o grupo dos links já foi criado */
// //         linkRef.current = document.getElementById('linkGroup');
// //         if (!linkRef.current) {
// //           linkRef.current = document.createElementNS(
// //             svgRef.current.namespaceURI,
// //             'svg:g',
// //             svgRef.current
// //           );
// //           linkRef.current.id = 'linkGroup';

// //           /** adiciona elementos no nó raiz */
// //           rootRef.current.appendChild(linkRef.current);
// //         }

// //         /** criando o elemento link do item */
// //         const link = document.createElementNS(
// //           svgRef.current.namespaceURI,
// //           'a',
// //           svgRef.current
// //         );

// //         link.setAttribute('xlink:href', href);
// //         link.setAttribute('target', '_blank');
// //         link.setAttribute('class', '');
// //         link.id = id;

// //         /**
// //          * Registra o tipo de rótulo no próprio <a>. O atributo data-* é
// //          * preservado pelo svgo do backend, então o editor sabe como tratar
// //          * o link ao reabrir a página. Links legados não têm o atributo e
// //          * são interpretados como opLinkRotulo.CODIGO.
// //          */
// //         if (rotulo && rotulo !== opLinkRotulo.CODIGO) {
// //           link.setAttribute('data-rotulo', rotulo);
// //         }
// //         /** código preventivo para o link não ser executado no design */
// //         link.addEventListener('click', (e) => e.preventDefault());

// //         link.addEventListener('mouseenter', () => {
// //           if (link.matches(':hover'))
// //             handleHoverHighlight(getIdItemLink(link), true);
// //         });
// //         link.addEventListener('mouseleave', () => {
// //           if (!link.matches(':hover'))
// //             handleHoverHighlight(getIdItemLink(link), false);
// //         });

// //         linkRef.current.appendChild(link);

// //         let linkForm;

// //         /** define o formato do link */
// //         switch (type) {
// //           /** cria círculo */
// //           case LINK_FORM_TYPES.circle:
// //             linkForm = document.createElementNS(
// //               svgRef.current.namespaceURI,
// //               'svg:circle',
// //               svgRef.current
// //             );

// //             linkForm.setAttribute('data-id', String(LINK_FORM_TYPES.circle));
// //             linkForm.setAttribute('class', 'inject');
// //             linkForm.setAttribute('stroke', '#ccc');
// //             linkForm.setAttribute('fill', '#fff');
// //             linkForm.setAttribute('cx', x + 18);
// //             linkForm.setAttribute('cy', y);
// //             linkForm.setAttribute('r', radius);
// //             link.appendChild(linkForm);

// //             oCriarRotuloLink({
// //               link,
// //               forma: linkForm,
// //               rotulo,
// //               texto: text,
// //               fontSize: radius,
// //             });

// //             break;
// //           /** cria retângulo */
// //           case LINK_FORM_TYPES.rect:
// //             linkForm = document.createElementNS(
// //               svgRef.current.namespaceURI,
// //               'svg:rect',
// //               svgRef.current
// //             );

// //             linkForm.setAttribute('data-id', String(LINK_FORM_TYPES.rect));
// //             linkForm.setAttribute('class', 'inject');
// //             linkForm.setAttribute('stroke', '#ccc');
// //             linkForm.setAttribute('fill', '#fff');
// //             linkForm.setAttribute('x', Number(x - textSize / 2));
// //             linkForm.setAttribute('y', Number(y - 10));
// //             linkForm.setAttribute('height', height);
// //             linkForm.setAttribute('width', width);
// //             linkForm.setAttribute('rx', '2');
// //             linkForm.setAttribute('ry', '2');
// //             link.appendChild(linkForm);

// //             oCriarRotuloLink({
// //               link,
// //               forma: linkForm,
// //               rotulo,
// //               texto: text,
// //               fontSize: Math.trunc(height / 2),
// //             });
// //             break;

// //           /**
// //            * Área: retângulo desenhado sobre o contorno real do componente.
// //            * Aqui x/y são o canto superior esquerdo (e não o centro, como
// //            * nas formas legadas) e width/height vêm do arraste do usuário.
// //            */
// //           case LINK_FORM_TYPES.area: {
// //             linkForm = document.createElementNS(
// //               svgRef.current.namespaceURI,
// //               'svg:rect',
// //               svgRef.current
// //             );

// //             const areaW = Math.max(
// //               LINK_AREA_SIZE_LIMIT.min,
// //               Math.min(LINK_AREA_SIZE_LIMIT.max, Number(width) || 0)
// //             );
// //             const areaH = Math.max(
// //               LINK_AREA_SIZE_LIMIT.min,
// //               Math.min(LINK_AREA_SIZE_LIMIT.max, Number(height) || 0)
// //             );

// //             linkForm.setAttribute('data-id', String(LINK_FORM_TYPES.area));
// //             linkForm.setAttribute('data-role', opLinkPapel.AREA);
// //             linkForm.setAttribute('class', 'inject');
// //             linkForm.setAttribute('x', Number(x));
// //             linkForm.setAttribute('y', Number(y));
// //             linkForm.setAttribute('width', areaW);
// //             linkForm.setAttribute('height', areaH);
// //             /** rx/ry são obrigatórios: sem eles o svgo converte o rect em path */
// //             linkForm.setAttribute('rx', '2');
// //             linkForm.setAttribute('ry', '2');
// //             linkForm.setAttribute('stroke', opLinkEstilo.COR);
// //             linkForm.setAttribute('stroke-width', opLinkEstilo.ESPESSURA);
// //             /**
// //              * O preenchimento translúcido é intencional: com fill="none" a
// //              * área só é clicável na borda, e com opacity 0 o plugin
// //              * removeHiddenElems do svgo apagaria o link inteiro ao salvar.
// //              */
// //             linkForm.setAttribute('fill', opLinkEstilo.COR);
// //             linkForm.setAttribute(
// //               'fill-opacity',
// //               opLinkEstilo.AREA_FILL_OPACITY
// //             );
// //             link.appendChild(linkForm);

// //             oCriarRotuloLink({
// //               link,
// //               forma: linkForm,
// //               rotulo,
// //               texto: text,
// //               fontSize: Number(textSize) || INITIAL_LINK_AREA.fontSize,
// //             });
// //             break;
// //           }
// //           default:
// //             break;
// //         }

// //         linkMappingRef.current.push(link);
// //       },
// //       // eslint-disable-next-line react-hooks/exhaustive-deps
// //       [LINK_FORM_TYPES, handleHoverHighlight, oCriarRotuloLink]
// //     );

// //     const oCheckConflict = useCallback(() => {
// //       /** desconta padding como margem de segurança */
// //       const padding = 3;

// //       if (!(linkMappingRef && linkMappingRef.current)) return;

// //       const mappingPos = linkMappingRef.current.map((item) => {
// //         const shape = item.childNodes[0];

// //         /** reprocessa os itens com classe padrão */
// //         shape.setAttribute('class', 'inject');

// //         if (shape.nodeName === 'svg:circle') {
// //           const cx = Number(shape.getAttribute('cx'));
// //           const cy = Number(shape.getAttribute('cy'));
// //           const r = Number(shape.getAttribute('r'));

// //           const top = cy - r;
// //           const left = cx - r;
// //           const width = r * 2;
// //           const height = r * 2;

// //           return { shape, top, left, width, height };
// //         }

// //         const left = Number(shape.getAttribute('x'));
// //         const top = Number(shape.getAttribute('y'));
// //         const width = Number(shape.getAttribute('width'));
// //         const height = Number(shape.getAttribute('height'));

// //         return { shape, top, left, width, height };
// //       });

// //       mappingPos.forEach((item) => {
// //         const conflicts = mappingPos.filter(
// //           (itemFilter) =>
// //             (item.left - padding >= itemFilter.left ||
// //               item.left - padding + item.width >= itemFilter.left) &&
// //             item.left + item.width / 2 - padding <=
// //               itemFilter.left + itemFilter.width &&
// //             (item.top - padding >= itemFilter.top ||
// //               item.top + item.height - padding >= itemFilter.top) &&
// //             item.top + item.height / 2 - padding <=
// //               itemFilter.top + itemFilter.height
// //         );

// //         if (conflicts.length > 1) {
// //           conflicts.forEach((itemConflict) =>
// //             itemConflict.shape.setAttribute('class', 'warning')
// //           );
// //         }
// //       });
// //     }, []);

// //     const oLink = useCallback(
// //       (data) => {
// //         const { catalogId, pageNum: pageId } = editor;
// //         const { id, fontSize, width, height } = currLinkTypeRef.current;

// //         const currHeight = defLinkSize.current.height || height;
// //         const currWidth = defLinkSize.current.width || width;

// //         /** transforma IDs com 0 à esquerda em IDs sem 0 à esquerda ("01" significa o mesmo que "1") */
// //         const normalizeValue = (value) => {
// //           const text = String(value ?? '')
// //             .trim()
// //             .toUpperCase();

// //           // Se for apenas número, remove zeros à esquerda convertendo para Number
// //           if (/^\d+$/.test(text)) {
// //             return String(Number(text));
// //           }

// //           // Se for texto/alfanumérico, mantém como texto normalizado
// //           return text;
// //         };

// //         const formattedIdItem = normalizeValue(data.idItem);

// //         /** busca o item no mapeamento OCR */
// //         const dotted = ocrMappingRef.current.filter((item) => {
// //           const formattedOcr = normalizeValue(item.ocr.text);

// //           return formattedOcr === formattedIdItem;
// //         });

// //         /** caso não encontre pelo método OCR, interrompe o processo */
// //         if (!dotted.length) return;

// //         dotted.forEach(({ attr, ocr }) => {
// //           /**
// //            * Geometria de ÁREA: aproveita a caixa que o OCR já devolve
// //            * (ocr.width / ocr.height, com ocr.x / ocr.y no centro do texto,
// //            * conforme NormalizarExtracaoTextoService no backend). Antes essas
// //            * duas informações eram descartadas e todo link nascia com o
// //            * tamanho padrão.
// //            */
// //           if (Number(id) === LINK_FORM_TYPES.area) {
// //             const larguraOcr = Number(ocr && ocr.width) || currWidth;
// //             const alturaOcr = Number(ocr && ocr.height) || currHeight;

// //             /** folga para a área não encostar no texto detectado */
// //             const folga = 2;
// //             const largura = larguraOcr + folga * 2;
// //             const altura = alturaOcr + folga * 2;

// //             const centroX =
// //               Number(ocr && ocr.x) ||
// //               Number(attr.childNodes[0].getAttribute('x'));
// //             const centroY =
// //               Number(ocr && ocr.y) ||
// //               Number(attr.childNodes[0].getAttribute('y'));

// //             createLink(
// //               id,
// //               centroX - largura / 2,
// //               centroY - altura / 2,
// //               0,
// //               altura,
// //               largura,
// //               data.partnumber,
// //               data.idItem,
// //               INITIAL_LINK_AREA.fontSize,
// //               `/${catalogId}/${pageId}/${data.idItem}`,
// //               currLinkRotuloRef.current
// //             );

// //             return;
// //           }

// //           createLink(
// //             id,
// //             Number(attr.childNodes[0].getAttribute('x')) - 10,
// //             Number(attr.childNodes[0].getAttribute('y')) + 10,
// //             currHeight,
// //             currHeight,
// //             currWidth,
// //             data.partnumber,
// //             data.idItem,
// //             fontSize,
// //             `/${catalogId}/${pageId}/${data.idItem}`,
// //             currLinkRotuloRef.current
// //           );
// //         });

// //         /** verifica associações */
// //         oCheckAssociation();

// //         /** verifica conflito */
// //         oCheckConflict();
// //       },
// //       [createLink, editor, oCheckAssociation, oCheckConflict]
// //     );

// //     /** mantém os refs sincronizados para uso dentro dos handlers de mouse */
// //     useEffect(() => {
// //       currLinkRotuloRef.current = currLinkRotulo;
// //     }, [currLinkRotulo]);

// //     /**
// //      * O elemento <SVG> é memoizado apenas por [editor.pageNum, editor.path]
// //      * (as dependências dos handlers estão comentadas de propósito, para não
// //      * reinjetar o desenho e perder os links a cada render). Como consequência,
// //      * os handlers de mouse carregam o estado do render da injeção.
// //      *
// //      * Espelhar a tabela em ref evita que o modo sequência trabalhe com uma
// //      * lista de itens vazia quando os itens da página chegam depois do SVG.
// //      */
// //     useEffect(() => {
// //       tabelaRef.current = table;
// //     }, [table]);

// //     useEffect(() => {
// //       modoSequenciaRef.current = modoSequencia;
// //     }, [modoSequencia]);

// //     /** itens da página que ainda não têm link no desenho */
// //     const itensPendentes = useMemo(() => {
// //       const vinculados = new Set(
// //         linkMappingRef.current.map((node) => String(getIdItemLink(node)))
// //       );

// //       return table.filter((item) => !vinculados.has(String(item.idItem)));
// //       // eslint-disable-next-line react-hooks/exhaustive-deps
// //     }, [table, getIdItemLink, currLinkType, currLinkRotulo, modoSequencia]);

// //     /**
// //      * Cria o link de um item usando a geometria de ÁREA a partir do
// //      * retângulo desenhado pelo usuário.
// //      */
// //     const oCriarLinkArea = useCallback(
// //       (item, x, y, largura, altura) => {
// //         if (!item) return;

// //         const { catalogId, pageNum: pageId } = editor;

// //         createLink(
// //           LINK_FORM_TYPES.area,
// //           x,
// //           y,
// //           0,
// //           altura,
// //           largura,
// //           item.partnumber,
// //           item.idItem,
// //           INITIAL_LINK_AREA.fontSize,
// //           `/${catalogId}/${pageId}/${item.idItem}`,
// //           currLinkRotuloRef.current
// //         );

// //         oCheckAssociation();
// //         oCheckConflict();
// //       },
// //       // eslint-disable-next-line react-hooks/exhaustive-deps
// //       [createLink, editor, oCheckAssociation, oCheckConflict]
// //     );

// //     /**
// //      * Cria o link de um item respeitando a geometria e o rótulo atuais.
// //      *
// //      * - legadoX/legadoY: ponto de ancoragem das formas legadas
// //      *   (círculo/retângulo), preservado exatamente como cada chamada fazia.
// //      * - centroX/centroY: centro usado pela geometria de ÁREA.
// //      * - ocr: caixa do texto detectado, quando houver, para dimensionar a
// //      *   área (campos width/height de NormalizarExtracaoTextoService).
// //      */
// //     const oCriarLinkNoPonto = useCallback(
// //       ({
// //         data,
// //         legadoX,
// //         legadoY,
// //         centroX,
// //         centroY,
// //         ocr = null,
// //         area = null,
// //       }) => {
// //         const { catalogId, pageNum: pageId } = editor;
// //         const { id, fontSize, width, height } = currLinkTypeRef.current;

// //         const currHeight = defLinkSize.current.height || height;
// //         const currWidth = defLinkSize.current.width || width;
// //         const href = `/${catalogId}/${pageId}/${data.idItem}`;

// //         /**
// //          * Retângulo desenhado pelo usuário tem prioridade sobre qualquer
// //          * outro tamanho (OCR ou padrão) — foi um gesto explícito.
// //          */
// //         if (area) {
// //           createLink(
// //             LINK_FORM_TYPES.area,
// //             area.x,
// //             area.y,
// //             0,
// //             area.altura,
// //             area.largura,
// //             data.partnumber,
// //             data.idItem,
// //             INITIAL_LINK_AREA.fontSize,
// //             href,
// //             currLinkRotuloRef.current
// //           );

// //           return;
// //         }

// //         if (Number(id) === LINK_FORM_TYPES.area) {
// //           const folga = 2;
// //           const largura = (Number(ocr && ocr.width) || currWidth) + folga * 2;
// //           const altura = (Number(ocr && ocr.height) || currHeight) + folga * 2;

// //           createLink(
// //             id,
// //             centroX - largura / 2,
// //             centroY - altura / 2,
// //             0,
// //             altura,
// //             largura,
// //             data.partnumber,
// //             data.idItem,
// //             INITIAL_LINK_AREA.fontSize,
// //             href,
// //             currLinkRotuloRef.current
// //           );

// //           return;
// //         }

// //         createLink(
// //           id,
// //           legadoX,
// //           legadoY,
// //           currHeight,
// //           currHeight,
// //           currWidth,
// //           data.partnumber,
// //           data.idItem,
// //           fontSize,
// //           href,
// //           currLinkRotuloRef.current
// //         );
// //       },
// //       // eslint-disable-next-line react-hooks/exhaustive-deps
// //       [createLink, editor]
// //     );

// //     /** avança o modo sequência para o próximo item ainda sem link */
// //     const oAvancarSequencia = useCallback(
// //       (idItemCriado) => {
// //         const vinculados = new Set(
// //           linkMappingRef.current.map((node) => String(getIdItemLink(node)))
// //         );

// //         if (idItemCriado) vinculados.add(String(idItemCriado));

// //         /** lê do ref: ver comentário do efeito que sincroniza tabelaRef */
// //         const proximo = tabelaRef.current.find(
// //           (item) => !vinculados.has(String(item.idItem))
// //         );

// //         itemSequenciaRef.current = proximo || null;
// //         setItemSequencia(proximo || null);
// //       },
// //       [getIdItemLink]
// //     );

// //     /** Retorna a posição do mouse no objeto SVGPoint { x: number, y: number } */
// //     const oMousePosSVG = useCallback(
// //       (e) => {
// //         let p = svgRef.current.createSVGPoint();
// //         p.x = e.clientX;
// //         p.y = e.clientY;
// //         const ctm = rootRef.current.getScreenCTM().inverse();
// //         p = p.matrixTransform(ctm);
// //         return p;
// //       },
// //       [rootRef]
// //     );

// //     /** Seleciona um link e define foco nele */
// //     const oSelectElement = useCallback(
// //       (el) => {
// //         const isSelected = !!selectedRef.current.find(
// //           (element) => element.node === el.node
// //         );

// //         if (!isSelected) {
// //           selectedRef.current.push(el);
// //         }

// //         /** limpa o foco atual */
// //         if (focusRef && focusRef.current) {
// //           const classes = focusRef.current.node
// //             .getAttribute('class')
// //             .split('focused');

// //           focusRef.current.node.setAttribute(
// //             'class',
// //             classes[0].trim() + (classes[1] || '')
// //           );
// //         }

// //         /** difene novo foco */
// //         focusRef.current = el;
// //         focusRef.current.node.setAttribute(
// //           'class',
// //           `selected ${
// //             selectedRef.current && selectedRef.current.length > 1
// //               ? 'focused'
// //               : ''
// //           }`.trim()
// //         );

// //         let currSizeW = 0;
// //         let currSizeH = 0;

// //         switch (Number(focusRef.current.node.childNodes[0].dataset.id)) {
// //           case LINK_FORM_TYPES.circle:
// //             currSizeH = focusRef.current.node.childNodes[0].getAttribute('r');
// //             break;
// //           case LINK_FORM_TYPES.rect:
// //           case LINK_FORM_TYPES.area:
// //             currSizeW = focusRef.current.node.childNodes[0].getAttribute(
// //               'width'
// //             );
// //             currSizeH = focusRef.current.node.childNodes[0].getAttribute(
// //               'height'
// //             );
// //             break;
// //           default:
// //             break;
// //         }

// //         oLinkSizeMode(currSizeH, currSizeW);
// //       },
// //       [LINK_FORM_TYPES, selectedRef, focusRef, oLinkSizeMode]
// //     );

// //     /** desseleciona um link */
// //     const oDeselectElement = useCallback(
// //       (el) => {
// //         const classes = el.node.getAttribute('class').split('selected');

// //         el.node.setAttribute('class', classes[0].trim() + (classes[1] || ''));

// //         selectedRef.current = selectedRef.current.filter(
// //           (element) => element.node !== el.node
// //         );
// //       },
// //       [selectedRef]
// //     );

// //     /** limpa seleção de links */
// //     const oClearSelection = useCallback(() => {
// //       /** limpa foco */
// //       if (focusRef && focusRef.current) {
// //         focusRef.current = null;
// //       }

// //       /** limpa seleção */
// //       if (selectedRef && selectedRef.current) {
// //         selectedRef.current.forEach((el) =>
// //           el.node.setAttribute(
// //             'class',
// //             el.node.getAttribute('class').split('selected')[0].trim()
// //           )
// //         );
// //         selectedRef.current = [];
// //       }

// //       oLinkSizeMode(0, 0);
// //     }, [selectedRef, oLinkSizeMode]);

// //     const oClearSelector = useCallback(() => {
// //       /** limpa área de seleção */
// //       if (selectorRef && selectorRef.current) {
// //         selectorRef.current.setAttribute('x', 0);
// //         selectorRef.current.setAttribute('y', 0);
// //         selectorRef.current.setAttribute('width', 0);
// //         selectorRef.current.setAttribute('height', 0);

// //         startCoordRef.current = { x: 0, y: 0 };
// //         finishCoordRef.current = { x: 0, y: 0 };
// //         maxCoordRef.current = { x: 0, y: 0 };
// //         minCoordRef.current = { x: 0, y: 0 };
// //       }
// //     }, [selectorRef]);

// //     const oRemove = useCallback((el) => {
// //       const drop = el.parentElement || null;

// //       if (!drop) return el;

// //       if (drop.childNodes.length > 1) return el;

// //       return oRemove(drop);
// //     }, []);

// //     const handleDragOverSVG = useCallback((e) => {
// //       e.preventDefault();
// //     }, []);

// //     const handleDropSVG = useCallback(
// //       (e) => {
// //         e.preventDefault();

// //         const m = oMousePosSVG(e);

// //         const data = JSON.parse(e.dataTransfer.getData('text/row-list'));
// //         if (!data) return;

// //         const dotted = ocrMappingRef.current.filter(
// //           (item) => item.ocr.text === String(data.idItem)
// //         );

// //         if (!dotted.length) {
// //           oCriarLinkNoPonto({
// //             data,
// //             legadoX: m.x,
// //             legadoY: m.y,
// //             centroX: m.x,
// //             centroY: m.y,
// //           });
// //         }

// //         dotted.forEach(({ attr, ocr }) => {
// //           const ancoraX = Number(attr.childNodes[0].getAttribute('x'));
// //           const ancoraY = Number(attr.childNodes[0].getAttribute('y'));

// //           oCriarLinkNoPonto({
// //             data,
// //             legadoX: ancoraX - 10,
// //             legadoY: ancoraY + 10,
// //             centroX: Number(ocr && ocr.x) || ancoraX,
// //             centroY: Number(ocr && ocr.y) || ancoraY,
// //             ocr,
// //           });

// //           /** remove elemento do mapeamento principal */
// //           const mappingIndex = ocrMappingRef.current.findIndex(
// //             (findAttr) => findAttr.attr.id === attr.id
// //           );
// //           ocrMappingRef.current.splice(mappingIndex, 1);

// //           /** remove elemento da tela */
// //           oRemove(attr).remove();
// //         });

// //         /** associa link com o item na tabela */
// //         oCheckAssociation();

// //         /** verifica conflito */
// //         oCheckConflict();
// //       },
// //       [
// //         editor,
// //         oMousePosSVG,
// //         oRemove,
// //         createLink,
// //         oCheckAssociation,
// //         oCheckConflict,
// //       ]
// //     );

// //     const handleDragOver = useCallback((e) => {
// //       const isLink = e.dataTransfer.types.includes('image/svg+xml');
// //       if (isLink) e.preventDefault();
// //     }, []);

// //     const handleMouseMove = useCallback(
// //       (e) => {
// //         if (!selectingRef.current) return;

// //         const m = oMousePosSVG(e);

// //         const isLink = isAlvoLink(e.target);

// //         const { shiftKey, ctrlKey, altKey } = e;

// //         /** Shift+Click */
// //         if (shiftKey && !ctrlKey && !altKey) {
// //           if (isLink && e.target.parentElement === focusRef.current.node) {
// //             actionRef.current = ACTION_STATE.move;
// //           }
// //         }

// //         /** Shift+Ctrl+Click Disponível */
// //         /** Shift+Alt+Click Disponível */
// //         /** Shift+Ctrl+Alt+Click Disponível */

// //         /** Ctrl+Click  */
// //         if (!shiftKey && ctrlKey && !altKey) {
// //           if (!selectedRef.current.length) {
// //             actionRef.current = ACTION_STATE.selectArea;
// //           }
// //         }

// //         /** Ctrl+Alt+Click Disponível */

// //         /** Alt+Click Disponível */
// //         if (!shiftKey && !ctrlKey && altKey) {
// //           if (isLink && e.target.parentElement === controlRef.current) {
// //             actionRef.current = ACTION_STATE.moveOne;
// //           }
// //         }

// //         /** Click */
// //         if (!shiftKey && !ctrlKey && !altKey) {
// //           if (rotuloDragRef.current) {
// //             /** arrastando a etiqueta: a área do link não se move */
// //             actionRef.current = ACTION_STATE.moveRotulo;
// //           } else if (isLink) {
// //             actionRef.current = ACTION_STATE.move;
// //           } else if (podeDesenharArea()) {
// //             /** arraste sobre o desenho desenha a área do link */
// //             actionRef.current = ACTION_STATE.createArea;
// //           }
// //         }

// //         switch (actionRef.current) {
// //           /**
// //            * Desenha o retângulo temporário da nova área. O link só é criado
// //            * ao soltar o botão, em handleMouseUp.
// //            */
// //           case ACTION_STATE.createArea: {
// //             const draft = oGetAreaDraft();
// //             if (!draft) return;

// //             /** garante a origem do arraste caso o mousedown não a tenha fixado */
// //             if (!areaStartRef.current) {
// //               areaStartRef.current = { x: m.x, y: m.y };
// //             }

// //             const inicio = areaStartRef.current;

// //             const x = Math.min(inicio.x, m.x);
// //             const y = Math.min(inicio.y, m.y);
// //             const largura = Math.abs(m.x - inicio.x);
// //             const altura = Math.abs(m.y - inicio.y);

// //             draft.setAttribute('x', x);
// //             draft.setAttribute('y', y);
// //             draft.setAttribute('width', largura);
// //             draft.setAttribute('height', altura);
// //             break;
// //           }

// //           /**
// //            * Move apenas a etiqueta do link e reancora a linha de chamada,
// //            * mantendo a área sobre o componente.
// //            */
// //           case ACTION_STATE.moveRotulo: {
// //             const link = rotuloDragRef.current;
// //             if (!link) return;

// //             const { rotulo, rotuloTexto } = getPartesLink(link);
// //             if (!rotulo) return;

// //             const caixa = getCaixaForma(rotulo);

// //             const dx = m.x - (caixa.x + caixa.width / 2);
// //             const dy = m.y - (caixa.y + caixa.height / 2);

// //             transladarElementoSvg(rotulo, dx, dy);
// //             if (rotuloTexto) transladarElementoSvg(rotuloTexto, dx, dy);

// //             oReancorarChamada(link);
// //             break;
// //           }

// //           case ACTION_STATE.move: {
// //             /** verifica se há links selecionados */
// //             if (selectedRef.current.length === 0) return;

// //             /** vetores de deslocamento para x e y */
// //             const xVector =
// //               m.x -
// //               Number(
// //                 focusRef.current.node.childNodes[0].getAttribute(
// //                   `${
// //                     Number(focusRef.current.node.childNodes[0].dataset.id) ===
// //                     LINK_FORM_TYPES.circle
// //                       ? 'cx'
// //                       : 'x'
// //                   }`
// //                 )
// //               );
// //             const yVector =
// //               m.y -
// //               Number(
// //                 focusRef.current.node.childNodes[0].getAttribute(
// //                   `${
// //                     Number(focusRef.current.node.childNodes[0].dataset.id) ===
// //                     LINK_FORM_TYPES.circle
// //                       ? 'cy'
// //                       : 'y'
// //                   }`
// //                 )
// //               );

// //             /** offsets do link em foco em x e y */
// //             const xOffset =
// //               Number(focusRef.current.node.childNodes[0].dataset.id) ===
// //               LINK_FORM_TYPES.circle
// //                 ? null
// //                 : Number(
// //                     focusRef.current.node.childNodes[0].width.baseVal.value
// //                   ) / 2;
// //             const yOffset =
// //               Number(focusRef.current.node.childNodes[0].dataset.id) ===
// //               LINK_FORM_TYPES.circle
// //                 ? null
// //                 : Number(
// //                     focusRef.current.node.childNodes[0].height.baseVal.value
// //                   ) / 2;

// //             selectedRef.current.forEach((element) => {
// //               const linkForm = element.node.childNodes[0];
// //               const linkText = element.node.childNodes[1];

// //               const { id: tipo = null } = linkForm.dataset || {};

// //               /** links compostos: translada todos os elementos internos */
// //               if (oUsaTranslacaoGenerica(element.node, tipo)) {
// //                 transladarLink(
// //                   element.node,
// //                   xVector - (xOffset || 0),
// //                   yVector - (yOffset || 0)
// //                 );
// //                 return;
// //               }

// //               switch (Number(tipo)) {
// //                 case LINK_FORM_TYPES.circle: {
// //                   /** posição da forma */
// //                   const xF = Number(linkForm.getAttribute('cx'));
// //                   const yF = Number(linkForm.getAttribute('cy'));
// //                   /** posição do texto */
// //                   const xT = linkText ? Number(linkText.getAttribute('x')) : 0;
// //                   const yT = linkText ? Number(linkText.getAttribute('y')) : 0;

// //                   /** nova posição da forma */
// //                   linkForm.setAttribute('cx', xF + xVector - xOffset);
// //                   linkForm.setAttribute('cy', yF + yVector - yOffset);
// //                   /** nova posição do texto */
// //                   if (linkText) {
// //                     linkText.setAttribute('x', xT + xVector - xOffset);
// //                     linkText.setAttribute('y', yT + yVector - yOffset);
// //                   }
// //                   break;
// //                 }
// //                 case LINK_FORM_TYPES.rect:
// //                 case LINK_FORM_TYPES.ocr: {
// //                   /** posição da forma */
// //                   const xF = Number(linkForm.getAttribute('x'));
// //                   const yF = Number(linkForm.getAttribute('y'));
// //                   /** posição do texto */
// //                   const xT = linkText ? Number(linkText.getAttribute('x')) : 0;
// //                   const yT = linkText ? Number(linkText.getAttribute('y')) : 0;

// //                   /** nova posição da forma */
// //                   linkForm.setAttribute('x', xF + xVector - xOffset);
// //                   linkForm.setAttribute('y', yF + yVector - yOffset);
// //                   /** nova posição do texto */
// //                   if (linkText) {
// //                     linkText.setAttribute('x', xT + xVector - xOffset);
// //                     linkText.setAttribute('y', yT + yVector - yOffset);
// //                   }
// //                   break;
// //                 }
// //                 default:
// //                   break;
// //               }
// //             });
// //             break;
// //           }

// //           case ACTION_STATE.moveOne:
// //             {
// //               const element = selectedRef.current.find(
// //                 (el) => el.node === controlRef.current
// //               );

// //               if (!element) return;
// //               /** vetores de deslocamento para x e y */
// //               const xVector =
// //                 m.x -
// //                 Number(
// //                   element.node.childNodes[0].getAttribute(
// //                     `${
// //                       Number(element.node.childNodes[0].dataset.id) ===
// //                       LINK_FORM_TYPES.circle
// //                         ? 'cx'
// //                         : 'x'
// //                     }`
// //                   )
// //                 );
// //               const yVector =
// //                 m.y -
// //                 Number(
// //                   element.node.childNodes[0].getAttribute(
// //                     `${
// //                       Number(element.node.childNodes[0].dataset.id) ===
// //                       LINK_FORM_TYPES.circle
// //                         ? 'cy'
// //                         : 'y'
// //                     }`
// //                   )
// //                 );

// //               /** offsets do link em foco em x e y */
// //               const xOffset =
// //                 Number(element.node.childNodes[0].dataset.id) ===
// //                 LINK_FORM_TYPES.circle
// //                   ? null
// //                   : Number(element.node.childNodes[0].width.baseVal.value) / 2;
// //               const yOffset =
// //                 Number(element.node.childNodes[0].dataset.id) ===
// //                 LINK_FORM_TYPES.circle
// //                   ? null
// //                   : Number(element.node.childNodes[0].height.baseVal.value) / 2;

// //               const linkForm = element.node.childNodes[0];
// //               const linkText = element.node.childNodes[1];

// //               const { id: tipo = null } = linkForm.dataset || {};

// //               /** links compostos: translada todos os elementos internos */
// //               if (oUsaTranslacaoGenerica(element.node, tipo)) {
// //                 transladarLink(
// //                   element.node,
// //                   xVector - (xOffset || 0),
// //                   yVector - (yOffset || 0)
// //                 );
// //                 break;
// //               }

// //               switch (Number(tipo)) {
// //                 case LINK_FORM_TYPES.circle: {
// //                   /** posição da forma */
// //                   const xF = Number(linkForm.getAttribute('cx'));
// //                   const yF = Number(linkForm.getAttribute('cy'));
// //                   /** posição do texto */
// //                   const xT = linkText ? Number(linkText.getAttribute('x')) : 0;
// //                   const yT = linkText ? Number(linkText.getAttribute('y')) : 0;

// //                   /** nova posição da forma */
// //                   linkForm.setAttribute('cx', xF + xVector - xOffset);
// //                   linkForm.setAttribute('cy', yF + yVector - yOffset);
// //                   /** nova posição do texto */
// //                   if (linkText) {
// //                     linkText.setAttribute('x', xT + xVector - xOffset);
// //                     linkText.setAttribute('y', yT + yVector - yOffset);
// //                   }
// //                   break;
// //                 }
// //                 case LINK_FORM_TYPES.rect:
// //                 case LINK_FORM_TYPES.ocr: {
// //                   /** posição da forma */
// //                   const xF = Number(linkForm.getAttribute('x'));
// //                   const yF = Number(linkForm.getAttribute('y'));
// //                   /** posição do texto */
// //                   const xT = linkText ? Number(linkText.getAttribute('x')) : 0;
// //                   const yT = linkText ? Number(linkText.getAttribute('y')) : 0;

// //                   /** nova posição da forma */
// //                   linkForm.setAttribute('x', xF + xVector - xOffset);
// //                   linkForm.setAttribute('y', yF + yVector - yOffset);
// //                   /** nova posição do texto */
// //                   if (linkText) {
// //                     linkText.setAttribute('x', xT + xVector - xOffset);
// //                     linkText.setAttribute('y', yT + yVector - yOffset);
// //                   }
// //                   break;
// //                 }
// //                 default:
// //                   break;
// //               }
// //             }
// //             break;
// //           case ACTION_STATE.selectArea: {
// //             /** define valores finais para a área de seleção */
// //             if (
// //               startCoordRef.current.x === 0 &&
// //               startCoordRef.current.y === 0
// //             ) {
// //               startCoordRef.current.x = m.x;
// //               startCoordRef.current.y = m.y;
// //             }

// //             finishCoordRef.current.x = m.x;
// //             finishCoordRef.current.y = m.y;

// //             minCoordRef.current.x = Math.min(
// //               startCoordRef.current.x,
// //               finishCoordRef.current.x
// //             );
// //             maxCoordRef.current.x = Math.max(
// //               startCoordRef.current.x,
// //               finishCoordRef.current.x
// //             );
// //             minCoordRef.current.y = Math.min(
// //               startCoordRef.current.y,
// //               finishCoordRef.current.y
// //             );
// //             maxCoordRef.current.y = Math.max(
// //               startCoordRef.current.y,
// //               finishCoordRef.current.y
// //             );

// //             selectorRef.current.setAttribute('x', minCoordRef.current.x);
// //             selectorRef.current.setAttribute('y', minCoordRef.current.y);
// //             selectorRef.current.setAttribute(
// //               'width',
// //               maxCoordRef.current.x - minCoordRef.current.x
// //             );
// //             selectorRef.current.setAttribute(
// //               'height',
// //               maxCoordRef.current.y - minCoordRef.current.y
// //             );

// //             /** seleciona itens dentro da área */
// //             const linkMappingPos = linkMappingRef.current.map((item) => {
// //               const shape = item.childNodes[0];

// //               const x = Number(
// //                 shape.getAttribute(shape.nodeName === 'svg:circle' ? 'cx' : 'x')
// //               );
// //               const y = Number(
// //                 shape.getAttribute(shape.nodeName === 'svg:circle' ? 'cy' : 'y')
// //               );

// //               return { attr: item, x, y };
// //             });

// //             const mappingOCRPos = ocrMappingRef.current.map((item) => {
// //               const x = Number(item.attr.childNodes[0].getAttribute('x'));
// //               const y = Number(item.attr.childNodes[0].getAttribute('y'));

// //               return { attr: item.attr, x, y };
// //             });

// //             const itemsPos = [...linkMappingPos, ...mappingOCRPos];

// //             itemsPos.forEach((item) => {
// //               if (
// //                 item.x >= minCoordRef.current.x &&
// //                 item.x <= maxCoordRef.current.x &&
// //                 item.y >= minCoordRef.current.y &&
// //                 item.y <= maxCoordRef.current.y
// //               ) {
// //                 oSelectElement({ node: item.attr });
// //               } else {
// //                 oDeselectElement({ node: item.attr });
// //               }
// //             });
// //             break;
// //           }
// //           default:
// //             break;
// //         }
// //       },
// //       [
// //         ACTION_STATE,
// //         LINK_FORM_TYPES,
// //         actionRef,
// //         selectingRef,
// //         oMousePosSVG,
// //         oSelectElement,
// //         oDeselectElement,
// //       ]
// //     );

// //     const handleMouseDown = useCallback(
// //       (e) => {
// //         /**
// //          * Os atalhos só chegam ao editor quando o wrapper do desenho está
// //          * com o foco (ele tem tabIndex="0"). Focar no mousedown garante
// //          * que Del, Alt+Z e Alt+S funcionem logo após o primeiro clique no
// //          * desenho, sem o usuário precisar tabular até ele.
// //          */
// //         if (e.currentTarget && e.currentTarget.focus) {
// //           e.currentTarget.focus({ preventScroll: true });
// //         }

// //         /** verifica se existe um arquivo na área de edição */
// //         if (svgRef.current) {
// //           selectingRef.current = true;

// //           const { shiftKey, ctrlKey, altKey } = e;

// //           const isLink = isAlvoLink(e.target);

// //           /** guarda o link cuja etiqueta está sendo arrastada */
// //           rotuloDragRef.current =
// //             !shiftKey && !ctrlKey && !altKey && isAlvoRotulo(e.target)
// //               ? e.target.parentElement
// //               : null;

// //           /** bloqueia movimento da imagem quando um link está sendo movido ou selecionado */
// //           if (isLink || ctrlKey) {
// //             setZoomCanMove(false);
// //           }

// //           /**
// //            * O arraste sobre o desenho desenha a área do link, então o pan da
// //            * imagem precisa ficar desligado durante o gesto.
// //            */
// //           if (
// //             podeDesenharArea() &&
// //             !isLink &&
// //             !shiftKey &&
// //             !ctrlKey &&
// //             !altKey
// //           ) {
// //             setZoomCanMove(false);

// //             const m = oMousePosSVG(e);
// //             areaStartRef.current = { x: m.x, y: m.y };

// //             const draft = oGetAreaDraft();
// //             if (draft) {
// //               draft.setAttribute('x', m.x);
// //               draft.setAttribute('y', m.y);
// //               draft.setAttribute('width', 0);
// //               draft.setAttribute('height', 0);
// //             }
// //           }

// //           /** Shift+Click */
// //           if (shiftKey && !ctrlKey && !altKey) {
// //             if (isLink) {
// //               actionRef.current = ACTION_STATE.select;
// //             }
// //           }

// //           /** Shift+Ctrl+Click Disponível */

// //           /** Shift+Alt+Click */
// //           if (shiftKey && !ctrlKey && altKey) {
// //             if (isLink) {
// //               actionRef.current = ACTION_STATE.deselect;
// //             }
// //           }

// //           /** Shift+Ctrl+Alt+Click Disponível */

// //           /** Ctrl+Click  */
// //           if (!shiftKey && ctrlKey && !altKey) {
// //             const m = oMousePosSVG(e);

// //             /** define valores iniciais para a área de seleção */
// //             startCoordRef.current.x = m.x;
// //             startCoordRef.current.y = m.y;
// //             selectorRef.current.setAttribute('x', 0);
// //             selectorRef.current.setAttribute('y', 0);
// //             selectorRef.current.setAttribute('width', 0);
// //             selectorRef.current.setAttribute('height', 0);
// //           }

// //           /** Ctrl+Alt+Click Disponível */

// //           /** Alt+Click Disponível  */
// //           if (!shiftKey && !ctrlKey && altKey) {
// //             /** armazena o elemento para o Alt+Click+Drag */
// //             if (isLink) {
// //               controlRef.current = e.target.parentElement;
// //             }
// //           }

// //           /** Click */
// //           if (!shiftKey && !ctrlKey && !altKey) {
// //             /** limpa seleção */
// //             oClearSelection();

// //             if (isLink) {
// //               controlRef.current = e.target.parentElement;
// //               actionRef.current = ACTION_STATE.select;
// //             }
// //           }

// //           switch (actionRef.current) {
// //             case ACTION_STATE.select:
// //               oSelectElement({ node: e.target.parentElement });
// //               break;
// //             case ACTION_STATE.deselect:
// //               oDeselectElement({ node: e.target.parentElement });
// //               break;
// //             default:
// //               break;
// //           }

// //           actionRef.current = null;
// //         }
// //       },
// //       [
// //         ACTION_STATE,
// //         actionRef,
// //         selectingRef,
// //         oSelectElement,
// //         oDeselectElement,
// //         oClearSelection,
// //         oMousePosSVG,
// //       ]
// //     );

// //     /**
// //      * Fecha o input rápido descartando também o retângulo desenhado que
// //      * estivesse aguardando o ID do item — sem isso ele seria reaproveitado
// //      * indevidamente na próxima criação de link.
// //      */
// //     const handleQuickInputCancel = useCallback(() => {
// //       areaPendenteRef.current = null;

// //       if (areaDraftRef.current) {
// //         areaDraftRef.current.setAttribute('width', 0);
// //         areaDraftRef.current.setAttribute('height', 0);
// //       }

// //       setQuickInput((state) => ({ ...state, open: false, value: '' }));
// //     }, []);

// //     /** NOVO: confirma criação rápida do link ao pressionar Enter */
// //     const handleQuickInputConfirm = useCallback(
// //       (rawValue) => {
// //         const value = String(rawValue || '').trim();
// //         if (!value) {
// //           handleQuickInputCancel();
// //           return;
// //         }

// //         // normalização “01” === “1”
// //         const norm = (v) => {
// //           const n = Number(v);
// //           return Number.isNaN(n) ? String(v).trim() : String(n);
// //         };

// //         const data = table.find((it) => norm(it.idItem) === norm(value));

// //         if (!data) {
// //           toast.info('Item não encontrado na lista desta página.');
// //           return;
// //         }

// //         /**
// //          * Se o usuário desenhou a área por arraste, o retângulo dele manda:
// //          * cria direto nessa geometria e ignora o casamento por OCR (que
// //          * reposicionaria o link para onde o texto foi detectado).
// //          */
// //         if (areaPendenteRef.current) {
// //           oCriarLinkNoPonto({ data, area: areaPendenteRef.current });
// //           areaPendenteRef.current = null;

// //           oCheckAssociation();
// //           oCheckConflict();
// //           oRegistrarHistorico();
// //           setQuickInput((state) => ({ ...state, open: false, value: '' }));

// //           return;
// //         }

// //         // tenta casar com OCR primeiro
// //         const dotted = ocrMappingRef.current.filter(
// //           (item) => norm(item.ocr.text) === norm(data.idItem)
// //         );

// //         if (dotted.length) {
// //           dotted.forEach(({ attr, ocr }) => {
// //             const ancoraX = Number(attr.childNodes[0].getAttribute('x'));
// //             const ancoraY = Number(attr.childNodes[0].getAttribute('y'));

// //             oCriarLinkNoPonto({
// //               data,
// //               legadoX: ancoraX - 10,
// //               legadoY: ancoraY + 10,
// //               centroX: Number(ocr && ocr.x) || ancoraX,
// //               centroY: Number(ocr && ocr.y) || ancoraY,
// //               ocr,
// //             });

// //             // remove overlay correspondente
// //             const mappingIndex = ocrMappingRef.current.findIndex(
// //               (findAttr) => findAttr.attr.id === attr.id
// //             );
// //             if (mappingIndex !== -1) {
// //               ocrMappingRef.current.splice(mappingIndex, 1);
// //             }
// //             oRemove(attr).remove();
// //           });
// //         } else {
// //           // cria no ponto clicado
// //           oCriarLinkNoPonto({
// //             data,
// //             legadoX: quickInput.svgX - 15,
// //             legadoY: quickInput.svgY + 2,
// //             centroX: quickInput.svgX,
// //             centroY: quickInput.svgY,
// //           });
// //         }

// //         // pós-criação
// //         oCheckAssociation();
// //         oCheckConflict();
// //         setQuickInput((s) => ({ ...s, open: false, value: '' }));
// //       },
// //       [
// //         table,
// //         editor,
// //         createLink,
// //         quickInput.svgX,
// //         quickInput.svgY,
// //         oRemove,
// //         oCheckAssociation,
// //         oCheckConflict,
// //       ]
// //     );

// //     /* =================================================================
// //        HISTÓRICO (desfazer / refazer)
// //        -----------------------------------------------------------------
// //        Guarda snapshots do innerHTML do grupo de links. Restaurar o HTML
// //        descarta os listeners dos elementos, então após cada restauração o
// //        mapeamento é reconstruído com mappingElement.

// //        O limite evita crescimento indefinido em páginas com muitos itens.
// //        ================================================================= */
// //     const HISTORICO_LIMITE = 40;
// //     const historicoRef = useRef([]);
// //     const historicoPosRef = useRef(-1);
// //     const [historicoInfo, setHistoricoInfo] = useState({
// //       podeDesfazer: false,
// //       podeRefazer: false,
// //     });

// //     const oGetLinkGroup = useCallback(() => {
// //       if (linkRef.current && linkRef.current.parentNode) return linkRef.current;

// //       const grupo = document.getElementById('linkGroup');
// //       if (grupo) linkRef.current = grupo;

// //       return grupo || null;
// //     }, []);

// //     const oAtualizarHistoricoInfo = useCallback(() => {
// //       setHistoricoInfo({
// //         podeDesfazer: historicoPosRef.current > 0,
// //         podeRefazer:
// //           historicoPosRef.current >= 0 &&
// //           historicoPosRef.current < historicoRef.current.length - 1,
// //       });
// //     }, []);

// //     /** reconstrói o mapeamento e os listeners depois de restaurar o HTML */
// //     const oRemapearLinks = useCallback(() => {
// //       const grupo = oGetLinkGroup();
// //       if (!grupo) return;

// //       selectedRef.current = [];
// //       focusRef.current = null;
// //       linkMappingRef.current = [];

// //       mappingElement(grupo.childNodes);

// //       oCheckAssociation();
// //       oCheckConflict();
// //       // eslint-disable-next-line react-hooks/exhaustive-deps
// //     }, [oGetLinkGroup, mappingElement, oCheckAssociation, oCheckConflict]);

// //     /** registra o estado atual no histórico */
// //     const oRegistrarHistorico = useCallback(() => {
// //       const grupo = oGetLinkGroup();
// //       if (!grupo) return;

// //       const snapshot = grupo.innerHTML;

// //       /** primeira chamada: guarda o estado inicial */
// //       if (historicoPosRef.current < 0) {
// //         historicoRef.current = [snapshot];
// //         historicoPosRef.current = 0;
// //         oAtualizarHistoricoInfo();
// //         return;
// //       }

// //       /** nada mudou desde o último registro */
// //       if (historicoRef.current[historicoPosRef.current] === snapshot) return;

// //       /** descarta o "futuro" quando há uma nova ação após um desfazer */
// //       historicoRef.current = historicoRef.current.slice(
// //         0,
// //         historicoPosRef.current + 1
// //       );

// //       historicoRef.current.push(snapshot);

// //       if (historicoRef.current.length > HISTORICO_LIMITE) {
// //         historicoRef.current.shift();
// //       }

// //       historicoPosRef.current = historicoRef.current.length - 1;
// //       oAtualizarHistoricoInfo();
// //     }, [oGetLinkGroup, oAtualizarHistoricoInfo]);

// //     const oAplicarHistorico = useCallback(
// //       (posicao) => {
// //         const grupo = oGetLinkGroup();
// //         if (!grupo) return;

// //         const snapshot = historicoRef.current[posicao];
// //         if (snapshot === undefined) return;

// //         grupo.innerHTML = snapshot;
// //         historicoPosRef.current = posicao;

// //         oRemapearLinks();
// //         oAtualizarHistoricoInfo();
// //       },
// //       [oGetLinkGroup, oRemapearLinks, oAtualizarHistoricoInfo]
// //     );

// //     const handleDesfazer = useCallback(() => {
// //       if (historicoPosRef.current <= 0) return;
// //       oAplicarHistorico(historicoPosRef.current - 1);
// //     }, [oAplicarHistorico]);

// //     const handleRefazer = useCallback(() => {
// //       if (historicoPosRef.current >= historicoRef.current.length - 1) return;
// //       oAplicarHistorico(historicoPosRef.current + 1);
// //     }, [oAplicarHistorico]);

// //     const handleMouseUp = useCallback(
// //       (e) => {
// //         if (selectingRef && selectingRef.current) {
// //           const m = oMousePosSVG(e);
// //           /** guarda a ação atual antes de limpar */
// //           const currentAction = actionRef.current;

// //           oClearSelector();

// //           // switch (actionRef.current) {
// //           switch (currentAction) {
// //             case ACTION_STATE.select:
// //               break;

// //             /** conclui o arraste e cria o link do item da sequência */
// //             case ACTION_STATE.createArea: {
// //               const item = itemSequenciaRef.current;

// //               /**
// //                * Lê de areaStartRef: o oClearSelector() acima já zerou o
// //                * startCoordRef, que pertence ao seletor do OCR.
// //                */
// //               const inicio = areaStartRef.current || { x: m.x, y: m.y };

// //               const x = Math.min(inicio.x, m.x);
// //               const y = Math.min(inicio.y, m.y);
// //               const largura = Math.abs(m.x - inicio.x);
// //               const altura = Math.abs(m.y - inicio.y);

// //               /** limpa o retângulo temporário */
// //               if (areaDraftRef.current) {
// //                 areaDraftRef.current.setAttribute('width', 0);
// //                 areaDraftRef.current.setAttribute('height', 0);
// //               }

// //               const arrastouOSuficiente =
// //                 largura >= LINK_AREA_SIZE_LIMIT.min &&
// //                 altura >= LINK_AREA_SIZE_LIMIT.min;

// //               if (item && arrastouOSuficiente) {
// //                 /** modo sequência: item já definido, cria e avança */
// //                 oCriarLinkArea(item, x, y, largura, altura);
// //                 oAvancarSequencia(item.idItem);
// //                 oRegistrarHistorico();
// //               } else if (item) {
// //                 /**
// //                  * Arraste muito pequeno: cria a área com o tamanho padrão
// //                  * centrada no ponto clicado, em vez de descartar a ação.
// //                  */
// //                 oCriarLinkArea(
// //                   item,
// //                   m.x - INITIAL_LINK_AREA.width / 2,
// //                   m.y - INITIAL_LINK_AREA.height / 2,
// //                   INITIAL_LINK_AREA.width,
// //                   INITIAL_LINK_AREA.height
// //                 );
// //                 oAvancarSequencia(item.idItem);
// //                 oRegistrarHistorico();
// //               } else if (arrastouOSuficiente) {
// //                 /**
// //                  * Fora do modo sequência não há item alvo: guarda o retângulo
// //                  * desenhado e pede o ID do item no input rápido. O tamanho
// //                  * usado será o do arraste, não o padrão.
// //                  */
// //                 areaPendenteRef.current = { x, y, largura, altura };

// //                 const host = editorAreaRef.current || e.currentTarget;
// //                 const rect = host.getBoundingClientRect();

// //                 setQuickInput({
// //                   open: true,
// //                   x: e.clientX - rect.left,
// //                   y: e.clientY - rect.top,
// //                   svgX: x + largura / 2,
// //                   svgY: y + altura / 2,
// //                   value: '',
// //                 });
// //               }

// //               areaStartRef.current = null;
// //               break;
// //             }

// //             /** conclui o arraste da etiqueta */
// //             case ACTION_STATE.moveRotulo:
// //               if (rotuloDragRef.current) {
// //                 oReancorarChamada(rotuloDragRef.current);
// //               }
// //               oCheckConflict();
// //               oRegistrarHistorico();
// //               break;
// //             case ACTION_STATE.move:
// //             case ACTION_STATE.moveOne:
// //               /** atualiza posições do mapeamento OCR */
// //               if (ocrMappingRef.current && !!ocrMappingRef.current.length) {
// //                 selectedRef.current.forEach((itemSelecionado) => {
// //                   const itemIndex = ocrMappingRef.current.findIndex(
// //                     (itemOCR) =>
// //                       String(itemOCR.attr.id) ===
// //                       String(itemSelecionado.node.id)
// //                   );

// //                   if (itemIndex >= 0) {
// //                     const { attr, ocr } = ocrMappingRef.current[itemIndex];

// //                     ocrMappingRef.current[itemIndex] = {
// //                       attr,
// //                       ocr: { ...ocr, x: m.x, y: m.y },
// //                     };
// //                   }
// //                 });
// //               }

// //               /** verifica conflitos */
// //               oCheckConflict();
// //               oRegistrarHistorico();
// //               break;
// //             default:
// //               break;
// //           }

// //           /** NOVO: clique simples em área vazia → abre input */
// //           const isLink = isAlvoLink(e.target);
// //           const { shiftKey, ctrlKey, altKey } = e;

// //           /**
// //            * O duplo clique só abre o input rápido fora do modo sequência —
// //            * nesse modo o gesto de criação é o próprio arraste.
// //            */
// //           if (
// //             !isLink &&
// //             !modoSequenciaRef.current &&
// //             !shiftKey &&
// //             !ctrlKey &&
// //             !altKey &&
// //             e.detail === 2
// //           ) {
// //             const host = editorAreaRef.current || e.currentTarget;
// //             const rect = host.getBoundingClientRect();
// //             setQuickInput({
// //               open: true,
// //               x: e.clientX - rect.left,
// //               y: e.clientY - rect.top,
// //               svgX: m.x,
// //               svgY: m.y,
// //               value: '',
// //             });
// //           }

// //           actionRef.current = null;
// //           selectingRef.current = false;
// //           rotuloDragRef.current = null;

// //           /** desbloqueia movimento da imagem */
// //           setZoomCanMove(true);
// //         }
// //       },
// //       // eslint-disable-next-line react-hooks/exhaustive-deps
// //       [
// //         ACTION_STATE,
// //         oMousePosSVG,
// //         oClearSelector,
// //         oCheckConflict,
// //         oCriarLinkArea,
// //         oAvancarSequencia,
// //         oReancorarChamada,
// //         isAlvoLink,
// //         oRegistrarHistorico,
// //       ]
// //     );

// //     const handleRemove = useCallback(() => {
// //       try {
// //         /** percorre elementos selecionados */
// //         selectedRef.current.forEach((s) => {
// //           /** remove elemento do mapeamento ORC */
// //           const mappingORCIndex = ocrMappingRef.current.findIndex(
// //             (m) => m.attr.id === s.node.id
// //           );

// //           if (mappingORCIndex !== -1)
// //             ocrMappingRef.current.splice(mappingORCIndex, 1);

// //           /** remove elemento do mapeamento principal */
// //           const mappingIndex = linkMappingRef.current.findIndex(
// //             (m) => m.id === s.node.id
// //           );

// //           if (mappingIndex !== -1)
// //             linkMappingRef.current.splice(mappingIndex, 1);

// //           /** verifica o nível para eliminar o elemento pai */
// //           oRemove(s.node).remove();
// //         });

// //         /** verifica associações */
// //         oCheckAssociation();

// //         /** verifica conflito */
// //         oCheckConflict();

// //         /** registra no histórico de desfazer/refazer */
// //         oRegistrarHistorico();

// //         oClearSelection();
// //       } catch (err) {
// //         /** erro */
// //         toast.error(`Ops! Ocorreu um problema. ${err}`);
// //       }
// //     }, [
// //       selectedRef,
// //       ocrMappingRef,
// //       oRemove,
// //       oCheckAssociation,
// //       oCheckConflict,
// //       oClearSelection,
// //     ]);

// //     const handlePosition = useCallback(
// //       (x, y) => {
// //         const { baseVal } = rootRef.current.transform;
// //         const baseIndex = Array.from(baseVal).findIndex((e) => e.type === 1);

// //         let transformMatrix = null;
// //         if (baseIndex >= 0) {
// //           const { matrix } = baseVal.getItem(baseIndex);
// //           transformMatrix = matrix;
// //         }

// //         if (!transformMatrix)
// //           transformMatrix = svgRef.current.createSVGMatrix();

// //         // matrix translate
// //         transformMatrix.e = rootXRef.current + x;
// //         transformMatrix.f = rootYRef.current + y;

// //         rootXRef.current += x;
// //         rootYRef.current += y;

// //         const transform = baseVal.createSVGTransformFromMatrix(transformMatrix);
// //         baseVal.clear();
// //         baseVal.appendItem(transform);
// //       },
// //       [rootRef, svgRef, rootXRef, rootYRef]
// //     );

// //     const handleCenter = useCallback(
// //       (initial = false) => {
// //         const { baseVal } = rootRef.current.transform;
// //         const baseIndex = Array.from(baseVal).findIndex((e) => e.type === 1);

// //         let transformMatrix = null;
// //         if (baseIndex >= 0) {
// //           if (initial) return;

// //           const { matrix } = baseVal.getItem(baseIndex);
// //           transformMatrix = matrix;
// //         }

// //         if (!transformMatrix)
// //           transformMatrix = svgRef.current.createSVGMatrix();

// //         const {
// //           height: svgHeight,
// //           width: svgWidth,
// //         } = svgRef.current.getBoundingClientRect();

// //         const {
// //           height: rootHeight,
// //           width: rootWidth,
// //         } = rootRef.current.getBoundingClientRect();

// //         const svgPosX = Math.trunc(svgWidth / 2);
// //         const svgPosY = Math.trunc(svgHeight / 2);

// //         const rootPosX = Math.trunc(rootWidth / 2);
// //         const rootPosY = Math.trunc(rootHeight / 2);

// //         const x = svgPosX - rootPosX;
// //         const y = svgPosY - rootPosY;

// //         // translate
// //         transformMatrix.e = x;
// //         transformMatrix.f = y;

// //         rootXRef.current = x;
// //         rootYRef.current = y;

// //         const transform = baseVal.createSVGTransformFromMatrix(transformMatrix);
// //         baseVal.clear();
// //         baseVal.appendItem(transform);
// //       },
// //       [svgRef, rootRef]
// //     );

// //     const handleLandscape = useCallback(() => {
// //       const width = 874;
// //       const height = 614;
// //       const viewBox = `0 0 ${width} ${height}`;

// //       svgRef.current.setAttribute('width', width);
// //       svgRef.current.setAttribute('height', height);
// //       svgRef.current.setAttribute('viewBox', viewBox);
// //       svgRef.current.setAttribute('data-guid', 'landscape');

// //       /** centraliza automaticamente */
// //       if (pdfTool) {
// //         handleCenterPdfProcess();
// //       } else {
// //         handleCenter();
// //       }
// //     }, [handleCenter, handleCenterPdfProcess, pdfTool]);

// //     const handlePortrait = useCallback(() => {
// //       const width = 614;
// //       const height = 874;
// //       const viewBox = `0 0 ${width} ${height}`;

// //       svgRef.current.setAttribute('width', width);
// //       svgRef.current.setAttribute('height', height);
// //       svgRef.current.setAttribute('viewBox', viewBox);
// //       svgRef.current.setAttribute('data-guid', 'portrait');

// //       /** centraliza automaticamente */
// //       if (pdfTool) {
// //         handleCenterPdfProcess();
// //       } else {
// //         handleCenter();
// //       }
// //     }, [handleCenter, handleCenterPdfProcess, pdfTool]);

// //     const handleScale = useCallback(
// //       (value) => {
// //         const { baseVal } = rootRef.current.transform;
// //         const baseIndex = Array.from(baseVal).findIndex((e) => e.type === 1);

// //         let transformMatrix = null;
// //         if (baseIndex >= 0) {
// //           const { matrix } = baseVal.getItem(baseIndex);
// //           transformMatrix = matrix;
// //         }

// //         if (!transformMatrix)
// //           transformMatrix = svgRef.current.createSVGMatrix();

// //         // matrix scale
// //         transformMatrix.a = rootScaleRef.current + value;
// //         transformMatrix.d = rootScaleRef.current + value;

// //         rootScaleRef.current += value;

// //         const transform = baseVal.createSVGTransformFromMatrix(transformMatrix);
// //         baseVal.clear();
// //         baseVal.appendItem(transform);

// //         /** centraliza automaticamente */
// //         handleCenter();
// //       },
// //       [rootRef, svgRef, rootScaleRef, handleCenter]
// //     );

// //     const handleResize = useCallback(() => {
// //       const currentGuid = svgRef.current.getAttribute('data-guid');
// //       const currentWidth = svgRef.current.getAttribute('width');
// //       const currentHeight = svgRef.current.getAttribute('height');

// //       const width = currentGuid ? currentWidth : 614;
// //       const height = currentGuid ? currentHeight : 874;
// //       const dataGuid = currentGuid || 'portrait';

// //       const viewBox = `0 0 ${width} ${height}`;

// //       svgRef.current.setAttribute('width', width);
// //       svgRef.current.setAttribute('height', height);
// //       svgRef.current.setAttribute('viewBox', viewBox);
// //       svgRef.current.setAttribute('data-guid', dataGuid);
// //     }, []);

// //     /** define o tamanho do item para o valor passado */
// //     const handleLinkScale = useCallback(
// //       (valueH, valueW, link) => {
// //         /** define os elementos de texto e formato do item */
// //         const linkForm = link.childNodes[0];
// //         const linkText = link.childNodes[1];

// //         const { id: tipo = null } = linkForm.dataset || {};

// //         switch (Number(tipo)) {
// //           case LINK_FORM_TYPES.circle: {
// //             /** validação */
// //             const newSize = Number(valueH);
// //             const dh = newSize - Number(linkForm.getAttribute('r'));
// //             const xF = Number(linkForm.getAttribute('cx'));
// //             const yF = Number(linkForm.getAttribute('cy'));

// //             linkForm.setAttribute('r', newSize);
// //             linkForm.setAttribute('x', xF - dh / 2);
// //             linkForm.setAttribute('y', yF - dh / 2);

// //             /** com o rótulo "nenhum" o link não tem <text> */
// //             if (linkText) linkText.setAttribute('font-size', `${newSize}px`);
// //             break;
// //           }
// //           case LINK_FORM_TYPES.rect: {
// //             const newSizeH = Number(valueH);
// //             const newSizeW = Number(valueW) || 0;

// //             const currWidth = Number(linkForm.getAttribute('width'));
// //             const currHeight = Number(linkForm.getAttribute('height'));

// //             const dh = currHeight - newSizeH;
// //             const dw = currWidth - newSizeW;
// //             const xF = Number(linkForm.getAttribute('x'));
// //             const yF = Number(linkForm.getAttribute('y'));

// //             linkForm.setAttribute('height', newSizeH);
// //             linkForm.setAttribute('width', newSizeW);

// //             linkForm.setAttribute('x', xF + dw / 2);
// //             linkForm.setAttribute('y', yF + dh / 2);

// //             /** atualiza tamanho do texto */
// //             if (linkText) {
// //               linkText.setAttribute(
// //                 'font-size',
// //                 `${Math.trunc(newSizeH / 2)}px`
// //               );
// //             }

// //             break;
// //           }
// //           /**
// //            * Área: redimensiona mantendo o centro. O rótulo é reposicionado
// //            * conforme o tipo: o código acompanha o centro da área e a
// //            * etiqueta permanece onde o usuário deixou, apenas com a linha de
// //            * chamada reancorada.
// //            */
// //           case LINK_FORM_TYPES.area: {
// //             const limite = LINK_AREA_SIZE_LIMIT;

// //             const novaH = Math.max(
// //               limite.min,
// //               Math.min(limite.max, Number(valueH) || 0)
// //             );
// //             const novaW = Math.max(
// //               limite.min,
// //               Math.min(limite.max, Number(valueW) || Number(valueH) || 0)
// //             );

// //             const currW = Number(linkForm.getAttribute('width'));
// //             const currH = Number(linkForm.getAttribute('height'));
// //             const xF = Number(linkForm.getAttribute('x'));
// //             const yF = Number(linkForm.getAttribute('y'));

// //             linkForm.setAttribute('width', novaW);
// //             linkForm.setAttribute('height', novaH);
// //             linkForm.setAttribute('x', xF + (currW - novaW) / 2);
// //             linkForm.setAttribute('y', yF + (currH - novaH) / 2);

// //             const rotuloAtual =
// //               (link.dataset && link.dataset.rotulo) || opLinkRotulo.CODIGO;

// //             if (rotuloAtual === opLinkRotulo.CODIGO && linkText) {
// //               const caixa = getCaixaForma(linkForm);
// //               linkText.setAttribute('x', caixa.x + caixa.width / 2);
// //               linkText.setAttribute('y', caixa.y + caixa.height / 2);
// //             }

// //             if (rotuloAtual === opLinkRotulo.ETIQUETA) {
// //               oReancorarChamada(link);
// //             }

// //             break;
// //           }
// //           case LINK_FORM_TYPES.ocr:
// //             break;
// //           default:
// //             break;
// //         }

// //         /** verifica conflito */
// //         oCheckConflict();
// //       },
// //       // eslint-disable-next-line react-hooks/exhaustive-deps
// //       [LINK_FORM_TYPES, oCheckConflict, oReancorarChamada]
// //     );

// //     const handleLink = useCallback(() => {
// //       const uniq = uniqBy(table, 'idItem');
// //       uniq.forEach((item) => {
// //         oLink(item);
// //       });
// //       handleOCRLimpar();

// //       /** registra no histórico de desfazer/refazer */
// //       oRegistrarHistorico();
// //       // eslint-disable-next-line react-hooks/exhaustive-deps
// //     }, [table, oLink, handleOCRLimpar]);

// //     const handleRotate = useCallback((value) => {
// //       const { baseVal } = rootRef.current.transform;
// //       const i = Array.from(baseVal).findIndex((e) => e.type === 4);
// //       let rotate;

// //       if (i > 0) {
// //         rotate = baseVal.getItem(i);
// //       } else {
// //         rotate = svgRef.current.createSVGTransform();
// //         baseVal.appendItem(rotate);
// //       }

// //       rootRotateRef.current += value;
// //       if (rootRotateRef.current >= 360 || rootRotateRef.current < 0)
// //         rootRotateRef.current = 0;

// //       rotate.setRotate(
// //         rootRotateRef.current,
// //         rootXRef.current,
// //         rootYRef.current
// //       );
// //     }, []);

// //     /**
// //      * Nudge: move os links selecionados em passos finos.
// //      *
// //      * As setas sem modificador passam a mover a SELEÇÃO; Shift+setas
// //      * continua movendo a página inteira, como antes.
// //      */
// //     const handleNudgeSelecao = useCallback(
// //       (dx, dy) => {
// //         if (!selectedRef.current.length) return false;

// //         selectedRef.current.forEach((element) => {
// //           transladarLink(element.node, dx, dy);

// //           const rotuloAtual =
// //             (element.node.dataset && element.node.dataset.rotulo) ||
// //             opLinkRotulo.CODIGO;

// //           if (rotuloAtual === opLinkRotulo.ETIQUETA) {
// //             oReancorarChamada(element.node);
// //           }
// //         });

// //         oCheckConflict();
// //         oRegistrarHistorico();

// //         return true;
// //       },
// //       [oCheckConflict, oRegistrarHistorico, oReancorarChamada]
// //     );

// //     /** rótulos legíveis das opções de rótulo, usados nos títulos dos botões */
// //     const LABEL_ROTULO = {
// //       [opLinkRotulo.CODIGO]: 'código dentro da forma',
// //       [opLinkRotulo.NENHUM]: 'sem rótulo',
// //       [opLinkRotulo.ETIQUETA]: 'etiqueta com linha de chamada',
// //     };

// //     /** alterna ciclicamente entre os três tipos de rótulo */
// //     const handleAlternarRotulo = useCallback(() => {
// //       const ordem = [
// //         opLinkRotulo.CODIGO,
// //         opLinkRotulo.NENHUM,
// //         opLinkRotulo.ETIQUETA,
// //       ];

// //       setCurrLinkRotulo((atual) => {
// //         const proximo = ordem[(ordem.indexOf(atual) + 1) % ordem.length];
// //         currLinkRotuloRef.current = proximo;
// //         return proximo;
// //       });
// //     }, []);

// //     /**
// //      * Liga/desliga o modo sequência. Ao ligar, seleciona automaticamente a
// //      * geometria de área e o primeiro item pendente; ao desligar, devolve o
// //      * pan da imagem.
// //      */
// //     const handleAlternarModoSequencia = useCallback(() => {
// //       setModoSequencia((atual) => {
// //         const proximo = !atual;
// //         modoSequenciaRef.current = proximo;

// //         if (proximo) {
// //           currLinkTypeRef.current = INITIAL_LINK_AREA;
// //           setCurrLinkType(LINK_FORM_TYPES.area);
// //           oAvancarSequencia();
// //         } else {
// //           itemSequenciaRef.current = null;
// //           setItemSequencia(null);
// //           setZoomCanMove(true);
// //         }

// //         return proximo;
// //       });
// //       // eslint-disable-next-line react-hooks/exhaustive-deps
// //     }, [oAvancarSequencia]);

// //     /** seleciona manualmente o item alvo da sequência */
// //     const handleSelecionarItemSequencia = useCallback((item) => {
// //       itemSequenciaRef.current = item || null;
// //       setItemSequencia(item || null);
// //     }, []);

// //     /**
// //      * ===================================================================
// //      * MODOS ALTERNADOS POR ATALHO
// //      * -------------------------------------------------------------------
// //      * Antes o Alt+Z e o Alt+S existiam SOMENTE como atalho, cada um com
// //      * "setTimeout(..., 200)" dentro do handler de teclado. Com a tecla
// //      * repetindo (keydown dispara em série enquanto pressionada), vários
// //      * timers eram enfileirados, cada um invertendo o estado — o painel
// //      * piscava e terminava aberto ou fechado de forma imprevisível.
// //      *
// //      * Agora a alternância está em um handler único, imediato e sem timer,
// //      * usado tanto pelo atalho quanto por um botão na barra de ferramentas.
// //      * ===================================================================
// //      */

// //     /** Alt+Z: liga/desliga o modo de zoom da página */
// //     const handleAlternarZoom = useCallback(() => {
// //       const proximo = !zoomControlRef.current;

// //       /** ao SAIR do modo, devolve a página à escala/posição original */
// //       if (!proximo && zoomResetRef.current && zoomResetRef.current.click) {
// //         zoomResetRef.current.click();
// //       }

// //       zoomControlRef.current = proximo;
// //       setZoomControl(proximo);

// //       return proximo;
// //     }, []);

// //     /** Alt+S: liga/desliga a edição de tamanho (H/W) dos links */
// //     const handleAlternarTamanho = useCallback(() => {
// //       const proximo = !sizeControlRef.current;

// //       sizeControlRef.current = proximo;
// //       setSizeControl(proximo);

// //       return proximo;
// //     }, []);

// //     /** legenda de atalhos: botão "?" da barra e teclas "?" / F1 */
// //     const handleAlternarAtalhos = useCallback(() => {
// //       const proximo = !atalhosAbertoRef.current;

// //       atalhosAbertoRef.current = proximo;
// //       setAtalhosAberto(proximo);

// //       return proximo;
// //     }, []);

// //     /**
// //      * Remoção dos links selecionados.
// //      *
// //      * Usada pelo Del/Backspace e pelo botão da barra. O handleRemove cru
// //      * não dá retorno visual nenhum: sem seleção ele apenas não faz nada,
// //      * e o usuário não sabia se o atalho existia ou se havia falhado. Aqui
// //      * o resultado é sempre informado.
// //      */
// //     const handleRemoverSelecao = useCallback(() => {
// //       const total =
// //         selectedRef.current && selectedRef.current.length
// //           ? selectedRef.current.length
// //           : 0;

// //       if (!total) {
// //         toast.info('Selecione um link no desenho para remover.');
// //         return false;
// //       }

// //       handleRemove();

// //       toast.success(
// //         total === 1 ? 'Link removido.' : `${total} links removidos.`
// //       );

// //       return true;
// //     }, [handleRemove]);

// //     /**
// //      * ===================================================================
// //      * ATALHOS DE TECLADO
// //      * -------------------------------------------------------------------
// //      * Regras aplicadas:
// //      *
// //      * 1. O preventDefault NÃO é mais aplicado a toda e qualquer tecla.
// //      *    Antes, com o desenho em foco, o navegador perdia F5, Ctrl+C e o
// //      *    próprio Tab. Agora só a tecla efetivamente tratada é consumida.
// //      *
// //      * 2. Alt "puro": em teclado ABNT2 o AltGr chega como Ctrl+Alt. Sem a
// //      *    checagem de !ctrlKey, combinações de AltGr disparavam os modos
// //      *    por engano.
// //      *
// //      * 3. e.repeat é ignorado nos comandos que alternam estado, para a
// //      *    tecla presa não inverter o modo várias vezes.
// //      * ===================================================================
// //      */
// //     const handleKeyDown = useCallback(
// //       (e) => {
// //         /** consome a tecla apenas quando o atalho é realmente tratado */
// //         const tratado = () => {
// //           e.preventDefault();
// //           e.stopPropagation();
// //         };

// //         /** Alt sem Ctrl e sem Shift (AltGr do ABNT2 vem como Ctrl+Alt) */
// //         const somenteAlt = e.altKey && !e.ctrlKey && !e.shiftKey;

// //         /** legenda: "?" independe do layout do teclado; F1 é o atalho usual */
// //         if (e.key === '?' || e.keyCode === 112) {
// //           tratado();
// //           if (!e.repeat) handleAlternarAtalhos();
// //           return;
// //         }

// //         if (svgRef.current) {
// //           switch (e.keyCode) {
// //             /** 17: ctrl */
// //             case 17:
// //               break;
// //             /** 16: shift */
// //             case 16:
// //               break;
// //             /** 18: alt */
// //             case 18:
// //               break;
// //             /**
// //              * 46: delete | 8: backspace.
// //              * O Backspace passa a valer porque é a tecla que o usuário
// //              * tenta naturalmente; sem tratá-la o navegador ainda podia
// //              * interpretar como "voltar página".
// //              */
// //             case 46:
// //             case 8:
// //               tratado();
// //               handleRemoverSelecao();
// //               break;
// //             /**
// //              * 27: esc.
// //              *
// //              * Ordem de prioridade: legenda aberta > seleção. Com a legenda
// //              * aberta o evento é consumido (só ela fecha). Sem legenda, a
// //              * seleção é limpa e o evento SEGUE subindo de propósito, para
// //              * a tela poder sair do modo tela cheia no mesmo Esc (ver o
// //              * listener de window em pages/EditorAI).
// //              */
// //             case 27:
// //               if (atalhosAbertoRef.current) {
// //                 tratado();
// //                 handleAlternarAtalhos();
// //               } else {
// //                 e.preventDefault();
// //                 oClearSelection();
// //               }
// //               break;
// //             /**
// //              * 37,38,39,40: setas.
// //              * Shift+seta continua movendo a PÁGINA (comportamento antigo).
// //              * Seta sozinha faz o ajuste fino do(s) link(s) selecionado(s);
// //              * Ctrl+seta usa passo maior. Sem seleção, nada acontece.
// //              */
// //             case 37:
// //               tratado();
// //               if (e.shiftKey) handlePosition(-10, 0);
// //               else handleNudgeSelecao(e.ctrlKey ? -5 : -1, 0);
// //               break;
// //             case 38:
// //               tratado();
// //               if (e.shiftKey) handlePosition(0, -10);
// //               else handleNudgeSelecao(0, e.ctrlKey ? -5 : -1);
// //               break;
// //             case 39:
// //               tratado();
// //               if (e.shiftKey) handlePosition(10, 0);
// //               else handleNudgeSelecao(e.ctrlKey ? 5 : 1, 0);
// //               break;
// //             case 40:
// //               tratado();
// //               if (e.shiftKey) handlePosition(0, 10);
// //               else handleNudgeSelecao(0, e.ctrlKey ? 5 : 1);
// //               break;
// //             case 83:
// //               /** Alt+S: edição de tamanho do link */
// //               if (somenteAlt) {
// //                 tratado();
// //                 if (!e.repeat) handleAlternarTamanho();
// //               }
// //               break;
// //             case 90:
// //               /** Alt+Z: modo de zoom da página */
// //               if (somenteAlt) {
// //                 tratado();
// //                 if (!e.repeat) handleAlternarZoom();
// //               }
// //               /** Ctrl+Z: desfazer / Ctrl+Shift+Z: refazer */
// //               if (e.ctrlKey && !e.altKey) {
// //                 tratado();
// //                 if (e.shiftKey) handleRefazer();
// //                 else handleDesfazer();
// //               }
// //               break;
// //             case 89:
// //               /** Ctrl+Y: refazer */
// //               if (e.ctrlKey && !e.altKey) {
// //                 tratado();
// //                 handleRefazer();
// //               }
// //               break;
// //             case 65:
// //               /** Alt+A: liga/desliga o modo sequência */
// //               if (somenteAlt) {
// //                 tratado();
// //                 if (!e.repeat) handleAlternarModoSequencia();
// //               }
// //               break;
// //             case 187:
// //               /** Shift+'=' */
// //               if (e.shiftKey) {
// //                 tratado();
// //                 handleScale(0.1);
// //               }
// //               break;
// //             case 189:
// //               /** Shift+'-' */
// //               if (e.shiftKey) {
// //                 tratado();
// //                 handleScale(-0.1);
// //               }
// //               break;
// //             default:
// //               break;
// //           }
// //         }
// //       },
// //       [
// //         handlePosition,
// //         handleScale,
// //         handleRemoverSelecao,
// //         handleNudgeSelecao,
// //         handleDesfazer,
// //         handleRefazer,
// //         handleAlternarModoSequencia,
// //         handleAlternarZoom,
// //         handleAlternarTamanho,
// //         handleAlternarAtalhos,
// //         oClearSelection,
// //       ]
// //     );

// //     /** limpa referências de controles */
// //     const handleKeyUp = useCallback(() => {
// //       if (svgRef.current) {
// //         selectingRef.current = false;

// //         if (actionRef.current) {
// //           actionRef.current = null;
// //         }

// //         if (controlRef.current) {
// //           controlRef.current = null;
// //         }
// //       }
// //     }, [svgRef, actionRef]);

// //     /**
// //      * ===================================================================
// //      * TECLADO: HANDLER SEMPRE ATUAL
// //      * -------------------------------------------------------------------
// //      * O elemento <SVG> é memoizado por [editor.pageNum, editor.path] (ver
// //      * editorSvg mais abaixo). Como consequência, o onKeyDown/onKeyUp
// //      * fixado no DOM é o da renderização em que a página foi carregada —
// //      * um fechamento CONGELADO.
// //      *
// //      * Era a causa de o Alt+Z não devolver a escala da página: o handler
// //      * antigo lia um zoomControl que nunca mudava. Todo handler novo
// //      * dependente de estado sofreria do mesmo problema.
// //      *
// //      * A indireção abaixo mantém a identidade estável para o useMemo (o
// //      * SVG não é reinjetado a cada tecla) e ainda assim executa sempre a
// //      * versão mais recente do handler.
// //      * ===================================================================
// //      */
// //     const keyDownRef = useRef(handleKeyDown);
// //     const keyUpRef = useRef(handleKeyUp);

// //     keyDownRef.current = handleKeyDown;
// //     keyUpRef.current = handleKeyUp;

// //     const onKeyDownEstavel = useCallback((e) => {
// //       if (keyDownRef.current) keyDownRef.current(e);
// //     }, []);

// //     const onKeyUpEstavel = useCallback((e) => {
// //       if (keyUpRef.current) keyUpRef.current(e);
// //     }, []);

// //     const handleControlClose = useCallback(
// //       (control) => {
// //         switch (control) {
// //           case 'zoomAnimControl':
// //             if (zoomControl && zoomResetRef.current) {
// //               zoomResetRef.current.click();
// //               setTimeout(() => setZoomControl((state) => !state), 200);
// //             }
// //             break;
// //           case 'sizeAnimControl':
// //             if (sizeControl) {
// //               setTimeout(() => setSizeControl((state) => !state), 200);
// //             }
// //             break;
// //           case 'all':
// //             if (zoomControl && zoomResetRef.current) {
// //               zoomResetRef.current.click();
// //               setTimeout(() => setZoomControl((state) => !state), 200);
// //             }
// //             if (sizeControl) {
// //               setTimeout(() => setSizeControl((state) => !state), 200);
// //             }
// //             break;
// //           default:
// //             break;
// //         }
// //       },
// //       [zoomControl, sizeControl]
// //     );

// //     const handleSizeEdit = useCallback(
// //       (valueH, valueW = 0, incremental = true) => {
// //         /** controle de alteração de tamanho */
// //         let newSizeH = 0;
// //         let newSizeW = 0;

// //         /** contagem de links alterados */
// //         let count = 0;

// //         /** verifica existencia de grupo de seleção */
// //         const selection = !!(selectedRef && selectedRef.current.length);

// //         /** altera o tamanho de todos os links conforme necessário */
// //         linkMappingRef.current.forEach((link) => {
// //           const isSelected = link.getAttribute('class')
// //             ? link.getAttribute('class').indexOf('selected') !== -1
// //             : false;

// //           /** não altera o tamanho se houver um grupo de seleção e este item não estiver selecionado */
// //           if (selection && !isSelected) return;

// //           /** altera apenas os tipos selecionados por padrão */
// //           if (
// //             !selection &&
// //             Number(link.childNodes[0].dataset.id) !== currLinkType
// //           )
// //             return;

// //           /** pega valor do atributo para incremental */
// //           switch (Number(link.childNodes[0].dataset.id)) {
// //             case LINK_FORM_TYPES.circle:
// //               newSizeH = valueH;
// //               newSizeW = 0;

// //               /** verifica se o processo é incremental */
// //               if (incremental)
// //                 newSizeH += Number(link.childNodes[0].getAttribute('r'));

// //               /** validação */
// //               if (newSizeH < LINK_SIZE_LIMIT.min)
// //                 newSizeH = LINK_SIZE_LIMIT.min;
// //               if (newSizeH > LINK_SIZE_LIMIT.max)
// //                 newSizeH = LINK_SIZE_LIMIT.max;

// //               break;
// //             case LINK_FORM_TYPES.rect:
// //               newSizeH = valueH;
// //               newSizeW = valueW;

// //               /** atribui mesmo valor de "valueH" + "width" pois no processo incremental não preenche "valueW" */
// //               if (incremental) {
// //                 const currSizeH = Number(
// //                   link.childNodes[0].getAttribute('height')
// //                 );
// //                 const currSizeW = Number(
// //                   link.childNodes[0].getAttribute('width')
// //                 );

// //                 newSizeH += currSizeH;
// //                 newSizeW += currSizeW + valueH;

// //                 /** proporcionalidade com o raio do circulo para situação incremental */
// //                 if (newSizeH < currSizeH) newSizeH -= 1;
// //                 if (newSizeW < currSizeW) newSizeW -= 1;

// //                 if (newSizeH > currSizeH) newSizeH += 1;
// //                 if (newSizeW > currSizeW) newSizeW += 1;
// //               }

// //               /** validação  */
// //               if (Math.trunc(newSizeH / 2) < LINK_SIZE_LIMIT.min) {
// //                 newSizeH = LINK_SIZE_LIMIT.min * 2;
// //                 newSizeW = LINK_SIZE_LIMIT.min * 2;
// //               }

// //               if (Math.trunc(newSizeH / 2) > LINK_SIZE_LIMIT.max) {
// //                 newSizeH = LINK_SIZE_LIMIT.max * 2;
// //               }

// //               if (Math.trunc(newSizeW / 2) < LINK_SIZE_LIMIT.min)
// //                 newSizeW = newSizeH;

// //               /** validação de comprimento somente para situação incremental */
// //               if (Math.trunc(newSizeW / 2) > LINK_SIZE_LIMIT.max) {
// //                 if (incremental) newSizeW = newSizeH;
// //               }

// //               break;
// //             /** área: incremento simétrico em altura e largura */
// //             case LINK_FORM_TYPES.area: {
// //               const currH = Number(link.childNodes[0].getAttribute('height'));
// //               const currW = Number(link.childNodes[0].getAttribute('width'));

// //               newSizeH = incremental ? currH + Number(valueH) : Number(valueH);
// //               newSizeW = incremental
// //                 ? currW + Number(valueH)
// //                 : Number(valueW) || Number(valueH);

// //               newSizeH = Math.max(
// //                 LINK_AREA_SIZE_LIMIT.min,
// //                 Math.min(LINK_AREA_SIZE_LIMIT.max, newSizeH)
// //               );
// //               newSizeW = Math.max(
// //                 LINK_AREA_SIZE_LIMIT.min,
// //                 Math.min(LINK_AREA_SIZE_LIMIT.max, newSizeW)
// //               );
// //               break;
// //             }
// //             default:
// //               break;
// //           }

// //           count += 1;

// //           handleLinkScale(newSizeH, newSizeW, link, incremental);
// //         });

// //         if (!selection && count === linkMappingRef.current.length)
// //           oChangeDefLinkSize(newSizeH, newSizeW, true);

// //         /** registra no histórico de desfazer/refazer */
// //         if (count > 0) oRegistrarHistorico();
// //       },
// //       [
// //         LINK_FORM_TYPES,
// //         LINK_SIZE_LIMIT,
// //         currLinkType,
// //         handleLinkScale,
// //         oChangeDefLinkSize,
// //         oRegistrarHistorico,
// //       ]
// //     );

// //     const handleConfirmar = useCallback(async () => {
// //       const { situacao } = catalogo;

// //       const confirmacao =
// //         situacao === opPaginaCatalogoSituacao.CONCLUIDO
// //           ? window.confirm(
// //               'Ao confirmar as alterações será necessário republicar o catálogo, deseja continuar?'
// //             )
// //           : true;

// //       if (confirmacao) {
// //         /** limpa biblioteca de localização OCR antes de salvar */
// //         handleOCRLimpar();

// //         /**
// //          * Remove o retângulo temporário do arraste de área. Ele é auxiliar
// //          * de edição e não deve ir para o arquivo salvo.
// //          */
// //         if (areaDraftRef.current) {
// //           areaDraftRef.current.remove();
// //           areaDraftRef.current = null;
// //         }

// //         /** carrega o arquivo editado */
// //         const blob = new Blob([svgRef.current.outerHTML], {
// //           type: 'image/svg+xml',
// //         });
// //         /** fecha controles do editor */
// //         handleControlClose('all');

// //         onSave({ svg: blob });
// //       }
// //     }, [catalogo, onSave, handleOCRLimpar, handleControlClose]);

// //     const handleCancelar = useCallback(() => {
// //       if (window.confirm('Deseja realmente cancelar as alterações?')) {
// //         setEditor(INITIAL_STATE);
// //         /** limpa biblioteca de localização OCR */
// //         handleOCRLimpar();
// //         /** fecha controles do editor */
// //         handleControlClose('all');
// //         setPdfTool(false);
// //         onCancel();
// //       }
// //     }, [INITIAL_STATE, onCancel, handleOCRLimpar, handleControlClose]);

// //     const loadAutoOCR = useCallback(
// //       async (idCatalogo, idPagina) => {
// //         // garante que já temos SVG/root
// //         if (!rootRef.current || !svgRef.current) return;

// //         // evita rodar duas vezes para a mesma página
// //         if (pagRef.current === idPagina) return;
// //         pagRef.current = idPagina;

// //         if (onBeforeOCR) {
// //           onBeforeOCR();
// //         }

// //         try {
// //           // limpa OCR anterior
// //           handleOCRLimpar();

// //           // cria o grupo OCR
// //           const ocrMapper = document.createElementNS(
// //             rootRef.current.namespaceURI,
// //             'g'
// //           );
// //           ocrMapper.setAttribute('id', 'ocrGroup');
// //           rootRef.current.appendChild(ocrMapper);
// //           ocrMapperRef.current = ocrMapper;

// //           // chama API
// //           const { data } = await api.get(
// //             `/editor-associar-autom/${idCatalogo}/pagina/${idPagina}`
// //           );

// //           // desenha overlays
// //           data.forEach((pt, index) => {
// //             const link = document.createElementNS(
// //               svgRef.current.namespaceURI,
// //               'a'
// //             );
// //             link.id = String(index);
// //             // link.setAttribute('x', pt.x);
// //             link.setAttribute('x', pt.x + 10);
// //             link.setAttribute('y', pt.y + 5);
// //             // link.setAttribute('y', pt.y);
// //             link.setAttribute('class', '');
// //             link.addEventListener('click', (e) => e.preventDefault());
// //             ocrMapperRef.current.appendChild(link);

// //             const linkForm = document.createElementNS(
// //               svgRef.current.namespaceURI,
// //               'rect'
// //             );

// //             const linkText = document.createElementNS(
// //               svgRef.current.namespaceURI,
// //               'text'
// //             );

// //             const linkFormWidth = pt.text.length * 6;

// //             linkForm.setAttribute('x', pt.x);
// //             // linkForm.setAttribute('x', pt.x);
// //             linkForm.setAttribute('y', pt.y - 3);
// //             // linkForm.setAttribute('y', pt.y);
// //             linkForm.setAttribute('height', '10');
// //             linkForm.setAttribute('width', `${linkFormWidth}`);
// //             linkForm.setAttribute(
// //               'class',
// //               pt.conf > 0.9 ? 'success' : 'warning'
// //             );
// //             linkForm.setAttribute('data-id', LINK_FORM_TYPES.ocr);
// //             link.appendChild(linkForm);

// //             linkText.setAttribute('x', pt.x + 5);
// //             linkText.setAttribute('y', pt.y + 5);
// //             linkText.setAttribute('font-size', '10');
// //             linkText.setAttribute(
// //               'class',
// //               pt.conf > 0.9 ? 'success' : 'warning'
// //             );
// //             linkText.textContent = pt.text;
// //             link.appendChild(linkText);

// //             ocrMappingRef.current.push({ attr: link, ocr: pt });
// //           });
// //         } catch (err) {
// //           toast.error(err);
// //         } finally {
// //           if (onAfterOCR) {
// //             onAfterOCR();
// //           }
// //         }
// //       },
// //       [onBeforeOCR, onAfterOCR, handleOCRLimpar]
// //     );

// //     const editorSvg = useMemo(
// //       () => (
// //         <SVG
// //           id={`page-${editor.pageNum}`}
// //           src={editor.path ? editor.path : ''}
// //           tabIndex="0"
// //           useRequestCache={false}
// //           onMouseDown={handleMouseDown}
// //           onMouseMove={handleMouseMove}
// //           onMouseUp={handleMouseUp}
// //           onKeyDown={onKeyDownEstavel}
// //           onKeyUp={onKeyUpEstavel}
// //           loading={() => <span>Loading</span>}
// //           fallback={() => <span>Selecione a imagem para editar</span>}
// //           // beforeInjection={(svg) => {
// //           //   /** atribui component a variáveis */
// //           //   svgRef.current = svg;
// //           // }}
// //           // afterInjection={(err, svg) => {
// //           //   if (svg) {
// //           //     /** nó raiz */
// //           //     rootRef.current = Array.from(svg.childNodes).find(
// //           //       (e) => e.nodeName === 'svg:g'
// //           //     );
// //           //     /** limpa variáveis de alteração */
// //           //     rootXRef.current = 0;
// //           //     rootYRef.current = 0;
// //           //     rootScaleRef.current = 1;
// //           //     rootRotateRef.current = 0;

// //           //     /** cria o componente seletor e atribui ao SVG */
// //           //     const selector = document.createElementNS(
// //           //       rootRef.current.namespaceURI,
// //           //       'rect',
// //           //       rootRef.current
// //           //     );
// //           //     selector.setAttribute('id', 'selector');
// //           //     selector.setAttribute('stroke', '#ccc');
// //           //     selector.setAttribute('fill', 'rgba(0,0,0,.2)');
// //           //     rootRef.current.appendChild(selector);

// //           //     /** mapeamento dos elementos */
// //           //     linkMappingRef.current = [];
// //           //     mappingElement(svg.childNodes);

// //           //     /** verifica associações */
// //           //     oCheckAssociation();

// //           //     /** verifica conflitos */
// //           //     oCheckConflict();

// //           //     /** adicionar processo de arrastar e soltar no SVG */
// //           //     svg.ondragover = handleDragOverSVG;
// //           //     svg.ondrop = handleDropSVG;

// //           //     /** redimensiona automaticamente para o tamanho padrão */
// //           //     handleResize();

// //           //     selectorRef.current = selector;

// //           //     const { baseVal } = rootRef.current.transform;
// //           //     const baseIndex = Array.from(baseVal).findIndex(
// //           //       (e) => e.type === 1
// //           //     );

// //           //     if (baseIndex >= 0) {
// //           //       const { matrix } = baseVal.getItem(baseIndex);

// //           //       rootXRef.current = matrix.e;
// //           //       rootYRef.current = matrix.f;
// //           //       rootScaleRef.current = matrix.a;
// //           //       // rootRotateRef.current = 0;
// //           //     }

// //           //     /** centraliza automaticamente */
// //           //     handleCenter(true);
// //           //   }
// //           // }}
// //           beforeInjection={(svg) => {
// //             /** atribui component a variáveis */
// //             svgRef.current = svg;
// //             // NOVO: ainda não está pronto
// //             setSvgReady(false);
// //           }}
// //           afterInjection={(err, svg) => {
// //             if (svg) {
// //               /** nó raiz */
// //               rootRef.current = Array.from(svg.childNodes).find(
// //                 (e) => e.nodeName === 'svg:g'
// //               );
// //               /** limpa variáveis de alteração */
// //               rootXRef.current = 0;
// //               rootYRef.current = 0;
// //               rootScaleRef.current = 1;
// //               rootRotateRef.current = 0;

// //               /** cria o componente seletor e atribui ao SVG */
// //               const selector = document.createElementNS(
// //                 rootRef.current.namespaceURI,
// //                 'rect',
// //                 rootRef.current
// //               );
// //               selector.setAttribute('id', 'selector');
// //               selector.setAttribute('stroke', '#ccc');
// //               selector.setAttribute('fill', 'rgba(0,0,0,.2)');
// //               rootRef.current.appendChild(selector);

// //               /**
// //                * Retângulo temporário do arraste que desenha a área de um
// //                * novo link. É separado do "selector" (usado pelo Ctrl+arraste
// //                * do OCR) para os dois não interferirem, e é removido antes de
// //                * salvar em handleConfirmar.
// //                */
// //               areaDraftRef.current = null;
// //               oGetAreaDraft();

// //               /** mapeamento dos elementos */
// //               linkMappingRef.current = [];
// //               mappingElement(svg.childNodes);

// //               /** verifica associações */
// //               oCheckAssociation();

// //               /** verifica conflitos */
// //               oCheckConflict();

// //               /** estado inicial do histórico de desfazer/refazer */
// //               historicoRef.current = [];
// //               historicoPosRef.current = -1;
// //               oRegistrarHistorico();

// //               /** adicionar processo de arrastar e soltar no SVG */
// //               svg.ondragover = handleDragOverSVG;
// //               svg.ondrop = handleDropSVG;

// //               /** redimensiona automaticamente para o tamanho padrão */
// //               handleResize();

// //               selectorRef.current = selector;

// //               const { baseVal } = rootRef.current.transform;
// //               const baseIndex = Array.from(baseVal).findIndex(
// //                 (e) => e.type === 1
// //               );

// //               if (baseIndex >= 0) {
// //                 const { matrix } = baseVal.getItem(baseIndex);

// //                 rootXRef.current = matrix.e;
// //                 rootYRef.current = matrix.f;
// //                 rootScaleRef.current = matrix.a;
// //                 // rootRotateRef.current = 0;
// //               }

// //               /** centraliza automaticamente */
// //               handleCenter(true);

// //               // 👇 NOVO: assim que o SVG da página estiver pronto, carrega o OCR automático
// //               if (catalogo?.idCatalogo && pagina?.idPagina) {
// //                 loadAutoOCR(catalogo.idCatalogo, pagina.idPagina);
// //               }
// //             }
// //           }}
// //           // afterInjection={(err, svg) => {
// //           //   if (svg) {
// //           //     /** nó raiz */
// //           //     rootRef.current = Array.from(svg.childNodes).find(
// //           //       (e) => e.nodeName === 'svg:g'
// //           //     );
// //           //     /** limpa variáveis de alteração */
// //           //     rootXRef.current = 0;
// //           //     rootYRef.current = 0;
// //           //     rootScaleRef.current = 1;
// //           //     rootRotateRef.current = 0;

// //           //     /** cria o componente seletor e atribui ao SVG */
// //           //     const selector = document.createElementNS(
// //           //       rootRef.current.namespaceURI,
// //           //       'rect',
// //           //       rootRef.current
// //           //     );
// //           //     selector.setAttribute('id', 'selector');
// //           //     selector.setAttribute('stroke', '#ccc');
// //           //     selector.setAttribute('fill', 'rgba(0,0,0,.2)');
// //           //     rootRef.current.appendChild(selector);

// //           //     /** mapeamento dos elementos */
// //           //     linkMappingRef.current = [];
// //           //     mappingElement(svg.childNodes);

// //           //     /** verifica associações */
// //           //     oCheckAssociation();

// //           //     /** verifica conflitos */
// //           //     oCheckConflict();

// //           //     /** adicionar processo de arrastar e soltar no SVG */
// //           //     svg.ondragover = handleDragOverSVG;
// //           //     svg.ondrop = handleDropSVG;

// //           //     /** redimensiona automaticamente para o tamanho padrão */
// //           //     handleResize();

// //           //     selectorRef.current = selector;

// //           //     const { baseVal } = rootRef.current.transform;
// //           //     const baseIndex = Array.from(baseVal).findIndex(
// //           //       (e) => e.type === 1
// //           //     );

// //           //     if (baseIndex >= 0) {
// //           //       const { matrix } = baseVal.getItem(baseIndex);

// //           //       rootXRef.current = matrix.e;
// //           //       rootYRef.current = matrix.f;
// //           //       rootScaleRef.current = matrix.a;
// //           //       // rootRotateRef.current = 0;
// //           //     }

// //           //     /** centraliza automaticamente */
// //           //     handleCenter(true);

// //           //     // NOVO: agora o SVG está pronto pra receber o OCR automático
// //           //     setSvgReady(true);
// //           //   }
// //           // }}
// //         />
// //       ),
// //       // eslint-disable-next-line react-hooks/exhaustive-deps
// //       [
// //         editor.pageNum,
// //         editor.path,
// //         // handleDropSVG,
// //         // handleDragOverSVG,
// //         // handleKeyDown,
// //         // handleKeyUp,
// //         // handleMouseDown,
// //         // handleMouseMove,
// //         // handleMouseUp,
// //         // mappingElement,
// //       ]
// //     );

// //     return (
// //       <Container id="editor" onDragOver={handleDragOver}>
// //         <ToolBar>
// //           <button title="Salvar" type="submit" onClick={handleConfirmar}>
// //             <MdDone size={16} />
// //           </button>
// //           <button type="button" title="Cancelar" onClick={handleCancelar}>
// //             <MdClose size={16} />
// //           </button>
// //           <button
// //             type="button"
// //             title="Remover link selecionado (Del)"
// //             onClick={handleRemoverSelecao}
// //           >
// //             <MdDelete size={16} />
// //           </button>
// //           <button type="button" title="Redimensionar" onClick={handleResize}>
// //             <MdCropFree size={16} />
// //           </button>
// //           {/**
// //            * Os modos de zoom e de tamanho do link existiam apenas por
// //            * atalho (Alt+Z / Alt+S), sem nenhuma indicação em tela. Os
// //            * botões abaixo usam os MESMOS handlers do teclado e mostram o
// //            * estado atual por aria-pressed.
// //            */}
// //           <button
// //             type="button"
// //             title="Modo zoom da página (Alt+Z)"
// //             aria-pressed={zoomControl}
// //             onClick={handleAlternarZoom}
// //             style={
// //               zoomControl
// //                 ? { color: opLinkEstilo.COR, fontWeight: 'bold' }
// //                 : undefined
// //             }
// //           >
// //             <MdZoomOutMap size={16} />
// //           </button>
// //           <button
// //             type="button"
// //             title="Editar tamanho do link (Alt+S)"
// //             aria-pressed={sizeControl}
// //             onClick={handleAlternarTamanho}
// //             style={
// //               sizeControl
// //                 ? { color: opLinkEstilo.COR, fontWeight: 'bold' }
// //                 : undefined
// //             }
// //           >
// //             <MdAspectRatio size={16} />
// //           </button>
// //           <button
// //             type="button"
// //             title="Centralizar"
// //             onClick={() =>
// //               pdfTool ? handleCenterPdfProcess() : handleCenter()
// //             }
// //           >
// //             <MdCenterFocusStrong size={16} />
// //           </button>
// //           <button type="button" title="Horizontal" onClick={handleLandscape}>
// //             <MdStayPrimaryLandscape size={16} />
// //           </button>
// //           <button type="button" title="Vertical" onClick={handlePortrait}>
// //             <MdStayPrimaryPortrait size={16} />
// //           </button>
// //           <button
// //             type="button"
// //             title="Escala +"
// //             onClick={() =>
// //               pdfTool ? handleScalePdfProcess(0.1) : handleScale(0.1)
// //             }
// //           >
// //             <MdExposurePlus1 size={16} />
// //           </button>
// //           <button
// //             type="button"
// //             title="Escala -"
// //             onClick={() =>
// //               pdfTool ? handleScalePdfProcess(-0.1) : handleScale(-0.1)
// //             }
// //           >
// //             <MdExposureNeg1 size={16} />
// //           </button>
// //           <button
// //             type="button"
// //             title="Rotacionar"
// //             onClick={() => handleRotate(-45)}
// //           >
// //             <MdRotateLeft size={16} />
// //           </button>
// //           <button
// //             type="button"
// //             title="Rotacionar"
// //             onClick={() => handleRotate(45)}
// //           >
// //             <MdRotateRight size={16} />
// //           </button>
// //           <button
// //             type="button"
// //             title="Posiciona (Esquerda)"
// //             onClick={() =>
// //               pdfTool
// //                 ? handlePositionPdfProcess(-10, 0)
// //                 : handlePosition(-10, 0)
// //             }
// //           >
// //             <MdKeyboardArrowLeft size={16} />
// //           </button>
// //           <button
// //             type="button"
// //             title="Posiciona (Abaixo)"
// //             onClick={() =>
// //               pdfTool ? handlePositionPdfProcess(0, 10) : handlePosition(0, 10)
// //             }
// //           >
// //             <MdKeyboardArrowDown size={16} />
// //           </button>
// //           <button
// //             type="button"
// //             title="Posiciona (Acima)"
// //             onClick={() =>
// //               pdfTool
// //                 ? handlePositionPdfProcess(0, -10)
// //                 : handlePosition(0, -10)
// //             }
// //           >
// //             <MdKeyboardArrowUp size={16} />
// //           </button>
// //           <button
// //             type="button"
// //             title="Posiciona (Direita)"
// //             onClick={() =>
// //               pdfTool ? handlePositionPdfProcess(10, 0) : handlePosition(10, 0)
// //             }
// //           >
// //             <MdKeyboardArrowRight size={16} />
// //           </button>
// //           <button type="button" title="Link" onClick={handleLink}>
// //             <MdLink size={20} />
// //           </button>
// //           <button
// //             type="button"
// //             title="Link +"
// //             onClick={() => handleSizeEdit(+1)}
// //           >
// //             <MdUnfoldMore size={16} />
// //           </button>
// //           <button
// //             type="button"
// //             title="Link -"
// //             onClick={() => handleSizeEdit(-1)}
// //           >
// //             <MdUnfoldLess size={16} />
// //           </button>
// //           <button
// //             type="button"
// //             title="Link círculo"
// //             disabled={currLinkType === LINK_FORM_TYPES.circle}
// //             onClick={() => {
// //               currLinkTypeRef.current = INITIAL_LINK_CIRCLE;
// //               setCurrLinkType(LINK_FORM_TYPES.circle);
// //               /** oculta para definir os campos */
// //               setSizeControl(false);

// //               oChangeDefLinkSize(0, 0, true);
// //             }}
// //           >
// //             <MdRadioButtonUnchecked size={16} />
// //           </button>
// //           <button
// //             type="button"
// //             title="Link retângulo"
// //             disabled={currLinkType === LINK_FORM_TYPES.rect}
// //             onClick={() => {
// //               currLinkTypeRef.current = INITIAL_LINK_RECT;
// //               setCurrLinkType(LINK_FORM_TYPES.rect);
// //               /** oculta para definir os campos */
// //               setSizeControl(false);

// //               oChangeDefLinkSize(0, 0, true);
// //             }}
// //           >
// //             <MdCheckBoxOutlineBlank size={16} />
// //           </button>
// //           {/**
// //            * Área por arraste: forma indicada para esquemas elétricos, em
// //            * que o link acompanha o contorno real do componente em vez de
// //            * um marcador de tamanho fixo.
// //            */}
// //           <button
// //             type="button"
// //             title="Desfazer (Ctrl+Z)"
// //             disabled={!historicoInfo.podeDesfazer}
// //             onClick={handleDesfazer}
// //           >
// //             <MdUndo size={16} />
// //           </button>
// //           <button
// //             type="button"
// //             title="Refazer (Ctrl+Y)"
// //             disabled={!historicoInfo.podeRefazer}
// //             onClick={handleRefazer}
// //           >
// //             <MdRedo size={16} />
// //           </button>
// //           <button
// //             type="button"
// //             title="Link área: arraste sobre o componente para desenhar o contorno (o ID do item é pedido ao soltar)"
// //             disabled={currLinkType === LINK_FORM_TYPES.area}
// //             onClick={() => {
// //               currLinkTypeRef.current = INITIAL_LINK_AREA;
// //               setCurrLinkType(LINK_FORM_TYPES.area);
// //               /** oculta para definir os campos */
// //               setSizeControl(false);

// //               oChangeDefLinkSize(
// //                 INITIAL_LINK_AREA.height,
// //                 INITIAL_LINK_AREA.width,
// //                 true
// //               );
// //             }}
// //           >
// //             <MdCropFree size={16} />
// //           </button>
// //           {/** alterna o rótulo aplicado aos novos links */}
// //           <button
// //             type="button"
// //             title={`Rótulo do link: ${LABEL_ROTULO[currLinkRotulo]} (clique para alternar)`}
// //             onClick={handleAlternarRotulo}
// //           >
// //             {currLinkRotulo === opLinkRotulo.ETIQUETA && (
// //               <MdLabelOutline size={16} />
// //             )}
// //             {currLinkRotulo === opLinkRotulo.NENHUM && <MdLabelOff size={16} />}
// //             {currLinkRotulo === opLinkRotulo.CODIGO && <MdLabel size={16} />}
// //           </button>
// //           {/**
// //            * Modo sequência: com ele ativo, cada arraste sobre o desenho
// //            * cria a área do próximo item pendente e avança automaticamente.
// //            */}
// //           <button
// //             type="button"
// //             title={
// //               modoSequencia
// //                 ? `Modo sequência ativo (Alt+A)${
// //                     itemSequencia ? ` - item ${itemSequencia.idItem}` : ''
// //                   }`
// //                 : 'Modo sequência: criar links em série por arraste (Alt+A)'
// //             }
// //             onClick={handleAlternarModoSequencia}
// //             style={
// //               modoSequencia
// //                 ? { color: opLinkEstilo.COR, fontWeight: 'bold' }
// //                 : undefined
// //             }
// //           >
// //             <MdPlaylistAddCheck size={18} />
// //           </button>
// //           {/**
// //            * Indicador do modo sequência: quantos itens ainda não têm link e
// //            * qual é o próximo alvo do arraste.
// //            */}
// //           {modoSequencia && (
// //             <span
// //               title="Itens sem link nesta página / próximo item do arraste"
// //               style={{
// //                 display: 'inline-flex',
// //                 alignItems: 'center',
// //                 gap: 4,
// //                 padding: '0 8px',
// //                 whiteSpace: 'nowrap',
// //                 fontSize: 12,
// //                 fontWeight: 700,
// //                 color: opLinkEstilo.COR,
// //               }}
// //             >
// //               {itensPendentes.length} pendente
// //               {itensPendentes.length === 1 ? '' : 's'}
// //               {itemSequencia ? ` - próximo: ${itemSequencia.idItem}` : ''}
// //             </span>
// //           )}
// //           <button
// //             type="button"
// //             title="OCR - Tradicional"
// //             onClick={() =>
// //               handleOCRLocalizar(opEditorAssociarTipoExtracao.TRADICIONAL)
// //             }
// //           >
// //             <MdOutlineFilter1 size={16} />
// //           </button>
// //           {process.env.REACT_APP_EXPERIMENTAL_IA_ASSOCIACAO ===
// //             opSimNao.SIM && (
// //             <>
// //               {/* <button
// //                 type="button"
// //                 title="OCR - Easy FAST"
// //                 onClick={() =>
// //                   handleOCRLocalizar(opEditorAssociarTipoExtracao.EASY_FAST)
// //                 }
// //               >
// //                 <MdOutlineFilter2 size={16} />
// //               </button>
// //               <button
// //                 type="button"
// //                 title="ORC = Easy DEEP"
// //                 onClick={() =>
// //                   handleOCRLocalizar(opEditorAssociarTipoExtracao.EASY_DEEP)
// //                 }
// //               >
// //                 <MdOutlineFilter3 size={16} />
// //               </button> */}
// //               <button
// //                 type="button"
// //                 title="Extração PDF"
// //                 onClick={() =>
// //                   handlePDFLocalizar(opEditorAssociarTipoExtracao.PDF)
// //                 }
// //               >
// //                 <MdOutlineFilter2 size={16} />
// //               </button>
// //               <button
// //                 type="button"
// //                 title="Paddle OCR"
// //                 onClick={() =>
// //                   handleOCRLocalizar(opEditorAssociarTipoExtracao.PADDLE_OCR)
// //                 }
// //               >
// //                 <MdOutlineFilter3 size={16} />
// //               </button>
// //             </>
// //           )}
// //           <button type="button" title="Limpar OCR" onClick={handleOCRLimpar}>
// //             <MdOutlineLayersClear size={16} />
// //           </button>
// //           {/**
// //            * Legenda de atalhos: fica no fim da barra, separada do resto,
// //            * e é o único ponto de descoberta dos comandos de teclado.
// //            */}
// //           <button
// //             type="button"
// //             title="Atalhos do teclado (? ou F1)"
// //             aria-pressed={atalhosAberto}
// //             onClick={handleAlternarAtalhos}
// //             style={{ marginLeft: 'auto' }}
// //           >
// //             <MdHelpOutline size={16} />
// //           </button>
// //         </ToolBar>

// //         <Wrapper
// //         // onMouseDown={handleMouseDown}
// //         // onMouseMove={handleMouseMove}
// //         // onMouseUp={handleMouseUp}
// //         // onKeyDown={handleKeyDown}
// //         // onKeyUp={handleKeyUp}
// //         >
// //           {/**
// //            * Zoom pela roda do mouse sem precisar alternar para o modo de
// //            * zoom (Alt+Z).
// //            *
// //            * O wrapper deixa de ser desabilitado para que a roda funcione,
// //            * mas o comportamento observado antes é preservado:
// //            *  - o pan continua exigindo o modo de zoom ativo
// //            *    (antes o wrapper inteiro estava desabilitado fora dele);
// //            *  - o duplo clique nunca dá zoom (antes também não dava, pois
// //            *    o wrapper estava desabilitado fora do modo de zoom e o
// //            *    doubleClick estava desabilitado dentro dele) — assim não
// //            *    concorre com o input rápido de link.
// //            */}
// //           <TransformWrapper
// //             initialScale={1}
// //             centerOnInit
// //             centerZoomedOut
// //             panning={{ disabled: !zoomCanMove || !zoomControl }}
// //             wheel={{ step: 0.08 }}
// //             doubleClick={{ disabled: true }}
// //             disabled={false}
// //             onZoom={(target) => {
// //               zoomScaleRef.current = target.scale;
// //               return target;
// //             }}
// //           >
// //             {({
// //               zoomIn,
// //               zoomOut,
// //               resetTransform,
// //               // setTransform
// //             }) => (
// //               // if (elementToZoom) {
// //               //   setTransform(
// //               //     -Math.abs(elementToZoom.layerX),
// //               //     -Math.abs(elementToZoom.layerY),
// //               //     1.5,
// //               //     1000,
// //               //     'easeInOutQuad'
// //               //   );
// //               // }
// //               <EditorWrapper ref={editorAreaRef}>
// //                 {(zoomControl || sizeControl) && (
// //                   <ControlWrapper show={zoomControl || sizeControl}>
// //                     {zoomControl && (
// //                       <Control isVisible={zoomControl} control="zoom">
// //                         <Control.BtnClose
// //                           type="button"
// //                           onClick={() =>
// //                             handleControlClose(zoomRef && zoomRef.current.id)
// //                           }
// //                         >
// //                           <MdCancel size={16} />
// //                         </Control.BtnClose>
// //                         <Control.Animated ref={zoomRef} id="zoomAnimControl">
// //                           <Control.ZoomBtnAct
// //                             ref={zoomInRef}
// //                             type="button"
// //                             onClick={() => zoomIn()}
// //                           >
// //                             <MdZoomIn size={25} />
// //                           </Control.ZoomBtnAct>
// //                           <Control.ZoomBtnAct
// //                             ref={zoomOutRef}
// //                             type="button"
// //                             onClick={() => zoomOut()}
// //                           >
// //                             <MdZoomOut size={25} />
// //                           </Control.ZoomBtnAct>
// //                           <Control.ZoomBtnAct
// //                             ref={zoomResetRef}
// //                             type="button"
// //                             onClick={() => resetTransform()}
// //                           >
// //                             <MdYoutubeSearchedFor size={25} />
// //                           </Control.ZoomBtnAct>
// //                         </Control.Animated>
// //                       </Control>
// //                     )}
// //                     {sizeControl && (
// //                       <Control isVisible={sizeControl} control="size">
// //                         <Control.BtnClose
// //                           type="button"
// //                           onClick={() =>
// //                             handleControlClose(sizeRef && sizeRef.current.id)
// //                           }
// //                         >
// //                           <MdCancel size={16} />
// //                         </Control.BtnClose>
// //                         <Control.Animated ref={sizeRef} id="sizeAnimControl">
// //                           <Form
// //                             ref={formSizeRef}
// //                             onSubmit={({ sizeInputH, sizeInputW }) => {
// //                               handleSizeEdit(
// //                                 Number(sizeInputH),
// //                                 Number(sizeInputW),
// //                                 false
// //                               );
// //                             }}
// //                             autoComplete="off"
// //                           >
// //                             <Control.SizeInput>
// //                               <Input
// //                                 id="sizeInputH"
// //                                 name="sizeInputH"
// //                                 type="number"
// //                                 placeholder="H"
// //                                 width={60}
// //                                 onKeyDown={(e) =>
// //                                   e.keyCode === 13 &&
// //                                   formSizeRef.current.submitForm()
// //                                 }
// //                               />
// //                               <Input
// //                                 id="sizeInputW"
// //                                 name="sizeInputW"
// //                                 type="number"
// //                                 placeholder="W"
// //                                 width={60}
// //                                 onKeyDown={(e) =>
// //                                   e.keyCode === 13 &&
// //                                   formSizeRef.current.submitForm()
// //                                 }
// //                               />
// //                             </Control.SizeInput>
// //                           </Form>
// //                         </Control.Animated>
// //                       </Control>
// //                     )}
// //                   </ControlWrapper>
// //                 )}

// //                 {quickInput.open && (
// //                   <div
// //                     role="dialog"
// //                     aria-modal="true"
// //                     aria-label="Inserir ID do item"
// //                     tabIndex={-1}
// //                     style={{
// //                       position: 'absolute',
// //                       left: quickInput.x,
// //                       top: quickInput.y,
// //                       transform: 'translate(-50%, -150%)',
// //                       background: '#fff',
// //                       border: '1px solid #d1d5db',
// //                       borderRadius: 8,
// //                       padding: 6,
// //                       zIndex: 9,
// //                       boxShadow: '0 2px 8px rgba(0,0,0,.40)',
// //                     }}
// //                     // onClick={(e) => e.stopPropagation()}
// //                   >
// //                     <input
// //                       ref={quickInputRef}
// //                       type="text"
// //                       placeholder="ID do item…"
// //                       value={quickInput.value}
// //                       onMouseDown={(e) => e.stopPropagation()}
// //                       onClick={(e) => e.stopPropagation()}
// //                       onChange={(e) => {
// //                         const v = e.target.value;
// //                         setQuickInput((s) => ({ ...s, value: v }));
// //                       }}
// //                       onKeyDown={(e) => {
// //                         if (e.key === 'Enter') {
// //                           e.stopPropagation();
// //                           e.preventDefault();
// //                           const v =
// //                             (quickInputRef.current &&
// //                               quickInputRef.current.value) ||
// //                             quickInput.value;
// //                           handleQuickInputConfirm(v);
// //                         } else if (e.key === 'Escape') {
// //                           e.stopPropagation();
// //                           e.preventDefault();
// //                           handleQuickInputCancel();
// //                         }
// //                       }}
// //                       onBlur={() => {
// //                         setTimeout(() => {
// //                           handleQuickInputCancel();
// //                         }, 0);
// //                       }}
// //                       style={{
// //                         width: 140,
// //                         outline: 'none',
// //                         border: 'none',
// //                         padding: '2px 5px',
// //                         borderRadius: 8,
// //                       }}
// //                     />
// //                   </div>
// //                 )}

// //                 {/**
// //                  * Legenda de atalhos. Renderizada por último dentro do
// //                  * EditorWrapper para ficar acima do desenho, e apenas
// //                  * quando aberta — fechada, não ocupa nada.
// //                  */}
// //                 {atalhosAberto && (
// //                   <Atalhos
// //                     role="dialog"
// //                     aria-label="Atalhos do teclado e do mouse"
// //                   >
// //                     <Atalhos.Header>
// //                       <strong>Atalhos</strong>
// //                       <Atalhos.BtnClose
// //                         type="button"
// //                         title="Fechar (Esc)"
// //                         onClick={handleAlternarAtalhos}
// //                       >
// //                         <MdClose size={16} />
// //                       </Atalhos.BtnClose>
// //                     </Atalhos.Header>

// //                     <Atalhos.Body>
// //                       {ATALHOS_EDITOR.map((secao) => (
// //                         <Atalhos.Grupo key={secao.grupo}>
// //                           <span>{secao.grupo}</span>
// //                           {secao.itens.map((atalho) => (
// //                             <Atalhos.Linha
// //                               key={`${secao.grupo}-${atalho.texto}`}
// //                             >
// //                               <p>{atalho.texto}</p>
// //                               <div>
// //                                 {atalho.teclas.map((tecla, indice) => (
// //                                   <Atalhos.Tecla
// //                                     key={`${atalho.texto}-${tecla}-${indice}`}
// //                                   >
// //                                     {tecla}
// //                                   </Atalhos.Tecla>
// //                                 ))}
// //                               </div>
// //                             </Atalhos.Linha>
// //                           ))}
// //                         </Atalhos.Grupo>
// //                       ))}
// //                     </Atalhos.Body>
// //                   </Atalhos>
// //                 )}

// //                 {/**
// //                  * O wrapper do zoom precisa de tamanho explícito: sem
// //                  * isso ele se ajusta ao SVG e a área extra conquistada no
// //                  * layout não vira espaço de trabalho.
// //                  */}
// //                 <TransformComponent
// //                   wrapperStyle={{ width: '100%', height: '100%' }}
// //                 >
// //                   {editorSvg}
// //                 </TransformComponent>
// //               </EditorWrapper>
// //             )}
// //           </TransformWrapper>
// //         </Wrapper>
// //       </Container>
// //     );
// //   }
// // );

// // export default EditorArea;

// // EditorArea.propTypes = {
// //   catalogo: PropTypes.instanceOf(Object).isRequired,
// //   pagina: PropTypes.instanceOf(Object),
// //   itensPagina: PropTypes.arrayOf(Object),
// //   onSave: PropTypes.func.isRequired,
// //   onCancel: PropTypes.func.isRequired,
// //   onBeforeOCR: PropTypes.func,
// //   onAfterOCR: PropTypes.func,
// //   onAssociate: PropTypes.func,
// //   onLinkHighlight: PropTypes.func,
// // };

// // EditorArea.defaultProps = {
// //   pagina: null,
// //   itensPagina: null,
// //   onBeforeOCR: null,
// //   onAfterOCR: null,
// //   onAssociate: null,
// //   onLinkHighlight: null,
// // };

// import React, {
//   useState,
//   useEffect,
//   useMemo,
//   useRef,
//   useCallback,
//   forwardRef,
//   useImperativeHandle,
// } from 'react';
// import uniqBy from 'lodash.uniqby';
// import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
// import {
//   MdAspectRatio,
//   MdCancel,
//   MdCheckBoxOutlineBlank,
//   MdCenterFocusStrong,
//   MdClose,
//   MdCropFree,
//   MdDelete,
//   MdDone,
//   MdHelpOutline,
//   MdZoomOutMap,
//   MdExposureNeg1,
//   MdExposurePlus1,
//   MdKeyboardArrowDown,
//   MdKeyboardArrowLeft,
//   MdKeyboardArrowRight,
//   MdKeyboardArrowUp,
//   MdOutlineFilter1,
//   MdOutlineFilter2,
//   MdOutlineFilter3,
//   MdOutlineFilter4,
//   MdOutlineFilter5,
//   MdOutlineLayersClear,
//   MdLink,
//   MdLabelOutline,
//   MdLabelOff,
//   MdLabel,
//   MdPlaylistAddCheck,
//   MdUndo,
//   MdRedo,
//   MdUnfoldLess,
//   MdUnfoldMore,
//   MdRadioButtonUnchecked,
//   MdRotateLeft,
//   MdRotateRight,
//   MdStayPrimaryLandscape,
//   MdStayPrimaryPortrait,
//   MdYoutubeSearchedFor,
//   MdZoomIn,
//   MdZoomOut,
// } from 'react-icons/md';
// import { toast } from 'react-toastify';
// import PropTypes from 'prop-types';

// import {
//   opEditorAssociarTipoExtracao,
//   opPaginaCatalogoSituacao,
//   opSimNao,
//   opLinkForma,
//   opLinkRotulo,
//   opLinkPapel,
//   opLinkTamanho,
//   opLinkEstilo,
// } from '../../lib/const';

// import {
//   getSvgCoordinates,
//   createOcrGroup,
//   createSvgLinkPdfProcess,
//   centerCalculation,
//   updateSvgPositionProcessPdf,
//   centerSvgPdfProcess,
//   scaleSvgProcessPdf,
//   getNomeLocalSvg,
//   isFormaLink,
//   getPapelLink,
//   getFormaPrincipal,
//   getCaixaForma,
//   criarLinhaChamada,
//   atualizarLinhaChamada,
//   transladarLink,
//   transladarElementoSvg,
//   calcularAncoraChamada,
//   larguraEstimadaRotulo,
// } from '../../lib/mapeamentoUtils';

// import api from '../../services/api';

// import { Form } from '../Form';
// import Input from '../Form/Input';

// import {
//   Container,
//   Wrapper,
//   EditorWrapper,
//   ControlWrapper,
//   Control,
//   ToolBar,
//   SVG,
//   Atalhos,
// } from './styles';

// /**
//  * =====================================================================
//  * CONTEÚDO DA LEGENDA DE ATALHOS
//  * ---------------------------------------------------------------------
//  * Espelha exatamente o que handleMouseDown / handleMouseMove /
//  * handleKeyDown tratam hoje. Ao criar ou alterar um atalho, atualize
//  * também esta lista — é o único lugar em que o usuário consegue
//  * descobrir os comandos.
//  * =====================================================================
//  */
// const ATALHOS_EDITOR = [
//   {
//     grupo: 'Mouse',
//     itens: [
//       {
//         teclas: ['Clique'],
//         texto: 'Seleciona o link; no vazio, limpa a seleção',
//       },
//       { teclas: ['Shift', 'Clique'], texto: 'Acrescenta o link à seleção' },
//       { teclas: ['Shift', 'Alt', 'Clique'], texto: 'Retira o link da seleção' },
//       {
//         teclas: ['Arraste'],
//         texto:
//           'Sobre um link, move o link; sobre a etiqueta, move só a etiqueta',
//       },
//       { teclas: ['Alt', 'Arraste'], texto: 'Move apenas o link sob o cursor' },
//       {
//         teclas: ['Ctrl', 'Arraste'],
//         texto: 'Seleção por área (também usada no OCR)',
//       },
//       {
//         teclas: ['Arraste'],
//         texto: 'Com a forma "área" ativa, desenha o contorno do novo link',
//       },
//       { teclas: ['Roda'], texto: 'Zoom do desenho' },
//     ],
//   },
//   {
//     grupo: 'Links',
//     itens: [
//       { teclas: ['Del'], texto: 'Remove os links selecionados' },
//       { teclas: ['Backspace'], texto: 'Mesmo efeito do Del' },
//       { teclas: ['←', '↑', '→', '↓'], texto: 'Ajuste fino da seleção (1 px)' },
//       { teclas: ['Ctrl', 'setas'], texto: 'Ajuste fino da seleção (5 px)' },
//       {
//         teclas: ['Alt', 'S'],
//         texto: 'Abre/fecha a edição de tamanho (H/W) do link',
//       },
//       { teclas: ['Alt', 'A'], texto: 'Liga/desliga o modo sequência' },
//       {
//         teclas: ['Esc'],
//         texto: 'Limpa a seleção (e sai do modo tela cheia, quando ativo)',
//       },
//     ],
//   },
//   {
//     grupo: 'Página',
//     itens: [
//       {
//         teclas: ['Alt', 'Z'],
//         texto: 'Liga/desliga o modo zoom (ao sair, volta à escala original)',
//       },
//       { teclas: ['Shift', 'setas'], texto: 'Move a página (10 px)' },
//       { teclas: ['Shift', '+'], texto: 'Aumenta a escala da página' },
//       { teclas: ['Shift', '-'], texto: 'Reduz a escala da página' },
//     ],
//   },
//   {
//     grupo: 'Histórico e ajuda',
//     itens: [
//       { teclas: ['Ctrl', 'Z'], texto: 'Desfazer' },
//       { teclas: ['Ctrl', 'Shift', 'Z'], texto: 'Refazer' },
//       { teclas: ['Ctrl', 'Y'], texto: 'Refazer' },
//       { teclas: ['?'], texto: 'Mostra/oculta esta legenda (F1 também)' },
//     ],
//   },
// ];

// /**
//  * Enquadramento do desenho na área de trabalho (ver handleEnquadrar).
//  * A margem deixa uma folga para o desenho não encostar na borda.
//  */
// const MARGEM_ENQUADRAR = 0.96;
// const ZOOM_MIN = 0.5;
// const ZOOM_MAX = 8;

// const EditorArea = forwardRef(
//   (
//     {
//       catalogo,
//       pagina,
//       itensPagina,
//       onSave,
//       onCancel,
//       onBeforeOCR,
//       onAfterOCR,
//       onAssociate,
//       onLinkHighlight,
//     },
//     ref
//   ) => {
//     /** controles de posicionamento e seleção */
//     const selectingRef = useRef(false);
//     const selectedRef = useRef([]);
//     const focusRef = useRef(null);
//     const controlRef = useRef(null);

//     const startCoordRef = useRef({ x: 0, y: 0 });
//     const finishCoordRef = useRef({ x: 0, y: 0 });
//     const minCoordRef = useRef({ x: 0, y: 0 });
//     const maxCoordRef = useRef({ x: 0, y: 0 });

//     const actionRef = useRef();
//     const linkRef = useRef();

//     const zoomRef = useRef();
//     const zoomInRef = useRef(HTMLButtonElement);
//     const zoomOutRef = useRef(HTMLButtonElement);
//     const zoomResetRef = useRef(HTMLButtonElement);

//     /**
//      * API do react-zoom-pan-pinch (resetTransform, setTransform, ...).
//      *
//      * Os botões de zoom só existem no DOM com o modo zoom ligado (Alt+Z),
//      * então zoomResetRef fica indefinido na maior parte do tempo. Este ref
//      * guarda as funções direto do render prop e está sempre disponível.
//      *
//      * É necessário porque o centerOnInit do TransformWrapper é calculado
//      * na montagem, quando o SVG da página ainda NÃO foi injetado (o
//      * react-svg busca o arquivo depois). O resultado é um pan calculado
//      * sobre conteúdo de tamanho zero — a origem do desenho aparecendo
//      * deslocado no canto da área.
//      */
//     const zoomApiRef = useRef(null);
//     const zoomScaleRef = useRef(1);

//     const sizeRef = useRef();
//     const formSizeRef = useRef();

//     const ocrMapperRef = useRef();
//     const ocrMappingRef = useRef([]);
//     const linkMappingRef = useRef([]);

//     const svgRef = useRef();
//     const rootRef = useRef();
//     const selectorRef = useRef();

//     const rootXRef = useRef(0);
//     const rootYRef = useRef(0);
//     const rootScaleRef = useRef(1);
//     const rootRotateRef = useRef(0);

//     /** NOVO: refs/estado para input rápido de link */
//     const editorAreaRef = useRef(null);
//     const quickInputRef = useRef(null);
//     const [quickInput, setQuickInput] = useState({
//       open: false,
//       x: 0,
//       y: 0,
//       svgX: 0,
//       svgY: 0,
//       value: '',
//     });

//     useEffect(() => {
//       if (quickInput.open && quickInputRef.current) {
//         setTimeout(() => {
//           if (quickInputRef.current) {
//             quickInputRef.current.focus({ preventScroll: true });
//             try {
//               quickInputRef.current.select();
//             } catch {}
//           }
//         }, 0);
//       }
//     }, [quickInput.open]);

//     const ACTION_STATE = {
//       select: 'SELECT',
//       deselect: 'DESELECT',
//       move: 'MOVE',
//       moveOne: 'MOVEONE',
//       selectArea: 'SELECTAREA',
//       /** arraste que desenha a área de um novo link (modo sequência) */
//       createArea: 'CREATEAREA',
//       /** arraste da etiqueta, sem mover a área do link */
//       moveRotulo: 'MOVEROTULO',
//     };

//     const INITIAL_STATE = {
//       catalogId: 0,
//       path: '',
//       pageNum: 0,
//       state: 0,
//       type: 0,
//       inDesign: false,
//     };

//     /**
//      * Alias com as chaves em minúsculo para não reescrever as dezenas de
//      * usos já existentes neste arquivo. A fonte única dos valores é
//      * opLinkForma em lib/const.js.
//      */
//     const LINK_FORM_TYPES = {
//       circle: opLinkForma.CIRCULO,
//       rect: opLinkForma.RETANGULO,
//       ocr: opLinkForma.OCR,
//       area: opLinkForma.AREA,
//     };

//     const INITIAL_LINK_CIRCLE = {
//       id: LINK_FORM_TYPES.circle,
//       fontSize: 10,
//       height: 10,
//       width: 0,
//     };

//     const INITIAL_LINK_RECT = {
//       id: LINK_FORM_TYPES.rect,
//       fontSize: 10,
//       height: 20,
//       width: 20,
//     };

//     /**
//      * Área: tamanho inicial usado quando o link é criado por clique
//      * (sem arraste) ou a partir de um marcador de OCR. Quando o usuário
//      * arrasta, o tamanho vem do próprio retângulo desenhado.
//      */
//     const INITIAL_LINK_AREA = {
//       id: LINK_FORM_TYPES.area,
//       fontSize: 7,
//       height: 14,
//       width: 28,
//     };

//     /** limites das formas legadas (círculo e retângulo) */
//     const LINK_SIZE_LIMIT = opLinkTamanho[opLinkForma.CIRCULO];

//     /** limites da área, que precisa cobrir de componentes pequenos a réguas */
//     const LINK_AREA_SIZE_LIMIT = opLinkTamanho[opLinkForma.AREA];

//     const [editor, setEditor] = useState(INITIAL_STATE);
//     const [table, setTable] = useState([]);

//     const [zoomControl, setZoomControl] = useState(false);
//     const [zoomCanMove, setZoomCanMove] = useState(true);
//     const [sizeControl, setSizeControl] = useState(false);

//     /**
//      * Espelhos dos dois modos alternados por atalho (Alt+Z e Alt+S).
//      *
//      * Os handlers de teclado precisam ler o valor ATUAL sem depender do
//      * fechamento da renderização — ver a indireção de onKeyDown mais
//      * abaixo — e também permitem alternar sem efeito colateral dentro do
//      * atualizador de estado.
//      */
//     const zoomControlRef = useRef(false);
//     const sizeControlRef = useRef(false);

//     /**
//      * Legenda de atalhos: fica oculta e é chamada pelo botão "?" da barra
//      * ou pelas teclas "?" / F1. Nunca abre sozinha, para não roubar área
//      * de desenho de quem já conhece os atalhos.
//      */
//     const [atalhosAberto, setAtalhosAberto] = useState(false);
//     const atalhosAbertoRef = useRef(false);

//     /**
//      * Alinha os espelhos com o estado. Feito por efeito para não precisar
//      * alterar todos os pontos que já chamam setZoomControl/setSizeControl
//      * (handleControlClose, troca de forma do link, carga de página).
//      */
//     useEffect(() => {
//       zoomControlRef.current = zoomControl;
//     }, [zoomControl]);

//     useEffect(() => {
//       sizeControlRef.current = sizeControl;
//     }, [sizeControl]);

//     useEffect(() => {
//       atalhosAbertoRef.current = atalhosAberto;
//     }, [atalhosAberto]);

//     const [centralizacaoX, setCentralizacaoX] = useState(0);
//     const [centralizacaoY, setCentralizacaoY] = useState(0);
//     const [pdfTool, setPdfTool] = useState(false);

//     const [currLinkType, setCurrLinkType] = useState(0);
//     const currLinkTypeRef = useRef(INITIAL_LINK_CIRCLE);

//     /**
//      * Rótulo aplicado aos novos links:
//      *  - codigo   : texto do IDITEM dentro da própria forma (legado)
//      *  - nenhum   : sem texto, descrição só no hover e na tabela
//      *  - etiqueta : balão externo com o código + linha de chamada
//      */
//     const [currLinkRotulo, setCurrLinkRotulo] = useState(opLinkRotulo.CODIGO);
//     const currLinkRotuloRef = useRef(opLinkRotulo.CODIGO);

//     /**
//      * Modo criação/sequência: quando ativo, arrastar sobre o desenho cria
//      * a área do próximo item pendente e avança para o seguinte. Enquanto
//      * inativo, todas as interações permanecem idênticas às atuais.
//      */
//     const [modoSequencia, setModoSequencia] = useState(false);
//     const modoSequenciaRef = useRef(false);
//     const [itemSequencia, setItemSequencia] = useState(null);
//     const itemSequenciaRef = useRef(null);

//     /** espelho da tabela de itens, para uso dentro dos handlers de mouse */
//     const tabelaRef = useRef([]);

//     /**
//      * Coordenada inicial do arraste que desenha a área do link.
//      *
//      * Precisa ser um ref PRÓPRIO, e não o startCoordRef compartilhado: o
//      * handleMouseUp chama oClearSelector() ANTES do switch das ações, e
//      * oClearSelector zera startCoordRef/finishCoordRef (eles pertencem ao
//      * seletor do Ctrl+arraste do OCR). Lendo startCoordRef depois disso o
//      * retângulo virava (0,0) -> ponto do mouse, criando o link muito maior
//      * do que o demarcado.
//      */
//     const areaStartRef = useRef(null);

//     /** retângulo temporário exibido durante o arraste de criação da área */
//     const areaDraftRef = useRef(null);

//     const defLinkSize = useRef({
//       height: 0,
//       width: 0,
//     });

//     const hasRunRef = useRef(false);
//     const pagRef = useRef();
//     const [svgReady, setSvgReady] = useState(false);

//     // const [elementToZoom, setElementToZoom] = useState();

//     const oLinkSizeMode = useCallback((height = 0, width = 0) => {
//       setTimeout(() => {
//         const newSizeH = Number(height) || currLinkTypeRef.current.height;
//         const newSizeW = Number(width) || currLinkTypeRef.current.width;

//         if (formSizeRef.current) {
//           formSizeRef.current.setFieldValue('sizeInputH', newSizeH);
//           formSizeRef.current.setFieldValue('sizeInputW', newSizeW);
//         }
//       }, 200);
//     }, []);

//     /** valida e define o tamanho padrão de um link */
//     const oChangeDefLinkSize = useCallback(
//       (height = 0, width = 0, updateDefault = false) => {
//         /** atualiza o tamanho para os links */
//         if (updateDefault) {
//           defLinkSize.current = {
//             height,
//             width,
//           };
//         }
//         /** atualiza informações do campo */
//         oLinkSizeMode(height, width);
//       },
//       [oLinkSizeMode]
//     );

//     useEffect(
//       () => {
//         let currSizeW = 0;
//         let currSizeH = 0;

//         if (sizeControl) {
//           if (focusRef.current) {
//             switch (Number(focusRef.current.node.childNodes[0].dataset.id)) {
//               case LINK_FORM_TYPES.circle:
//                 currSizeW = focusRef.current.node.childNodes[0].getAttribute(
//                   'r'
//                 );
//                 currSizeH = focusRef.current.node.childNodes[0].getAttribute(
//                   'r'
//                 );
//                 break;
//               case LINK_FORM_TYPES.rect:
//               case LINK_FORM_TYPES.area:
//                 currSizeW = focusRef.current.node.childNodes[0].getAttribute(
//                   'width'
//                 );
//                 currSizeH = focusRef.current.node.childNodes[0].getAttribute(
//                   'height'
//                 );
//                 break;
//               default:
//                 break;
//             }
//           }

//           oChangeDefLinkSize(currSizeH, currSizeW);
//         }
//       },
//       // eslint-disable-next-line react-hooks/exhaustive-deps
//       [LINK_FORM_TYPES, sizeControl]
//     );

//     useEffect(() => {
//       if (!pagina) return;

//       const { idPagina, urlEdicao, situacao, tipo } = pagina;
//       const { idCatalogo } = catalogo;

//       setEditor({
//         catalogId: idCatalogo,
//         pageNum: idPagina,
//         path: urlEdicao,
//         state: situacao,
//         type: tipo,
//         inDesign: true,
//       });

//       setZoomControl(false);
//       setSizeControl(false);

//       // handleMapeamentoOCR();
//     }, [catalogo, pagina]);

//     useEffect(() => {
//       if (!itensPagina) return;
//       setTable(
//         itensPagina.map((item) => ({
//           ...item,
//           quantidade: item.quantidade ? Number(item.quantidade) : 0,
//         }))
//       );
//     }, [itensPagina]);

//     const oCheckAssociation = useCallback(() => {
//       onAssociate(linkMappingRef.current.map((item) => getIdItemLink(item)));
//     }, [onAssociate, getIdItemLink]);

//     useImperativeHandle(ref, () => ({
//       highlightLinks: (links) => {
//         linkMappingRef.current = linkMappingRef.current.map((node) => {
//           const classes = node.getAttribute('class');

//           if (links.includes(getIdItemLink(node))) {
//             /** não aplica highlight se ja for um ou se estiver em conflito */
//             if (!classes.includes('highlight') && !classes.includes('warning'))
//               node.setAttribute('class', `${classes} highlight`.trim());
//           } else if (classes && classes.includes('highlight'))
//             node.setAttribute('class', classes.split('highlight')[0].trim());

//           return node;
//         });
//       },
//       getLinked: () => oCheckAssociation(),

//       /** itens da página que ainda não têm link no desenho */
//       getPendentes: () => itensPendentes,

//       /**
//        * Define manualmente o item alvo do modo sequência e liga o modo,
//        * já selecionando a geometria de área — é o que se espera ao clicar
//        * em "mapear este item agora" na tabela.
//        */
//       setItemSequencia: (item) => {
//         handleSelecionarItemSequencia(item);

//         if (!modoSequenciaRef.current) {
//           modoSequenciaRef.current = true;
//           setModoSequencia(true);
//           currLinkTypeRef.current = INITIAL_LINK_AREA;
//           setCurrLinkType(LINK_FORM_TYPES.area);
//         }
//       },

//       /** rola o desenho até o link do item e o destaca */
//       irParaLink: (idItem) => {
//         const alvo = linkMappingRef.current.find(
//           (node) => String(getIdItemLink(node)) === String(idItem)
//         );

//         if (!alvo) return false;

//         handleHoverHighlight(String(idItem), true);

//         if (typeof alvo.scrollIntoView === 'function') {
//           alvo.scrollIntoView({
//             behavior: 'smooth',
//             block: 'center',
//             inline: 'center',
//           });
//         }

//         return true;
//       },
//     }));

//     const handleOCRLimpar = useCallback(() => {
//       /** limpa coleção e coordenadas */
//       ocrMappingRef.current = [];

//       selectorRef.current.setAttribute('x', 0);
//       selectorRef.current.setAttribute('y', 0);
//       selectorRef.current.setAttribute('width', 0);
//       selectorRef.current.setAttribute('height', 0);

//       /** remove grupo do SVG */
//       const ocrMapper = Array.from(rootRef.current.childNodes).find(
//         (attr) => attr.id === 'ocrGroup'
//       );
//       if (ocrMapper) {
//         ocrMapper.remove();
//       }
//       ocrMapperRef.current = null;
//     }, []);

//     // const handleMappedAutom = useCallback(async () => {
//     //   if (onBeforeOCR) {
//     //     onBeforeOCR();
//     //   }

//     //   try {
//     //     handleOCRLimpar();

//     //     const ocrMapper = document.createElementNS(
//     //       rootRef.current.namespaceURI,
//     //       'g'
//     //     );
//     //     ocrMapper.setAttribute('id', 'ocrGroup');
//     //     rootRef.current.appendChild(ocrMapper);
//     //     ocrMapperRef.current = ocrMapper;

//     //     const { idCatalogo } = catalogo;
//     //     const { idPagina } = pagina;

//     //     const { data } = await api.get(
//     //       `/editor-associar-autom/${idCatalogo}/pagina/${idPagina}`
//     //     );

//     //     data.forEach((pt, index) => {
//     //       const link = document.createElementNS(
//     //         svgRef.current.namespaceURI,
//     //         'a'
//     //       );
//     //       link.id = String(index);
//     //       link.setAttribute('x', pt.x);
//     //       link.setAttribute('y', pt.y - 5);
//     //       link.setAttribute('class', '');
//     //       link.addEventListener('click', (e) => e.preventDefault());
//     //       ocrMapperRef.current.appendChild(link);

//     //       const linkForm = document.createElementNS(
//     //         svgRef.current.namespaceURI,
//     //         'rect'
//     //       );

//     //       const linkText = document.createElementNS(
//     //         svgRef.current.namespaceURI,
//     //         'text'
//     //       );

//     //       const linkFormWidth = pt.text.length * 6;

//     //       linkForm.setAttribute('x', pt.x + 10);
//     //       linkForm.setAttribute('y', pt.y - 5);
//     //       linkForm.setAttribute('height', '15');
//     //       linkForm.setAttribute('width', `${linkFormWidth}`);
//     //       linkForm.setAttribute('class', pt.conf > 70 ? 'success' : 'warning');
//     //       linkForm.setAttribute('data-id', LINK_FORM_TYPES.ocr);
//     //       link.appendChild(linkForm);

//     //       linkText.setAttribute('x', pt.x + 10);
//     //       linkText.setAttribute('y', pt.y + 5);
//     //       linkText.setAttribute('font-size', '10');
//     //       linkText.setAttribute('class', pt.conf > 70 ? 'success' : 'warning');
//     //       linkText.textContent = pt.text;
//     //       link.appendChild(linkText);

//     //       ocrMappingRef.current.push({ attr: link, ocr: pt });
//     //     });
//     //   } catch (err) {
//     //     toast.error(err);
//     //   } finally {
//     //     if (onAfterOCR) {
//     //       onAfterOCR();
//     //     }
//     //   }
//     // }, [onBeforeOCR, onAfterOCR, handleOCRLimpar, catalogo, pagina]);

//     // useEffect(() => {
//     //   handleMappedAutom();
//     // }, [handleMappedAutom]);

//     // useEffect(() => {
//     //   // sem dados ainda? sai quietinho, e espera a próxima render
//     //   if (!catalogo?.idCatalogo || !pagina?.idPagina) return;
//     //   if (!rootRef.current || !svgRef.current) return;

//     //   if (
//     //     // hasRunRef.current &&
//     //     pagRef.current === pagina.idPagina
//     //   )
//     //     return;

//     //   // hasRunRef.current = true; // marca que já executou
//     //   pagRef.current = pagina.idPagina;

//     //   const handleMappedAutom = async () => {
//     //     if (onBeforeOCR) {
//     //       onBeforeOCR();
//     //     }

//     //     try {
//     //       handleOCRLimpar();

//     //       const ocrMapper = document.createElementNS(
//     //         rootRef.current.namespaceURI,
//     //         'g'
//     //       );
//     //       ocrMapper.setAttribute('id', 'ocrGroup');
//     //       rootRef.current.appendChild(ocrMapper);
//     //       ocrMapperRef.current = ocrMapper;

//     //       const { idCatalogo } = catalogo;
//     //       const { idPagina } = pagina;

//     //       const { data } = await api.get(
//     //         `/editor-associar-autom/${idCatalogo}/pagina/${idPagina}`
//     //       );

//     //       data.forEach((pt, index) => {
//     //         const link = document.createElementNS(
//     //           svgRef.current.namespaceURI,
//     //           'a'
//     //         );
//     //         link.id = String(index);
//     //         link.setAttribute('x', pt.x);
//     //         link.setAttribute('y', pt.y - 5);
//     //         link.setAttribute('class', '');
//     //         link.addEventListener('click', (e) => e.preventDefault());
//     //         ocrMapperRef.current.appendChild(link);

//     //         const linkForm = document.createElementNS(
//     //           svgRef.current.namespaceURI,
//     //           'rect'
//     //         );

//     //         const linkText = document.createElementNS(
//     //           svgRef.current.namespaceURI,
//     //           'text'
//     //         );

//     //         const linkFormWidth = pt.text.length * 6;

//     //         linkForm.setAttribute('x', pt.x + 10);
//     //         linkForm.setAttribute('y', pt.y - 5);
//     //         linkForm.setAttribute('height', '15');
//     //         linkForm.setAttribute('width', `${linkFormWidth}`);
//     //         linkForm.setAttribute(
//     //           'class',
//     //           pt.conf > 70 ? 'success' : 'warning'
//     //         );
//     //         linkForm.setAttribute('data-id', LINK_FORM_TYPES.ocr);
//     //         link.appendChild(linkForm);

//     //         linkText.setAttribute('x', pt.x + 10);
//     //         linkText.setAttribute('y', pt.y + 5);
//     //         linkText.setAttribute('font-size', '10');
//     //         linkText.setAttribute(
//     //           'class',
//     //           pt.conf > 70 ? 'success' : 'warning'
//     //         );
//     //         linkText.textContent = pt.text;
//     //         link.appendChild(linkText);

//     //         ocrMappingRef.current.push({ attr: link, ocr: pt });
//     //       });
//     //     } catch (err) {
//     //       toast.error(err);
//     //     } finally {
//     //       if (onAfterOCR) {
//     //         onAfterOCR();
//     //       }
//     //     }
//     //   };

//     //   handleMappedAutom();
//     // }, [
//     //   catalogo?.idCatalogo,
//     //   pagina?.idPagina,
//     //   onBeforeOCR,
//     //   onAfterOCR,
//     //   handleOCRLimpar,
//     // ]);

//     // useEffect(() => {
//     //   // ainda sem dados? espera a próxima render
//     //   if (!catalogo?.idCatalogo || !pagina?.idPagina) return;

//     //   // SVG ainda não foi carregado pra essa página
//     //   if (!svgReady) return;

//     //   if (!rootRef.current || !svgRef.current) return;

//     //   // já rodou pra essa página? então não faz de novo
//     //   if (pagRef.current === pagina.idPagina) return;

//     //   pagRef.current = pagina.idPagina;

//     //   const handleMappedAutom = async () => {
//     //     if (onBeforeOCR) {
//     //       onBeforeOCR();
//     //     }

//     //     try {
//     //       handleOCRLimpar();

//     //       const ocrMapper = document.createElementNS(
//     //         rootRef.current.namespaceURI,
//     //         'g'
//     //       );
//     //       ocrMapper.setAttribute('id', 'ocrGroup');
//     //       rootRef.current.appendChild(ocrMapper);
//     //       ocrMapperRef.current = ocrMapper;

//     //       const { idCatalogo } = catalogo;
//     //       const { idPagina } = pagina;

//     //       const { data } = await api.get(
//     //         `/editor-associar-autom/${idCatalogo}/pagina/${idPagina}`
//     //       );

//     //       data.forEach((pt, index) => {
//     //         const link = document.createElementNS(
//     //           svgRef.current.namespaceURI,
//     //           'a'
//     //         );
//     //         link.id = String(index);
//     //         link.setAttribute('x', pt.x);
//     //         link.setAttribute('y', pt.y - 5);
//     //         link.setAttribute('class', '');
//     //         link.addEventListener('click', (e) => e.preventDefault());
//     //         ocrMapperRef.current.appendChild(link);

//     //         const linkForm = document.createElementNS(
//     //           svgRef.current.namespaceURI,
//     //           'rect'
//     //         );

//     //         const linkText = document.createElementNS(
//     //           svgRef.current.namespaceURI,
//     //           'text'
//     //         );

//     //         const linkFormWidth = pt.text.length * 6;

//     //         linkForm.setAttribute('x', pt.x + 10);
//     //         linkForm.setAttribute('y', pt.y - 5);
//     //         linkForm.setAttribute('height', '15');
//     //         linkForm.setAttribute('width', `${linkFormWidth}`);
//     //         linkForm.setAttribute(
//     //           'class',
//     //           pt.conf > 70 ? 'success' : 'warning'
//     //         );
//     //         linkForm.setAttribute('data-id', LINK_FORM_TYPES.ocr);
//     //         link.appendChild(linkForm);

//     //         linkText.setAttribute('x', pt.x + 10);
//     //         linkText.setAttribute('y', pt.y + 5);
//     //         linkText.setAttribute('font-size', '10');
//     //         linkText.setAttribute(
//     //           'class',
//     //           pt.conf > 70 ? 'success' : 'warning'
//     //         );
//     //         linkText.textContent = pt.text;
//     //         link.appendChild(linkText);

//     //         ocrMappingRef.current.push({ attr: link, ocr: pt });
//     //       });
//     //     } catch (err) {
//     //       toast.error(err);
//     //     } finally {
//     //       if (onAfterOCR) {
//     //         onAfterOCR();
//     //       }
//     //     }
//     //   };

//     //   handleMappedAutom();
//     // }, [
//     //   catalogo?.idCatalogo,
//     //   pagina?.idPagina,
//     //   svgReady, // NOVO: só roda quando o SVG dessa página estiver pronto
//     //   onBeforeOCR,
//     //   onAfterOCR,
//     //   handleOCRLimpar,
//     // ]);

//     const handleOCRLocalizar = useCallback(
//       async (tipoExtracao = opEditorAssociarTipoExtracao.TRADICIONAL) => {
//         /** executa evento antes da consulta */
//         if (onBeforeOCR) {
//           onBeforeOCR();
//         }

//         try {
//           const x = selectorRef.current.x.baseVal.value;
//           const y = selectorRef.current.y.baseVal.value;
//           const width = selectorRef.current.width.baseVal.value;
//           const height = selectorRef.current.height.baseVal.value;

//           /** limpa mapeamento anterior */
//           handleOCRLimpar();

//           /** cria grupo para mapeamento do serviço de OCR */
//           const ocrMapper = document.createElementNS(
//             rootRef.current.namespaceURI,
//             'svg:g',
//             rootRef.current
//           );
//           ocrMapper.setAttribute('id', 'ocrGroup');
//           rootRef.current.appendChild(ocrMapper);

//           ocrMapperRef.current = ocrMapper;

//           const response = await api.post(
//             `/editor-associar/${catalogo.idCatalogo}/pagina/${pagina.idPagina}`,
//             { tipoExtracao, parametros: { x, y, width, height } }
//           );

//           /** cria links OCR */
//           response.data.forEach((pt, index) => {
//             /** cria elemento */
//             const link = document.createElementNS(
//               svgRef.current.namespaceURI,
//               'a',
//               svgRef.current
//             );
//             link.id = index;
//             link.setAttribute('x', pt.x);
//             link.setAttribute('y', pt.y - 5);
//             link.setAttribute('class', '');
//             // código preventivo para o link não ser executado no design
//             link.addEventListener('click', (e) => e.preventDefault());
//             ocrMapperRef.current.appendChild(link);

//             /** cria retângulo ocr */
//             const linkForm = document.createElementNS(
//               svgRef.current.namespaceURI,
//               'svg:rect',
//               svgRef.current
//             );

//             /** cria texto */
//             const linkText = document.createElementNS(
//               svgRef.current.namespaceURI,
//               'svg:text',
//               svgRef.current
//             );

//             const linkFormWidth = pt.text.length * 6;

//             linkForm.setAttribute('x', pt.x + 10);
//             linkForm.setAttribute('y', pt.y - 5);
//             linkForm.setAttribute('height', '15px');
//             linkForm.setAttribute('width', `${linkFormWidth}px`);
//             linkForm.setAttribute(
//               'class',
//               pt.conf > 70 ? 'success' : 'warning'
//             );
//             linkForm.setAttribute('data-id', LINK_FORM_TYPES.ocr);
//             link.appendChild(linkForm);

//             linkText.setAttribute('x', pt.x + 10);
//             linkText.setAttribute('y', pt.y + 10 - 5);
//             linkText.setAttribute('font-size', '10px');
//             linkText.setAttribute(
//               'class',
//               pt.conf > 70 ? 'success' : 'warning'
//             );
//             linkText.textContent = pt.text;
//             link.appendChild(linkText);

//             ocrMappingRef.current.push({ attr: link, ocr: pt });
//           });
//         } catch (err) {
//           toast.error(err);
//         } finally {
//           /** executa evento depois da consulta */
//           if (onAfterOCR) {
//             onAfterOCR();
//           }
//         }
//       },
//       [
//         LINK_FORM_TYPES,
//         svgRef,
//         selectorRef,
//         catalogo,
//         pagina,
//         handleOCRLimpar,
//         onBeforeOCR,
//         onAfterOCR,
//       ]
//     );

//     const handlePDFLocalizar = useCallback(
//       async (tipoExtracao = opEditorAssociarTipoExtracao.TRADICIONAL) => {
//         /** executa evento antes da consulta */
//         if (onBeforeOCR) {
//           onBeforeOCR();
//         }
//         setPdfTool(true);
//         try {
//           const { x, y, width, height } = getSvgCoordinates(selectorRef);
//           /** limpa mapeamento anterior */
//           handleOCRLimpar();
//           const ocrMapper = createOcrGroup(rootRef);
//           ocrMapperRef.current = ocrMapper;

//           const response = await api.post(
//             `/editor-associar/${catalogo.idCatalogo}/pagina/${pagina.idPagina}`,
//             { tipoExtracao, parametros: { x, y, width, height } }
//           );

//           /** cria links PDF */
//           response.data.forEach((pt, index) => {
//             const link = createSvgLinkPdfProcess(
//               svgRef.current.namespaceURI,
//               ocrMapperRef,
//               pt,
//               index
//             );
//             ocrMappingRef.current.push({ attr: link, ocr: pt });
//           });

//           const { centroX, centroY } = centerCalculation(
//             pagina.orientacaoImagem,
//             x,
//             y,
//             width,
//             height
//           );

//           centerSvgPdfProcess(svgRef, rootRef, centroX, centroY);
//           setCentralizacaoX(centroX);
//           setCentralizacaoY(centroY);
//         } catch (err) {
//           toast.error(err);
//         } finally {
//           /** executa evento depois da consulta */
//           if (onAfterOCR) {
//             onAfterOCR();
//           }
//         }
//       },
//       [
//         svgRef,
//         selectorRef,
//         catalogo,
//         pagina,
//         handleOCRLimpar,
//         onBeforeOCR,
//         onAfterOCR,
//       ]
//     );

//     const handlePositionPdfProcess = useCallback((coordX, coordY) => {
//       updateSvgPositionProcessPdf(svgRef, rootRef, coordX, coordY);
//     }, []);

//     const handleCenterPdfProcess = useCallback(() => {
//       centerSvgPdfProcess(svgRef, rootRef, centralizacaoX, centralizacaoY);
//     }, [centralizacaoX, centralizacaoY]);

//     const handleScalePdfProcess = useCallback(
//       (valor) => {
//         scaleSvgProcessPdf(svgRef, rootRef, rootScaleRef, valor);
//         centerSvgPdfProcess(svgRef, rootRef, centralizacaoX, centralizacaoY);
//       },
//       [centralizacaoX, centralizacaoY]
//     );

//     /**
//      * IDITEM de um link, lido do href.
//      *
//      * Antes a associação item x link usava o textContent do <text> interno.
//      * Isso deixou de funcionar com o rótulo "nenhum" (link sem texto) e com
//      * o rótulo "etiqueta" (o textContent passa a ser o texto do balão).
//      * O href tem o formato /{idCatalogo}/{idPagina}/{idItem} e é a mesma
//      * fonte que a Home usa em Pagina/index.js -> handleLink, portanto é a
//      * chave mais confiável. O textContent fica só como retrocompatibilidade
//      * para eventuais links sem href.
//      */
//     const getIdItemLink = useCallback((node) => {
//       if (!node) return '';

//       const href =
//         node.getAttribute('xlink:href') ||
//         (node.href && node.href.baseVal) ||
//         node.getAttribute('href') ||
//         '';

//       const partes = String(href)
//         .split('/')
//         .filter((parte) => parte !== '');
//       const idItem = partes.length ? partes[partes.length - 1] : '';

//       return idItem || String(node.textContent || '').trim();
//     }, []);

//     const handleHoverHighlight = useCallback(
//       (id, state) => {
//         linkMappingRef.current.forEach((node) => {
//           const classes = node.getAttribute('class');

//           if (getIdItemLink(node) === id)
//             node.setAttribute(
//               'class',
//               (state
//                 ? `${classes} highlight`
//                 : classes.split('highlight')[0]
//               ).trim()
//             );
//         });

//         const highlightedItems = linkMappingRef.current
//           .filter((node) => node.getAttribute('class').includes('highlight'))
//           .map((node) => getIdItemLink(node));

//         onLinkHighlight(highlightedItems, 'editor');
//       },
//       [onLinkHighlight, getIdItemLink]
//     );

//     const mappingElement = useCallback(
//       (lstNode) => {
//         Array.from(lstNode).map((node) => {
//           if (
//             node.nodeName === 'svg:path' ||
//             node.nodeName === 'svg:rect' ||
//             node.nodeName === 'svg:image' ||
//             node.nodeName === 'a'
//           ) {
//             /** tratamento para links já carregados */
//             if (node.nodeName === 'a') {
//               /** coloca o nome do grupo do link */
//               if (node.parentElement.nodeName === 'svg:g') {
//                 node.parentElement.id = 'linkGroup';
//               }
//               node.setAttribute('class', '');
//               node.addEventListener('click', (e) => e.preventDefault());
//               node.addEventListener('mouseenter', () => {
//                 handleHoverHighlight(getIdItemLink(node), true);
//               });
//               node.addEventListener('mouseleave', () => {
//                 handleHoverHighlight(getIdItemLink(node), false);
//               });

//               linkMappingRef.current.push(node);
//             }

//             node.id = Math.random();
//           }

//           if (node.hasChildNodes()) {
//             return mappingElement(node.childNodes);
//           }

//           return node;
//         });
//       },
//       [handleHoverHighlight]
//     );

//     /**
//      * Cria os elementos do rótulo de um link.
//      *
//      * - opLinkRotulo.CODIGO  : <text> centralizado na própria forma
//      * - opLinkRotulo.NENHUM  : nada (descrição só no hover e na tabela)
//      * - opLinkRotulo.ETIQUETA: <path data-role="chamada"> +
//      *                          <rect data-role="rotulo"> +
//      *                          <text data-role="rotulo-texto">
//      *
//      * A ordem de inserção importa: a forma principal continua sendo
//      * childNodes[0], pois todo o restante do editor (seleção, conflito,
//      * redimensionamento) depende disso.
//      */
//     const oCriarRotuloLink = useCallback(
//       ({ link, forma, rotulo, texto, fontSize }) => {
//         const ns = svgRef.current.namespaceURI;

//         if (rotulo === opLinkRotulo.NENHUM) return;

//         const caixa = getCaixaForma(forma);

//         if (rotulo === opLinkRotulo.ETIQUETA) {
//           const alturaRotulo = fontSize + 5;
//           const larguraRotulo = larguraEstimadaRotulo(texto, fontSize);

//           /**
//            * Posição inicial da etiqueta: acima e à direita da área, com
//            * um deslocamento proporcional à própria etiqueta. O usuário
//            * reposiciona arrastando a etiqueta (a área não se move).
//            */
//           const caixaRotulo = {
//             x: caixa.x + caixa.width + alturaRotulo,
//             y: caixa.y - alturaRotulo * 1.6,
//             width: larguraRotulo,
//             height: alturaRotulo,
//           };

//           const ancora = calcularAncoraChamada(caixa, caixaRotulo);

//           const chamada = criarLinhaChamada(
//             ns,
//             ancora.x1,
//             ancora.y1,
//             ancora.x2,
//             ancora.y2
//           );
//           link.appendChild(chamada);

//           const caixaEtiqueta = document.createElementNS(ns, 'svg:rect');
//           caixaEtiqueta.setAttribute('data-role', opLinkPapel.ROTULO);
//           caixaEtiqueta.setAttribute('x', caixaRotulo.x);
//           caixaEtiqueta.setAttribute('y', caixaRotulo.y);
//           caixaEtiqueta.setAttribute('width', caixaRotulo.width);
//           caixaEtiqueta.setAttribute('height', caixaRotulo.height);
//           /** rx/ry são obrigatórios: sem eles o svgo converte o rect em path */
//           caixaEtiqueta.setAttribute('rx', '3');
//           caixaEtiqueta.setAttribute('ry', '3');
//           caixaEtiqueta.setAttribute('fill', opLinkEstilo.ROTULO_FILL);
//           caixaEtiqueta.setAttribute(
//             'fill-opacity',
//             opLinkEstilo.ROTULO_FILL_OPACITY
//           );
//           caixaEtiqueta.setAttribute('stroke', opLinkEstilo.COR);
//           caixaEtiqueta.setAttribute('stroke-width', opLinkEstilo.ESPESSURA);
//           link.appendChild(caixaEtiqueta);

//           const textoEtiqueta = document.createElementNS(ns, 'svg:text');
//           textoEtiqueta.setAttribute('data-role', opLinkPapel.ROTULO_TEXTO);
//           textoEtiqueta.setAttribute(
//             'x',
//             caixaRotulo.x + caixaRotulo.width / 2
//           );
//           textoEtiqueta.setAttribute(
//             'y',
//             caixaRotulo.y + caixaRotulo.height / 2
//           );
//           textoEtiqueta.setAttribute('text-anchor', 'middle');
//           textoEtiqueta.setAttribute('alignment-baseline', 'middle');
//           textoEtiqueta.setAttribute('font-size', `${fontSize}px`);
//           textoEtiqueta.setAttribute('fill', opLinkEstilo.COR_TEXTO);
//           textoEtiqueta.textContent = texto;
//           link.appendChild(textoEtiqueta);

//           return;
//         }

//         /**
//          * opLinkRotulo.CODIGO: texto dentro da forma.
//          *
//          * Não define "fill" de propósito — os links legados nunca tiveram
//          * esse atributo e o CSS da Home depende do fill herdado
//          * (regra "text:hover { fill: #fff }" em Pagina/styles.js).
//          */
//         const textoInterno = document.createElementNS(ns, 'svg:text');
//         textoInterno.setAttribute('x', caixa.x + caixa.width / 2);
//         textoInterno.setAttribute('y', caixa.y + caixa.height / 2);
//         textoInterno.setAttribute('text-anchor', 'middle');
//         textoInterno.setAttribute('alignment-baseline', 'middle');
//         textoInterno.setAttribute('font-size', `${fontSize}px`);
//         textoInterno.textContent = texto;
//         link.appendChild(textoInterno);
//       },
//       []
//     );

//     /** elementos internos de um link, por papel (data-role) */
//     const getPartesLink = useCallback((link) => {
//       const partes = {
//         area: null,
//         chamada: null,
//         rotulo: null,
//         rotuloTexto: null,
//       };

//       if (!link || !link.childNodes) return partes;

//       Array.from(link.childNodes).forEach((filho) => {
//         switch (getPapelLink(filho)) {
//           case opLinkPapel.AREA:
//             partes.area = filho;
//             break;
//           case opLinkPapel.CHAMADA:
//             partes.chamada = filho;
//             break;
//           case opLinkPapel.ROTULO:
//             partes.rotulo = filho;
//             break;
//           case opLinkPapel.ROTULO_TEXTO:
//             partes.rotuloTexto = filho;
//             break;
//           default:
//             break;
//         }
//       });

//       /** formas legadas não têm data-role: a forma principal é a primeira */
//       if (!partes.area) partes.area = getFormaPrincipal(link);

//       return partes;
//     }, []);

//     /**
//      * Recalcula a linha de chamada a partir das posições atuais da área e
//      * da etiqueta. Necessário depois de arrastar só a etiqueta ou de
//      * redimensionar a área.
//      */
//     const oReancorarChamada = useCallback(
//       (link) => {
//         const { area, chamada, rotulo } = getPartesLink(link);

//         if (!area || !chamada || !rotulo) return;

//         const ancora = calcularAncoraChamada(
//           getCaixaForma(area),
//           getCaixaForma(rotulo)
//         );

//         if (ancora) {
//           atualizarLinhaChamada(
//             chamada,
//             ancora.x1,
//             ancora.y1,
//             ancora.x2,
//             ancora.y2
//           );
//         }
//       },
//       [getPartesLink]
//     );

//     /**
//      * true quando um arraste sobre o desenho deve DESENHAR a área de um
//      * novo link.
//      *
//      * Vale tanto no modo sequência (o item alvo já está definido) quanto com
//      * a geometria de ÁREA selecionada fora dele — nesse caso o ID do item é
//      * pedido no input rápido ao terminar o arraste.
//      */
//     const podeDesenharArea = useCallback(() => {
//       if (modoSequenciaRef.current && itemSequenciaRef.current) return true;

//       return (
//         Number(currLinkTypeRef.current && currLinkTypeRef.current.id) ===
//         LINK_FORM_TYPES.area
//       );
//       // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, []);

//     /** true quando o alvo do mouse é a etiqueta (caixa ou texto) do link */
//     const isAlvoRotulo = useCallback((target) => {
//       const papel = getPapelLink(target);
//       return papel === opLinkPapel.ROTULO || papel === opLinkPapel.ROTULO_TEXTO;
//     }, []);

//     /**
//      * true quando o alvo do mouse é uma forma clicável de link.
//      *
//      * Compara pelo nome LOCAL do elemento: o SVG das páginas usa prefixo de
//      * namespace (svg:rect) mas nem toda origem de arquivo mantém o prefixo,
//      * e agora também existe a elipse. A verificação antiga era
//      * nodeName === 'svg:circle' || nodeName === 'svg:rect'.
//      */
//     const isAlvoLink = useCallback(
//       (target) => {
//         if (!target || !target.parentElement) return false;

//         /** só conta se o pai for o próprio <a> do link */
//         if (getNomeLocalSvg(target.parentElement) !== 'a') return false;

//         return isFormaLink(target) || isAlvoRotulo(target);
//       },
//       [isAlvoRotulo]
//     );

//     /**
//      * Retângulo temporário do arraste de área, criado sob demanda.
//      * É recriado se tiver sido removido (por exemplo ao salvar), para o
//      * arraste não deixar de funcionar depois de uma gravação.
//      */
//     const oGetAreaDraft = useCallback(() => {
//       if (areaDraftRef.current && areaDraftRef.current.parentNode) {
//         return areaDraftRef.current;
//       }

//       if (!rootRef.current) return null;

//       const areaDraft = document.createElementNS(
//         rootRef.current.namespaceURI,
//         'rect',
//         rootRef.current
//       );
//       areaDraft.setAttribute('id', 'areaDraft');
//       areaDraft.setAttribute('stroke', opLinkEstilo.COR);
//       areaDraft.setAttribute('stroke-width', '0.8');
//       areaDraft.setAttribute('stroke-dasharray', '3 2');
//       areaDraft.setAttribute('fill', opLinkEstilo.COR);
//       areaDraft.setAttribute('fill-opacity', '0.18');
//       areaDraft.setAttribute('pointer-events', 'none');
//       areaDraft.setAttribute('x', 0);
//       areaDraft.setAttribute('y', 0);
//       areaDraft.setAttribute('width', 0);
//       areaDraft.setAttribute('height', 0);
//       rootRef.current.appendChild(areaDraft);
//       areaDraftRef.current = areaDraft;

//       return areaDraft;
//     }, []);

//     /** referência do link cuja etiqueta está sendo arrastada */
//     const rotuloDragRef = useRef(null);

//     /**
//      * Retângulo já desenhado pelo usuário que está aguardando o ID do item.
//      * Usado quando a geometria de ÁREA é arrastada FORA do modo sequência:
//      * o tamanho vem do arraste e o item é informado no input rápido.
//      */
//     const areaPendenteRef = useRef(null);

//     /**
//      * Um link é "composto" quando tem mais de dois elementos internos:
//      * área com etiqueta (área + chamada + caixa + texto) ou qualquer forma
//      * sem rótulo. Nesses casos a regra legada de mover apenas
//      * childNodes[0] (forma) e childNodes[1] (texto) não se aplica — é
//      * preciso transladar todos os filhos.
//      *
//      * Links legados (círculo/retângulo com o código dentro) continuam
//      * pelo caminho antigo, preservando o comportamento atual.
//      */
//     const oUsaTranslacaoGenerica = useCallback(
//       (node, tipo) => {
//         if (Number(tipo) === LINK_FORM_TYPES.area) return true;

//         const rotuloAtual =
//           (node && node.dataset && node.dataset.rotulo) || opLinkRotulo.CODIGO;

//         return rotuloAtual !== opLinkRotulo.CODIGO;
//       },
//       // eslint-disable-next-line react-hooks/exhaustive-deps
//       []
//     );

//     const createLink = useCallback(
//       (
//         type,
//         x,
//         y,
//         radius,
//         height,
//         width,
//         id,
//         text,
//         textSize,
//         href,
//         rotulo = opLinkRotulo.CODIGO
//       ) => {
//         /** verifica se o grupo dos links já foi criado */
//         linkRef.current = document.getElementById('linkGroup');
//         if (!linkRef.current) {
//           linkRef.current = document.createElementNS(
//             svgRef.current.namespaceURI,
//             'svg:g',
//             svgRef.current
//           );
//           linkRef.current.id = 'linkGroup';

//           /** adiciona elementos no nó raiz */
//           rootRef.current.appendChild(linkRef.current);
//         }

//         /** criando o elemento link do item */
//         const link = document.createElementNS(
//           svgRef.current.namespaceURI,
//           'a',
//           svgRef.current
//         );

//         link.setAttribute('xlink:href', href);
//         link.setAttribute('target', '_blank');
//         link.setAttribute('class', '');
//         link.id = id;

//         /**
//          * Registra o tipo de rótulo no próprio <a>. O atributo data-* é
//          * preservado pelo svgo do backend, então o editor sabe como tratar
//          * o link ao reabrir a página. Links legados não têm o atributo e
//          * são interpretados como opLinkRotulo.CODIGO.
//          */
//         if (rotulo && rotulo !== opLinkRotulo.CODIGO) {
//           link.setAttribute('data-rotulo', rotulo);
//         }
//         /** código preventivo para o link não ser executado no design */
//         link.addEventListener('click', (e) => e.preventDefault());

//         link.addEventListener('mouseenter', () => {
//           if (link.matches(':hover'))
//             handleHoverHighlight(getIdItemLink(link), true);
//         });
//         link.addEventListener('mouseleave', () => {
//           if (!link.matches(':hover'))
//             handleHoverHighlight(getIdItemLink(link), false);
//         });

//         linkRef.current.appendChild(link);

//         let linkForm;

//         /** define o formato do link */
//         switch (type) {
//           /** cria círculo */
//           case LINK_FORM_TYPES.circle:
//             linkForm = document.createElementNS(
//               svgRef.current.namespaceURI,
//               'svg:circle',
//               svgRef.current
//             );

//             linkForm.setAttribute('data-id', String(LINK_FORM_TYPES.circle));
//             linkForm.setAttribute('class', 'inject');
//             linkForm.setAttribute('stroke', '#ccc');
//             linkForm.setAttribute('fill', '#fff');
//             linkForm.setAttribute('cx', x + 18);
//             linkForm.setAttribute('cy', y);
//             linkForm.setAttribute('r', radius);
//             link.appendChild(linkForm);

//             oCriarRotuloLink({
//               link,
//               forma: linkForm,
//               rotulo,
//               texto: text,
//               fontSize: radius,
//             });

//             break;
//           /** cria retângulo */
//           case LINK_FORM_TYPES.rect:
//             linkForm = document.createElementNS(
//               svgRef.current.namespaceURI,
//               'svg:rect',
//               svgRef.current
//             );

//             linkForm.setAttribute('data-id', String(LINK_FORM_TYPES.rect));
//             linkForm.setAttribute('class', 'inject');
//             linkForm.setAttribute('stroke', '#ccc');
//             linkForm.setAttribute('fill', '#fff');
//             linkForm.setAttribute('x', Number(x - textSize / 2));
//             linkForm.setAttribute('y', Number(y - 10));
//             linkForm.setAttribute('height', height);
//             linkForm.setAttribute('width', width);
//             linkForm.setAttribute('rx', '2');
//             linkForm.setAttribute('ry', '2');
//             link.appendChild(linkForm);

//             oCriarRotuloLink({
//               link,
//               forma: linkForm,
//               rotulo,
//               texto: text,
//               fontSize: Math.trunc(height / 2),
//             });
//             break;

//           /**
//            * Área: retângulo desenhado sobre o contorno real do componente.
//            * Aqui x/y são o canto superior esquerdo (e não o centro, como
//            * nas formas legadas) e width/height vêm do arraste do usuário.
//            */
//           case LINK_FORM_TYPES.area: {
//             linkForm = document.createElementNS(
//               svgRef.current.namespaceURI,
//               'svg:rect',
//               svgRef.current
//             );

//             const areaW = Math.max(
//               LINK_AREA_SIZE_LIMIT.min,
//               Math.min(LINK_AREA_SIZE_LIMIT.max, Number(width) || 0)
//             );
//             const areaH = Math.max(
//               LINK_AREA_SIZE_LIMIT.min,
//               Math.min(LINK_AREA_SIZE_LIMIT.max, Number(height) || 0)
//             );

//             linkForm.setAttribute('data-id', String(LINK_FORM_TYPES.area));
//             linkForm.setAttribute('data-role', opLinkPapel.AREA);
//             linkForm.setAttribute('class', 'inject');
//             linkForm.setAttribute('x', Number(x));
//             linkForm.setAttribute('y', Number(y));
//             linkForm.setAttribute('width', areaW);
//             linkForm.setAttribute('height', areaH);
//             /** rx/ry são obrigatórios: sem eles o svgo converte o rect em path */
//             linkForm.setAttribute('rx', '2');
//             linkForm.setAttribute('ry', '2');
//             linkForm.setAttribute('stroke', opLinkEstilo.COR);
//             linkForm.setAttribute('stroke-width', opLinkEstilo.ESPESSURA);
//             /**
//              * O preenchimento translúcido é intencional: com fill="none" a
//              * área só é clicável na borda, e com opacity 0 o plugin
//              * removeHiddenElems do svgo apagaria o link inteiro ao salvar.
//              */
//             linkForm.setAttribute('fill', opLinkEstilo.COR);
//             linkForm.setAttribute(
//               'fill-opacity',
//               opLinkEstilo.AREA_FILL_OPACITY
//             );
//             link.appendChild(linkForm);

//             oCriarRotuloLink({
//               link,
//               forma: linkForm,
//               rotulo,
//               texto: text,
//               fontSize: Number(textSize) || INITIAL_LINK_AREA.fontSize,
//             });
//             break;
//           }
//           default:
//             break;
//         }

//         linkMappingRef.current.push(link);
//       },
//       // eslint-disable-next-line react-hooks/exhaustive-deps
//       [LINK_FORM_TYPES, handleHoverHighlight, oCriarRotuloLink]
//     );

//     const oCheckConflict = useCallback(() => {
//       /** desconta padding como margem de segurança */
//       const padding = 3;

//       if (!(linkMappingRef && linkMappingRef.current)) return;

//       const mappingPos = linkMappingRef.current.map((item) => {
//         const shape = item.childNodes[0];

//         /** reprocessa os itens com classe padrão */
//         shape.setAttribute('class', 'inject');

//         if (shape.nodeName === 'svg:circle') {
//           const cx = Number(shape.getAttribute('cx'));
//           const cy = Number(shape.getAttribute('cy'));
//           const r = Number(shape.getAttribute('r'));

//           const top = cy - r;
//           const left = cx - r;
//           const width = r * 2;
//           const height = r * 2;

//           return { shape, top, left, width, height };
//         }

//         const left = Number(shape.getAttribute('x'));
//         const top = Number(shape.getAttribute('y'));
//         const width = Number(shape.getAttribute('width'));
//         const height = Number(shape.getAttribute('height'));

//         return { shape, top, left, width, height };
//       });

//       mappingPos.forEach((item) => {
//         const conflicts = mappingPos.filter(
//           (itemFilter) =>
//             (item.left - padding >= itemFilter.left ||
//               item.left - padding + item.width >= itemFilter.left) &&
//             item.left + item.width / 2 - padding <=
//               itemFilter.left + itemFilter.width &&
//             (item.top - padding >= itemFilter.top ||
//               item.top + item.height - padding >= itemFilter.top) &&
//             item.top + item.height / 2 - padding <=
//               itemFilter.top + itemFilter.height
//         );

//         if (conflicts.length > 1) {
//           conflicts.forEach((itemConflict) =>
//             itemConflict.shape.setAttribute('class', 'warning')
//           );
//         }
//       });
//     }, []);

//     const oLink = useCallback(
//       (data) => {
//         const { catalogId, pageNum: pageId } = editor;
//         const { id, fontSize, width, height } = currLinkTypeRef.current;

//         const currHeight = defLinkSize.current.height || height;
//         const currWidth = defLinkSize.current.width || width;

//         /** transforma IDs com 0 à esquerda em IDs sem 0 à esquerda ("01" significa o mesmo que "1") */
//         const normalizeValue = (value) => {
//           const text = String(value ?? '')
//             .trim()
//             .toUpperCase();

//           // Se for apenas número, remove zeros à esquerda convertendo para Number
//           if (/^\d+$/.test(text)) {
//             return String(Number(text));
//           }

//           // Se for texto/alfanumérico, mantém como texto normalizado
//           return text;
//         };

//         const formattedIdItem = normalizeValue(data.idItem);

//         /** busca o item no mapeamento OCR */
//         const dotted = ocrMappingRef.current.filter((item) => {
//           const formattedOcr = normalizeValue(item.ocr.text);

//           return formattedOcr === formattedIdItem;
//         });

//         /** caso não encontre pelo método OCR, interrompe o processo */
//         if (!dotted.length) return;

//         dotted.forEach(({ attr, ocr }) => {
//           /**
//            * Geometria de ÁREA: aproveita a caixa que o OCR já devolve
//            * (ocr.width / ocr.height, com ocr.x / ocr.y no centro do texto,
//            * conforme NormalizarExtracaoTextoService no backend). Antes essas
//            * duas informações eram descartadas e todo link nascia com o
//            * tamanho padrão.
//            */
//           if (Number(id) === LINK_FORM_TYPES.area) {
//             const larguraOcr = Number(ocr && ocr.width) || currWidth;
//             const alturaOcr = Number(ocr && ocr.height) || currHeight;

//             /** folga para a área não encostar no texto detectado */
//             const folga = 2;
//             const largura = larguraOcr + folga * 2;
//             const altura = alturaOcr + folga * 2;

//             const centroX =
//               Number(ocr && ocr.x) ||
//               Number(attr.childNodes[0].getAttribute('x'));
//             const centroY =
//               Number(ocr && ocr.y) ||
//               Number(attr.childNodes[0].getAttribute('y'));

//             createLink(
//               id,
//               centroX - largura / 2,
//               centroY - altura / 2,
//               0,
//               altura,
//               largura,
//               data.partnumber,
//               data.idItem,
//               INITIAL_LINK_AREA.fontSize,
//               `/${catalogId}/${pageId}/${data.idItem}`,
//               currLinkRotuloRef.current
//             );

//             return;
//           }

//           createLink(
//             id,
//             Number(attr.childNodes[0].getAttribute('x')) - 10,
//             Number(attr.childNodes[0].getAttribute('y')) + 10,
//             currHeight,
//             currHeight,
//             currWidth,
//             data.partnumber,
//             data.idItem,
//             fontSize,
//             `/${catalogId}/${pageId}/${data.idItem}`,
//             currLinkRotuloRef.current
//           );
//         });

//         /** verifica associações */
//         oCheckAssociation();

//         /** verifica conflito */
//         oCheckConflict();
//       },
//       [createLink, editor, oCheckAssociation, oCheckConflict]
//     );

//     /** mantém os refs sincronizados para uso dentro dos handlers de mouse */
//     useEffect(() => {
//       currLinkRotuloRef.current = currLinkRotulo;
//     }, [currLinkRotulo]);

//     /**
//      * O elemento <SVG> é memoizado apenas por [editor.pageNum, editor.path]
//      * (as dependências dos handlers estão comentadas de propósito, para não
//      * reinjetar o desenho e perder os links a cada render). Como consequência,
//      * os handlers de mouse carregam o estado do render da injeção.
//      *
//      * Espelhar a tabela em ref evita que o modo sequência trabalhe com uma
//      * lista de itens vazia quando os itens da página chegam depois do SVG.
//      */
//     useEffect(() => {
//       tabelaRef.current = table;
//     }, [table]);

//     useEffect(() => {
//       modoSequenciaRef.current = modoSequencia;
//     }, [modoSequencia]);

//     /** itens da página que ainda não têm link no desenho */
//     const itensPendentes = useMemo(() => {
//       const vinculados = new Set(
//         linkMappingRef.current.map((node) => String(getIdItemLink(node)))
//       );

//       return table.filter((item) => !vinculados.has(String(item.idItem)));
//       // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [table, getIdItemLink, currLinkType, currLinkRotulo, modoSequencia]);

//     /**
//      * Cria o link de um item usando a geometria de ÁREA a partir do
//      * retângulo desenhado pelo usuário.
//      */
//     const oCriarLinkArea = useCallback(
//       (item, x, y, largura, altura) => {
//         if (!item) return;

//         const { catalogId, pageNum: pageId } = editor;

//         createLink(
//           LINK_FORM_TYPES.area,
//           x,
//           y,
//           0,
//           altura,
//           largura,
//           item.partnumber,
//           item.idItem,
//           INITIAL_LINK_AREA.fontSize,
//           `/${catalogId}/${pageId}/${item.idItem}`,
//           currLinkRotuloRef.current
//         );

//         oCheckAssociation();
//         oCheckConflict();
//       },
//       // eslint-disable-next-line react-hooks/exhaustive-deps
//       [createLink, editor, oCheckAssociation, oCheckConflict]
//     );

//     /**
//      * Cria o link de um item respeitando a geometria e o rótulo atuais.
//      *
//      * - legadoX/legadoY: ponto de ancoragem das formas legadas
//      *   (círculo/retângulo), preservado exatamente como cada chamada fazia.
//      * - centroX/centroY: centro usado pela geometria de ÁREA.
//      * - ocr: caixa do texto detectado, quando houver, para dimensionar a
//      *   área (campos width/height de NormalizarExtracaoTextoService).
//      */
//     const oCriarLinkNoPonto = useCallback(
//       ({
//         data,
//         legadoX,
//         legadoY,
//         centroX,
//         centroY,
//         ocr = null,
//         area = null,
//       }) => {
//         const { catalogId, pageNum: pageId } = editor;
//         const { id, fontSize, width, height } = currLinkTypeRef.current;

//         const currHeight = defLinkSize.current.height || height;
//         const currWidth = defLinkSize.current.width || width;
//         const href = `/${catalogId}/${pageId}/${data.idItem}`;

//         /**
//          * Retângulo desenhado pelo usuário tem prioridade sobre qualquer
//          * outro tamanho (OCR ou padrão) — foi um gesto explícito.
//          */
//         if (area) {
//           createLink(
//             LINK_FORM_TYPES.area,
//             area.x,
//             area.y,
//             0,
//             area.altura,
//             area.largura,
//             data.partnumber,
//             data.idItem,
//             INITIAL_LINK_AREA.fontSize,
//             href,
//             currLinkRotuloRef.current
//           );

//           return;
//         }

//         if (Number(id) === LINK_FORM_TYPES.area) {
//           const folga = 2;
//           const largura = (Number(ocr && ocr.width) || currWidth) + folga * 2;
//           const altura = (Number(ocr && ocr.height) || currHeight) + folga * 2;

//           createLink(
//             id,
//             centroX - largura / 2,
//             centroY - altura / 2,
//             0,
//             altura,
//             largura,
//             data.partnumber,
//             data.idItem,
//             INITIAL_LINK_AREA.fontSize,
//             href,
//             currLinkRotuloRef.current
//           );

//           return;
//         }

//         createLink(
//           id,
//           legadoX,
//           legadoY,
//           currHeight,
//           currHeight,
//           currWidth,
//           data.partnumber,
//           data.idItem,
//           fontSize,
//           href,
//           currLinkRotuloRef.current
//         );
//       },
//       // eslint-disable-next-line react-hooks/exhaustive-deps
//       [createLink, editor]
//     );

//     /** avança o modo sequência para o próximo item ainda sem link */
//     const oAvancarSequencia = useCallback(
//       (idItemCriado) => {
//         const vinculados = new Set(
//           linkMappingRef.current.map((node) => String(getIdItemLink(node)))
//         );

//         if (idItemCriado) vinculados.add(String(idItemCriado));

//         /** lê do ref: ver comentário do efeito que sincroniza tabelaRef */
//         const proximo = tabelaRef.current.find(
//           (item) => !vinculados.has(String(item.idItem))
//         );

//         itemSequenciaRef.current = proximo || null;
//         setItemSequencia(proximo || null);
//       },
//       [getIdItemLink]
//     );

//     /** Retorna a posição do mouse no objeto SVGPoint { x: number, y: number } */
//     const oMousePosSVG = useCallback(
//       (e) => {
//         let p = svgRef.current.createSVGPoint();
//         p.x = e.clientX;
//         p.y = e.clientY;
//         const ctm = rootRef.current.getScreenCTM().inverse();
//         p = p.matrixTransform(ctm);
//         return p;
//       },
//       [rootRef]
//     );

//     /** Seleciona um link e define foco nele */
//     const oSelectElement = useCallback(
//       (el) => {
//         const isSelected = !!selectedRef.current.find(
//           (element) => element.node === el.node
//         );

//         if (!isSelected) {
//           selectedRef.current.push(el);
//         }

//         /** limpa o foco atual */
//         if (focusRef && focusRef.current) {
//           const classes = focusRef.current.node
//             .getAttribute('class')
//             .split('focused');

//           focusRef.current.node.setAttribute(
//             'class',
//             classes[0].trim() + (classes[1] || '')
//           );
//         }

//         /** difene novo foco */
//         focusRef.current = el;
//         focusRef.current.node.setAttribute(
//           'class',
//           `selected ${
//             selectedRef.current && selectedRef.current.length > 1
//               ? 'focused'
//               : ''
//           }`.trim()
//         );

//         let currSizeW = 0;
//         let currSizeH = 0;

//         switch (Number(focusRef.current.node.childNodes[0].dataset.id)) {
//           case LINK_FORM_TYPES.circle:
//             currSizeH = focusRef.current.node.childNodes[0].getAttribute('r');
//             break;
//           case LINK_FORM_TYPES.rect:
//           case LINK_FORM_TYPES.area:
//             currSizeW = focusRef.current.node.childNodes[0].getAttribute(
//               'width'
//             );
//             currSizeH = focusRef.current.node.childNodes[0].getAttribute(
//               'height'
//             );
//             break;
//           default:
//             break;
//         }

//         oLinkSizeMode(currSizeH, currSizeW);
//       },
//       [LINK_FORM_TYPES, selectedRef, focusRef, oLinkSizeMode]
//     );

//     /** desseleciona um link */
//     const oDeselectElement = useCallback(
//       (el) => {
//         const classes = el.node.getAttribute('class').split('selected');

//         el.node.setAttribute('class', classes[0].trim() + (classes[1] || ''));

//         selectedRef.current = selectedRef.current.filter(
//           (element) => element.node !== el.node
//         );
//       },
//       [selectedRef]
//     );

//     /** limpa seleção de links */
//     const oClearSelection = useCallback(() => {
//       /** limpa foco */
//       if (focusRef && focusRef.current) {
//         focusRef.current = null;
//       }

//       /** limpa seleção */
//       if (selectedRef && selectedRef.current) {
//         selectedRef.current.forEach((el) =>
//           el.node.setAttribute(
//             'class',
//             el.node.getAttribute('class').split('selected')[0].trim()
//           )
//         );
//         selectedRef.current = [];
//       }

//       oLinkSizeMode(0, 0);
//     }, [selectedRef, oLinkSizeMode]);

//     const oClearSelector = useCallback(() => {
//       /** limpa área de seleção */
//       if (selectorRef && selectorRef.current) {
//         selectorRef.current.setAttribute('x', 0);
//         selectorRef.current.setAttribute('y', 0);
//         selectorRef.current.setAttribute('width', 0);
//         selectorRef.current.setAttribute('height', 0);

//         startCoordRef.current = { x: 0, y: 0 };
//         finishCoordRef.current = { x: 0, y: 0 };
//         maxCoordRef.current = { x: 0, y: 0 };
//         minCoordRef.current = { x: 0, y: 0 };
//       }
//     }, [selectorRef]);

//     const oRemove = useCallback((el) => {
//       const drop = el.parentElement || null;

//       if (!drop) return el;

//       if (drop.childNodes.length > 1) return el;

//       return oRemove(drop);
//     }, []);

//     const handleDragOverSVG = useCallback((e) => {
//       e.preventDefault();
//     }, []);

//     const handleDropSVG = useCallback(
//       (e) => {
//         e.preventDefault();

//         const m = oMousePosSVG(e);

//         const data = JSON.parse(e.dataTransfer.getData('text/row-list'));
//         if (!data) return;

//         const dotted = ocrMappingRef.current.filter(
//           (item) => item.ocr.text === String(data.idItem)
//         );

//         if (!dotted.length) {
//           oCriarLinkNoPonto({
//             data,
//             legadoX: m.x,
//             legadoY: m.y,
//             centroX: m.x,
//             centroY: m.y,
//           });
//         }

//         dotted.forEach(({ attr, ocr }) => {
//           const ancoraX = Number(attr.childNodes[0].getAttribute('x'));
//           const ancoraY = Number(attr.childNodes[0].getAttribute('y'));

//           oCriarLinkNoPonto({
//             data,
//             legadoX: ancoraX - 10,
//             legadoY: ancoraY + 10,
//             centroX: Number(ocr && ocr.x) || ancoraX,
//             centroY: Number(ocr && ocr.y) || ancoraY,
//             ocr,
//           });

//           /** remove elemento do mapeamento principal */
//           const mappingIndex = ocrMappingRef.current.findIndex(
//             (findAttr) => findAttr.attr.id === attr.id
//           );
//           ocrMappingRef.current.splice(mappingIndex, 1);

//           /** remove elemento da tela */
//           oRemove(attr).remove();
//         });

//         /** associa link com o item na tabela */
//         oCheckAssociation();

//         /** verifica conflito */
//         oCheckConflict();
//       },
//       [
//         editor,
//         oMousePosSVG,
//         oRemove,
//         createLink,
//         oCheckAssociation,
//         oCheckConflict,
//       ]
//     );

//     const handleDragOver = useCallback((e) => {
//       const isLink = e.dataTransfer.types.includes('image/svg+xml');
//       if (isLink) e.preventDefault();
//     }, []);

//     const handleMouseMove = useCallback(
//       (e) => {
//         if (!selectingRef.current) return;

//         const m = oMousePosSVG(e);

//         const isLink = isAlvoLink(e.target);

//         const { shiftKey, ctrlKey, altKey } = e;

//         /** Shift+Click */
//         if (shiftKey && !ctrlKey && !altKey) {
//           if (isLink && e.target.parentElement === focusRef.current.node) {
//             actionRef.current = ACTION_STATE.move;
//           }
//         }

//         /** Shift+Ctrl+Click Disponível */
//         /** Shift+Alt+Click Disponível */
//         /** Shift+Ctrl+Alt+Click Disponível */

//         /** Ctrl+Click  */
//         if (!shiftKey && ctrlKey && !altKey) {
//           if (!selectedRef.current.length) {
//             actionRef.current = ACTION_STATE.selectArea;
//           }
//         }

//         /** Ctrl+Alt+Click Disponível */

//         /** Alt+Click Disponível */
//         if (!shiftKey && !ctrlKey && altKey) {
//           if (isLink && e.target.parentElement === controlRef.current) {
//             actionRef.current = ACTION_STATE.moveOne;
//           }
//         }

//         /** Click */
//         if (!shiftKey && !ctrlKey && !altKey) {
//           if (rotuloDragRef.current) {
//             /** arrastando a etiqueta: a área do link não se move */
//             actionRef.current = ACTION_STATE.moveRotulo;
//           } else if (isLink) {
//             actionRef.current = ACTION_STATE.move;
//           } else if (podeDesenharArea()) {
//             /** arraste sobre o desenho desenha a área do link */
//             actionRef.current = ACTION_STATE.createArea;
//           }
//         }

//         switch (actionRef.current) {
//           /**
//            * Desenha o retângulo temporário da nova área. O link só é criado
//            * ao soltar o botão, em handleMouseUp.
//            */
//           case ACTION_STATE.createArea: {
//             const draft = oGetAreaDraft();
//             if (!draft) return;

//             /** garante a origem do arraste caso o mousedown não a tenha fixado */
//             if (!areaStartRef.current) {
//               areaStartRef.current = { x: m.x, y: m.y };
//             }

//             const inicio = areaStartRef.current;

//             const x = Math.min(inicio.x, m.x);
//             const y = Math.min(inicio.y, m.y);
//             const largura = Math.abs(m.x - inicio.x);
//             const altura = Math.abs(m.y - inicio.y);

//             draft.setAttribute('x', x);
//             draft.setAttribute('y', y);
//             draft.setAttribute('width', largura);
//             draft.setAttribute('height', altura);
//             break;
//           }

//           /**
//            * Move apenas a etiqueta do link e reancora a linha de chamada,
//            * mantendo a área sobre o componente.
//            */
//           case ACTION_STATE.moveRotulo: {
//             const link = rotuloDragRef.current;
//             if (!link) return;

//             const { rotulo, rotuloTexto } = getPartesLink(link);
//             if (!rotulo) return;

//             const caixa = getCaixaForma(rotulo);

//             const dx = m.x - (caixa.x + caixa.width / 2);
//             const dy = m.y - (caixa.y + caixa.height / 2);

//             transladarElementoSvg(rotulo, dx, dy);
//             if (rotuloTexto) transladarElementoSvg(rotuloTexto, dx, dy);

//             oReancorarChamada(link);
//             break;
//           }

//           case ACTION_STATE.move: {
//             /** verifica se há links selecionados */
//             if (selectedRef.current.length === 0) return;

//             /** vetores de deslocamento para x e y */
//             const xVector =
//               m.x -
//               Number(
//                 focusRef.current.node.childNodes[0].getAttribute(
//                   `${
//                     Number(focusRef.current.node.childNodes[0].dataset.id) ===
//                     LINK_FORM_TYPES.circle
//                       ? 'cx'
//                       : 'x'
//                   }`
//                 )
//               );
//             const yVector =
//               m.y -
//               Number(
//                 focusRef.current.node.childNodes[0].getAttribute(
//                   `${
//                     Number(focusRef.current.node.childNodes[0].dataset.id) ===
//                     LINK_FORM_TYPES.circle
//                       ? 'cy'
//                       : 'y'
//                   }`
//                 )
//               );

//             /** offsets do link em foco em x e y */
//             const xOffset =
//               Number(focusRef.current.node.childNodes[0].dataset.id) ===
//               LINK_FORM_TYPES.circle
//                 ? null
//                 : Number(
//                     focusRef.current.node.childNodes[0].width.baseVal.value
//                   ) / 2;
//             const yOffset =
//               Number(focusRef.current.node.childNodes[0].dataset.id) ===
//               LINK_FORM_TYPES.circle
//                 ? null
//                 : Number(
//                     focusRef.current.node.childNodes[0].height.baseVal.value
//                   ) / 2;

//             selectedRef.current.forEach((element) => {
//               const linkForm = element.node.childNodes[0];
//               const linkText = element.node.childNodes[1];

//               const { id: tipo = null } = linkForm.dataset || {};

//               /** links compostos: translada todos os elementos internos */
//               if (oUsaTranslacaoGenerica(element.node, tipo)) {
//                 transladarLink(
//                   element.node,
//                   xVector - (xOffset || 0),
//                   yVector - (yOffset || 0)
//                 );
//                 return;
//               }

//               switch (Number(tipo)) {
//                 case LINK_FORM_TYPES.circle: {
//                   /** posição da forma */
//                   const xF = Number(linkForm.getAttribute('cx'));
//                   const yF = Number(linkForm.getAttribute('cy'));
//                   /** posição do texto */
//                   const xT = linkText ? Number(linkText.getAttribute('x')) : 0;
//                   const yT = linkText ? Number(linkText.getAttribute('y')) : 0;

//                   /** nova posição da forma */
//                   linkForm.setAttribute('cx', xF + xVector - xOffset);
//                   linkForm.setAttribute('cy', yF + yVector - yOffset);
//                   /** nova posição do texto */
//                   if (linkText) {
//                     linkText.setAttribute('x', xT + xVector - xOffset);
//                     linkText.setAttribute('y', yT + yVector - yOffset);
//                   }
//                   break;
//                 }
//                 case LINK_FORM_TYPES.rect:
//                 case LINK_FORM_TYPES.ocr: {
//                   /** posição da forma */
//                   const xF = Number(linkForm.getAttribute('x'));
//                   const yF = Number(linkForm.getAttribute('y'));
//                   /** posição do texto */
//                   const xT = linkText ? Number(linkText.getAttribute('x')) : 0;
//                   const yT = linkText ? Number(linkText.getAttribute('y')) : 0;

//                   /** nova posição da forma */
//                   linkForm.setAttribute('x', xF + xVector - xOffset);
//                   linkForm.setAttribute('y', yF + yVector - yOffset);
//                   /** nova posição do texto */
//                   if (linkText) {
//                     linkText.setAttribute('x', xT + xVector - xOffset);
//                     linkText.setAttribute('y', yT + yVector - yOffset);
//                   }
//                   break;
//                 }
//                 default:
//                   break;
//               }
//             });
//             break;
//           }

//           case ACTION_STATE.moveOne:
//             {
//               const element = selectedRef.current.find(
//                 (el) => el.node === controlRef.current
//               );

//               if (!element) return;
//               /** vetores de deslocamento para x e y */
//               const xVector =
//                 m.x -
//                 Number(
//                   element.node.childNodes[0].getAttribute(
//                     `${
//                       Number(element.node.childNodes[0].dataset.id) ===
//                       LINK_FORM_TYPES.circle
//                         ? 'cx'
//                         : 'x'
//                     }`
//                   )
//                 );
//               const yVector =
//                 m.y -
//                 Number(
//                   element.node.childNodes[0].getAttribute(
//                     `${
//                       Number(element.node.childNodes[0].dataset.id) ===
//                       LINK_FORM_TYPES.circle
//                         ? 'cy'
//                         : 'y'
//                     }`
//                   )
//                 );

//               /** offsets do link em foco em x e y */
//               const xOffset =
//                 Number(element.node.childNodes[0].dataset.id) ===
//                 LINK_FORM_TYPES.circle
//                   ? null
//                   : Number(element.node.childNodes[0].width.baseVal.value) / 2;
//               const yOffset =
//                 Number(element.node.childNodes[0].dataset.id) ===
//                 LINK_FORM_TYPES.circle
//                   ? null
//                   : Number(element.node.childNodes[0].height.baseVal.value) / 2;

//               const linkForm = element.node.childNodes[0];
//               const linkText = element.node.childNodes[1];

//               const { id: tipo = null } = linkForm.dataset || {};

//               /** links compostos: translada todos os elementos internos */
//               if (oUsaTranslacaoGenerica(element.node, tipo)) {
//                 transladarLink(
//                   element.node,
//                   xVector - (xOffset || 0),
//                   yVector - (yOffset || 0)
//                 );
//                 break;
//               }

//               switch (Number(tipo)) {
//                 case LINK_FORM_TYPES.circle: {
//                   /** posição da forma */
//                   const xF = Number(linkForm.getAttribute('cx'));
//                   const yF = Number(linkForm.getAttribute('cy'));
//                   /** posição do texto */
//                   const xT = linkText ? Number(linkText.getAttribute('x')) : 0;
//                   const yT = linkText ? Number(linkText.getAttribute('y')) : 0;

//                   /** nova posição da forma */
//                   linkForm.setAttribute('cx', xF + xVector - xOffset);
//                   linkForm.setAttribute('cy', yF + yVector - yOffset);
//                   /** nova posição do texto */
//                   if (linkText) {
//                     linkText.setAttribute('x', xT + xVector - xOffset);
//                     linkText.setAttribute('y', yT + yVector - yOffset);
//                   }
//                   break;
//                 }
//                 case LINK_FORM_TYPES.rect:
//                 case LINK_FORM_TYPES.ocr: {
//                   /** posição da forma */
//                   const xF = Number(linkForm.getAttribute('x'));
//                   const yF = Number(linkForm.getAttribute('y'));
//                   /** posição do texto */
//                   const xT = linkText ? Number(linkText.getAttribute('x')) : 0;
//                   const yT = linkText ? Number(linkText.getAttribute('y')) : 0;

//                   /** nova posição da forma */
//                   linkForm.setAttribute('x', xF + xVector - xOffset);
//                   linkForm.setAttribute('y', yF + yVector - yOffset);
//                   /** nova posição do texto */
//                   if (linkText) {
//                     linkText.setAttribute('x', xT + xVector - xOffset);
//                     linkText.setAttribute('y', yT + yVector - yOffset);
//                   }
//                   break;
//                 }
//                 default:
//                   break;
//               }
//             }
//             break;
//           case ACTION_STATE.selectArea: {
//             /** define valores finais para a área de seleção */
//             if (
//               startCoordRef.current.x === 0 &&
//               startCoordRef.current.y === 0
//             ) {
//               startCoordRef.current.x = m.x;
//               startCoordRef.current.y = m.y;
//             }

//             finishCoordRef.current.x = m.x;
//             finishCoordRef.current.y = m.y;

//             minCoordRef.current.x = Math.min(
//               startCoordRef.current.x,
//               finishCoordRef.current.x
//             );
//             maxCoordRef.current.x = Math.max(
//               startCoordRef.current.x,
//               finishCoordRef.current.x
//             );
//             minCoordRef.current.y = Math.min(
//               startCoordRef.current.y,
//               finishCoordRef.current.y
//             );
//             maxCoordRef.current.y = Math.max(
//               startCoordRef.current.y,
//               finishCoordRef.current.y
//             );

//             selectorRef.current.setAttribute('x', minCoordRef.current.x);
//             selectorRef.current.setAttribute('y', minCoordRef.current.y);
//             selectorRef.current.setAttribute(
//               'width',
//               maxCoordRef.current.x - minCoordRef.current.x
//             );
//             selectorRef.current.setAttribute(
//               'height',
//               maxCoordRef.current.y - minCoordRef.current.y
//             );

//             /** seleciona itens dentro da área */
//             const linkMappingPos = linkMappingRef.current.map((item) => {
//               const shape = item.childNodes[0];

//               const x = Number(
//                 shape.getAttribute(shape.nodeName === 'svg:circle' ? 'cx' : 'x')
//               );
//               const y = Number(
//                 shape.getAttribute(shape.nodeName === 'svg:circle' ? 'cy' : 'y')
//               );

//               return { attr: item, x, y };
//             });

//             const mappingOCRPos = ocrMappingRef.current.map((item) => {
//               const x = Number(item.attr.childNodes[0].getAttribute('x'));
//               const y = Number(item.attr.childNodes[0].getAttribute('y'));

//               return { attr: item.attr, x, y };
//             });

//             const itemsPos = [...linkMappingPos, ...mappingOCRPos];

//             itemsPos.forEach((item) => {
//               if (
//                 item.x >= minCoordRef.current.x &&
//                 item.x <= maxCoordRef.current.x &&
//                 item.y >= minCoordRef.current.y &&
//                 item.y <= maxCoordRef.current.y
//               ) {
//                 oSelectElement({ node: item.attr });
//               } else {
//                 oDeselectElement({ node: item.attr });
//               }
//             });
//             break;
//           }
//           default:
//             break;
//         }
//       },
//       [
//         ACTION_STATE,
//         LINK_FORM_TYPES,
//         actionRef,
//         selectingRef,
//         oMousePosSVG,
//         oSelectElement,
//         oDeselectElement,
//       ]
//     );

//     const handleMouseDown = useCallback(
//       (e) => {
//         /**
//          * Os atalhos só chegam ao editor quando o wrapper do desenho está
//          * com o foco (ele tem tabIndex="0"). Focar no mousedown garante
//          * que Del, Alt+Z e Alt+S funcionem logo após o primeiro clique no
//          * desenho, sem o usuário precisar tabular até ele.
//          */
//         if (e.currentTarget && e.currentTarget.focus) {
//           e.currentTarget.focus({ preventScroll: true });
//         }

//         /** verifica se existe um arquivo na área de edição */
//         if (svgRef.current) {
//           selectingRef.current = true;

//           const { shiftKey, ctrlKey, altKey } = e;

//           const isLink = isAlvoLink(e.target);

//           /** guarda o link cuja etiqueta está sendo arrastada */
//           rotuloDragRef.current =
//             !shiftKey && !ctrlKey && !altKey && isAlvoRotulo(e.target)
//               ? e.target.parentElement
//               : null;

//           /** bloqueia movimento da imagem quando um link está sendo movido ou selecionado */
//           if (isLink || ctrlKey) {
//             setZoomCanMove(false);
//           }

//           /**
//            * O arraste sobre o desenho desenha a área do link, então o pan da
//            * imagem precisa ficar desligado durante o gesto.
//            */
//           if (
//             podeDesenharArea() &&
//             !isLink &&
//             !shiftKey &&
//             !ctrlKey &&
//             !altKey
//           ) {
//             setZoomCanMove(false);

//             const m = oMousePosSVG(e);
//             areaStartRef.current = { x: m.x, y: m.y };

//             const draft = oGetAreaDraft();
//             if (draft) {
//               draft.setAttribute('x', m.x);
//               draft.setAttribute('y', m.y);
//               draft.setAttribute('width', 0);
//               draft.setAttribute('height', 0);
//             }
//           }

//           /** Shift+Click */
//           if (shiftKey && !ctrlKey && !altKey) {
//             if (isLink) {
//               actionRef.current = ACTION_STATE.select;
//             }
//           }

//           /** Shift+Ctrl+Click Disponível */

//           /** Shift+Alt+Click */
//           if (shiftKey && !ctrlKey && altKey) {
//             if (isLink) {
//               actionRef.current = ACTION_STATE.deselect;
//             }
//           }

//           /** Shift+Ctrl+Alt+Click Disponível */

//           /** Ctrl+Click  */
//           if (!shiftKey && ctrlKey && !altKey) {
//             const m = oMousePosSVG(e);

//             /** define valores iniciais para a área de seleção */
//             startCoordRef.current.x = m.x;
//             startCoordRef.current.y = m.y;
//             selectorRef.current.setAttribute('x', 0);
//             selectorRef.current.setAttribute('y', 0);
//             selectorRef.current.setAttribute('width', 0);
//             selectorRef.current.setAttribute('height', 0);
//           }

//           /** Ctrl+Alt+Click Disponível */

//           /** Alt+Click Disponível  */
//           if (!shiftKey && !ctrlKey && altKey) {
//             /** armazena o elemento para o Alt+Click+Drag */
//             if (isLink) {
//               controlRef.current = e.target.parentElement;
//             }
//           }

//           /** Click */
//           if (!shiftKey && !ctrlKey && !altKey) {
//             /** limpa seleção */
//             oClearSelection();

//             if (isLink) {
//               controlRef.current = e.target.parentElement;
//               actionRef.current = ACTION_STATE.select;
//             }
//           }

//           switch (actionRef.current) {
//             case ACTION_STATE.select:
//               oSelectElement({ node: e.target.parentElement });
//               break;
//             case ACTION_STATE.deselect:
//               oDeselectElement({ node: e.target.parentElement });
//               break;
//             default:
//               break;
//           }

//           actionRef.current = null;
//         }
//       },
//       [
//         ACTION_STATE,
//         actionRef,
//         selectingRef,
//         oSelectElement,
//         oDeselectElement,
//         oClearSelection,
//         oMousePosSVG,
//       ]
//     );

//     /**
//      * Fecha o input rápido descartando também o retângulo desenhado que
//      * estivesse aguardando o ID do item — sem isso ele seria reaproveitado
//      * indevidamente na próxima criação de link.
//      */
//     const handleQuickInputCancel = useCallback(() => {
//       areaPendenteRef.current = null;

//       if (areaDraftRef.current) {
//         areaDraftRef.current.setAttribute('width', 0);
//         areaDraftRef.current.setAttribute('height', 0);
//       }

//       setQuickInput((state) => ({ ...state, open: false, value: '' }));
//     }, []);

//     /** NOVO: confirma criação rápida do link ao pressionar Enter */
//     const handleQuickInputConfirm = useCallback(
//       (rawValue) => {
//         const value = String(rawValue || '').trim();
//         if (!value) {
//           handleQuickInputCancel();
//           return;
//         }

//         // normalização “01” === “1”
//         const norm = (v) => {
//           const n = Number(v);
//           return Number.isNaN(n) ? String(v).trim() : String(n);
//         };

//         const data = table.find((it) => norm(it.idItem) === norm(value));

//         if (!data) {
//           toast.info('Item não encontrado na lista desta página.');
//           return;
//         }

//         /**
//          * Se o usuário desenhou a área por arraste, o retângulo dele manda:
//          * cria direto nessa geometria e ignora o casamento por OCR (que
//          * reposicionaria o link para onde o texto foi detectado).
//          */
//         if (areaPendenteRef.current) {
//           oCriarLinkNoPonto({ data, area: areaPendenteRef.current });
//           areaPendenteRef.current = null;

//           oCheckAssociation();
//           oCheckConflict();
//           oRegistrarHistorico();
//           setQuickInput((state) => ({ ...state, open: false, value: '' }));

//           return;
//         }

//         // tenta casar com OCR primeiro
//         const dotted = ocrMappingRef.current.filter(
//           (item) => norm(item.ocr.text) === norm(data.idItem)
//         );

//         if (dotted.length) {
//           dotted.forEach(({ attr, ocr }) => {
//             const ancoraX = Number(attr.childNodes[0].getAttribute('x'));
//             const ancoraY = Number(attr.childNodes[0].getAttribute('y'));

//             oCriarLinkNoPonto({
//               data,
//               legadoX: ancoraX - 10,
//               legadoY: ancoraY + 10,
//               centroX: Number(ocr && ocr.x) || ancoraX,
//               centroY: Number(ocr && ocr.y) || ancoraY,
//               ocr,
//             });

//             // remove overlay correspondente
//             const mappingIndex = ocrMappingRef.current.findIndex(
//               (findAttr) => findAttr.attr.id === attr.id
//             );
//             if (mappingIndex !== -1) {
//               ocrMappingRef.current.splice(mappingIndex, 1);
//             }
//             oRemove(attr).remove();
//           });
//         } else {
//           // cria no ponto clicado
//           oCriarLinkNoPonto({
//             data,
//             legadoX: quickInput.svgX - 15,
//             legadoY: quickInput.svgY + 2,
//             centroX: quickInput.svgX,
//             centroY: quickInput.svgY,
//           });
//         }

//         // pós-criação
//         oCheckAssociation();
//         oCheckConflict();
//         setQuickInput((s) => ({ ...s, open: false, value: '' }));
//       },
//       [
//         table,
//         editor,
//         createLink,
//         quickInput.svgX,
//         quickInput.svgY,
//         oRemove,
//         oCheckAssociation,
//         oCheckConflict,
//       ]
//     );

//     /* =================================================================
//        HISTÓRICO (desfazer / refazer)
//        -----------------------------------------------------------------
//        Guarda snapshots do innerHTML do grupo de links. Restaurar o HTML
//        descarta os listeners dos elementos, então após cada restauração o
//        mapeamento é reconstruído com mappingElement.

//        O limite evita crescimento indefinido em páginas com muitos itens.
//        ================================================================= */
//     const HISTORICO_LIMITE = 40;
//     const historicoRef = useRef([]);
//     const historicoPosRef = useRef(-1);
//     const [historicoInfo, setHistoricoInfo] = useState({
//       podeDesfazer: false,
//       podeRefazer: false,
//     });

//     const oGetLinkGroup = useCallback(() => {
//       if (linkRef.current && linkRef.current.parentNode) return linkRef.current;

//       const grupo = document.getElementById('linkGroup');
//       if (grupo) linkRef.current = grupo;

//       return grupo || null;
//     }, []);

//     const oAtualizarHistoricoInfo = useCallback(() => {
//       setHistoricoInfo({
//         podeDesfazer: historicoPosRef.current > 0,
//         podeRefazer:
//           historicoPosRef.current >= 0 &&
//           historicoPosRef.current < historicoRef.current.length - 1,
//       });
//     }, []);

//     /** reconstrói o mapeamento e os listeners depois de restaurar o HTML */
//     const oRemapearLinks = useCallback(() => {
//       const grupo = oGetLinkGroup();
//       if (!grupo) return;

//       selectedRef.current = [];
//       focusRef.current = null;
//       linkMappingRef.current = [];

//       mappingElement(grupo.childNodes);

//       oCheckAssociation();
//       oCheckConflict();
//       // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [oGetLinkGroup, mappingElement, oCheckAssociation, oCheckConflict]);

//     /** registra o estado atual no histórico */
//     const oRegistrarHistorico = useCallback(() => {
//       const grupo = oGetLinkGroup();
//       if (!grupo) return;

//       const snapshot = grupo.innerHTML;

//       /** primeira chamada: guarda o estado inicial */
//       if (historicoPosRef.current < 0) {
//         historicoRef.current = [snapshot];
//         historicoPosRef.current = 0;
//         oAtualizarHistoricoInfo();
//         return;
//       }

//       /** nada mudou desde o último registro */
//       if (historicoRef.current[historicoPosRef.current] === snapshot) return;

//       /** descarta o "futuro" quando há uma nova ação após um desfazer */
//       historicoRef.current = historicoRef.current.slice(
//         0,
//         historicoPosRef.current + 1
//       );

//       historicoRef.current.push(snapshot);

//       if (historicoRef.current.length > HISTORICO_LIMITE) {
//         historicoRef.current.shift();
//       }

//       historicoPosRef.current = historicoRef.current.length - 1;
//       oAtualizarHistoricoInfo();
//     }, [oGetLinkGroup, oAtualizarHistoricoInfo]);

//     const oAplicarHistorico = useCallback(
//       (posicao) => {
//         const grupo = oGetLinkGroup();
//         if (!grupo) return;

//         const snapshot = historicoRef.current[posicao];
//         if (snapshot === undefined) return;

//         grupo.innerHTML = snapshot;
//         historicoPosRef.current = posicao;

//         oRemapearLinks();
//         oAtualizarHistoricoInfo();
//       },
//       [oGetLinkGroup, oRemapearLinks, oAtualizarHistoricoInfo]
//     );

//     const handleDesfazer = useCallback(() => {
//       if (historicoPosRef.current <= 0) return;
//       oAplicarHistorico(historicoPosRef.current - 1);
//     }, [oAplicarHistorico]);

//     const handleRefazer = useCallback(() => {
//       if (historicoPosRef.current >= historicoRef.current.length - 1) return;
//       oAplicarHistorico(historicoPosRef.current + 1);
//     }, [oAplicarHistorico]);

//     const handleMouseUp = useCallback(
//       (e) => {
//         if (selectingRef && selectingRef.current) {
//           const m = oMousePosSVG(e);
//           /** guarda a ação atual antes de limpar */
//           const currentAction = actionRef.current;

//           oClearSelector();

//           // switch (actionRef.current) {
//           switch (currentAction) {
//             case ACTION_STATE.select:
//               break;

//             /** conclui o arraste e cria o link do item da sequência */
//             case ACTION_STATE.createArea: {
//               const item = itemSequenciaRef.current;

//               /**
//                * Lê de areaStartRef: o oClearSelector() acima já zerou o
//                * startCoordRef, que pertence ao seletor do OCR.
//                */
//               const inicio = areaStartRef.current || { x: m.x, y: m.y };

//               const x = Math.min(inicio.x, m.x);
//               const y = Math.min(inicio.y, m.y);
//               const largura = Math.abs(m.x - inicio.x);
//               const altura = Math.abs(m.y - inicio.y);

//               /** limpa o retângulo temporário */
//               if (areaDraftRef.current) {
//                 areaDraftRef.current.setAttribute('width', 0);
//                 areaDraftRef.current.setAttribute('height', 0);
//               }

//               const arrastouOSuficiente =
//                 largura >= LINK_AREA_SIZE_LIMIT.min &&
//                 altura >= LINK_AREA_SIZE_LIMIT.min;

//               if (item && arrastouOSuficiente) {
//                 /** modo sequência: item já definido, cria e avança */
//                 oCriarLinkArea(item, x, y, largura, altura);
//                 oAvancarSequencia(item.idItem);
//                 oRegistrarHistorico();
//               } else if (item) {
//                 /**
//                  * Arraste muito pequeno: cria a área com o tamanho padrão
//                  * centrada no ponto clicado, em vez de descartar a ação.
//                  */
//                 oCriarLinkArea(
//                   item,
//                   m.x - INITIAL_LINK_AREA.width / 2,
//                   m.y - INITIAL_LINK_AREA.height / 2,
//                   INITIAL_LINK_AREA.width,
//                   INITIAL_LINK_AREA.height
//                 );
//                 oAvancarSequencia(item.idItem);
//                 oRegistrarHistorico();
//               } else if (arrastouOSuficiente) {
//                 /**
//                  * Fora do modo sequência não há item alvo: guarda o retângulo
//                  * desenhado e pede o ID do item no input rápido. O tamanho
//                  * usado será o do arraste, não o padrão.
//                  */
//                 areaPendenteRef.current = { x, y, largura, altura };

//                 const host = editorAreaRef.current || e.currentTarget;
//                 const rect = host.getBoundingClientRect();

//                 setQuickInput({
//                   open: true,
//                   x: e.clientX - rect.left,
//                   y: e.clientY - rect.top,
//                   svgX: x + largura / 2,
//                   svgY: y + altura / 2,
//                   value: '',
//                 });
//               }

//               areaStartRef.current = null;
//               break;
//             }

//             /** conclui o arraste da etiqueta */
//             case ACTION_STATE.moveRotulo:
//               if (rotuloDragRef.current) {
//                 oReancorarChamada(rotuloDragRef.current);
//               }
//               oCheckConflict();
//               oRegistrarHistorico();
//               break;
//             case ACTION_STATE.move:
//             case ACTION_STATE.moveOne:
//               /** atualiza posições do mapeamento OCR */
//               if (ocrMappingRef.current && !!ocrMappingRef.current.length) {
//                 selectedRef.current.forEach((itemSelecionado) => {
//                   const itemIndex = ocrMappingRef.current.findIndex(
//                     (itemOCR) =>
//                       String(itemOCR.attr.id) ===
//                       String(itemSelecionado.node.id)
//                   );

//                   if (itemIndex >= 0) {
//                     const { attr, ocr } = ocrMappingRef.current[itemIndex];

//                     ocrMappingRef.current[itemIndex] = {
//                       attr,
//                       ocr: { ...ocr, x: m.x, y: m.y },
//                     };
//                   }
//                 });
//               }

//               /** verifica conflitos */
//               oCheckConflict();
//               oRegistrarHistorico();
//               break;
//             default:
//               break;
//           }

//           /** NOVO: clique simples em área vazia → abre input */
//           const isLink = isAlvoLink(e.target);
//           const { shiftKey, ctrlKey, altKey } = e;

//           /**
//            * O duplo clique só abre o input rápido fora do modo sequência —
//            * nesse modo o gesto de criação é o próprio arraste.
//            */
//           if (
//             !isLink &&
//             !modoSequenciaRef.current &&
//             !shiftKey &&
//             !ctrlKey &&
//             !altKey &&
//             e.detail === 2
//           ) {
//             const host = editorAreaRef.current || e.currentTarget;
//             const rect = host.getBoundingClientRect();
//             setQuickInput({
//               open: true,
//               x: e.clientX - rect.left,
//               y: e.clientY - rect.top,
//               svgX: m.x,
//               svgY: m.y,
//               value: '',
//             });
//           }

//           actionRef.current = null;
//           selectingRef.current = false;
//           rotuloDragRef.current = null;

//           /** desbloqueia movimento da imagem */
//           setZoomCanMove(true);
//         }
//       },
//       // eslint-disable-next-line react-hooks/exhaustive-deps
//       [
//         ACTION_STATE,
//         oMousePosSVG,
//         oClearSelector,
//         oCheckConflict,
//         oCriarLinkArea,
//         oAvancarSequencia,
//         oReancorarChamada,
//         isAlvoLink,
//         oRegistrarHistorico,
//       ]
//     );

//     const handleRemove = useCallback(() => {
//       try {
//         /** percorre elementos selecionados */
//         selectedRef.current.forEach((s) => {
//           /** remove elemento do mapeamento ORC */
//           const mappingORCIndex = ocrMappingRef.current.findIndex(
//             (m) => m.attr.id === s.node.id
//           );

//           if (mappingORCIndex !== -1)
//             ocrMappingRef.current.splice(mappingORCIndex, 1);

//           /** remove elemento do mapeamento principal */
//           const mappingIndex = linkMappingRef.current.findIndex(
//             (m) => m.id === s.node.id
//           );

//           if (mappingIndex !== -1)
//             linkMappingRef.current.splice(mappingIndex, 1);

//           /** verifica o nível para eliminar o elemento pai */
//           oRemove(s.node).remove();
//         });

//         /** verifica associações */
//         oCheckAssociation();

//         /** verifica conflito */
//         oCheckConflict();

//         /** registra no histórico de desfazer/refazer */
//         oRegistrarHistorico();

//         oClearSelection();
//       } catch (err) {
//         /** erro */
//         toast.error(`Ops! Ocorreu um problema. ${err}`);
//       }
//     }, [
//       selectedRef,
//       ocrMappingRef,
//       oRemove,
//       oCheckAssociation,
//       oCheckConflict,
//       oClearSelection,
//     ]);

//     const handlePosition = useCallback(
//       (x, y) => {
//         const { baseVal } = rootRef.current.transform;
//         const baseIndex = Array.from(baseVal).findIndex((e) => e.type === 1);

//         let transformMatrix = null;
//         if (baseIndex >= 0) {
//           const { matrix } = baseVal.getItem(baseIndex);
//           transformMatrix = matrix;
//         }

//         if (!transformMatrix)
//           transformMatrix = svgRef.current.createSVGMatrix();

//         // matrix translate
//         transformMatrix.e = rootXRef.current + x;
//         transformMatrix.f = rootYRef.current + y;

//         rootXRef.current += x;
//         rootYRef.current += y;

//         const transform = baseVal.createSVGTransformFromMatrix(transformMatrix);
//         baseVal.clear();
//         baseVal.appendItem(transform);
//       },
//       [rootRef, svgRef, rootXRef, rootYRef]
//     );

//     /**
//      * ===================================================================
//      * CENTRALIZAÇÃO DO DESENHO
//      * -------------------------------------------------------------------
//      * A conta anterior misturava duas unidades: media svg e root com
//      * getBoundingClientRect() (PIXELS DE TELA) e gravava o resultado na
//      * translação da matriz do <g> (UNIDADES DO viewBox). Enquanto o <svg>
//      * tinha exatamente o tamanho do viewBox em pixels, 1 unidade valia
//      * 1 pixel e o erro não aparecia. Com o desenho ocupando toda a área
//      * (fluido, escalado pelo viewBox) a razão deixa de ser 1 e o desenho
//      * ia parar fora do lugar — foi o que produziu a imagem pequena e
//      * jogada no canto.
//      *
//      * Agora a conta é feita inteira em unidades do viewBox:
//      *   - o tamanho da área vem de svg.viewBox.baseVal
//      *   - o tamanho e a origem do conteúdo vêm de root.getBBox(), que
//      *     ignora a transformação do próprio <g>
//      *   - a escala atual do <g> entra na conta
//      * ===================================================================
//      */
//     const handleCenter = useCallback(
//       (initial = false) => {
//         if (!svgRef.current || !rootRef.current) return;

//         const { baseVal } = rootRef.current.transform;
//         const baseIndex = Array.from(baseVal).findIndex((e) => e.type === 1);

//         let transformMatrix = null;
//         if (baseIndex >= 0) {
//           if (initial) return;

//           const { matrix } = baseVal.getItem(baseIndex);
//           transformMatrix = matrix;
//         }

//         if (!transformMatrix)
//           transformMatrix = svgRef.current.createSVGMatrix();

//         /** área útil em unidades do viewBox */
//         const caixaVisao =
//           svgRef.current.viewBox && svgRef.current.viewBox.baseVal;

//         const areaLargura =
//           caixaVisao && caixaVisao.width
//             ? caixaVisao.width
//             : Number(svgRef.current.getAttribute('width')) || 0;

//         const areaAltura =
//           caixaVisao && caixaVisao.height
//             ? caixaVisao.height
//             : Number(svgRef.current.getAttribute('height')) || 0;

//         if (!areaLargura || !areaAltura) return;

//         /** conteúdo em unidades próprias, antes da transformação do <g> */
//         let conteudo = null;
//         try {
//           conteudo = rootRef.current.getBBox();
//         } catch (err) {
//           /** SVG ainda sem geometria renderizada */
//           return;
//         }

//         if (!conteudo || !conteudo.width || !conteudo.height) return;

//         const escala = transformMatrix.a || rootScaleRef.current || 1;

//         const x =
//           (areaLargura - conteudo.width * escala) / 2 - conteudo.x * escala;
//         const y =
//           (areaAltura - conteudo.height * escala) / 2 - conteudo.y * escala;

//         // translate
//         transformMatrix.e = x;
//         transformMatrix.f = y;

//         rootXRef.current = x;
//         rootYRef.current = y;

//         const transform = baseVal.createSVGTransformFromMatrix(transformMatrix);
//         baseVal.clear();
//         baseVal.appendItem(transform);
//       },
//       [svgRef, rootRef]
//     );

//     /**
//      * ===================================================================
//      * ENQUADRAR: O DESENHO OCUPANDO TODA A ÁREA, CENTRALIZADO
//      * -------------------------------------------------------------------
//      * Três coisas somadas, e é isso que o usuário espera do botão
//      * "Centralizar":
//      *
//      *   1. centralizar o conteúdo dentro do viewBox (handleCenter);
//      *   2. zerar o pan/zoom acumulado da roda do mouse;
//      *   3. dar zoom para o desenho preencher a área.
//      *
//      * O passo 3 é indispensável: os SVGs de página trazem uma escala
//      * própria na transformação do <g> raiz (algo como
//      * matrix(.6 0 0 .6 ...)), então o desenho renderiza bem menor que o
//      * viewBox e sobrava área vazia mesmo depois de centralizar.
//      *
//      * IMPORTANTE: o zoom é aplicado na CAMADA DE VISUALIZAÇÃO
//      * (react-zoom-pan-pinch, um transform CSS na div que envolve o SVG),
//      * nunca na geometria do arquivo. Assim o enquadramento não altera
//      * nada do que é serializado em handleConfirmar — nem o desenho, nem a
//      * posição dos links, nem o que a Home vai renderizar depois.
//      * ===================================================================
//      */
//     const handleEnquadrar = useCallback(() => {
//       /** 1. centraliza o conteúdo dentro do viewBox */
//       handleCenter();

//       const api = zoomApiRef.current;
//       const areaEl = editorAreaRef.current;
//       const rootEl = rootRef.current;

//       if (!api || !api.setTransform || !areaEl || !rootEl) return;

//       /** 2. volta ao estado neutro para medir sem transformação acumulada */
//       api.resetTransform(0);

//       /**
//        * A medição precisa acontecer depois de o navegador aplicar o
//        * reset; dois quadros garantem isso sem depender de detalhe
//        * interno da biblioteca.
//        */
//       window.requestAnimationFrame(() => {
//         window.requestAnimationFrame(() => {
//           if (!editorAreaRef.current || !rootRef.current) return;

//           const area = editorAreaRef.current.getBoundingClientRect();
//           const conteudo = rootRef.current.getBoundingClientRect();

//           if (
//             !area.width ||
//             !area.height ||
//             !conteudo.width ||
//             !conteudo.height
//           ) {
//             return;
//           }

//           /** 3. escala que faz o desenho preencher a área */
//           let fator =
//             Math.min(
//               area.width / conteudo.width,
//               area.height / conteudo.height
//             ) * MARGEM_ENQUADRAR;

//           fator = Math.max(ZOOM_MIN, Math.min(ZOOM_MAX, fator));

//           /** centro do desenho em coordenadas da área, no estado neutro */
//           const centroX = conteudo.left + conteudo.width / 2 - area.left;
//           const centroY = conteudo.top + conteudo.height / 2 - area.top;

//           /** leva esse centro para o centro da área, já na escala nova */
//           const x = area.width / 2 - centroX * fator;
//           const y = area.height / 2 - centroY * fator;

//           api.setTransform(x, y, fator, 200, 'easeOut');
//         });
//       });
//       // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [handleCenter]);

//     const handleLandscape = useCallback(() => {
//       const width = 874;
//       const height = 614;
//       const viewBox = `0 0 ${width} ${height}`;

//       svgRef.current.setAttribute('width', width);
//       svgRef.current.setAttribute('height', height);
//       svgRef.current.setAttribute('viewBox', viewBox);
//       svgRef.current.setAttribute('data-guid', 'landscape');

//       /** centraliza automaticamente */
//       if (pdfTool) {
//         handleCenterPdfProcess();
//       } else {
//         handleCenter();
//       }
//     }, [handleCenter, handleCenterPdfProcess, pdfTool]);

//     const handlePortrait = useCallback(() => {
//       const width = 614;
//       const height = 874;
//       const viewBox = `0 0 ${width} ${height}`;

//       svgRef.current.setAttribute('width', width);
//       svgRef.current.setAttribute('height', height);
//       svgRef.current.setAttribute('viewBox', viewBox);
//       svgRef.current.setAttribute('data-guid', 'portrait');

//       /** centraliza automaticamente */
//       if (pdfTool) {
//         handleCenterPdfProcess();
//       } else {
//         handleCenter();
//       }
//     }, [handleCenter, handleCenterPdfProcess, pdfTool]);

//     const handleScale = useCallback(
//       (value) => {
//         const { baseVal } = rootRef.current.transform;
//         const baseIndex = Array.from(baseVal).findIndex((e) => e.type === 1);

//         let transformMatrix = null;
//         if (baseIndex >= 0) {
//           const { matrix } = baseVal.getItem(baseIndex);
//           transformMatrix = matrix;
//         }

//         if (!transformMatrix)
//           transformMatrix = svgRef.current.createSVGMatrix();

//         // matrix scale
//         transformMatrix.a = rootScaleRef.current + value;
//         transformMatrix.d = rootScaleRef.current + value;

//         rootScaleRef.current += value;

//         const transform = baseVal.createSVGTransformFromMatrix(transformMatrix);
//         baseVal.clear();
//         baseVal.appendItem(transform);

//         /** centraliza automaticamente */
//         handleCenter();
//       },
//       [rootRef, svgRef, rootScaleRef, handleCenter]
//     );

//     const handleResize = useCallback(() => {
//       const currentGuid = svgRef.current.getAttribute('data-guid');
//       const currentWidth = svgRef.current.getAttribute('width');
//       const currentHeight = svgRef.current.getAttribute('height');

//       const width = currentGuid ? currentWidth : 614;
//       const height = currentGuid ? currentHeight : 874;
//       const dataGuid = currentGuid || 'portrait';

//       const viewBox = `0 0 ${width} ${height}`;

//       svgRef.current.setAttribute('width', width);
//       svgRef.current.setAttribute('height', height);
//       svgRef.current.setAttribute('viewBox', viewBox);
//       svgRef.current.setAttribute('data-guid', dataGuid);

//       /**
//        * Garante o ajuste "caber e centralizar". É o padrão do SVG, mas
//        * alguns arquivos convertidos trazem preserveAspectRatio="none",
//        * que com width/height em 100% distorceria o desenho.
//        */
//       svgRef.current.setAttribute('preserveAspectRatio', 'xMidYMid meet');
//     }, []);

//     /** define o tamanho do item para o valor passado */
//     const handleLinkScale = useCallback(
//       (valueH, valueW, link) => {
//         /** define os elementos de texto e formato do item */
//         const linkForm = link.childNodes[0];
//         const linkText = link.childNodes[1];

//         const { id: tipo = null } = linkForm.dataset || {};

//         switch (Number(tipo)) {
//           case LINK_FORM_TYPES.circle: {
//             /** validação */
//             const newSize = Number(valueH);
//             const dh = newSize - Number(linkForm.getAttribute('r'));
//             const xF = Number(linkForm.getAttribute('cx'));
//             const yF = Number(linkForm.getAttribute('cy'));

//             linkForm.setAttribute('r', newSize);
//             linkForm.setAttribute('x', xF - dh / 2);
//             linkForm.setAttribute('y', yF - dh / 2);

//             /** com o rótulo "nenhum" o link não tem <text> */
//             if (linkText) linkText.setAttribute('font-size', `${newSize}px`);
//             break;
//           }
//           case LINK_FORM_TYPES.rect: {
//             const newSizeH = Number(valueH);
//             const newSizeW = Number(valueW) || 0;

//             const currWidth = Number(linkForm.getAttribute('width'));
//             const currHeight = Number(linkForm.getAttribute('height'));

//             const dh = currHeight - newSizeH;
//             const dw = currWidth - newSizeW;
//             const xF = Number(linkForm.getAttribute('x'));
//             const yF = Number(linkForm.getAttribute('y'));

//             linkForm.setAttribute('height', newSizeH);
//             linkForm.setAttribute('width', newSizeW);

//             linkForm.setAttribute('x', xF + dw / 2);
//             linkForm.setAttribute('y', yF + dh / 2);

//             /** atualiza tamanho do texto */
//             if (linkText) {
//               linkText.setAttribute(
//                 'font-size',
//                 `${Math.trunc(newSizeH / 2)}px`
//               );
//             }

//             break;
//           }
//           /**
//            * Área: redimensiona mantendo o centro. O rótulo é reposicionado
//            * conforme o tipo: o código acompanha o centro da área e a
//            * etiqueta permanece onde o usuário deixou, apenas com a linha de
//            * chamada reancorada.
//            */
//           case LINK_FORM_TYPES.area: {
//             const limite = LINK_AREA_SIZE_LIMIT;

//             const novaH = Math.max(
//               limite.min,
//               Math.min(limite.max, Number(valueH) || 0)
//             );
//             const novaW = Math.max(
//               limite.min,
//               Math.min(limite.max, Number(valueW) || Number(valueH) || 0)
//             );

//             const currW = Number(linkForm.getAttribute('width'));
//             const currH = Number(linkForm.getAttribute('height'));
//             const xF = Number(linkForm.getAttribute('x'));
//             const yF = Number(linkForm.getAttribute('y'));

//             linkForm.setAttribute('width', novaW);
//             linkForm.setAttribute('height', novaH);
//             linkForm.setAttribute('x', xF + (currW - novaW) / 2);
//             linkForm.setAttribute('y', yF + (currH - novaH) / 2);

//             const rotuloAtual =
//               (link.dataset && link.dataset.rotulo) || opLinkRotulo.CODIGO;

//             if (rotuloAtual === opLinkRotulo.CODIGO && linkText) {
//               const caixa = getCaixaForma(linkForm);
//               linkText.setAttribute('x', caixa.x + caixa.width / 2);
//               linkText.setAttribute('y', caixa.y + caixa.height / 2);
//             }

//             if (rotuloAtual === opLinkRotulo.ETIQUETA) {
//               oReancorarChamada(link);
//             }

//             break;
//           }
//           case LINK_FORM_TYPES.ocr:
//             break;
//           default:
//             break;
//         }

//         /** verifica conflito */
//         oCheckConflict();
//       },
//       // eslint-disable-next-line react-hooks/exhaustive-deps
//       [LINK_FORM_TYPES, oCheckConflict, oReancorarChamada]
//     );

//     const handleLink = useCallback(() => {
//       const uniq = uniqBy(table, 'idItem');
//       uniq.forEach((item) => {
//         oLink(item);
//       });
//       handleOCRLimpar();

//       /** registra no histórico de desfazer/refazer */
//       oRegistrarHistorico();
//       // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [table, oLink, handleOCRLimpar]);

//     const handleRotate = useCallback((value) => {
//       const { baseVal } = rootRef.current.transform;
//       const i = Array.from(baseVal).findIndex((e) => e.type === 4);
//       let rotate;

//       if (i > 0) {
//         rotate = baseVal.getItem(i);
//       } else {
//         rotate = svgRef.current.createSVGTransform();
//         baseVal.appendItem(rotate);
//       }

//       rootRotateRef.current += value;
//       if (rootRotateRef.current >= 360 || rootRotateRef.current < 0)
//         rootRotateRef.current = 0;

//       rotate.setRotate(
//         rootRotateRef.current,
//         rootXRef.current,
//         rootYRef.current
//       );
//     }, []);

//     /**
//      * Nudge: move os links selecionados em passos finos.
//      *
//      * As setas sem modificador passam a mover a SELEÇÃO; Shift+setas
//      * continua movendo a página inteira, como antes.
//      */
//     const handleNudgeSelecao = useCallback(
//       (dx, dy) => {
//         if (!selectedRef.current.length) return false;

//         selectedRef.current.forEach((element) => {
//           transladarLink(element.node, dx, dy);

//           const rotuloAtual =
//             (element.node.dataset && element.node.dataset.rotulo) ||
//             opLinkRotulo.CODIGO;

//           if (rotuloAtual === opLinkRotulo.ETIQUETA) {
//             oReancorarChamada(element.node);
//           }
//         });

//         oCheckConflict();
//         oRegistrarHistorico();

//         return true;
//       },
//       [oCheckConflict, oRegistrarHistorico, oReancorarChamada]
//     );

//     /** rótulos legíveis das opções de rótulo, usados nos títulos dos botões */
//     const LABEL_ROTULO = {
//       [opLinkRotulo.CODIGO]: 'código dentro da forma',
//       [opLinkRotulo.NENHUM]: 'sem rótulo',
//       [opLinkRotulo.ETIQUETA]: 'etiqueta com linha de chamada',
//     };

//     /** alterna ciclicamente entre os três tipos de rótulo */
//     const handleAlternarRotulo = useCallback(() => {
//       const ordem = [
//         opLinkRotulo.CODIGO,
//         opLinkRotulo.NENHUM,
//         opLinkRotulo.ETIQUETA,
//       ];

//       setCurrLinkRotulo((atual) => {
//         const proximo = ordem[(ordem.indexOf(atual) + 1) % ordem.length];
//         currLinkRotuloRef.current = proximo;
//         return proximo;
//       });
//     }, []);

//     /**
//      * Liga/desliga o modo sequência. Ao ligar, seleciona automaticamente a
//      * geometria de área e o primeiro item pendente; ao desligar, devolve o
//      * pan da imagem.
//      */
//     const handleAlternarModoSequencia = useCallback(() => {
//       setModoSequencia((atual) => {
//         const proximo = !atual;
//         modoSequenciaRef.current = proximo;

//         if (proximo) {
//           currLinkTypeRef.current = INITIAL_LINK_AREA;
//           setCurrLinkType(LINK_FORM_TYPES.area);
//           oAvancarSequencia();
//         } else {
//           itemSequenciaRef.current = null;
//           setItemSequencia(null);
//           setZoomCanMove(true);
//         }

//         return proximo;
//       });
//       // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [oAvancarSequencia]);

//     /** seleciona manualmente o item alvo da sequência */
//     const handleSelecionarItemSequencia = useCallback((item) => {
//       itemSequenciaRef.current = item || null;
//       setItemSequencia(item || null);
//     }, []);

//     /**
//      * ===================================================================
//      * MODOS ALTERNADOS POR ATALHO
//      * -------------------------------------------------------------------
//      * Antes o Alt+Z e o Alt+S existiam SOMENTE como atalho, cada um com
//      * "setTimeout(..., 200)" dentro do handler de teclado. Com a tecla
//      * repetindo (keydown dispara em série enquanto pressionada), vários
//      * timers eram enfileirados, cada um invertendo o estado — o painel
//      * piscava e terminava aberto ou fechado de forma imprevisível.
//      *
//      * Agora a alternância está em um handler único, imediato e sem timer,
//      * usado tanto pelo atalho quanto por um botão na barra de ferramentas.
//      * ===================================================================
//      */

//     /** Alt+Z: liga/desliga o modo de zoom da página */
//     const handleAlternarZoom = useCallback(() => {
//       const proximo = !zoomControlRef.current;

//       /** ao SAIR do modo, devolve a página à escala/posição original */
//       if (!proximo && zoomResetRef.current && zoomResetRef.current.click) {
//         zoomResetRef.current.click();
//       }

//       zoomControlRef.current = proximo;
//       setZoomControl(proximo);

//       return proximo;
//     }, []);

//     /** Alt+S: liga/desliga a edição de tamanho (H/W) dos links */
//     const handleAlternarTamanho = useCallback(() => {
//       const proximo = !sizeControlRef.current;

//       sizeControlRef.current = proximo;
//       setSizeControl(proximo);

//       return proximo;
//     }, []);

//     /** legenda de atalhos: botão "?" da barra e teclas "?" / F1 */
//     const handleAlternarAtalhos = useCallback(() => {
//       const proximo = !atalhosAbertoRef.current;

//       atalhosAbertoRef.current = proximo;
//       setAtalhosAberto(proximo);

//       return proximo;
//     }, []);

//     /**
//      * Remoção dos links selecionados.
//      *
//      * Usada pelo Del/Backspace e pelo botão da barra. O handleRemove cru
//      * não dá retorno visual nenhum: sem seleção ele apenas não faz nada,
//      * e o usuário não sabia se o atalho existia ou se havia falhado. Aqui
//      * o resultado é sempre informado.
//      */
//     const handleRemoverSelecao = useCallback(() => {
//       const total =
//         selectedRef.current && selectedRef.current.length
//           ? selectedRef.current.length
//           : 0;

//       if (!total) {
//         toast.info('Selecione um link no desenho para remover.');
//         return false;
//       }

//       handleRemove();

//       toast.success(
//         total === 1 ? 'Link removido.' : `${total} links removidos.`
//       );

//       return true;
//     }, [handleRemove]);

//     /**
//      * ===================================================================
//      * ATALHOS DE TECLADO
//      * -------------------------------------------------------------------
//      * Regras aplicadas:
//      *
//      * 1. O preventDefault NÃO é mais aplicado a toda e qualquer tecla.
//      *    Antes, com o desenho em foco, o navegador perdia F5, Ctrl+C e o
//      *    próprio Tab. Agora só a tecla efetivamente tratada é consumida.
//      *
//      * 2. Alt "puro": em teclado ABNT2 o AltGr chega como Ctrl+Alt. Sem a
//      *    checagem de !ctrlKey, combinações de AltGr disparavam os modos
//      *    por engano.
//      *
//      * 3. e.repeat é ignorado nos comandos que alternam estado, para a
//      *    tecla presa não inverter o modo várias vezes.
//      * ===================================================================
//      */
//     const handleKeyDown = useCallback(
//       (e) => {
//         /** consome a tecla apenas quando o atalho é realmente tratado */
//         const tratado = () => {
//           e.preventDefault();
//           e.stopPropagation();
//         };

//         /** Alt sem Ctrl e sem Shift (AltGr do ABNT2 vem como Ctrl+Alt) */
//         const somenteAlt = e.altKey && !e.ctrlKey && !e.shiftKey;

//         /** legenda: "?" independe do layout do teclado; F1 é o atalho usual */
//         if (e.key === '?' || e.keyCode === 112) {
//           tratado();
//           if (!e.repeat) handleAlternarAtalhos();
//           return;
//         }

//         if (svgRef.current) {
//           switch (e.keyCode) {
//             /** 17: ctrl */
//             case 17:
//               break;
//             /** 16: shift */
//             case 16:
//               break;
//             /** 18: alt */
//             case 18:
//               break;
//             /**
//              * 46: delete | 8: backspace.
//              * O Backspace passa a valer porque é a tecla que o usuário
//              * tenta naturalmente; sem tratá-la o navegador ainda podia
//              * interpretar como "voltar página".
//              */
//             case 46:
//             case 8:
//               tratado();
//               handleRemoverSelecao();
//               break;
//             /**
//              * 27: esc.
//              *
//              * Ordem de prioridade: legenda aberta > seleção. Com a legenda
//              * aberta o evento é consumido (só ela fecha). Sem legenda, a
//              * seleção é limpa e o evento SEGUE subindo de propósito, para
//              * a tela poder sair do modo tela cheia no mesmo Esc (ver o
//              * listener de window em pages/EditorAI).
//              */
//             case 27:
//               if (atalhosAbertoRef.current) {
//                 tratado();
//                 handleAlternarAtalhos();
//               } else {
//                 e.preventDefault();
//                 oClearSelection();
//               }
//               break;
//             /**
//              * 37,38,39,40: setas.
//              * Shift+seta continua movendo a PÁGINA (comportamento antigo).
//              * Seta sozinha faz o ajuste fino do(s) link(s) selecionado(s);
//              * Ctrl+seta usa passo maior. Sem seleção, nada acontece.
//              */
//             case 37:
//               tratado();
//               if (e.shiftKey) handlePosition(-10, 0);
//               else handleNudgeSelecao(e.ctrlKey ? -5 : -1, 0);
//               break;
//             case 38:
//               tratado();
//               if (e.shiftKey) handlePosition(0, -10);
//               else handleNudgeSelecao(0, e.ctrlKey ? -5 : -1);
//               break;
//             case 39:
//               tratado();
//               if (e.shiftKey) handlePosition(10, 0);
//               else handleNudgeSelecao(e.ctrlKey ? 5 : 1, 0);
//               break;
//             case 40:
//               tratado();
//               if (e.shiftKey) handlePosition(0, 10);
//               else handleNudgeSelecao(0, e.ctrlKey ? 5 : 1);
//               break;
//             case 83:
//               /** Alt+S: edição de tamanho do link */
//               if (somenteAlt) {
//                 tratado();
//                 if (!e.repeat) handleAlternarTamanho();
//               }
//               break;
//             case 90:
//               /** Alt+Z: modo de zoom da página */
//               if (somenteAlt) {
//                 tratado();
//                 if (!e.repeat) handleAlternarZoom();
//               }
//               /** Ctrl+Z: desfazer / Ctrl+Shift+Z: refazer */
//               if (e.ctrlKey && !e.altKey) {
//                 tratado();
//                 if (e.shiftKey) handleRefazer();
//                 else handleDesfazer();
//               }
//               break;
//             case 89:
//               /** Ctrl+Y: refazer */
//               if (e.ctrlKey && !e.altKey) {
//                 tratado();
//                 handleRefazer();
//               }
//               break;
//             case 65:
//               /** Alt+A: liga/desliga o modo sequência */
//               if (somenteAlt) {
//                 tratado();
//                 if (!e.repeat) handleAlternarModoSequencia();
//               }
//               break;
//             case 187:
//               /** Shift+'=' */
//               if (e.shiftKey) {
//                 tratado();
//                 handleScale(0.1);
//               }
//               break;
//             case 189:
//               /** Shift+'-' */
//               if (e.shiftKey) {
//                 tratado();
//                 handleScale(-0.1);
//               }
//               break;
//             default:
//               break;
//           }
//         }
//       },
//       [
//         handlePosition,
//         handleScale,
//         handleRemoverSelecao,
//         handleNudgeSelecao,
//         handleDesfazer,
//         handleRefazer,
//         handleAlternarModoSequencia,
//         handleAlternarZoom,
//         handleAlternarTamanho,
//         handleAlternarAtalhos,
//         oClearSelection,
//       ]
//     );

//     /** limpa referências de controles */
//     const handleKeyUp = useCallback(() => {
//       if (svgRef.current) {
//         selectingRef.current = false;

//         if (actionRef.current) {
//           actionRef.current = null;
//         }

//         if (controlRef.current) {
//           controlRef.current = null;
//         }
//       }
//     }, [svgRef, actionRef]);

//     /**
//      * ===================================================================
//      * TECLADO: HANDLER SEMPRE ATUAL
//      * -------------------------------------------------------------------
//      * O elemento <SVG> é memoizado por [editor.pageNum, editor.path] (ver
//      * editorSvg mais abaixo). Como consequência, o onKeyDown/onKeyUp
//      * fixado no DOM é o da renderização em que a página foi carregada —
//      * um fechamento CONGELADO.
//      *
//      * Era a causa de o Alt+Z não devolver a escala da página: o handler
//      * antigo lia um zoomControl que nunca mudava. Todo handler novo
//      * dependente de estado sofreria do mesmo problema.
//      *
//      * A indireção abaixo mantém a identidade estável para o useMemo (o
//      * SVG não é reinjetado a cada tecla) e ainda assim executa sempre a
//      * versão mais recente do handler.
//      * ===================================================================
//      */
//     const keyDownRef = useRef(handleKeyDown);
//     const keyUpRef = useRef(handleKeyUp);

//     keyDownRef.current = handleKeyDown;
//     keyUpRef.current = handleKeyUp;

//     const onKeyDownEstavel = useCallback((e) => {
//       if (keyDownRef.current) keyDownRef.current(e);
//     }, []);

//     const onKeyUpEstavel = useCallback((e) => {
//       if (keyUpRef.current) keyUpRef.current(e);
//     }, []);

//     const handleControlClose = useCallback(
//       (control) => {
//         switch (control) {
//           case 'zoomAnimControl':
//             if (zoomControl && zoomResetRef.current) {
//               zoomResetRef.current.click();
//               setTimeout(() => setZoomControl((state) => !state), 200);
//             }
//             break;
//           case 'sizeAnimControl':
//             if (sizeControl) {
//               setTimeout(() => setSizeControl((state) => !state), 200);
//             }
//             break;
//           case 'all':
//             if (zoomControl && zoomResetRef.current) {
//               zoomResetRef.current.click();
//               setTimeout(() => setZoomControl((state) => !state), 200);
//             }
//             if (sizeControl) {
//               setTimeout(() => setSizeControl((state) => !state), 200);
//             }
//             break;
//           default:
//             break;
//         }
//       },
//       [zoomControl, sizeControl]
//     );

//     const handleSizeEdit = useCallback(
//       (valueH, valueW = 0, incremental = true) => {
//         /** controle de alteração de tamanho */
//         let newSizeH = 0;
//         let newSizeW = 0;

//         /** contagem de links alterados */
//         let count = 0;

//         /** verifica existencia de grupo de seleção */
//         const selection = !!(selectedRef && selectedRef.current.length);

//         /** altera o tamanho de todos os links conforme necessário */
//         linkMappingRef.current.forEach((link) => {
//           const isSelected = link.getAttribute('class')
//             ? link.getAttribute('class').indexOf('selected') !== -1
//             : false;

//           /** não altera o tamanho se houver um grupo de seleção e este item não estiver selecionado */
//           if (selection && !isSelected) return;

//           /** altera apenas os tipos selecionados por padrão */
//           if (
//             !selection &&
//             Number(link.childNodes[0].dataset.id) !== currLinkType
//           )
//             return;

//           /** pega valor do atributo para incremental */
//           switch (Number(link.childNodes[0].dataset.id)) {
//             case LINK_FORM_TYPES.circle:
//               newSizeH = valueH;
//               newSizeW = 0;

//               /** verifica se o processo é incremental */
//               if (incremental)
//                 newSizeH += Number(link.childNodes[0].getAttribute('r'));

//               /** validação */
//               if (newSizeH < LINK_SIZE_LIMIT.min)
//                 newSizeH = LINK_SIZE_LIMIT.min;
//               if (newSizeH > LINK_SIZE_LIMIT.max)
//                 newSizeH = LINK_SIZE_LIMIT.max;

//               break;
//             case LINK_FORM_TYPES.rect:
//               newSizeH = valueH;
//               newSizeW = valueW;

//               /** atribui mesmo valor de "valueH" + "width" pois no processo incremental não preenche "valueW" */
//               if (incremental) {
//                 const currSizeH = Number(
//                   link.childNodes[0].getAttribute('height')
//                 );
//                 const currSizeW = Number(
//                   link.childNodes[0].getAttribute('width')
//                 );

//                 newSizeH += currSizeH;
//                 newSizeW += currSizeW + valueH;

//                 /** proporcionalidade com o raio do circulo para situação incremental */
//                 if (newSizeH < currSizeH) newSizeH -= 1;
//                 if (newSizeW < currSizeW) newSizeW -= 1;

//                 if (newSizeH > currSizeH) newSizeH += 1;
//                 if (newSizeW > currSizeW) newSizeW += 1;
//               }

//               /** validação  */
//               if (Math.trunc(newSizeH / 2) < LINK_SIZE_LIMIT.min) {
//                 newSizeH = LINK_SIZE_LIMIT.min * 2;
//                 newSizeW = LINK_SIZE_LIMIT.min * 2;
//               }

//               if (Math.trunc(newSizeH / 2) > LINK_SIZE_LIMIT.max) {
//                 newSizeH = LINK_SIZE_LIMIT.max * 2;
//               }

//               if (Math.trunc(newSizeW / 2) < LINK_SIZE_LIMIT.min)
//                 newSizeW = newSizeH;

//               /** validação de comprimento somente para situação incremental */
//               if (Math.trunc(newSizeW / 2) > LINK_SIZE_LIMIT.max) {
//                 if (incremental) newSizeW = newSizeH;
//               }

//               break;
//             /** área: incremento simétrico em altura e largura */
//             case LINK_FORM_TYPES.area: {
//               const currH = Number(link.childNodes[0].getAttribute('height'));
//               const currW = Number(link.childNodes[0].getAttribute('width'));

//               newSizeH = incremental ? currH + Number(valueH) : Number(valueH);
//               newSizeW = incremental
//                 ? currW + Number(valueH)
//                 : Number(valueW) || Number(valueH);

//               newSizeH = Math.max(
//                 LINK_AREA_SIZE_LIMIT.min,
//                 Math.min(LINK_AREA_SIZE_LIMIT.max, newSizeH)
//               );
//               newSizeW = Math.max(
//                 LINK_AREA_SIZE_LIMIT.min,
//                 Math.min(LINK_AREA_SIZE_LIMIT.max, newSizeW)
//               );
//               break;
//             }
//             default:
//               break;
//           }

//           count += 1;

//           handleLinkScale(newSizeH, newSizeW, link, incremental);
//         });

//         if (!selection && count === linkMappingRef.current.length)
//           oChangeDefLinkSize(newSizeH, newSizeW, true);

//         /** registra no histórico de desfazer/refazer */
//         if (count > 0) oRegistrarHistorico();
//       },
//       [
//         LINK_FORM_TYPES,
//         LINK_SIZE_LIMIT,
//         currLinkType,
//         handleLinkScale,
//         oChangeDefLinkSize,
//         oRegistrarHistorico,
//       ]
//     );

//     const handleConfirmar = useCallback(async () => {
//       const { situacao } = catalogo;

//       const confirmacao =
//         situacao === opPaginaCatalogoSituacao.CONCLUIDO
//           ? window.confirm(
//               'Ao confirmar as alterações será necessário republicar o catálogo, deseja continuar?'
//             )
//           : true;

//       if (confirmacao) {
//         /** limpa biblioteca de localização OCR antes de salvar */
//         handleOCRLimpar();

//         /**
//          * Remove o retângulo temporário do arraste de área. Ele é auxiliar
//          * de edição e não deve ir para o arquivo salvo.
//          */
//         if (areaDraftRef.current) {
//           areaDraftRef.current.remove();
//           areaDraftRef.current = null;
//         }

//         /** carrega o arquivo editado */
//         const blob = new Blob([svgRef.current.outerHTML], {
//           type: 'image/svg+xml',
//         });
//         /** fecha controles do editor */
//         handleControlClose('all');

//         onSave({ svg: blob });
//       }
//     }, [catalogo, onSave, handleOCRLimpar, handleControlClose]);

//     const handleCancelar = useCallback(() => {
//       if (window.confirm('Deseja realmente cancelar as alterações?')) {
//         setEditor(INITIAL_STATE);
//         /** limpa biblioteca de localização OCR */
//         handleOCRLimpar();
//         /** fecha controles do editor */
//         handleControlClose('all');
//         setPdfTool(false);
//         onCancel();
//       }
//     }, [INITIAL_STATE, onCancel, handleOCRLimpar, handleControlClose]);

//     const loadAutoOCR = useCallback(
//       async (idCatalogo, idPagina) => {
//         // garante que já temos SVG/root
//         if (!rootRef.current || !svgRef.current) return;

//         // evita rodar duas vezes para a mesma página
//         if (pagRef.current === idPagina) return;
//         pagRef.current = idPagina;

//         if (onBeforeOCR) {
//           onBeforeOCR();
//         }

//         try {
//           // limpa OCR anterior
//           handleOCRLimpar();

//           // cria o grupo OCR
//           const ocrMapper = document.createElementNS(
//             rootRef.current.namespaceURI,
//             'g'
//           );
//           ocrMapper.setAttribute('id', 'ocrGroup');
//           rootRef.current.appendChild(ocrMapper);
//           ocrMapperRef.current = ocrMapper;

//           // chama API
//           const { data } = await api.get(
//             `/editor-associar-autom/${idCatalogo}/pagina/${idPagina}`
//           );

//           // desenha overlays
//           data.forEach((pt, index) => {
//             const link = document.createElementNS(
//               svgRef.current.namespaceURI,
//               'a'
//             );
//             link.id = String(index);
//             // link.setAttribute('x', pt.x);
//             link.setAttribute('x', pt.x + 10);
//             link.setAttribute('y', pt.y + 5);
//             // link.setAttribute('y', pt.y);
//             link.setAttribute('class', '');
//             link.addEventListener('click', (e) => e.preventDefault());
//             ocrMapperRef.current.appendChild(link);

//             const linkForm = document.createElementNS(
//               svgRef.current.namespaceURI,
//               'rect'
//             );

//             const linkText = document.createElementNS(
//               svgRef.current.namespaceURI,
//               'text'
//             );

//             const linkFormWidth = pt.text.length * 6;

//             linkForm.setAttribute('x', pt.x);
//             // linkForm.setAttribute('x', pt.x);
//             linkForm.setAttribute('y', pt.y - 3);
//             // linkForm.setAttribute('y', pt.y);
//             linkForm.setAttribute('height', '10');
//             linkForm.setAttribute('width', `${linkFormWidth}`);
//             linkForm.setAttribute(
//               'class',
//               pt.conf > 0.9 ? 'success' : 'warning'
//             );
//             linkForm.setAttribute('data-id', LINK_FORM_TYPES.ocr);
//             link.appendChild(linkForm);

//             linkText.setAttribute('x', pt.x + 5);
//             linkText.setAttribute('y', pt.y + 5);
//             linkText.setAttribute('font-size', '10');
//             linkText.setAttribute(
//               'class',
//               pt.conf > 0.9 ? 'success' : 'warning'
//             );
//             linkText.textContent = pt.text;
//             link.appendChild(linkText);

//             ocrMappingRef.current.push({ attr: link, ocr: pt });
//           });
//         } catch (err) {
//           toast.error(err);
//         } finally {
//           if (onAfterOCR) {
//             onAfterOCR();
//           }
//         }
//       },
//       [onBeforeOCR, onAfterOCR, handleOCRLimpar]
//     );

//     const editorSvg = useMemo(
//       () => (
//         <SVG
//           id={`page-${editor.pageNum}`}
//           src={editor.path ? editor.path : ''}
//           tabIndex="0"
//           useRequestCache={false}
//           onMouseDown={handleMouseDown}
//           onMouseMove={handleMouseMove}
//           onMouseUp={handleMouseUp}
//           onKeyDown={onKeyDownEstavel}
//           onKeyUp={onKeyUpEstavel}
//           loading={() => <span>Loading</span>}
//           fallback={() => <span>Selecione a imagem para editar</span>}
//           // beforeInjection={(svg) => {
//           //   /** atribui component a variáveis */
//           //   svgRef.current = svg;
//           // }}
//           // afterInjection={(err, svg) => {
//           //   if (svg) {
//           //     /** nó raiz */
//           //     rootRef.current = Array.from(svg.childNodes).find(
//           //       (e) => e.nodeName === 'svg:g'
//           //     );
//           //     /** limpa variáveis de alteração */
//           //     rootXRef.current = 0;
//           //     rootYRef.current = 0;
//           //     rootScaleRef.current = 1;
//           //     rootRotateRef.current = 0;

//           //     /** cria o componente seletor e atribui ao SVG */
//           //     const selector = document.createElementNS(
//           //       rootRef.current.namespaceURI,
//           //       'rect',
//           //       rootRef.current
//           //     );
//           //     selector.setAttribute('id', 'selector');
//           //     selector.setAttribute('stroke', '#ccc');
//           //     selector.setAttribute('fill', 'rgba(0,0,0,.2)');
//           //     rootRef.current.appendChild(selector);

//           //     /** mapeamento dos elementos */
//           //     linkMappingRef.current = [];
//           //     mappingElement(svg.childNodes);

//           //     /** verifica associações */
//           //     oCheckAssociation();

//           //     /** verifica conflitos */
//           //     oCheckConflict();

//           //     /** adicionar processo de arrastar e soltar no SVG */
//           //     svg.ondragover = handleDragOverSVG;
//           //     svg.ondrop = handleDropSVG;

//           //     /** redimensiona automaticamente para o tamanho padrão */
//           //     handleResize();

//           //     selectorRef.current = selector;

//           //     const { baseVal } = rootRef.current.transform;
//           //     const baseIndex = Array.from(baseVal).findIndex(
//           //       (e) => e.type === 1
//           //     );

//           //     if (baseIndex >= 0) {
//           //       const { matrix } = baseVal.getItem(baseIndex);

//           //       rootXRef.current = matrix.e;
//           //       rootYRef.current = matrix.f;
//           //       rootScaleRef.current = matrix.a;
//           //       // rootRotateRef.current = 0;
//           //     }

//           //     /** centraliza automaticamente */
//           //     handleCenter(true);
//           //   }
//           // }}
//           beforeInjection={(svg) => {
//             /** atribui component a variáveis */
//             svgRef.current = svg;
//             // NOVO: ainda não está pronto
//             setSvgReady(false);
//           }}
//           afterInjection={(err, svg) => {
//             if (svg) {
//               /** nó raiz */
//               rootRef.current = Array.from(svg.childNodes).find(
//                 (e) => e.nodeName === 'svg:g'
//               );
//               /** limpa variáveis de alteração */
//               rootXRef.current = 0;
//               rootYRef.current = 0;
//               rootScaleRef.current = 1;
//               rootRotateRef.current = 0;

//               /** cria o componente seletor e atribui ao SVG */
//               const selector = document.createElementNS(
//                 rootRef.current.namespaceURI,
//                 'rect',
//                 rootRef.current
//               );
//               selector.setAttribute('id', 'selector');
//               selector.setAttribute('stroke', '#ccc');
//               selector.setAttribute('fill', 'rgba(0,0,0,.2)');
//               rootRef.current.appendChild(selector);

//               /**
//                * Retângulo temporário do arraste que desenha a área de um
//                * novo link. É separado do "selector" (usado pelo Ctrl+arraste
//                * do OCR) para os dois não interferirem, e é removido antes de
//                * salvar em handleConfirmar.
//                */
//               areaDraftRef.current = null;
//               oGetAreaDraft();

//               /** mapeamento dos elementos */
//               linkMappingRef.current = [];
//               mappingElement(svg.childNodes);

//               /** verifica associações */
//               oCheckAssociation();

//               /** verifica conflitos */
//               oCheckConflict();

//               /** estado inicial do histórico de desfazer/refazer */
//               historicoRef.current = [];
//               historicoPosRef.current = -1;
//               oRegistrarHistorico();

//               /** adicionar processo de arrastar e soltar no SVG */
//               svg.ondragover = handleDragOverSVG;
//               svg.ondrop = handleDropSVG;

//               /** redimensiona automaticamente para o tamanho padrão */
//               handleResize();

//               selectorRef.current = selector;

//               const { baseVal } = rootRef.current.transform;
//               const baseIndex = Array.from(baseVal).findIndex(
//                 (e) => e.type === 1
//               );

//               if (baseIndex >= 0) {
//                 const { matrix } = baseVal.getItem(baseIndex);

//                 rootXRef.current = matrix.e;
//                 rootYRef.current = matrix.f;
//                 rootScaleRef.current = matrix.a;
//                 // rootRotateRef.current = 0;
//               }

//               /** centraliza automaticamente */
//               handleCenter(true);

//               /**
//                * Enquadra depois que o navegador já mediu o SVG injetado.
//                *
//                * Sem isso o desenho abria pequeno e no canto: o
//                * centerOnInit do TransformWrapper roda na montagem, quando
//                * o SVG ainda não existe (o react-svg busca o arquivo em
//                * seguida), então o pan é calculado sobre conteúdo de
//                * tamanho zero. O timeout entrega o reset já com a
//                * geometria real disponível.
//                */
//               setTimeout(() => {
//                 handleEnquadrar();
//               }, 60);

//               // 👇 NOVO: assim que o SVG da página estiver pronto, carrega o OCR automático
//               if (catalogo?.idCatalogo && pagina?.idPagina) {
//                 loadAutoOCR(catalogo.idCatalogo, pagina.idPagina);
//               }
//             }
//           }}
//           // afterInjection={(err, svg) => {
//           //   if (svg) {
//           //     /** nó raiz */
//           //     rootRef.current = Array.from(svg.childNodes).find(
//           //       (e) => e.nodeName === 'svg:g'
//           //     );
//           //     /** limpa variáveis de alteração */
//           //     rootXRef.current = 0;
//           //     rootYRef.current = 0;
//           //     rootScaleRef.current = 1;
//           //     rootRotateRef.current = 0;

//           //     /** cria o componente seletor e atribui ao SVG */
//           //     const selector = document.createElementNS(
//           //       rootRef.current.namespaceURI,
//           //       'rect',
//           //       rootRef.current
//           //     );
//           //     selector.setAttribute('id', 'selector');
//           //     selector.setAttribute('stroke', '#ccc');
//           //     selector.setAttribute('fill', 'rgba(0,0,0,.2)');
//           //     rootRef.current.appendChild(selector);

//           //     /** mapeamento dos elementos */
//           //     linkMappingRef.current = [];
//           //     mappingElement(svg.childNodes);

//           //     /** verifica associações */
//           //     oCheckAssociation();

//           //     /** verifica conflitos */
//           //     oCheckConflict();

//           //     /** adicionar processo de arrastar e soltar no SVG */
//           //     svg.ondragover = handleDragOverSVG;
//           //     svg.ondrop = handleDropSVG;

//           //     /** redimensiona automaticamente para o tamanho padrão */
//           //     handleResize();

//           //     selectorRef.current = selector;

//           //     const { baseVal } = rootRef.current.transform;
//           //     const baseIndex = Array.from(baseVal).findIndex(
//           //       (e) => e.type === 1
//           //     );

//           //     if (baseIndex >= 0) {
//           //       const { matrix } = baseVal.getItem(baseIndex);

//           //       rootXRef.current = matrix.e;
//           //       rootYRef.current = matrix.f;
//           //       rootScaleRef.current = matrix.a;
//           //       // rootRotateRef.current = 0;
//           //     }

//           //     /** centraliza automaticamente */
//           //     handleCenter(true);

//           //     // NOVO: agora o SVG está pronto pra receber o OCR automático
//           //     setSvgReady(true);
//           //   }
//           // }}
//         />
//       ),
//       // eslint-disable-next-line react-hooks/exhaustive-deps
//       [
//         editor.pageNum,
//         editor.path,
//         // handleDropSVG,
//         // handleDragOverSVG,
//         // handleKeyDown,
//         // handleKeyUp,
//         // handleMouseDown,
//         // handleMouseMove,
//         // handleMouseUp,
//         // mappingElement,
//       ]
//     );

//     return (
//       <Container id="editor" onDragOver={handleDragOver}>
//         <ToolBar>
//           <button title="Salvar" type="submit" onClick={handleConfirmar}>
//             <MdDone size={16} />
//           </button>
//           <button type="button" title="Cancelar" onClick={handleCancelar}>
//             <MdClose size={16} />
//           </button>
//           <button
//             type="button"
//             title="Remover link selecionado (Del)"
//             onClick={handleRemoverSelecao}
//           >
//             <MdDelete size={16} />
//           </button>
//           <button type="button" title="Redimensionar" onClick={handleResize}>
//             <MdCropFree size={16} />
//           </button>
//           {/**
//            * Os modos de zoom e de tamanho do link existiam apenas por
//            * atalho (Alt+Z / Alt+S), sem nenhuma indicação em tela. Os
//            * botões abaixo usam os MESMOS handlers do teclado e mostram o
//            * estado atual por aria-pressed.
//            */}
//           <button
//             type="button"
//             title="Modo zoom da página (Alt+Z)"
//             aria-pressed={zoomControl}
//             onClick={handleAlternarZoom}
//             style={
//               zoomControl
//                 ? { color: opLinkEstilo.COR, fontWeight: 'bold' }
//                 : undefined
//             }
//           >
//             <MdZoomOutMap size={16} />
//           </button>
//           <button
//             type="button"
//             title="Editar tamanho do link (Alt+S)"
//             aria-pressed={sizeControl}
//             onClick={handleAlternarTamanho}
//             style={
//               sizeControl
//                 ? { color: opLinkEstilo.COR, fontWeight: 'bold' }
//                 : undefined
//             }
//           >
//             <MdAspectRatio size={16} />
//           </button>
//           <button
//             type="button"
//             title="Centralizar e enquadrar o desenho na área"
//             onClick={() =>
//               pdfTool ? handleCenterPdfProcess() : handleEnquadrar()
//             }
//           >
//             <MdCenterFocusStrong size={16} />
//           </button>
//           <button type="button" title="Horizontal" onClick={handleLandscape}>
//             <MdStayPrimaryLandscape size={16} />
//           </button>
//           <button type="button" title="Vertical" onClick={handlePortrait}>
//             <MdStayPrimaryPortrait size={16} />
//           </button>
//           <button
//             type="button"
//             title="Escala +"
//             onClick={() =>
//               pdfTool ? handleScalePdfProcess(0.1) : handleScale(0.1)
//             }
//           >
//             <MdExposurePlus1 size={16} />
//           </button>
//           <button
//             type="button"
//             title="Escala -"
//             onClick={() =>
//               pdfTool ? handleScalePdfProcess(-0.1) : handleScale(-0.1)
//             }
//           >
//             <MdExposureNeg1 size={16} />
//           </button>
//           <button
//             type="button"
//             title="Rotacionar"
//             onClick={() => handleRotate(-45)}
//           >
//             <MdRotateLeft size={16} />
//           </button>
//           <button
//             type="button"
//             title="Rotacionar"
//             onClick={() => handleRotate(45)}
//           >
//             <MdRotateRight size={16} />
//           </button>
//           <button
//             type="button"
//             title="Posiciona (Esquerda)"
//             onClick={() =>
//               pdfTool
//                 ? handlePositionPdfProcess(-10, 0)
//                 : handlePosition(-10, 0)
//             }
//           >
//             <MdKeyboardArrowLeft size={16} />
//           </button>
//           <button
//             type="button"
//             title="Posiciona (Abaixo)"
//             onClick={() =>
//               pdfTool ? handlePositionPdfProcess(0, 10) : handlePosition(0, 10)
//             }
//           >
//             <MdKeyboardArrowDown size={16} />
//           </button>
//           <button
//             type="button"
//             title="Posiciona (Acima)"
//             onClick={() =>
//               pdfTool
//                 ? handlePositionPdfProcess(0, -10)
//                 : handlePosition(0, -10)
//             }
//           >
//             <MdKeyboardArrowUp size={16} />
//           </button>
//           <button
//             type="button"
//             title="Posiciona (Direita)"
//             onClick={() =>
//               pdfTool ? handlePositionPdfProcess(10, 0) : handlePosition(10, 0)
//             }
//           >
//             <MdKeyboardArrowRight size={16} />
//           </button>
//           <button type="button" title="Link" onClick={handleLink}>
//             <MdLink size={20} />
//           </button>
//           <button
//             type="button"
//             title="Link +"
//             onClick={() => handleSizeEdit(+1)}
//           >
//             <MdUnfoldMore size={16} />
//           </button>
//           <button
//             type="button"
//             title="Link -"
//             onClick={() => handleSizeEdit(-1)}
//           >
//             <MdUnfoldLess size={16} />
//           </button>
//           <button
//             type="button"
//             title="Link círculo"
//             disabled={currLinkType === LINK_FORM_TYPES.circle}
//             onClick={() => {
//               currLinkTypeRef.current = INITIAL_LINK_CIRCLE;
//               setCurrLinkType(LINK_FORM_TYPES.circle);
//               /** oculta para definir os campos */
//               setSizeControl(false);

//               oChangeDefLinkSize(0, 0, true);
//             }}
//           >
//             <MdRadioButtonUnchecked size={16} />
//           </button>
//           <button
//             type="button"
//             title="Link retângulo"
//             disabled={currLinkType === LINK_FORM_TYPES.rect}
//             onClick={() => {
//               currLinkTypeRef.current = INITIAL_LINK_RECT;
//               setCurrLinkType(LINK_FORM_TYPES.rect);
//               /** oculta para definir os campos */
//               setSizeControl(false);

//               oChangeDefLinkSize(0, 0, true);
//             }}
//           >
//             <MdCheckBoxOutlineBlank size={16} />
//           </button>
//           {/**
//            * Área por arraste: forma indicada para esquemas elétricos, em
//            * que o link acompanha o contorno real do componente em vez de
//            * um marcador de tamanho fixo.
//            */}
//           <button
//             type="button"
//             title="Desfazer (Ctrl+Z)"
//             disabled={!historicoInfo.podeDesfazer}
//             onClick={handleDesfazer}
//           >
//             <MdUndo size={16} />
//           </button>
//           <button
//             type="button"
//             title="Refazer (Ctrl+Y)"
//             disabled={!historicoInfo.podeRefazer}
//             onClick={handleRefazer}
//           >
//             <MdRedo size={16} />
//           </button>
//           <button
//             type="button"
//             title="Link área: arraste sobre o componente para desenhar o contorno (o ID do item é pedido ao soltar)"
//             disabled={currLinkType === LINK_FORM_TYPES.area}
//             onClick={() => {
//               currLinkTypeRef.current = INITIAL_LINK_AREA;
//               setCurrLinkType(LINK_FORM_TYPES.area);
//               /** oculta para definir os campos */
//               setSizeControl(false);

//               oChangeDefLinkSize(
//                 INITIAL_LINK_AREA.height,
//                 INITIAL_LINK_AREA.width,
//                 true
//               );
//             }}
//           >
//             <MdCropFree size={16} />
//           </button>
//           {/** alterna o rótulo aplicado aos novos links */}
//           <button
//             type="button"
//             title={`Rótulo do link: ${LABEL_ROTULO[currLinkRotulo]} (clique para alternar)`}
//             onClick={handleAlternarRotulo}
//           >
//             {currLinkRotulo === opLinkRotulo.ETIQUETA && (
//               <MdLabelOutline size={16} />
//             )}
//             {currLinkRotulo === opLinkRotulo.NENHUM && <MdLabelOff size={16} />}
//             {currLinkRotulo === opLinkRotulo.CODIGO && <MdLabel size={16} />}
//           </button>
//           {/**
//            * Modo sequência: com ele ativo, cada arraste sobre o desenho
//            * cria a área do próximo item pendente e avança automaticamente.
//            */}
//           <button
//             type="button"
//             title={
//               modoSequencia
//                 ? `Modo sequência ativo (Alt+A)${
//                     itemSequencia ? ` - item ${itemSequencia.idItem}` : ''
//                   }`
//                 : 'Modo sequência: criar links em série por arraste (Alt+A)'
//             }
//             onClick={handleAlternarModoSequencia}
//             style={
//               modoSequencia
//                 ? { color: opLinkEstilo.COR, fontWeight: 'bold' }
//                 : undefined
//             }
//           >
//             <MdPlaylistAddCheck size={18} />
//           </button>
//           {/**
//            * Indicador do modo sequência: quantos itens ainda não têm link e
//            * qual é o próximo alvo do arraste.
//            */}
//           {modoSequencia && (
//             <span
//               title="Itens sem link nesta página / próximo item do arraste"
//               style={{
//                 display: 'inline-flex',
//                 alignItems: 'center',
//                 gap: 4,
//                 padding: '0 8px',
//                 whiteSpace: 'nowrap',
//                 fontSize: 12,
//                 fontWeight: 700,
//                 color: opLinkEstilo.COR,
//               }}
//             >
//               {itensPendentes.length} pendente
//               {itensPendentes.length === 1 ? '' : 's'}
//               {itemSequencia ? ` - próximo: ${itemSequencia.idItem}` : ''}
//             </span>
//           )}
//           <button
//             type="button"
//             title="OCR - Tradicional"
//             onClick={() =>
//               handleOCRLocalizar(opEditorAssociarTipoExtracao.TRADICIONAL)
//             }
//           >
//             <MdOutlineFilter1 size={16} />
//           </button>
//           {process.env.REACT_APP_EXPERIMENTAL_IA_ASSOCIACAO ===
//             opSimNao.SIM && (
//             <>
//               {/* <button
//                 type="button"
//                 title="OCR - Easy FAST"
//                 onClick={() =>
//                   handleOCRLocalizar(opEditorAssociarTipoExtracao.EASY_FAST)
//                 }
//               >
//                 <MdOutlineFilter2 size={16} />
//               </button>
//               <button
//                 type="button"
//                 title="ORC = Easy DEEP"
//                 onClick={() =>
//                   handleOCRLocalizar(opEditorAssociarTipoExtracao.EASY_DEEP)
//                 }
//               >
//                 <MdOutlineFilter3 size={16} />
//               </button> */}
//               <button
//                 type="button"
//                 title="Extração PDF"
//                 onClick={() =>
//                   handlePDFLocalizar(opEditorAssociarTipoExtracao.PDF)
//                 }
//               >
//                 <MdOutlineFilter2 size={16} />
//               </button>
//               <button
//                 type="button"
//                 title="Paddle OCR"
//                 onClick={() =>
//                   handleOCRLocalizar(opEditorAssociarTipoExtracao.PADDLE_OCR)
//                 }
//               >
//                 <MdOutlineFilter3 size={16} />
//               </button>
//             </>
//           )}
//           <button type="button" title="Limpar OCR" onClick={handleOCRLimpar}>
//             <MdOutlineLayersClear size={16} />
//           </button>
//           {/**
//            * Legenda de atalhos: fica no fim da barra, separada do resto,
//            * e é o único ponto de descoberta dos comandos de teclado.
//            */}
//           <button
//             type="button"
//             title="Atalhos do teclado (? ou F1)"
//             aria-pressed={atalhosAberto}
//             onClick={handleAlternarAtalhos}
//             style={{ marginLeft: 'auto' }}
//           >
//             <MdHelpOutline size={16} />
//           </button>
//         </ToolBar>

//         <Wrapper
//         // onMouseDown={handleMouseDown}
//         // onMouseMove={handleMouseMove}
//         // onMouseUp={handleMouseUp}
//         // onKeyDown={handleKeyDown}
//         // onKeyUp={handleKeyUp}
//         >
//           {/**
//            * Zoom pela roda do mouse sem precisar alternar para o modo de
//            * zoom (Alt+Z).
//            *
//            * O wrapper deixa de ser desabilitado para que a roda funcione,
//            * mas o comportamento observado antes é preservado:
//            *  - o pan continua exigindo o modo de zoom ativo
//            *    (antes o wrapper inteiro estava desabilitado fora dele);
//            *  - o duplo clique nunca dá zoom (antes também não dava, pois
//            *    o wrapper estava desabilitado fora do modo de zoom e o
//            *    doubleClick estava desabilitado dentro dele) — assim não
//            *    concorre com o input rápido de link.
//            */}
//           <TransformWrapper
//             initialScale={1}
//             centerOnInit
//             centerZoomedOut
//             /**
//              * minScale abaixo de 1 é necessário para o enquadramento
//              * poder reduzir quando o desenho é maior que a área — e de
//              * quebra o usuário passa a conseguir afastar com a roda.
//              */
//             minScale={0.5}
//             panning={{ disabled: !zoomCanMove || !zoomControl }}
//             wheel={{ step: 0.08 }}
//             doubleClick={{ disabled: true }}
//             disabled={false}
//             onZoom={(target) => {
//               zoomScaleRef.current = target.scale;
//               return target;
//             }}
//           >
//             {(zoomApi) => {
//               /**
//                * Guarda a API do zoom para uso fora dos botões (após a
//                * injeção do SVG e no botão Centralizar/Enquadrar).
//                */
//               zoomApiRef.current = zoomApi;

//               const { zoomIn, zoomOut, resetTransform } = zoomApi;

//               return (
//                 // if (elementToZoom) {
//                 //   setTransform(
//                 //     -Math.abs(elementToZoom.layerX),
//                 //     -Math.abs(elementToZoom.layerY),
//                 //     1.5,
//                 //     1000,
//                 //     'easeInOutQuad'
//                 //   );
//                 // }
//                 <EditorWrapper ref={editorAreaRef}>
//                   {(zoomControl || sizeControl) && (
//                     <ControlWrapper show={zoomControl || sizeControl}>
//                       {zoomControl && (
//                         <Control isVisible={zoomControl} control="zoom">
//                           <Control.BtnClose
//                             type="button"
//                             onClick={() =>
//                               handleControlClose(zoomRef && zoomRef.current.id)
//                             }
//                           >
//                             <MdCancel size={16} />
//                           </Control.BtnClose>
//                           <Control.Animated ref={zoomRef} id="zoomAnimControl">
//                             <Control.ZoomBtnAct
//                               ref={zoomInRef}
//                               type="button"
//                               onClick={() => zoomIn()}
//                             >
//                               <MdZoomIn size={25} />
//                             </Control.ZoomBtnAct>
//                             <Control.ZoomBtnAct
//                               ref={zoomOutRef}
//                               type="button"
//                               onClick={() => zoomOut()}
//                             >
//                               <MdZoomOut size={25} />
//                             </Control.ZoomBtnAct>
//                             <Control.ZoomBtnAct
//                               ref={zoomResetRef}
//                               type="button"
//                               onClick={() => resetTransform()}
//                             >
//                               <MdYoutubeSearchedFor size={25} />
//                             </Control.ZoomBtnAct>
//                           </Control.Animated>
//                         </Control>
//                       )}
//                       {sizeControl && (
//                         <Control isVisible={sizeControl} control="size">
//                           <Control.BtnClose
//                             type="button"
//                             onClick={() =>
//                               handleControlClose(sizeRef && sizeRef.current.id)
//                             }
//                           >
//                             <MdCancel size={16} />
//                           </Control.BtnClose>
//                           <Control.Animated ref={sizeRef} id="sizeAnimControl">
//                             <Form
//                               ref={formSizeRef}
//                               onSubmit={({ sizeInputH, sizeInputW }) => {
//                                 handleSizeEdit(
//                                   Number(sizeInputH),
//                                   Number(sizeInputW),
//                                   false
//                                 );
//                               }}
//                               autoComplete="off"
//                             >
//                               <Control.SizeInput>
//                                 <Input
//                                   id="sizeInputH"
//                                   name="sizeInputH"
//                                   type="number"
//                                   placeholder="H"
//                                   width={60}
//                                   onKeyDown={(e) =>
//                                     e.keyCode === 13 &&
//                                     formSizeRef.current.submitForm()
//                                   }
//                                 />
//                                 <Input
//                                   id="sizeInputW"
//                                   name="sizeInputW"
//                                   type="number"
//                                   placeholder="W"
//                                   width={60}
//                                   onKeyDown={(e) =>
//                                     e.keyCode === 13 &&
//                                     formSizeRef.current.submitForm()
//                                   }
//                                 />
//                               </Control.SizeInput>
//                             </Form>
//                           </Control.Animated>
//                         </Control>
//                       )}
//                     </ControlWrapper>
//                   )}

//                   {quickInput.open && (
//                     <div
//                       role="dialog"
//                       aria-modal="true"
//                       aria-label="Inserir ID do item"
//                       tabIndex={-1}
//                       style={{
//                         position: 'absolute',
//                         left: quickInput.x,
//                         top: quickInput.y,
//                         transform: 'translate(-50%, -150%)',
//                         background: '#fff',
//                         border: '1px solid #d1d5db',
//                         borderRadius: 8,
//                         padding: 6,
//                         zIndex: 9,
//                         boxShadow: '0 2px 8px rgba(0,0,0,.40)',
//                       }}
//                       // onClick={(e) => e.stopPropagation()}
//                     >
//                       <input
//                         ref={quickInputRef}
//                         type="text"
//                         placeholder="ID do item…"
//                         value={quickInput.value}
//                         onMouseDown={(e) => e.stopPropagation()}
//                         onClick={(e) => e.stopPropagation()}
//                         onChange={(e) => {
//                           const v = e.target.value;
//                           setQuickInput((s) => ({ ...s, value: v }));
//                         }}
//                         onKeyDown={(e) => {
//                           if (e.key === 'Enter') {
//                             e.stopPropagation();
//                             e.preventDefault();
//                             const v =
//                               (quickInputRef.current &&
//                                 quickInputRef.current.value) ||
//                               quickInput.value;
//                             handleQuickInputConfirm(v);
//                           } else if (e.key === 'Escape') {
//                             e.stopPropagation();
//                             e.preventDefault();
//                             handleQuickInputCancel();
//                           }
//                         }}
//                         onBlur={() => {
//                           setTimeout(() => {
//                             handleQuickInputCancel();
//                           }, 0);
//                         }}
//                         style={{
//                           width: 140,
//                           outline: 'none',
//                           border: 'none',
//                           padding: '2px 5px',
//                           borderRadius: 8,
//                         }}
//                       />
//                     </div>
//                   )}

//                   {/**
//                    * Legenda de atalhos. Renderizada por último dentro do
//                    * EditorWrapper para ficar acima do desenho, e apenas
//                    * quando aberta — fechada, não ocupa nada.
//                    */}
//                   {atalhosAberto && (
//                     <Atalhos
//                       role="dialog"
//                       aria-label="Atalhos do teclado e do mouse"
//                     >
//                       <Atalhos.Header>
//                         <strong>Atalhos</strong>
//                         <Atalhos.BtnClose
//                           type="button"
//                           title="Fechar (Esc)"
//                           onClick={handleAlternarAtalhos}
//                         >
//                           <MdClose size={16} />
//                         </Atalhos.BtnClose>
//                       </Atalhos.Header>

//                       <Atalhos.Body>
//                         {ATALHOS_EDITOR.map((secao) => (
//                           <Atalhos.Grupo key={secao.grupo}>
//                             <span>{secao.grupo}</span>
//                             {secao.itens.map((atalho) => (
//                               <Atalhos.Linha
//                                 key={`${secao.grupo}-${atalho.texto}`}
//                               >
//                                 <p>{atalho.texto}</p>
//                                 <div>
//                                   {atalho.teclas.map((tecla, indice) => (
//                                     <Atalhos.Tecla
//                                       key={`${atalho.texto}-${tecla}-${indice}`}
//                                     >
//                                       {tecla}
//                                     </Atalhos.Tecla>
//                                   ))}
//                                 </div>
//                               </Atalhos.Linha>
//                             ))}
//                           </Atalhos.Grupo>
//                         ))}
//                       </Atalhos.Body>
//                     </Atalhos>
//                   )}

//                   {/**
//                    * O wrapper do zoom precisa de tamanho explícito: sem
//                    * isso ele se ajusta ao SVG e a área extra conquistada no
//                    * layout não vira espaço de trabalho.
//                    */}
//                   {/**
//                    * wrapperStyle E contentStyle em 100%.
//                    *
//                    * O react-zoom-pan-pinch dimensiona a div externa
//                    * (.react-transform-wrapper) mas deixa a interna
//                    * (.react-transform-component) no tamanho do conteúdo.
//                    * Sem altura definida nela, o "height: 100%" do <svg>
//                    * não tem contra o que resolver e o desenho volta ao
//                    * tamanho dos atributos do arquivo (614x874) — era o que
//                    * fazia sobrar área vazia em volta.
//                    */}
//                   <TransformComponent
//                     wrapperStyle={{ width: '100%', height: '100%' }}
//                     contentStyle={{ width: '100%', height: '100%' }}
//                   >
//                     {editorSvg}
//                   </TransformComponent>
//                 </EditorWrapper>
//               );
//             }}
//           </TransformWrapper>
//         </Wrapper>
//       </Container>
//     );
//   }
// );

// export default EditorArea;

// EditorArea.propTypes = {
//   catalogo: PropTypes.instanceOf(Object).isRequired,
//   pagina: PropTypes.instanceOf(Object),
//   itensPagina: PropTypes.arrayOf(Object),
//   onSave: PropTypes.func.isRequired,
//   onCancel: PropTypes.func.isRequired,
//   onBeforeOCR: PropTypes.func,
//   onAfterOCR: PropTypes.func,
//   onAssociate: PropTypes.func,
//   onLinkHighlight: PropTypes.func,
// };

// EditorArea.defaultProps = {
//   pagina: null,
//   itensPagina: null,
//   onBeforeOCR: null,
//   onAfterOCR: null,
//   onAssociate: null,
//   onLinkHighlight: null,
// };

import React, {
  useState,
  useEffect,
  useMemo,
  useRef,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from 'react';
import uniqBy from 'lodash.uniqby';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import {
  MdAspectRatio,
  MdCancel,
  MdCheckBoxOutlineBlank,
  MdCenterFocusStrong,
  MdClose,
  MdCropFree,
  MdDelete,
  MdDone,
  MdHelpOutline,
  MdZoomOutMap,
  MdExposureNeg1,
  MdExposurePlus1,
  MdKeyboardArrowDown,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdKeyboardArrowUp,
  MdOutlineFilter1,
  MdOutlineFilter2,
  MdOutlineFilter3,
  MdOutlineFilter4,
  MdOutlineFilter5,
  MdOutlineLayersClear,
  MdLink,
  MdLabelOutline,
  MdLabelOff,
  MdLabel,
  MdPlaylistAddCheck,
  MdUndo,
  MdRedo,
  MdUnfoldLess,
  MdUnfoldMore,
  MdRadioButtonUnchecked,
  MdRotateLeft,
  MdRotateRight,
  MdStayPrimaryLandscape,
  MdStayPrimaryPortrait,
  MdYoutubeSearchedFor,
  MdZoomIn,
  MdZoomOut,
} from 'react-icons/md';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';

import {
  opEditorAssociarTipoExtracao,
  opPaginaCatalogoSituacao,
  opSimNao,
  opLinkForma,
  opLinkRotulo,
  opLinkPapel,
  opLinkTamanho,
  opLinkEstilo,
} from '../../lib/const';

import {
  getSvgCoordinates,
  createOcrGroup,
  createSvgLinkPdfProcess,
  centerCalculation,
  updateSvgPositionProcessPdf,
  centerSvgPdfProcess,
  scaleSvgProcessPdf,
  getNomeLocalSvg,
  isFormaLink,
  getPapelLink,
  getFormaPrincipal,
  getCaixaForma,
  criarLinhaChamada,
  atualizarLinhaChamada,
  transladarLink,
  transladarElementoSvg,
  calcularAncoraChamada,
  larguraEstimadaRotulo,
} from '../../lib/mapeamentoUtils';

import api from '../../services/api';

import { Form } from '../Form';
import Input from '../Form/Input';

import {
  Container,
  Wrapper,
  EditorWrapper,
  ControlWrapper,
  Control,
  ToolBar,
  ToolBarArea,
  SVG,
  Atalhos,
} from './styles';

/**
 * =====================================================================
 * CONTEÚDO DA LEGENDA DE ATALHOS
 * ---------------------------------------------------------------------
 * Espelha exatamente o que handleMouseDown / handleMouseMove /
 * handleKeyDown tratam hoje. Ao criar ou alterar um atalho, atualize
 * também esta lista — é o único lugar em que o usuário consegue
 * descobrir os comandos.
 * =====================================================================
 */
const ATALHOS_EDITOR = [
  {
    grupo: 'Mouse',
    itens: [
      {
        teclas: ['Clique'],
        texto: 'Seleciona o link; no vazio, limpa a seleção',
      },
      { teclas: ['Shift', 'Clique'], texto: 'Acrescenta o link à seleção' },
      { teclas: ['Shift', 'Alt', 'Clique'], texto: 'Retira o link da seleção' },
      {
        teclas: ['Arraste'],
        texto:
          'Sobre um link, move o link; sobre a etiqueta, move só a etiqueta',
      },
      { teclas: ['Alt', 'Arraste'], texto: 'Move apenas o link sob o cursor' },
      {
        teclas: ['Ctrl', 'Arraste'],
        texto: 'Seleção por área (também usada no OCR)',
      },
      {
        teclas: ['Arraste'],
        texto: 'Com a forma "área" ativa, desenha o contorno do novo link',
      },
      { teclas: ['Roda'], texto: 'Zoom do desenho' },
    ],
  },
  {
    grupo: 'Links',
    itens: [
      { teclas: ['Del'], texto: 'Remove os links selecionados' },
      { teclas: ['Backspace'], texto: 'Mesmo efeito do Del' },
      { teclas: ['←', '↑', '→', '↓'], texto: 'Ajuste fino da seleção (1 px)' },
      { teclas: ['Ctrl', 'setas'], texto: 'Ajuste fino da seleção (5 px)' },
      {
        teclas: ['Alt', 'S'],
        texto: 'Abre/fecha a edição de tamanho (H/W) do link',
      },
      { teclas: ['Alt', 'A'], texto: 'Liga/desliga o modo sequência' },
      {
        teclas: ['Esc'],
        texto: 'Limpa a seleção (e sai do modo tela cheia, quando ativo)',
      },
    ],
  },
  {
    grupo: 'Página',
    itens: [
      {
        teclas: ['Alt', 'Z'],
        texto: 'Liga/desliga o modo zoom (ao sair, volta à escala original)',
      },
      { teclas: ['Shift', 'setas'], texto: 'Move a página (10 px)' },
      { teclas: ['Shift', '+'], texto: 'Aumenta a escala da página' },
      { teclas: ['Shift', '-'], texto: 'Reduz a escala da página' },
    ],
  },
  {
    grupo: 'Histórico e ajuda',
    itens: [
      { teclas: ['Ctrl', 'Z'], texto: 'Desfazer' },
      { teclas: ['Ctrl', 'Shift', 'Z'], texto: 'Refazer' },
      { teclas: ['Ctrl', 'Y'], texto: 'Refazer' },
      { teclas: ['?'], texto: 'Mostra/oculta esta legenda (F1 também)' },
    ],
  },
];

/**
 * Enquadramento do desenho na área de trabalho (ver handleEnquadrar).
 * A margem deixa uma folga para o desenho não encostar na borda.
 */
const MARGEM_ENQUADRAR = 0.96;
const ZOOM_MIN = 0.5;
const ZOOM_MAX = 8;

const EditorArea = forwardRef(
  (
    {
      catalogo,
      pagina,
      itensPagina,
      onSave,
      onCancel,
      onBeforeOCR,
      onAfterOCR,
      onAssociate,
      onLinkHighlight,
    },
    ref
  ) => {
    /** controles de posicionamento e seleção */
    const selectingRef = useRef(false);
    const selectedRef = useRef([]);
    const focusRef = useRef(null);
    const controlRef = useRef(null);

    const startCoordRef = useRef({ x: 0, y: 0 });
    const finishCoordRef = useRef({ x: 0, y: 0 });
    const minCoordRef = useRef({ x: 0, y: 0 });
    const maxCoordRef = useRef({ x: 0, y: 0 });

    const actionRef = useRef();
    const linkRef = useRef();

    const zoomRef = useRef();
    const zoomInRef = useRef(HTMLButtonElement);
    const zoomOutRef = useRef(HTMLButtonElement);
    const zoomResetRef = useRef(HTMLButtonElement);

    /**
     * API do react-zoom-pan-pinch (resetTransform, setTransform, ...).
     *
     * Os botões de zoom só existem no DOM com o modo zoom ligado (Alt+Z),
     * então zoomResetRef fica indefinido na maior parte do tempo. Este ref
     * guarda as funções direto do render prop e está sempre disponível.
     *
     * É necessário porque o centerOnInit do TransformWrapper é calculado
     * na montagem, quando o SVG da página ainda NÃO foi injetado (o
     * react-svg busca o arquivo depois). O resultado é um pan calculado
     * sobre conteúdo de tamanho zero — a origem do desenho aparecendo
     * deslocado no canto da área.
     */
    const zoomApiRef = useRef(null);
    const zoomScaleRef = useRef(1);

    const sizeRef = useRef();
    const formSizeRef = useRef();

    const ocrMapperRef = useRef();
    const ocrMappingRef = useRef([]);
    const linkMappingRef = useRef([]);

    const svgRef = useRef();
    const rootRef = useRef();
    const selectorRef = useRef();

    const rootXRef = useRef(0);
    const rootYRef = useRef(0);
    const rootScaleRef = useRef(1);
    const rootRotateRef = useRef(0);

    /** NOVO: refs/estado para input rápido de link */
    const editorAreaRef = useRef(null);
    const quickInputRef = useRef(null);
    const [quickInput, setQuickInput] = useState({
      open: false,
      x: 0,
      y: 0,
      svgX: 0,
      svgY: 0,
      value: '',
    });

    useEffect(() => {
      if (quickInput.open && quickInputRef.current) {
        setTimeout(() => {
          if (quickInputRef.current) {
            quickInputRef.current.focus({ preventScroll: true });
            try {
              quickInputRef.current.select();
            } catch {}
          }
        }, 0);
      }
    }, [quickInput.open]);

    const ACTION_STATE = {
      select: 'SELECT',
      deselect: 'DESELECT',
      move: 'MOVE',
      moveOne: 'MOVEONE',
      selectArea: 'SELECTAREA',
      /** arraste que desenha a área de um novo link (modo sequência) */
      createArea: 'CREATEAREA',
      /** arraste da etiqueta, sem mover a área do link */
      moveRotulo: 'MOVEROTULO',
    };

    const INITIAL_STATE = {
      catalogId: 0,
      path: '',
      pageNum: 0,
      state: 0,
      type: 0,
      inDesign: false,
    };

    /**
     * Alias com as chaves em minúsculo para não reescrever as dezenas de
     * usos já existentes neste arquivo. A fonte única dos valores é
     * opLinkForma em lib/const.js.
     */
    const LINK_FORM_TYPES = {
      circle: opLinkForma.CIRCULO,
      rect: opLinkForma.RETANGULO,
      ocr: opLinkForma.OCR,
      area: opLinkForma.AREA,
    };

    const INITIAL_LINK_CIRCLE = {
      id: LINK_FORM_TYPES.circle,
      fontSize: 10,
      height: 10,
      width: 0,
    };

    const INITIAL_LINK_RECT = {
      id: LINK_FORM_TYPES.rect,
      fontSize: 10,
      height: 20,
      width: 20,
    };

    /**
     * Área: tamanho inicial usado quando o link é criado por clique
     * (sem arraste) ou a partir de um marcador de OCR. Quando o usuário
     * arrasta, o tamanho vem do próprio retângulo desenhado.
     */
    const INITIAL_LINK_AREA = {
      id: LINK_FORM_TYPES.area,
      fontSize: 7,
      height: 14,
      width: 28,
    };

    /** limites das formas legadas (círculo e retângulo) */
    const LINK_SIZE_LIMIT = opLinkTamanho[opLinkForma.CIRCULO];

    /** limites da área, que precisa cobrir de componentes pequenos a réguas */
    const LINK_AREA_SIZE_LIMIT = opLinkTamanho[opLinkForma.AREA];

    const [editor, setEditor] = useState(INITIAL_STATE);
    const [table, setTable] = useState([]);

    const [zoomControl, setZoomControl] = useState(false);
    const [zoomCanMove, setZoomCanMove] = useState(true);
    const [sizeControl, setSizeControl] = useState(false);

    /**
     * Espelhos dos dois modos alternados por atalho (Alt+Z e Alt+S).
     *
     * Os handlers de teclado precisam ler o valor ATUAL sem depender do
     * fechamento da renderização — ver a indireção de onKeyDown mais
     * abaixo — e também permitem alternar sem efeito colateral dentro do
     * atualizador de estado.
     */
    const zoomControlRef = useRef(false);
    const sizeControlRef = useRef(false);

    /**
     * Legenda de atalhos: fica oculta e é chamada pelo botão "?" da barra
     * ou pelas teclas "?" / F1. Nunca abre sozinha, para não roubar área
     * de desenho de quem já conhece os atalhos.
     */
    const [atalhosAberto, setAtalhosAberto] = useState(false);
    const atalhosAbertoRef = useRef(false);

    /**
     * ===================================================================
     * ROLAGEM DA BARRA DE FERRAMENTAS
     * -------------------------------------------------------------------
     * A barra não quebra mais em várias linhas (comia a altura do
     * desenho): passa a rolar na horizontal. Estes estados dizem se
     * existe conteúdo escondido de cada lado, para mostrar a seta e o
     * degradê correspondentes — sem isso a rolagem ficaria invisível.
     * ===================================================================
     */
    const barraRef = useRef(null);
    const [barraEsq, setBarraEsq] = useState(false);
    const [barraDir, setBarraDir] = useState(false);

    const oAtualizarRolagemBarra = useCallback(() => {
      const el = barraRef.current;
      if (!el) return;

      const { scrollLeft, scrollWidth, clientWidth } = el;

      setBarraEsq(scrollLeft > 1);
      setBarraDir(scrollLeft + clientWidth < scrollWidth - 1);
    }, []);

    /** rola uma "página" da barra para o lado indicado */
    const handleRolarBarra = useCallback((direcao) => {
      const el = barraRef.current;
      if (!el) return;

      el.scrollBy({
        left: direcao * Math.max(120, el.clientWidth * 0.7),
        behavior: 'smooth',
      });
    }, []);

    useEffect(() => {
      const el = barraRef.current;
      if (!el) return undefined;

      oAtualizarRolagemBarra();

      /**
       * Roda do mouse sobre a barra rola na horizontal. Registrado no
       * elemento com passive: false porque o preventDefault é necessário
       * — como listener do React o navegador pode tratá-lo como passivo e
       * ignorar o preventDefault.
       */
      const naRoda = (e) => {
        if (el.scrollWidth <= el.clientWidth) return;

        /** gesto horizontal de trackpad já funciona sozinho */
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;

        e.preventDefault();
        el.scrollLeft += e.deltaY;
      };

      el.addEventListener('wheel', naRoda, { passive: false });
      el.addEventListener('scroll', oAtualizarRolagemBarra);
      window.addEventListener('resize', oAtualizarRolagemBarra);

      /**
       * A largura da barra muda sem evento de resize da janela: ao
       * recolher o painel de itens, ao entrar em tela cheia e quando
       * botões aparecem/desaparecem (modo sequência, OCR experimental).
       */
      let observador = null;
      if (typeof ResizeObserver !== 'undefined') {
        observador = new ResizeObserver(oAtualizarRolagemBarra);
        observador.observe(el);
      }

      return () => {
        el.removeEventListener('wheel', naRoda);
        el.removeEventListener('scroll', oAtualizarRolagemBarra);
        window.removeEventListener('resize', oAtualizarRolagemBarra);
        if (observador) observador.disconnect();
      };
    }, [oAtualizarRolagemBarra]);

    /**
     * Alinha os espelhos com o estado. Feito por efeito para não precisar
     * alterar todos os pontos que já chamam setZoomControl/setSizeControl
     * (handleControlClose, troca de forma do link, carga de página).
     */
    useEffect(() => {
      zoomControlRef.current = zoomControl;
    }, [zoomControl]);

    useEffect(() => {
      sizeControlRef.current = sizeControl;
    }, [sizeControl]);

    useEffect(() => {
      atalhosAbertoRef.current = atalhosAberto;
    }, [atalhosAberto]);

    const [centralizacaoX, setCentralizacaoX] = useState(0);
    const [centralizacaoY, setCentralizacaoY] = useState(0);
    const [pdfTool, setPdfTool] = useState(false);

    const [currLinkType, setCurrLinkType] = useState(0);
    const currLinkTypeRef = useRef(INITIAL_LINK_CIRCLE);

    /**
     * Rótulo aplicado aos novos links:
     *  - codigo   : texto do IDITEM dentro da própria forma (legado)
     *  - nenhum   : sem texto, descrição só no hover e na tabela
     *  - etiqueta : balão externo com o código + linha de chamada
     */
    const [currLinkRotulo, setCurrLinkRotulo] = useState(opLinkRotulo.CODIGO);
    const currLinkRotuloRef = useRef(opLinkRotulo.CODIGO);

    /**
     * Modo criação/sequência: quando ativo, arrastar sobre o desenho cria
     * a área do próximo item pendente e avança para o seguinte. Enquanto
     * inativo, todas as interações permanecem idênticas às atuais.
     */
    const [modoSequencia, setModoSequencia] = useState(false);
    const modoSequenciaRef = useRef(false);
    const [itemSequencia, setItemSequencia] = useState(null);
    const itemSequenciaRef = useRef(null);

    /** espelho da tabela de itens, para uso dentro dos handlers de mouse */
    const tabelaRef = useRef([]);

    /**
     * Coordenada inicial do arraste que desenha a área do link.
     *
     * Precisa ser um ref PRÓPRIO, e não o startCoordRef compartilhado: o
     * handleMouseUp chama oClearSelector() ANTES do switch das ações, e
     * oClearSelector zera startCoordRef/finishCoordRef (eles pertencem ao
     * seletor do Ctrl+arraste do OCR). Lendo startCoordRef depois disso o
     * retângulo virava (0,0) -> ponto do mouse, criando o link muito maior
     * do que o demarcado.
     */
    const areaStartRef = useRef(null);

    /** retângulo temporário exibido durante o arraste de criação da área */
    const areaDraftRef = useRef(null);

    const defLinkSize = useRef({
      height: 0,
      width: 0,
    });

    const hasRunRef = useRef(false);
    const pagRef = useRef();
    const [svgReady, setSvgReady] = useState(false);

    // const [elementToZoom, setElementToZoom] = useState();

    const oLinkSizeMode = useCallback((height = 0, width = 0) => {
      setTimeout(() => {
        const newSizeH = Number(height) || currLinkTypeRef.current.height;
        const newSizeW = Number(width) || currLinkTypeRef.current.width;

        if (formSizeRef.current) {
          formSizeRef.current.setFieldValue('sizeInputH', newSizeH);
          formSizeRef.current.setFieldValue('sizeInputW', newSizeW);
        }
      }, 200);
    }, []);

    /** valida e define o tamanho padrão de um link */
    const oChangeDefLinkSize = useCallback(
      (height = 0, width = 0, updateDefault = false) => {
        /** atualiza o tamanho para os links */
        if (updateDefault) {
          defLinkSize.current = {
            height,
            width,
          };
        }
        /** atualiza informações do campo */
        oLinkSizeMode(height, width);
      },
      [oLinkSizeMode]
    );

    useEffect(
      () => {
        let currSizeW = 0;
        let currSizeH = 0;

        if (sizeControl) {
          if (focusRef.current) {
            switch (Number(focusRef.current.node.childNodes[0].dataset.id)) {
              case LINK_FORM_TYPES.circle:
                currSizeW = focusRef.current.node.childNodes[0].getAttribute(
                  'r'
                );
                currSizeH = focusRef.current.node.childNodes[0].getAttribute(
                  'r'
                );
                break;
              case LINK_FORM_TYPES.rect:
              case LINK_FORM_TYPES.area:
                currSizeW = focusRef.current.node.childNodes[0].getAttribute(
                  'width'
                );
                currSizeH = focusRef.current.node.childNodes[0].getAttribute(
                  'height'
                );
                break;
              default:
                break;
            }
          }

          oChangeDefLinkSize(currSizeH, currSizeW);
        }
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [LINK_FORM_TYPES, sizeControl]
    );

    useEffect(() => {
      if (!pagina) return;

      const { idPagina, urlEdicao, situacao, tipo } = pagina;
      const { idCatalogo } = catalogo;

      setEditor({
        catalogId: idCatalogo,
        pageNum: idPagina,
        path: urlEdicao,
        state: situacao,
        type: tipo,
        inDesign: true,
      });

      setZoomControl(false);
      setSizeControl(false);

      // handleMapeamentoOCR();
    }, [catalogo, pagina]);

    useEffect(() => {
      if (!itensPagina) return;
      setTable(
        itensPagina.map((item) => ({
          ...item,
          quantidade: item.quantidade ? Number(item.quantidade) : 0,
        }))
      );
    }, [itensPagina]);

    const oCheckAssociation = useCallback(() => {
      onAssociate(linkMappingRef.current.map((item) => getIdItemLink(item)));
    }, [onAssociate, getIdItemLink]);

    useImperativeHandle(ref, () => ({
      highlightLinks: (links) => {
        linkMappingRef.current = linkMappingRef.current.map((node) => {
          const classes = node.getAttribute('class');

          if (links.includes(getIdItemLink(node))) {
            /** não aplica highlight se ja for um ou se estiver em conflito */
            if (!classes.includes('highlight') && !classes.includes('warning'))
              node.setAttribute('class', `${classes} highlight`.trim());
          } else if (classes && classes.includes('highlight'))
            node.setAttribute('class', classes.split('highlight')[0].trim());

          return node;
        });
      },
      getLinked: () => oCheckAssociation(),

      /** itens da página que ainda não têm link no desenho */
      getPendentes: () => itensPendentes,

      /**
       * Define manualmente o item alvo do modo sequência e liga o modo,
       * já selecionando a geometria de área — é o que se espera ao clicar
       * em "mapear este item agora" na tabela.
       */
      setItemSequencia: (item) => {
        handleSelecionarItemSequencia(item);

        if (!modoSequenciaRef.current) {
          modoSequenciaRef.current = true;
          setModoSequencia(true);
          currLinkTypeRef.current = INITIAL_LINK_AREA;
          setCurrLinkType(LINK_FORM_TYPES.area);
        }
      },

      /** rola o desenho até o link do item e o destaca */
      irParaLink: (idItem) => {
        const alvo = linkMappingRef.current.find(
          (node) => String(getIdItemLink(node)) === String(idItem)
        );

        if (!alvo) return false;

        handleHoverHighlight(String(idItem), true);

        if (typeof alvo.scrollIntoView === 'function') {
          alvo.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center',
          });
        }

        return true;
      },
    }));

    const handleOCRLimpar = useCallback(() => {
      /** limpa coleção e coordenadas */
      ocrMappingRef.current = [];

      selectorRef.current.setAttribute('x', 0);
      selectorRef.current.setAttribute('y', 0);
      selectorRef.current.setAttribute('width', 0);
      selectorRef.current.setAttribute('height', 0);

      /** remove grupo do SVG */
      const ocrMapper = Array.from(rootRef.current.childNodes).find(
        (attr) => attr.id === 'ocrGroup'
      );
      if (ocrMapper) {
        ocrMapper.remove();
      }
      ocrMapperRef.current = null;
    }, []);

    // const handleMappedAutom = useCallback(async () => {
    //   if (onBeforeOCR) {
    //     onBeforeOCR();
    //   }

    //   try {
    //     handleOCRLimpar();

    //     const ocrMapper = document.createElementNS(
    //       rootRef.current.namespaceURI,
    //       'g'
    //     );
    //     ocrMapper.setAttribute('id', 'ocrGroup');
    //     rootRef.current.appendChild(ocrMapper);
    //     ocrMapperRef.current = ocrMapper;

    //     const { idCatalogo } = catalogo;
    //     const { idPagina } = pagina;

    //     const { data } = await api.get(
    //       `/editor-associar-autom/${idCatalogo}/pagina/${idPagina}`
    //     );

    //     data.forEach((pt, index) => {
    //       const link = document.createElementNS(
    //         svgRef.current.namespaceURI,
    //         'a'
    //       );
    //       link.id = String(index);
    //       link.setAttribute('x', pt.x);
    //       link.setAttribute('y', pt.y - 5);
    //       link.setAttribute('class', '');
    //       link.addEventListener('click', (e) => e.preventDefault());
    //       ocrMapperRef.current.appendChild(link);

    //       const linkForm = document.createElementNS(
    //         svgRef.current.namespaceURI,
    //         'rect'
    //       );

    //       const linkText = document.createElementNS(
    //         svgRef.current.namespaceURI,
    //         'text'
    //       );

    //       const linkFormWidth = pt.text.length * 6;

    //       linkForm.setAttribute('x', pt.x + 10);
    //       linkForm.setAttribute('y', pt.y - 5);
    //       linkForm.setAttribute('height', '15');
    //       linkForm.setAttribute('width', `${linkFormWidth}`);
    //       linkForm.setAttribute('class', pt.conf > 70 ? 'success' : 'warning');
    //       linkForm.setAttribute('data-id', LINK_FORM_TYPES.ocr);
    //       link.appendChild(linkForm);

    //       linkText.setAttribute('x', pt.x + 10);
    //       linkText.setAttribute('y', pt.y + 5);
    //       linkText.setAttribute('font-size', '10');
    //       linkText.setAttribute('class', pt.conf > 70 ? 'success' : 'warning');
    //       linkText.textContent = pt.text;
    //       link.appendChild(linkText);

    //       ocrMappingRef.current.push({ attr: link, ocr: pt });
    //     });
    //   } catch (err) {
    //     toast.error(err);
    //   } finally {
    //     if (onAfterOCR) {
    //       onAfterOCR();
    //     }
    //   }
    // }, [onBeforeOCR, onAfterOCR, handleOCRLimpar, catalogo, pagina]);

    // useEffect(() => {
    //   handleMappedAutom();
    // }, [handleMappedAutom]);

    // useEffect(() => {
    //   // sem dados ainda? sai quietinho, e espera a próxima render
    //   if (!catalogo?.idCatalogo || !pagina?.idPagina) return;
    //   if (!rootRef.current || !svgRef.current) return;

    //   if (
    //     // hasRunRef.current &&
    //     pagRef.current === pagina.idPagina
    //   )
    //     return;

    //   // hasRunRef.current = true; // marca que já executou
    //   pagRef.current = pagina.idPagina;

    //   const handleMappedAutom = async () => {
    //     if (onBeforeOCR) {
    //       onBeforeOCR();
    //     }

    //     try {
    //       handleOCRLimpar();

    //       const ocrMapper = document.createElementNS(
    //         rootRef.current.namespaceURI,
    //         'g'
    //       );
    //       ocrMapper.setAttribute('id', 'ocrGroup');
    //       rootRef.current.appendChild(ocrMapper);
    //       ocrMapperRef.current = ocrMapper;

    //       const { idCatalogo } = catalogo;
    //       const { idPagina } = pagina;

    //       const { data } = await api.get(
    //         `/editor-associar-autom/${idCatalogo}/pagina/${idPagina}`
    //       );

    //       data.forEach((pt, index) => {
    //         const link = document.createElementNS(
    //           svgRef.current.namespaceURI,
    //           'a'
    //         );
    //         link.id = String(index);
    //         link.setAttribute('x', pt.x);
    //         link.setAttribute('y', pt.y - 5);
    //         link.setAttribute('class', '');
    //         link.addEventListener('click', (e) => e.preventDefault());
    //         ocrMapperRef.current.appendChild(link);

    //         const linkForm = document.createElementNS(
    //           svgRef.current.namespaceURI,
    //           'rect'
    //         );

    //         const linkText = document.createElementNS(
    //           svgRef.current.namespaceURI,
    //           'text'
    //         );

    //         const linkFormWidth = pt.text.length * 6;

    //         linkForm.setAttribute('x', pt.x + 10);
    //         linkForm.setAttribute('y', pt.y - 5);
    //         linkForm.setAttribute('height', '15');
    //         linkForm.setAttribute('width', `${linkFormWidth}`);
    //         linkForm.setAttribute(
    //           'class',
    //           pt.conf > 70 ? 'success' : 'warning'
    //         );
    //         linkForm.setAttribute('data-id', LINK_FORM_TYPES.ocr);
    //         link.appendChild(linkForm);

    //         linkText.setAttribute('x', pt.x + 10);
    //         linkText.setAttribute('y', pt.y + 5);
    //         linkText.setAttribute('font-size', '10');
    //         linkText.setAttribute(
    //           'class',
    //           pt.conf > 70 ? 'success' : 'warning'
    //         );
    //         linkText.textContent = pt.text;
    //         link.appendChild(linkText);

    //         ocrMappingRef.current.push({ attr: link, ocr: pt });
    //       });
    //     } catch (err) {
    //       toast.error(err);
    //     } finally {
    //       if (onAfterOCR) {
    //         onAfterOCR();
    //       }
    //     }
    //   };

    //   handleMappedAutom();
    // }, [
    //   catalogo?.idCatalogo,
    //   pagina?.idPagina,
    //   onBeforeOCR,
    //   onAfterOCR,
    //   handleOCRLimpar,
    // ]);

    // useEffect(() => {
    //   // ainda sem dados? espera a próxima render
    //   if (!catalogo?.idCatalogo || !pagina?.idPagina) return;

    //   // SVG ainda não foi carregado pra essa página
    //   if (!svgReady) return;

    //   if (!rootRef.current || !svgRef.current) return;

    //   // já rodou pra essa página? então não faz de novo
    //   if (pagRef.current === pagina.idPagina) return;

    //   pagRef.current = pagina.idPagina;

    //   const handleMappedAutom = async () => {
    //     if (onBeforeOCR) {
    //       onBeforeOCR();
    //     }

    //     try {
    //       handleOCRLimpar();

    //       const ocrMapper = document.createElementNS(
    //         rootRef.current.namespaceURI,
    //         'g'
    //       );
    //       ocrMapper.setAttribute('id', 'ocrGroup');
    //       rootRef.current.appendChild(ocrMapper);
    //       ocrMapperRef.current = ocrMapper;

    //       const { idCatalogo } = catalogo;
    //       const { idPagina } = pagina;

    //       const { data } = await api.get(
    //         `/editor-associar-autom/${idCatalogo}/pagina/${idPagina}`
    //       );

    //       data.forEach((pt, index) => {
    //         const link = document.createElementNS(
    //           svgRef.current.namespaceURI,
    //           'a'
    //         );
    //         link.id = String(index);
    //         link.setAttribute('x', pt.x);
    //         link.setAttribute('y', pt.y - 5);
    //         link.setAttribute('class', '');
    //         link.addEventListener('click', (e) => e.preventDefault());
    //         ocrMapperRef.current.appendChild(link);

    //         const linkForm = document.createElementNS(
    //           svgRef.current.namespaceURI,
    //           'rect'
    //         );

    //         const linkText = document.createElementNS(
    //           svgRef.current.namespaceURI,
    //           'text'
    //         );

    //         const linkFormWidth = pt.text.length * 6;

    //         linkForm.setAttribute('x', pt.x + 10);
    //         linkForm.setAttribute('y', pt.y - 5);
    //         linkForm.setAttribute('height', '15');
    //         linkForm.setAttribute('width', `${linkFormWidth}`);
    //         linkForm.setAttribute(
    //           'class',
    //           pt.conf > 70 ? 'success' : 'warning'
    //         );
    //         linkForm.setAttribute('data-id', LINK_FORM_TYPES.ocr);
    //         link.appendChild(linkForm);

    //         linkText.setAttribute('x', pt.x + 10);
    //         linkText.setAttribute('y', pt.y + 5);
    //         linkText.setAttribute('font-size', '10');
    //         linkText.setAttribute(
    //           'class',
    //           pt.conf > 70 ? 'success' : 'warning'
    //         );
    //         linkText.textContent = pt.text;
    //         link.appendChild(linkText);

    //         ocrMappingRef.current.push({ attr: link, ocr: pt });
    //       });
    //     } catch (err) {
    //       toast.error(err);
    //     } finally {
    //       if (onAfterOCR) {
    //         onAfterOCR();
    //       }
    //     }
    //   };

    //   handleMappedAutom();
    // }, [
    //   catalogo?.idCatalogo,
    //   pagina?.idPagina,
    //   svgReady, // NOVO: só roda quando o SVG dessa página estiver pronto
    //   onBeforeOCR,
    //   onAfterOCR,
    //   handleOCRLimpar,
    // ]);

    const handleOCRLocalizar = useCallback(
      async (tipoExtracao = opEditorAssociarTipoExtracao.TRADICIONAL) => {
        /** executa evento antes da consulta */
        if (onBeforeOCR) {
          onBeforeOCR();
        }

        try {
          const x = selectorRef.current.x.baseVal.value;
          const y = selectorRef.current.y.baseVal.value;
          const width = selectorRef.current.width.baseVal.value;
          const height = selectorRef.current.height.baseVal.value;

          /** limpa mapeamento anterior */
          handleOCRLimpar();

          /** cria grupo para mapeamento do serviço de OCR */
          const ocrMapper = document.createElementNS(
            rootRef.current.namespaceURI,
            'svg:g',
            rootRef.current
          );
          ocrMapper.setAttribute('id', 'ocrGroup');
          rootRef.current.appendChild(ocrMapper);

          ocrMapperRef.current = ocrMapper;

          const response = await api.post(
            `/editor-associar/${catalogo.idCatalogo}/pagina/${pagina.idPagina}`,
            { tipoExtracao, parametros: { x, y, width, height } }
          );

          /** cria links OCR */
          response.data.forEach((pt, index) => {
            /** cria elemento */
            const link = document.createElementNS(
              svgRef.current.namespaceURI,
              'a',
              svgRef.current
            );
            link.id = index;
            link.setAttribute('x', pt.x);
            link.setAttribute('y', pt.y - 5);
            link.setAttribute('class', '');
            // código preventivo para o link não ser executado no design
            link.addEventListener('click', (e) => e.preventDefault());
            ocrMapperRef.current.appendChild(link);

            /** cria retângulo ocr */
            const linkForm = document.createElementNS(
              svgRef.current.namespaceURI,
              'svg:rect',
              svgRef.current
            );

            /** cria texto */
            const linkText = document.createElementNS(
              svgRef.current.namespaceURI,
              'svg:text',
              svgRef.current
            );

            const linkFormWidth = pt.text.length * 6;

            linkForm.setAttribute('x', pt.x + 10);
            linkForm.setAttribute('y', pt.y - 5);
            linkForm.setAttribute('height', '15px');
            linkForm.setAttribute('width', `${linkFormWidth}px`);
            linkForm.setAttribute(
              'class',
              pt.conf > 70 ? 'success' : 'warning'
            );
            linkForm.setAttribute('data-id', LINK_FORM_TYPES.ocr);
            link.appendChild(linkForm);

            linkText.setAttribute('x', pt.x + 10);
            linkText.setAttribute('y', pt.y + 10 - 5);
            linkText.setAttribute('font-size', '10px');
            linkText.setAttribute(
              'class',
              pt.conf > 70 ? 'success' : 'warning'
            );
            linkText.textContent = pt.text;
            link.appendChild(linkText);

            ocrMappingRef.current.push({ attr: link, ocr: pt });
          });
        } catch (err) {
          toast.error(err);
        } finally {
          /** executa evento depois da consulta */
          if (onAfterOCR) {
            onAfterOCR();
          }
        }
      },
      [
        LINK_FORM_TYPES,
        svgRef,
        selectorRef,
        catalogo,
        pagina,
        handleOCRLimpar,
        onBeforeOCR,
        onAfterOCR,
      ]
    );

    const handlePDFLocalizar = useCallback(
      async (tipoExtracao = opEditorAssociarTipoExtracao.TRADICIONAL) => {
        /** executa evento antes da consulta */
        if (onBeforeOCR) {
          onBeforeOCR();
        }
        setPdfTool(true);
        try {
          const { x, y, width, height } = getSvgCoordinates(selectorRef);
          /** limpa mapeamento anterior */
          handleOCRLimpar();
          const ocrMapper = createOcrGroup(rootRef);
          ocrMapperRef.current = ocrMapper;

          const response = await api.post(
            `/editor-associar/${catalogo.idCatalogo}/pagina/${pagina.idPagina}`,
            { tipoExtracao, parametros: { x, y, width, height } }
          );

          /** cria links PDF */
          response.data.forEach((pt, index) => {
            const link = createSvgLinkPdfProcess(
              svgRef.current.namespaceURI,
              ocrMapperRef,
              pt,
              index
            );
            ocrMappingRef.current.push({ attr: link, ocr: pt });
          });

          const { centroX, centroY } = centerCalculation(
            pagina.orientacaoImagem,
            x,
            y,
            width,
            height
          );

          centerSvgPdfProcess(svgRef, rootRef, centroX, centroY);
          setCentralizacaoX(centroX);
          setCentralizacaoY(centroY);
        } catch (err) {
          toast.error(err);
        } finally {
          /** executa evento depois da consulta */
          if (onAfterOCR) {
            onAfterOCR();
          }
        }
      },
      [
        svgRef,
        selectorRef,
        catalogo,
        pagina,
        handleOCRLimpar,
        onBeforeOCR,
        onAfterOCR,
      ]
    );

    const handlePositionPdfProcess = useCallback((coordX, coordY) => {
      updateSvgPositionProcessPdf(svgRef, rootRef, coordX, coordY);
    }, []);

    const handleCenterPdfProcess = useCallback(() => {
      centerSvgPdfProcess(svgRef, rootRef, centralizacaoX, centralizacaoY);
    }, [centralizacaoX, centralizacaoY]);

    const handleScalePdfProcess = useCallback(
      (valor) => {
        scaleSvgProcessPdf(svgRef, rootRef, rootScaleRef, valor);
        centerSvgPdfProcess(svgRef, rootRef, centralizacaoX, centralizacaoY);
      },
      [centralizacaoX, centralizacaoY]
    );

    /**
     * IDITEM de um link, lido do href.
     *
     * Antes a associação item x link usava o textContent do <text> interno.
     * Isso deixou de funcionar com o rótulo "nenhum" (link sem texto) e com
     * o rótulo "etiqueta" (o textContent passa a ser o texto do balão).
     * O href tem o formato /{idCatalogo}/{idPagina}/{idItem} e é a mesma
     * fonte que a Home usa em Pagina/index.js -> handleLink, portanto é a
     * chave mais confiável. O textContent fica só como retrocompatibilidade
     * para eventuais links sem href.
     */
    const getIdItemLink = useCallback((node) => {
      if (!node) return '';

      const href =
        node.getAttribute('xlink:href') ||
        (node.href && node.href.baseVal) ||
        node.getAttribute('href') ||
        '';

      const partes = String(href)
        .split('/')
        .filter((parte) => parte !== '');
      const idItem = partes.length ? partes[partes.length - 1] : '';

      return idItem || String(node.textContent || '').trim();
    }, []);

    const handleHoverHighlight = useCallback(
      (id, state) => {
        linkMappingRef.current.forEach((node) => {
          const classes = node.getAttribute('class');

          if (getIdItemLink(node) === id)
            node.setAttribute(
              'class',
              (state
                ? `${classes} highlight`
                : classes.split('highlight')[0]
              ).trim()
            );
        });

        const highlightedItems = linkMappingRef.current
          .filter((node) => node.getAttribute('class').includes('highlight'))
          .map((node) => getIdItemLink(node));

        onLinkHighlight(highlightedItems, 'editor');
      },
      [onLinkHighlight, getIdItemLink]
    );

    const mappingElement = useCallback(
      (lstNode) => {
        Array.from(lstNode).map((node) => {
          if (
            node.nodeName === 'svg:path' ||
            node.nodeName === 'svg:rect' ||
            node.nodeName === 'svg:image' ||
            node.nodeName === 'a'
          ) {
            /** tratamento para links já carregados */
            if (node.nodeName === 'a') {
              /** coloca o nome do grupo do link */
              if (node.parentElement.nodeName === 'svg:g') {
                node.parentElement.id = 'linkGroup';
              }
              node.setAttribute('class', '');
              node.addEventListener('click', (e) => e.preventDefault());
              node.addEventListener('mouseenter', () => {
                handleHoverHighlight(getIdItemLink(node), true);
              });
              node.addEventListener('mouseleave', () => {
                handleHoverHighlight(getIdItemLink(node), false);
              });

              linkMappingRef.current.push(node);
            }

            node.id = Math.random();
          }

          if (node.hasChildNodes()) {
            return mappingElement(node.childNodes);
          }

          return node;
        });
      },
      [handleHoverHighlight]
    );

    /**
     * Cria os elementos do rótulo de um link.
     *
     * - opLinkRotulo.CODIGO  : <text> centralizado na própria forma
     * - opLinkRotulo.NENHUM  : nada (descrição só no hover e na tabela)
     * - opLinkRotulo.ETIQUETA: <path data-role="chamada"> +
     *                          <rect data-role="rotulo"> +
     *                          <text data-role="rotulo-texto">
     *
     * A ordem de inserção importa: a forma principal continua sendo
     * childNodes[0], pois todo o restante do editor (seleção, conflito,
     * redimensionamento) depende disso.
     */
    const oCriarRotuloLink = useCallback(
      ({ link, forma, rotulo, texto, fontSize }) => {
        const ns = svgRef.current.namespaceURI;

        if (rotulo === opLinkRotulo.NENHUM) return;

        const caixa = getCaixaForma(forma);

        if (rotulo === opLinkRotulo.ETIQUETA) {
          const alturaRotulo = fontSize + 5;
          const larguraRotulo = larguraEstimadaRotulo(texto, fontSize);

          /**
           * Posição inicial da etiqueta: acima e à direita da área, com
           * um deslocamento proporcional à própria etiqueta. O usuário
           * reposiciona arrastando a etiqueta (a área não se move).
           */
          const caixaRotulo = {
            x: caixa.x + caixa.width + alturaRotulo,
            y: caixa.y - alturaRotulo * 1.6,
            width: larguraRotulo,
            height: alturaRotulo,
          };

          const ancora = calcularAncoraChamada(caixa, caixaRotulo);

          const chamada = criarLinhaChamada(
            ns,
            ancora.x1,
            ancora.y1,
            ancora.x2,
            ancora.y2
          );
          link.appendChild(chamada);

          const caixaEtiqueta = document.createElementNS(ns, 'svg:rect');
          caixaEtiqueta.setAttribute('data-role', opLinkPapel.ROTULO);
          caixaEtiqueta.setAttribute('x', caixaRotulo.x);
          caixaEtiqueta.setAttribute('y', caixaRotulo.y);
          caixaEtiqueta.setAttribute('width', caixaRotulo.width);
          caixaEtiqueta.setAttribute('height', caixaRotulo.height);
          /** rx/ry são obrigatórios: sem eles o svgo converte o rect em path */
          caixaEtiqueta.setAttribute('rx', '3');
          caixaEtiqueta.setAttribute('ry', '3');
          caixaEtiqueta.setAttribute('fill', opLinkEstilo.ROTULO_FILL);
          caixaEtiqueta.setAttribute(
            'fill-opacity',
            opLinkEstilo.ROTULO_FILL_OPACITY
          );
          caixaEtiqueta.setAttribute('stroke', opLinkEstilo.COR);
          caixaEtiqueta.setAttribute('stroke-width', opLinkEstilo.ESPESSURA);
          link.appendChild(caixaEtiqueta);

          const textoEtiqueta = document.createElementNS(ns, 'svg:text');
          textoEtiqueta.setAttribute('data-role', opLinkPapel.ROTULO_TEXTO);
          textoEtiqueta.setAttribute(
            'x',
            caixaRotulo.x + caixaRotulo.width / 2
          );
          textoEtiqueta.setAttribute(
            'y',
            caixaRotulo.y + caixaRotulo.height / 2
          );
          textoEtiqueta.setAttribute('text-anchor', 'middle');
          textoEtiqueta.setAttribute('alignment-baseline', 'middle');
          textoEtiqueta.setAttribute('font-size', `${fontSize}px`);
          textoEtiqueta.setAttribute('fill', opLinkEstilo.COR_TEXTO);
          textoEtiqueta.textContent = texto;
          link.appendChild(textoEtiqueta);

          return;
        }

        /**
         * opLinkRotulo.CODIGO: texto dentro da forma.
         *
         * Não define "fill" de propósito — os links legados nunca tiveram
         * esse atributo e o CSS da Home depende do fill herdado
         * (regra "text:hover { fill: #fff }" em Pagina/styles.js).
         */
        const textoInterno = document.createElementNS(ns, 'svg:text');
        textoInterno.setAttribute('x', caixa.x + caixa.width / 2);
        textoInterno.setAttribute('y', caixa.y + caixa.height / 2);
        textoInterno.setAttribute('text-anchor', 'middle');
        textoInterno.setAttribute('alignment-baseline', 'middle');
        textoInterno.setAttribute('font-size', `${fontSize}px`);
        textoInterno.textContent = texto;
        link.appendChild(textoInterno);
      },
      []
    );

    /** elementos internos de um link, por papel (data-role) */
    const getPartesLink = useCallback((link) => {
      const partes = {
        area: null,
        chamada: null,
        rotulo: null,
        rotuloTexto: null,
      };

      if (!link || !link.childNodes) return partes;

      Array.from(link.childNodes).forEach((filho) => {
        switch (getPapelLink(filho)) {
          case opLinkPapel.AREA:
            partes.area = filho;
            break;
          case opLinkPapel.CHAMADA:
            partes.chamada = filho;
            break;
          case opLinkPapel.ROTULO:
            partes.rotulo = filho;
            break;
          case opLinkPapel.ROTULO_TEXTO:
            partes.rotuloTexto = filho;
            break;
          default:
            break;
        }
      });

      /** formas legadas não têm data-role: a forma principal é a primeira */
      if (!partes.area) partes.area = getFormaPrincipal(link);

      return partes;
    }, []);

    /**
     * Recalcula a linha de chamada a partir das posições atuais da área e
     * da etiqueta. Necessário depois de arrastar só a etiqueta ou de
     * redimensionar a área.
     */
    const oReancorarChamada = useCallback(
      (link) => {
        const { area, chamada, rotulo } = getPartesLink(link);

        if (!area || !chamada || !rotulo) return;

        const ancora = calcularAncoraChamada(
          getCaixaForma(area),
          getCaixaForma(rotulo)
        );

        if (ancora) {
          atualizarLinhaChamada(
            chamada,
            ancora.x1,
            ancora.y1,
            ancora.x2,
            ancora.y2
          );
        }
      },
      [getPartesLink]
    );

    /**
     * true quando um arraste sobre o desenho deve DESENHAR a área de um
     * novo link.
     *
     * Vale tanto no modo sequência (o item alvo já está definido) quanto com
     * a geometria de ÁREA selecionada fora dele — nesse caso o ID do item é
     * pedido no input rápido ao terminar o arraste.
     */
    const podeDesenharArea = useCallback(() => {
      if (modoSequenciaRef.current && itemSequenciaRef.current) return true;

      return (
        Number(currLinkTypeRef.current && currLinkTypeRef.current.id) ===
        LINK_FORM_TYPES.area
      );
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /** true quando o alvo do mouse é a etiqueta (caixa ou texto) do link */
    const isAlvoRotulo = useCallback((target) => {
      const papel = getPapelLink(target);
      return papel === opLinkPapel.ROTULO || papel === opLinkPapel.ROTULO_TEXTO;
    }, []);

    /**
     * true quando o alvo do mouse é uma forma clicável de link.
     *
     * Compara pelo nome LOCAL do elemento: o SVG das páginas usa prefixo de
     * namespace (svg:rect) mas nem toda origem de arquivo mantém o prefixo,
     * e agora também existe a elipse. A verificação antiga era
     * nodeName === 'svg:circle' || nodeName === 'svg:rect'.
     */
    const isAlvoLink = useCallback(
      (target) => {
        if (!target || !target.parentElement) return false;

        /** só conta se o pai for o próprio <a> do link */
        if (getNomeLocalSvg(target.parentElement) !== 'a') return false;

        return isFormaLink(target) || isAlvoRotulo(target);
      },
      [isAlvoRotulo]
    );

    /**
     * Retângulo temporário do arraste de área, criado sob demanda.
     * É recriado se tiver sido removido (por exemplo ao salvar), para o
     * arraste não deixar de funcionar depois de uma gravação.
     */
    const oGetAreaDraft = useCallback(() => {
      if (areaDraftRef.current && areaDraftRef.current.parentNode) {
        return areaDraftRef.current;
      }

      if (!rootRef.current) return null;

      const areaDraft = document.createElementNS(
        rootRef.current.namespaceURI,
        'rect',
        rootRef.current
      );
      areaDraft.setAttribute('id', 'areaDraft');
      areaDraft.setAttribute('stroke', opLinkEstilo.COR);
      areaDraft.setAttribute('stroke-width', '0.8');
      areaDraft.setAttribute('stroke-dasharray', '3 2');
      areaDraft.setAttribute('fill', opLinkEstilo.COR);
      areaDraft.setAttribute('fill-opacity', '0.18');
      areaDraft.setAttribute('pointer-events', 'none');
      areaDraft.setAttribute('x', 0);
      areaDraft.setAttribute('y', 0);
      areaDraft.setAttribute('width', 0);
      areaDraft.setAttribute('height', 0);
      rootRef.current.appendChild(areaDraft);
      areaDraftRef.current = areaDraft;

      return areaDraft;
    }, []);

    /** referência do link cuja etiqueta está sendo arrastada */
    const rotuloDragRef = useRef(null);

    /**
     * Retângulo já desenhado pelo usuário que está aguardando o ID do item.
     * Usado quando a geometria de ÁREA é arrastada FORA do modo sequência:
     * o tamanho vem do arraste e o item é informado no input rápido.
     */
    const areaPendenteRef = useRef(null);

    /**
     * Um link é "composto" quando tem mais de dois elementos internos:
     * área com etiqueta (área + chamada + caixa + texto) ou qualquer forma
     * sem rótulo. Nesses casos a regra legada de mover apenas
     * childNodes[0] (forma) e childNodes[1] (texto) não se aplica — é
     * preciso transladar todos os filhos.
     *
     * Links legados (círculo/retângulo com o código dentro) continuam
     * pelo caminho antigo, preservando o comportamento atual.
     */
    const oUsaTranslacaoGenerica = useCallback(
      (node, tipo) => {
        if (Number(tipo) === LINK_FORM_TYPES.area) return true;

        const rotuloAtual =
          (node && node.dataset && node.dataset.rotulo) || opLinkRotulo.CODIGO;

        return rotuloAtual !== opLinkRotulo.CODIGO;
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      []
    );

    const createLink = useCallback(
      (
        type,
        x,
        y,
        radius,
        height,
        width,
        id,
        text,
        textSize,
        href,
        rotulo = opLinkRotulo.CODIGO
      ) => {
        /** verifica se o grupo dos links já foi criado */
        linkRef.current = document.getElementById('linkGroup');
        if (!linkRef.current) {
          linkRef.current = document.createElementNS(
            svgRef.current.namespaceURI,
            'svg:g',
            svgRef.current
          );
          linkRef.current.id = 'linkGroup';

          /** adiciona elementos no nó raiz */
          rootRef.current.appendChild(linkRef.current);
        }

        /** criando o elemento link do item */
        const link = document.createElementNS(
          svgRef.current.namespaceURI,
          'a',
          svgRef.current
        );

        link.setAttribute('xlink:href', href);
        link.setAttribute('target', '_blank');
        link.setAttribute('class', '');
        link.id = id;

        /**
         * Registra o tipo de rótulo no próprio <a>. O atributo data-* é
         * preservado pelo svgo do backend, então o editor sabe como tratar
         * o link ao reabrir a página. Links legados não têm o atributo e
         * são interpretados como opLinkRotulo.CODIGO.
         */
        if (rotulo && rotulo !== opLinkRotulo.CODIGO) {
          link.setAttribute('data-rotulo', rotulo);
        }
        /** código preventivo para o link não ser executado no design */
        link.addEventListener('click', (e) => e.preventDefault());

        link.addEventListener('mouseenter', () => {
          if (link.matches(':hover'))
            handleHoverHighlight(getIdItemLink(link), true);
        });
        link.addEventListener('mouseleave', () => {
          if (!link.matches(':hover'))
            handleHoverHighlight(getIdItemLink(link), false);
        });

        linkRef.current.appendChild(link);

        let linkForm;

        /** define o formato do link */
        switch (type) {
          /** cria círculo */
          case LINK_FORM_TYPES.circle:
            linkForm = document.createElementNS(
              svgRef.current.namespaceURI,
              'svg:circle',
              svgRef.current
            );

            linkForm.setAttribute('data-id', String(LINK_FORM_TYPES.circle));
            linkForm.setAttribute('class', 'inject');
            linkForm.setAttribute('stroke', '#ccc');
            linkForm.setAttribute('fill', '#fff');
            linkForm.setAttribute('cx', x + 18);
            linkForm.setAttribute('cy', y);
            linkForm.setAttribute('r', radius);
            link.appendChild(linkForm);

            oCriarRotuloLink({
              link,
              forma: linkForm,
              rotulo,
              texto: text,
              fontSize: radius,
            });

            break;
          /** cria retângulo */
          case LINK_FORM_TYPES.rect:
            linkForm = document.createElementNS(
              svgRef.current.namespaceURI,
              'svg:rect',
              svgRef.current
            );

            linkForm.setAttribute('data-id', String(LINK_FORM_TYPES.rect));
            linkForm.setAttribute('class', 'inject');
            linkForm.setAttribute('stroke', '#ccc');
            linkForm.setAttribute('fill', '#fff');
            linkForm.setAttribute('x', Number(x - textSize / 2));
            linkForm.setAttribute('y', Number(y - 10));
            linkForm.setAttribute('height', height);
            linkForm.setAttribute('width', width);
            linkForm.setAttribute('rx', '2');
            linkForm.setAttribute('ry', '2');
            link.appendChild(linkForm);

            oCriarRotuloLink({
              link,
              forma: linkForm,
              rotulo,
              texto: text,
              fontSize: Math.trunc(height / 2),
            });
            break;

          /**
           * Área: retângulo desenhado sobre o contorno real do componente.
           * Aqui x/y são o canto superior esquerdo (e não o centro, como
           * nas formas legadas) e width/height vêm do arraste do usuário.
           */
          case LINK_FORM_TYPES.area: {
            linkForm = document.createElementNS(
              svgRef.current.namespaceURI,
              'svg:rect',
              svgRef.current
            );

            const areaW = Math.max(
              LINK_AREA_SIZE_LIMIT.min,
              Math.min(LINK_AREA_SIZE_LIMIT.max, Number(width) || 0)
            );
            const areaH = Math.max(
              LINK_AREA_SIZE_LIMIT.min,
              Math.min(LINK_AREA_SIZE_LIMIT.max, Number(height) || 0)
            );

            linkForm.setAttribute('data-id', String(LINK_FORM_TYPES.area));
            linkForm.setAttribute('data-role', opLinkPapel.AREA);
            linkForm.setAttribute('class', 'inject');
            linkForm.setAttribute('x', Number(x));
            linkForm.setAttribute('y', Number(y));
            linkForm.setAttribute('width', areaW);
            linkForm.setAttribute('height', areaH);
            /** rx/ry são obrigatórios: sem eles o svgo converte o rect em path */
            linkForm.setAttribute('rx', '2');
            linkForm.setAttribute('ry', '2');
            linkForm.setAttribute('stroke', opLinkEstilo.COR);
            linkForm.setAttribute('stroke-width', opLinkEstilo.ESPESSURA);
            /**
             * O preenchimento translúcido é intencional: com fill="none" a
             * área só é clicável na borda, e com opacity 0 o plugin
             * removeHiddenElems do svgo apagaria o link inteiro ao salvar.
             */
            linkForm.setAttribute('fill', opLinkEstilo.COR);
            linkForm.setAttribute(
              'fill-opacity',
              opLinkEstilo.AREA_FILL_OPACITY
            );
            link.appendChild(linkForm);

            oCriarRotuloLink({
              link,
              forma: linkForm,
              rotulo,
              texto: text,
              fontSize: Number(textSize) || INITIAL_LINK_AREA.fontSize,
            });
            break;
          }
          default:
            break;
        }

        linkMappingRef.current.push(link);
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [LINK_FORM_TYPES, handleHoverHighlight, oCriarRotuloLink]
    );

    const oCheckConflict = useCallback(() => {
      /** desconta padding como margem de segurança */
      const padding = 3;

      if (!(linkMappingRef && linkMappingRef.current)) return;

      const mappingPos = linkMappingRef.current.map((item) => {
        const shape = item.childNodes[0];

        /** reprocessa os itens com classe padrão */
        shape.setAttribute('class', 'inject');

        if (shape.nodeName === 'svg:circle') {
          const cx = Number(shape.getAttribute('cx'));
          const cy = Number(shape.getAttribute('cy'));
          const r = Number(shape.getAttribute('r'));

          const top = cy - r;
          const left = cx - r;
          const width = r * 2;
          const height = r * 2;

          return { shape, top, left, width, height };
        }

        const left = Number(shape.getAttribute('x'));
        const top = Number(shape.getAttribute('y'));
        const width = Number(shape.getAttribute('width'));
        const height = Number(shape.getAttribute('height'));

        return { shape, top, left, width, height };
      });

      mappingPos.forEach((item) => {
        const conflicts = mappingPos.filter(
          (itemFilter) =>
            (item.left - padding >= itemFilter.left ||
              item.left - padding + item.width >= itemFilter.left) &&
            item.left + item.width / 2 - padding <=
              itemFilter.left + itemFilter.width &&
            (item.top - padding >= itemFilter.top ||
              item.top + item.height - padding >= itemFilter.top) &&
            item.top + item.height / 2 - padding <=
              itemFilter.top + itemFilter.height
        );

        if (conflicts.length > 1) {
          conflicts.forEach((itemConflict) =>
            itemConflict.shape.setAttribute('class', 'warning')
          );
        }
      });
    }, []);

    const oLink = useCallback(
      (data) => {
        const { catalogId, pageNum: pageId } = editor;
        const { id, fontSize, width, height } = currLinkTypeRef.current;

        const currHeight = defLinkSize.current.height || height;
        const currWidth = defLinkSize.current.width || width;

        /** transforma IDs com 0 à esquerda em IDs sem 0 à esquerda ("01" significa o mesmo que "1") */
        const normalizeValue = (value) => {
          const text = String(value ?? '')
            .trim()
            .toUpperCase();

          // Se for apenas número, remove zeros à esquerda convertendo para Number
          if (/^\d+$/.test(text)) {
            return String(Number(text));
          }

          // Se for texto/alfanumérico, mantém como texto normalizado
          return text;
        };

        const formattedIdItem = normalizeValue(data.idItem);

        /** busca o item no mapeamento OCR */
        const dotted = ocrMappingRef.current.filter((item) => {
          const formattedOcr = normalizeValue(item.ocr.text);

          return formattedOcr === formattedIdItem;
        });

        /** caso não encontre pelo método OCR, interrompe o processo */
        if (!dotted.length) return;

        dotted.forEach(({ attr, ocr }) => {
          /**
           * Geometria de ÁREA: aproveita a caixa que o OCR já devolve
           * (ocr.width / ocr.height, com ocr.x / ocr.y no centro do texto,
           * conforme NormalizarExtracaoTextoService no backend). Antes essas
           * duas informações eram descartadas e todo link nascia com o
           * tamanho padrão.
           */
          if (Number(id) === LINK_FORM_TYPES.area) {
            const larguraOcr = Number(ocr && ocr.width) || currWidth;
            const alturaOcr = Number(ocr && ocr.height) || currHeight;

            /** folga para a área não encostar no texto detectado */
            const folga = 2;
            const largura = larguraOcr + folga * 2;
            const altura = alturaOcr + folga * 2;

            const centroX =
              Number(ocr && ocr.x) ||
              Number(attr.childNodes[0].getAttribute('x'));
            const centroY =
              Number(ocr && ocr.y) ||
              Number(attr.childNodes[0].getAttribute('y'));

            createLink(
              id,
              centroX - largura / 2,
              centroY - altura / 2,
              0,
              altura,
              largura,
              data.partnumber,
              data.idItem,
              INITIAL_LINK_AREA.fontSize,
              `/${catalogId}/${pageId}/${data.idItem}`,
              currLinkRotuloRef.current
            );

            return;
          }

          createLink(
            id,
            Number(attr.childNodes[0].getAttribute('x')) - 10,
            Number(attr.childNodes[0].getAttribute('y')) + 10,
            currHeight,
            currHeight,
            currWidth,
            data.partnumber,
            data.idItem,
            fontSize,
            `/${catalogId}/${pageId}/${data.idItem}`,
            currLinkRotuloRef.current
          );
        });

        /** verifica associações */
        oCheckAssociation();

        /** verifica conflito */
        oCheckConflict();
      },
      [createLink, editor, oCheckAssociation, oCheckConflict]
    );

    /** mantém os refs sincronizados para uso dentro dos handlers de mouse */
    useEffect(() => {
      currLinkRotuloRef.current = currLinkRotulo;
    }, [currLinkRotulo]);

    /**
     * O elemento <SVG> é memoizado apenas por [editor.pageNum, editor.path]
     * (as dependências dos handlers estão comentadas de propósito, para não
     * reinjetar o desenho e perder os links a cada render). Como consequência,
     * os handlers de mouse carregam o estado do render da injeção.
     *
     * Espelhar a tabela em ref evita que o modo sequência trabalhe com uma
     * lista de itens vazia quando os itens da página chegam depois do SVG.
     */
    useEffect(() => {
      tabelaRef.current = table;
    }, [table]);

    useEffect(() => {
      modoSequenciaRef.current = modoSequencia;
    }, [modoSequencia]);

    /** itens da página que ainda não têm link no desenho */
    const itensPendentes = useMemo(() => {
      const vinculados = new Set(
        linkMappingRef.current.map((node) => String(getIdItemLink(node)))
      );

      return table.filter((item) => !vinculados.has(String(item.idItem)));
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [table, getIdItemLink, currLinkType, currLinkRotulo, modoSequencia]);

    /**
     * Cria o link de um item usando a geometria de ÁREA a partir do
     * retângulo desenhado pelo usuário.
     */
    const oCriarLinkArea = useCallback(
      (item, x, y, largura, altura) => {
        if (!item) return;

        const { catalogId, pageNum: pageId } = editor;

        createLink(
          LINK_FORM_TYPES.area,
          x,
          y,
          0,
          altura,
          largura,
          item.partnumber,
          item.idItem,
          INITIAL_LINK_AREA.fontSize,
          `/${catalogId}/${pageId}/${item.idItem}`,
          currLinkRotuloRef.current
        );

        oCheckAssociation();
        oCheckConflict();
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [createLink, editor, oCheckAssociation, oCheckConflict]
    );

    /**
     * Cria o link de um item respeitando a geometria e o rótulo atuais.
     *
     * - legadoX/legadoY: ponto de ancoragem das formas legadas
     *   (círculo/retângulo), preservado exatamente como cada chamada fazia.
     * - centroX/centroY: centro usado pela geometria de ÁREA.
     * - ocr: caixa do texto detectado, quando houver, para dimensionar a
     *   área (campos width/height de NormalizarExtracaoTextoService).
     */
    const oCriarLinkNoPonto = useCallback(
      ({
        data,
        legadoX,
        legadoY,
        centroX,
        centroY,
        ocr = null,
        area = null,
      }) => {
        const { catalogId, pageNum: pageId } = editor;
        const { id, fontSize, width, height } = currLinkTypeRef.current;

        const currHeight = defLinkSize.current.height || height;
        const currWidth = defLinkSize.current.width || width;
        const href = `/${catalogId}/${pageId}/${data.idItem}`;

        /**
         * Retângulo desenhado pelo usuário tem prioridade sobre qualquer
         * outro tamanho (OCR ou padrão) — foi um gesto explícito.
         */
        if (area) {
          createLink(
            LINK_FORM_TYPES.area,
            area.x,
            area.y,
            0,
            area.altura,
            area.largura,
            data.partnumber,
            data.idItem,
            INITIAL_LINK_AREA.fontSize,
            href,
            currLinkRotuloRef.current
          );

          return;
        }

        if (Number(id) === LINK_FORM_TYPES.area) {
          const folga = 2;
          const largura = (Number(ocr && ocr.width) || currWidth) + folga * 2;
          const altura = (Number(ocr && ocr.height) || currHeight) + folga * 2;

          createLink(
            id,
            centroX - largura / 2,
            centroY - altura / 2,
            0,
            altura,
            largura,
            data.partnumber,
            data.idItem,
            INITIAL_LINK_AREA.fontSize,
            href,
            currLinkRotuloRef.current
          );

          return;
        }

        createLink(
          id,
          legadoX,
          legadoY,
          currHeight,
          currHeight,
          currWidth,
          data.partnumber,
          data.idItem,
          fontSize,
          href,
          currLinkRotuloRef.current
        );
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [createLink, editor]
    );

    /** avança o modo sequência para o próximo item ainda sem link */
    const oAvancarSequencia = useCallback(
      (idItemCriado) => {
        const vinculados = new Set(
          linkMappingRef.current.map((node) => String(getIdItemLink(node)))
        );

        if (idItemCriado) vinculados.add(String(idItemCriado));

        /** lê do ref: ver comentário do efeito que sincroniza tabelaRef */
        const proximo = tabelaRef.current.find(
          (item) => !vinculados.has(String(item.idItem))
        );

        itemSequenciaRef.current = proximo || null;
        setItemSequencia(proximo || null);
      },
      [getIdItemLink]
    );

    /** Retorna a posição do mouse no objeto SVGPoint { x: number, y: number } */
    const oMousePosSVG = useCallback(
      (e) => {
        let p = svgRef.current.createSVGPoint();
        p.x = e.clientX;
        p.y = e.clientY;
        const ctm = rootRef.current.getScreenCTM().inverse();
        p = p.matrixTransform(ctm);
        return p;
      },
      [rootRef]
    );

    /** Seleciona um link e define foco nele */
    const oSelectElement = useCallback(
      (el) => {
        const isSelected = !!selectedRef.current.find(
          (element) => element.node === el.node
        );

        if (!isSelected) {
          selectedRef.current.push(el);
        }

        /** limpa o foco atual */
        if (focusRef && focusRef.current) {
          const classes = focusRef.current.node
            .getAttribute('class')
            .split('focused');

          focusRef.current.node.setAttribute(
            'class',
            classes[0].trim() + (classes[1] || '')
          );
        }

        /** difene novo foco */
        focusRef.current = el;
        focusRef.current.node.setAttribute(
          'class',
          `selected ${
            selectedRef.current && selectedRef.current.length > 1
              ? 'focused'
              : ''
          }`.trim()
        );

        let currSizeW = 0;
        let currSizeH = 0;

        switch (Number(focusRef.current.node.childNodes[0].dataset.id)) {
          case LINK_FORM_TYPES.circle:
            currSizeH = focusRef.current.node.childNodes[0].getAttribute('r');
            break;
          case LINK_FORM_TYPES.rect:
          case LINK_FORM_TYPES.area:
            currSizeW = focusRef.current.node.childNodes[0].getAttribute(
              'width'
            );
            currSizeH = focusRef.current.node.childNodes[0].getAttribute(
              'height'
            );
            break;
          default:
            break;
        }

        oLinkSizeMode(currSizeH, currSizeW);
      },
      [LINK_FORM_TYPES, selectedRef, focusRef, oLinkSizeMode]
    );

    /** desseleciona um link */
    const oDeselectElement = useCallback(
      (el) => {
        const classes = el.node.getAttribute('class').split('selected');

        el.node.setAttribute('class', classes[0].trim() + (classes[1] || ''));

        selectedRef.current = selectedRef.current.filter(
          (element) => element.node !== el.node
        );
      },
      [selectedRef]
    );

    /** limpa seleção de links */
    const oClearSelection = useCallback(() => {
      /** limpa foco */
      if (focusRef && focusRef.current) {
        focusRef.current = null;
      }

      /** limpa seleção */
      if (selectedRef && selectedRef.current) {
        selectedRef.current.forEach((el) =>
          el.node.setAttribute(
            'class',
            el.node.getAttribute('class').split('selected')[0].trim()
          )
        );
        selectedRef.current = [];
      }

      oLinkSizeMode(0, 0);
    }, [selectedRef, oLinkSizeMode]);

    const oClearSelector = useCallback(() => {
      /** limpa área de seleção */
      if (selectorRef && selectorRef.current) {
        selectorRef.current.setAttribute('x', 0);
        selectorRef.current.setAttribute('y', 0);
        selectorRef.current.setAttribute('width', 0);
        selectorRef.current.setAttribute('height', 0);

        startCoordRef.current = { x: 0, y: 0 };
        finishCoordRef.current = { x: 0, y: 0 };
        maxCoordRef.current = { x: 0, y: 0 };
        minCoordRef.current = { x: 0, y: 0 };
      }
    }, [selectorRef]);

    const oRemove = useCallback((el) => {
      const drop = el.parentElement || null;

      if (!drop) return el;

      if (drop.childNodes.length > 1) return el;

      return oRemove(drop);
    }, []);

    const handleDragOverSVG = useCallback((e) => {
      e.preventDefault();
    }, []);

    const handleDropSVG = useCallback(
      (e) => {
        e.preventDefault();

        const m = oMousePosSVG(e);

        const data = JSON.parse(e.dataTransfer.getData('text/row-list'));
        if (!data) return;

        const dotted = ocrMappingRef.current.filter(
          (item) => item.ocr.text === String(data.idItem)
        );

        if (!dotted.length) {
          oCriarLinkNoPonto({
            data,
            legadoX: m.x,
            legadoY: m.y,
            centroX: m.x,
            centroY: m.y,
          });
        }

        dotted.forEach(({ attr, ocr }) => {
          const ancoraX = Number(attr.childNodes[0].getAttribute('x'));
          const ancoraY = Number(attr.childNodes[0].getAttribute('y'));

          oCriarLinkNoPonto({
            data,
            legadoX: ancoraX - 10,
            legadoY: ancoraY + 10,
            centroX: Number(ocr && ocr.x) || ancoraX,
            centroY: Number(ocr && ocr.y) || ancoraY,
            ocr,
          });

          /** remove elemento do mapeamento principal */
          const mappingIndex = ocrMappingRef.current.findIndex(
            (findAttr) => findAttr.attr.id === attr.id
          );
          ocrMappingRef.current.splice(mappingIndex, 1);

          /** remove elemento da tela */
          oRemove(attr).remove();
        });

        /** associa link com o item na tabela */
        oCheckAssociation();

        /** verifica conflito */
        oCheckConflict();
      },
      [
        editor,
        oMousePosSVG,
        oRemove,
        createLink,
        oCheckAssociation,
        oCheckConflict,
      ]
    );

    const handleDragOver = useCallback((e) => {
      const isLink = e.dataTransfer.types.includes('image/svg+xml');
      if (isLink) e.preventDefault();
    }, []);

    const handleMouseMove = useCallback(
      (e) => {
        if (!selectingRef.current) return;

        const m = oMousePosSVG(e);

        const isLink = isAlvoLink(e.target);

        const { shiftKey, ctrlKey, altKey } = e;

        /** Shift+Click */
        if (shiftKey && !ctrlKey && !altKey) {
          if (isLink && e.target.parentElement === focusRef.current.node) {
            actionRef.current = ACTION_STATE.move;
          }
        }

        /** Shift+Ctrl+Click Disponível */
        /** Shift+Alt+Click Disponível */
        /** Shift+Ctrl+Alt+Click Disponível */

        /** Ctrl+Click  */
        if (!shiftKey && ctrlKey && !altKey) {
          if (!selectedRef.current.length) {
            actionRef.current = ACTION_STATE.selectArea;
          }
        }

        /** Ctrl+Alt+Click Disponível */

        /** Alt+Click Disponível */
        if (!shiftKey && !ctrlKey && altKey) {
          if (isLink && e.target.parentElement === controlRef.current) {
            actionRef.current = ACTION_STATE.moveOne;
          }
        }

        /** Click */
        if (!shiftKey && !ctrlKey && !altKey) {
          if (rotuloDragRef.current) {
            /** arrastando a etiqueta: a área do link não se move */
            actionRef.current = ACTION_STATE.moveRotulo;
          } else if (isLink) {
            actionRef.current = ACTION_STATE.move;
          } else if (podeDesenharArea()) {
            /** arraste sobre o desenho desenha a área do link */
            actionRef.current = ACTION_STATE.createArea;
          }
        }

        switch (actionRef.current) {
          /**
           * Desenha o retângulo temporário da nova área. O link só é criado
           * ao soltar o botão, em handleMouseUp.
           */
          case ACTION_STATE.createArea: {
            const draft = oGetAreaDraft();
            if (!draft) return;

            /** garante a origem do arraste caso o mousedown não a tenha fixado */
            if (!areaStartRef.current) {
              areaStartRef.current = { x: m.x, y: m.y };
            }

            const inicio = areaStartRef.current;

            const x = Math.min(inicio.x, m.x);
            const y = Math.min(inicio.y, m.y);
            const largura = Math.abs(m.x - inicio.x);
            const altura = Math.abs(m.y - inicio.y);

            draft.setAttribute('x', x);
            draft.setAttribute('y', y);
            draft.setAttribute('width', largura);
            draft.setAttribute('height', altura);
            break;
          }

          /**
           * Move apenas a etiqueta do link e reancora a linha de chamada,
           * mantendo a área sobre o componente.
           */
          case ACTION_STATE.moveRotulo: {
            const link = rotuloDragRef.current;
            if (!link) return;

            const { rotulo, rotuloTexto } = getPartesLink(link);
            if (!rotulo) return;

            const caixa = getCaixaForma(rotulo);

            const dx = m.x - (caixa.x + caixa.width / 2);
            const dy = m.y - (caixa.y + caixa.height / 2);

            transladarElementoSvg(rotulo, dx, dy);
            if (rotuloTexto) transladarElementoSvg(rotuloTexto, dx, dy);

            oReancorarChamada(link);
            break;
          }

          case ACTION_STATE.move: {
            /** verifica se há links selecionados */
            if (selectedRef.current.length === 0) return;

            /** vetores de deslocamento para x e y */
            const xVector =
              m.x -
              Number(
                focusRef.current.node.childNodes[0].getAttribute(
                  `${
                    Number(focusRef.current.node.childNodes[0].dataset.id) ===
                    LINK_FORM_TYPES.circle
                      ? 'cx'
                      : 'x'
                  }`
                )
              );
            const yVector =
              m.y -
              Number(
                focusRef.current.node.childNodes[0].getAttribute(
                  `${
                    Number(focusRef.current.node.childNodes[0].dataset.id) ===
                    LINK_FORM_TYPES.circle
                      ? 'cy'
                      : 'y'
                  }`
                )
              );

            /** offsets do link em foco em x e y */
            const xOffset =
              Number(focusRef.current.node.childNodes[0].dataset.id) ===
              LINK_FORM_TYPES.circle
                ? null
                : Number(
                    focusRef.current.node.childNodes[0].width.baseVal.value
                  ) / 2;
            const yOffset =
              Number(focusRef.current.node.childNodes[0].dataset.id) ===
              LINK_FORM_TYPES.circle
                ? null
                : Number(
                    focusRef.current.node.childNodes[0].height.baseVal.value
                  ) / 2;

            selectedRef.current.forEach((element) => {
              const linkForm = element.node.childNodes[0];
              const linkText = element.node.childNodes[1];

              const { id: tipo = null } = linkForm.dataset || {};

              /** links compostos: translada todos os elementos internos */
              if (oUsaTranslacaoGenerica(element.node, tipo)) {
                transladarLink(
                  element.node,
                  xVector - (xOffset || 0),
                  yVector - (yOffset || 0)
                );
                return;
              }

              switch (Number(tipo)) {
                case LINK_FORM_TYPES.circle: {
                  /** posição da forma */
                  const xF = Number(linkForm.getAttribute('cx'));
                  const yF = Number(linkForm.getAttribute('cy'));
                  /** posição do texto */
                  const xT = linkText ? Number(linkText.getAttribute('x')) : 0;
                  const yT = linkText ? Number(linkText.getAttribute('y')) : 0;

                  /** nova posição da forma */
                  linkForm.setAttribute('cx', xF + xVector - xOffset);
                  linkForm.setAttribute('cy', yF + yVector - yOffset);
                  /** nova posição do texto */
                  if (linkText) {
                    linkText.setAttribute('x', xT + xVector - xOffset);
                    linkText.setAttribute('y', yT + yVector - yOffset);
                  }
                  break;
                }
                case LINK_FORM_TYPES.rect:
                case LINK_FORM_TYPES.ocr: {
                  /** posição da forma */
                  const xF = Number(linkForm.getAttribute('x'));
                  const yF = Number(linkForm.getAttribute('y'));
                  /** posição do texto */
                  const xT = linkText ? Number(linkText.getAttribute('x')) : 0;
                  const yT = linkText ? Number(linkText.getAttribute('y')) : 0;

                  /** nova posição da forma */
                  linkForm.setAttribute('x', xF + xVector - xOffset);
                  linkForm.setAttribute('y', yF + yVector - yOffset);
                  /** nova posição do texto */
                  if (linkText) {
                    linkText.setAttribute('x', xT + xVector - xOffset);
                    linkText.setAttribute('y', yT + yVector - yOffset);
                  }
                  break;
                }
                default:
                  break;
              }
            });
            break;
          }

          case ACTION_STATE.moveOne:
            {
              const element = selectedRef.current.find(
                (el) => el.node === controlRef.current
              );

              if (!element) return;
              /** vetores de deslocamento para x e y */
              const xVector =
                m.x -
                Number(
                  element.node.childNodes[0].getAttribute(
                    `${
                      Number(element.node.childNodes[0].dataset.id) ===
                      LINK_FORM_TYPES.circle
                        ? 'cx'
                        : 'x'
                    }`
                  )
                );
              const yVector =
                m.y -
                Number(
                  element.node.childNodes[0].getAttribute(
                    `${
                      Number(element.node.childNodes[0].dataset.id) ===
                      LINK_FORM_TYPES.circle
                        ? 'cy'
                        : 'y'
                    }`
                  )
                );

              /** offsets do link em foco em x e y */
              const xOffset =
                Number(element.node.childNodes[0].dataset.id) ===
                LINK_FORM_TYPES.circle
                  ? null
                  : Number(element.node.childNodes[0].width.baseVal.value) / 2;
              const yOffset =
                Number(element.node.childNodes[0].dataset.id) ===
                LINK_FORM_TYPES.circle
                  ? null
                  : Number(element.node.childNodes[0].height.baseVal.value) / 2;

              const linkForm = element.node.childNodes[0];
              const linkText = element.node.childNodes[1];

              const { id: tipo = null } = linkForm.dataset || {};

              /** links compostos: translada todos os elementos internos */
              if (oUsaTranslacaoGenerica(element.node, tipo)) {
                transladarLink(
                  element.node,
                  xVector - (xOffset || 0),
                  yVector - (yOffset || 0)
                );
                break;
              }

              switch (Number(tipo)) {
                case LINK_FORM_TYPES.circle: {
                  /** posição da forma */
                  const xF = Number(linkForm.getAttribute('cx'));
                  const yF = Number(linkForm.getAttribute('cy'));
                  /** posição do texto */
                  const xT = linkText ? Number(linkText.getAttribute('x')) : 0;
                  const yT = linkText ? Number(linkText.getAttribute('y')) : 0;

                  /** nova posição da forma */
                  linkForm.setAttribute('cx', xF + xVector - xOffset);
                  linkForm.setAttribute('cy', yF + yVector - yOffset);
                  /** nova posição do texto */
                  if (linkText) {
                    linkText.setAttribute('x', xT + xVector - xOffset);
                    linkText.setAttribute('y', yT + yVector - yOffset);
                  }
                  break;
                }
                case LINK_FORM_TYPES.rect:
                case LINK_FORM_TYPES.ocr: {
                  /** posição da forma */
                  const xF = Number(linkForm.getAttribute('x'));
                  const yF = Number(linkForm.getAttribute('y'));
                  /** posição do texto */
                  const xT = linkText ? Number(linkText.getAttribute('x')) : 0;
                  const yT = linkText ? Number(linkText.getAttribute('y')) : 0;

                  /** nova posição da forma */
                  linkForm.setAttribute('x', xF + xVector - xOffset);
                  linkForm.setAttribute('y', yF + yVector - yOffset);
                  /** nova posição do texto */
                  if (linkText) {
                    linkText.setAttribute('x', xT + xVector - xOffset);
                    linkText.setAttribute('y', yT + yVector - yOffset);
                  }
                  break;
                }
                default:
                  break;
              }
            }
            break;
          case ACTION_STATE.selectArea: {
            /** define valores finais para a área de seleção */
            if (
              startCoordRef.current.x === 0 &&
              startCoordRef.current.y === 0
            ) {
              startCoordRef.current.x = m.x;
              startCoordRef.current.y = m.y;
            }

            finishCoordRef.current.x = m.x;
            finishCoordRef.current.y = m.y;

            minCoordRef.current.x = Math.min(
              startCoordRef.current.x,
              finishCoordRef.current.x
            );
            maxCoordRef.current.x = Math.max(
              startCoordRef.current.x,
              finishCoordRef.current.x
            );
            minCoordRef.current.y = Math.min(
              startCoordRef.current.y,
              finishCoordRef.current.y
            );
            maxCoordRef.current.y = Math.max(
              startCoordRef.current.y,
              finishCoordRef.current.y
            );

            selectorRef.current.setAttribute('x', minCoordRef.current.x);
            selectorRef.current.setAttribute('y', minCoordRef.current.y);
            selectorRef.current.setAttribute(
              'width',
              maxCoordRef.current.x - minCoordRef.current.x
            );
            selectorRef.current.setAttribute(
              'height',
              maxCoordRef.current.y - minCoordRef.current.y
            );

            /** seleciona itens dentro da área */
            const linkMappingPos = linkMappingRef.current.map((item) => {
              const shape = item.childNodes[0];

              const x = Number(
                shape.getAttribute(shape.nodeName === 'svg:circle' ? 'cx' : 'x')
              );
              const y = Number(
                shape.getAttribute(shape.nodeName === 'svg:circle' ? 'cy' : 'y')
              );

              return { attr: item, x, y };
            });

            const mappingOCRPos = ocrMappingRef.current.map((item) => {
              const x = Number(item.attr.childNodes[0].getAttribute('x'));
              const y = Number(item.attr.childNodes[0].getAttribute('y'));

              return { attr: item.attr, x, y };
            });

            const itemsPos = [...linkMappingPos, ...mappingOCRPos];

            itemsPos.forEach((item) => {
              if (
                item.x >= minCoordRef.current.x &&
                item.x <= maxCoordRef.current.x &&
                item.y >= minCoordRef.current.y &&
                item.y <= maxCoordRef.current.y
              ) {
                oSelectElement({ node: item.attr });
              } else {
                oDeselectElement({ node: item.attr });
              }
            });
            break;
          }
          default:
            break;
        }
      },
      [
        ACTION_STATE,
        LINK_FORM_TYPES,
        actionRef,
        selectingRef,
        oMousePosSVG,
        oSelectElement,
        oDeselectElement,
      ]
    );

    const handleMouseDown = useCallback(
      (e) => {
        /**
         * Os atalhos só chegam ao editor quando o wrapper do desenho está
         * com o foco (ele tem tabIndex="0"). Focar no mousedown garante
         * que Del, Alt+Z e Alt+S funcionem logo após o primeiro clique no
         * desenho, sem o usuário precisar tabular até ele.
         */
        if (e.currentTarget && e.currentTarget.focus) {
          e.currentTarget.focus({ preventScroll: true });
        }

        /** verifica se existe um arquivo na área de edição */
        if (svgRef.current) {
          selectingRef.current = true;

          const { shiftKey, ctrlKey, altKey } = e;

          const isLink = isAlvoLink(e.target);

          /** guarda o link cuja etiqueta está sendo arrastada */
          rotuloDragRef.current =
            !shiftKey && !ctrlKey && !altKey && isAlvoRotulo(e.target)
              ? e.target.parentElement
              : null;

          /** bloqueia movimento da imagem quando um link está sendo movido ou selecionado */
          if (isLink || ctrlKey) {
            setZoomCanMove(false);
          }

          /**
           * O arraste sobre o desenho desenha a área do link, então o pan da
           * imagem precisa ficar desligado durante o gesto.
           */
          if (
            podeDesenharArea() &&
            !isLink &&
            !shiftKey &&
            !ctrlKey &&
            !altKey
          ) {
            setZoomCanMove(false);

            const m = oMousePosSVG(e);
            areaStartRef.current = { x: m.x, y: m.y };

            const draft = oGetAreaDraft();
            if (draft) {
              draft.setAttribute('x', m.x);
              draft.setAttribute('y', m.y);
              draft.setAttribute('width', 0);
              draft.setAttribute('height', 0);
            }
          }

          /** Shift+Click */
          if (shiftKey && !ctrlKey && !altKey) {
            if (isLink) {
              actionRef.current = ACTION_STATE.select;
            }
          }

          /** Shift+Ctrl+Click Disponível */

          /** Shift+Alt+Click */
          if (shiftKey && !ctrlKey && altKey) {
            if (isLink) {
              actionRef.current = ACTION_STATE.deselect;
            }
          }

          /** Shift+Ctrl+Alt+Click Disponível */

          /** Ctrl+Click  */
          if (!shiftKey && ctrlKey && !altKey) {
            const m = oMousePosSVG(e);

            /** define valores iniciais para a área de seleção */
            startCoordRef.current.x = m.x;
            startCoordRef.current.y = m.y;
            selectorRef.current.setAttribute('x', 0);
            selectorRef.current.setAttribute('y', 0);
            selectorRef.current.setAttribute('width', 0);
            selectorRef.current.setAttribute('height', 0);
          }

          /** Ctrl+Alt+Click Disponível */

          /** Alt+Click Disponível  */
          if (!shiftKey && !ctrlKey && altKey) {
            /** armazena o elemento para o Alt+Click+Drag */
            if (isLink) {
              controlRef.current = e.target.parentElement;
            }
          }

          /** Click */
          if (!shiftKey && !ctrlKey && !altKey) {
            /** limpa seleção */
            oClearSelection();

            if (isLink) {
              controlRef.current = e.target.parentElement;
              actionRef.current = ACTION_STATE.select;
            }
          }

          switch (actionRef.current) {
            case ACTION_STATE.select:
              oSelectElement({ node: e.target.parentElement });
              break;
            case ACTION_STATE.deselect:
              oDeselectElement({ node: e.target.parentElement });
              break;
            default:
              break;
          }

          actionRef.current = null;
        }
      },
      [
        ACTION_STATE,
        actionRef,
        selectingRef,
        oSelectElement,
        oDeselectElement,
        oClearSelection,
        oMousePosSVG,
      ]
    );

    /**
     * Fecha o input rápido descartando também o retângulo desenhado que
     * estivesse aguardando o ID do item — sem isso ele seria reaproveitado
     * indevidamente na próxima criação de link.
     */
    const handleQuickInputCancel = useCallback(() => {
      areaPendenteRef.current = null;

      if (areaDraftRef.current) {
        areaDraftRef.current.setAttribute('width', 0);
        areaDraftRef.current.setAttribute('height', 0);
      }

      setQuickInput((state) => ({ ...state, open: false, value: '' }));
    }, []);

    /** NOVO: confirma criação rápida do link ao pressionar Enter */
    const handleQuickInputConfirm = useCallback(
      (rawValue) => {
        const value = String(rawValue || '').trim();
        if (!value) {
          handleQuickInputCancel();
          return;
        }

        // normalização “01” === “1”
        const norm = (v) => {
          const n = Number(v);
          return Number.isNaN(n) ? String(v).trim() : String(n);
        };

        const data = table.find((it) => norm(it.idItem) === norm(value));

        if (!data) {
          toast.info('Item não encontrado na lista desta página.');
          return;
        }

        /**
         * Se o usuário desenhou a área por arraste, o retângulo dele manda:
         * cria direto nessa geometria e ignora o casamento por OCR (que
         * reposicionaria o link para onde o texto foi detectado).
         */
        if (areaPendenteRef.current) {
          oCriarLinkNoPonto({ data, area: areaPendenteRef.current });
          areaPendenteRef.current = null;

          oCheckAssociation();
          oCheckConflict();
          oRegistrarHistorico();
          setQuickInput((state) => ({ ...state, open: false, value: '' }));

          return;
        }

        // tenta casar com OCR primeiro
        const dotted = ocrMappingRef.current.filter(
          (item) => norm(item.ocr.text) === norm(data.idItem)
        );

        if (dotted.length) {
          dotted.forEach(({ attr, ocr }) => {
            const ancoraX = Number(attr.childNodes[0].getAttribute('x'));
            const ancoraY = Number(attr.childNodes[0].getAttribute('y'));

            oCriarLinkNoPonto({
              data,
              legadoX: ancoraX - 10,
              legadoY: ancoraY + 10,
              centroX: Number(ocr && ocr.x) || ancoraX,
              centroY: Number(ocr && ocr.y) || ancoraY,
              ocr,
            });

            // remove overlay correspondente
            const mappingIndex = ocrMappingRef.current.findIndex(
              (findAttr) => findAttr.attr.id === attr.id
            );
            if (mappingIndex !== -1) {
              ocrMappingRef.current.splice(mappingIndex, 1);
            }
            oRemove(attr).remove();
          });
        } else {
          // cria no ponto clicado
          oCriarLinkNoPonto({
            data,
            legadoX: quickInput.svgX - 15,
            legadoY: quickInput.svgY + 2,
            centroX: quickInput.svgX,
            centroY: quickInput.svgY,
          });
        }

        // pós-criação
        oCheckAssociation();
        oCheckConflict();
        setQuickInput((s) => ({ ...s, open: false, value: '' }));
      },
      [
        table,
        editor,
        createLink,
        quickInput.svgX,
        quickInput.svgY,
        oRemove,
        oCheckAssociation,
        oCheckConflict,
      ]
    );

    /* =================================================================
       HISTÓRICO (desfazer / refazer)
       -----------------------------------------------------------------
       Guarda snapshots do innerHTML do grupo de links. Restaurar o HTML
       descarta os listeners dos elementos, então após cada restauração o
       mapeamento é reconstruído com mappingElement.

       O limite evita crescimento indefinido em páginas com muitos itens.
       ================================================================= */
    const HISTORICO_LIMITE = 40;
    const historicoRef = useRef([]);
    const historicoPosRef = useRef(-1);
    const [historicoInfo, setHistoricoInfo] = useState({
      podeDesfazer: false,
      podeRefazer: false,
    });

    const oGetLinkGroup = useCallback(() => {
      if (linkRef.current && linkRef.current.parentNode) return linkRef.current;

      const grupo = document.getElementById('linkGroup');
      if (grupo) linkRef.current = grupo;

      return grupo || null;
    }, []);

    const oAtualizarHistoricoInfo = useCallback(() => {
      setHistoricoInfo({
        podeDesfazer: historicoPosRef.current > 0,
        podeRefazer:
          historicoPosRef.current >= 0 &&
          historicoPosRef.current < historicoRef.current.length - 1,
      });
    }, []);

    /** reconstrói o mapeamento e os listeners depois de restaurar o HTML */
    const oRemapearLinks = useCallback(() => {
      const grupo = oGetLinkGroup();
      if (!grupo) return;

      selectedRef.current = [];
      focusRef.current = null;
      linkMappingRef.current = [];

      mappingElement(grupo.childNodes);

      oCheckAssociation();
      oCheckConflict();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [oGetLinkGroup, mappingElement, oCheckAssociation, oCheckConflict]);

    /** registra o estado atual no histórico */
    const oRegistrarHistorico = useCallback(() => {
      const grupo = oGetLinkGroup();
      if (!grupo) return;

      const snapshot = grupo.innerHTML;

      /** primeira chamada: guarda o estado inicial */
      if (historicoPosRef.current < 0) {
        historicoRef.current = [snapshot];
        historicoPosRef.current = 0;
        oAtualizarHistoricoInfo();
        return;
      }

      /** nada mudou desde o último registro */
      if (historicoRef.current[historicoPosRef.current] === snapshot) return;

      /** descarta o "futuro" quando há uma nova ação após um desfazer */
      historicoRef.current = historicoRef.current.slice(
        0,
        historicoPosRef.current + 1
      );

      historicoRef.current.push(snapshot);

      if (historicoRef.current.length > HISTORICO_LIMITE) {
        historicoRef.current.shift();
      }

      historicoPosRef.current = historicoRef.current.length - 1;
      oAtualizarHistoricoInfo();
    }, [oGetLinkGroup, oAtualizarHistoricoInfo]);

    const oAplicarHistorico = useCallback(
      (posicao) => {
        const grupo = oGetLinkGroup();
        if (!grupo) return;

        const snapshot = historicoRef.current[posicao];
        if (snapshot === undefined) return;

        grupo.innerHTML = snapshot;
        historicoPosRef.current = posicao;

        oRemapearLinks();
        oAtualizarHistoricoInfo();
      },
      [oGetLinkGroup, oRemapearLinks, oAtualizarHistoricoInfo]
    );

    const handleDesfazer = useCallback(() => {
      if (historicoPosRef.current <= 0) return;
      oAplicarHistorico(historicoPosRef.current - 1);
    }, [oAplicarHistorico]);

    const handleRefazer = useCallback(() => {
      if (historicoPosRef.current >= historicoRef.current.length - 1) return;
      oAplicarHistorico(historicoPosRef.current + 1);
    }, [oAplicarHistorico]);

    const handleMouseUp = useCallback(
      (e) => {
        if (selectingRef && selectingRef.current) {
          const m = oMousePosSVG(e);
          /** guarda a ação atual antes de limpar */
          const currentAction = actionRef.current;

          oClearSelector();

          // switch (actionRef.current) {
          switch (currentAction) {
            case ACTION_STATE.select:
              break;

            /** conclui o arraste e cria o link do item da sequência */
            case ACTION_STATE.createArea: {
              const item = itemSequenciaRef.current;

              /**
               * Lê de areaStartRef: o oClearSelector() acima já zerou o
               * startCoordRef, que pertence ao seletor do OCR.
               */
              const inicio = areaStartRef.current || { x: m.x, y: m.y };

              const x = Math.min(inicio.x, m.x);
              const y = Math.min(inicio.y, m.y);
              const largura = Math.abs(m.x - inicio.x);
              const altura = Math.abs(m.y - inicio.y);

              /** limpa o retângulo temporário */
              if (areaDraftRef.current) {
                areaDraftRef.current.setAttribute('width', 0);
                areaDraftRef.current.setAttribute('height', 0);
              }

              const arrastouOSuficiente =
                largura >= LINK_AREA_SIZE_LIMIT.min &&
                altura >= LINK_AREA_SIZE_LIMIT.min;

              if (item && arrastouOSuficiente) {
                /** modo sequência: item já definido, cria e avança */
                oCriarLinkArea(item, x, y, largura, altura);
                oAvancarSequencia(item.idItem);
                oRegistrarHistorico();
              } else if (item) {
                /**
                 * Arraste muito pequeno: cria a área com o tamanho padrão
                 * centrada no ponto clicado, em vez de descartar a ação.
                 */
                oCriarLinkArea(
                  item,
                  m.x - INITIAL_LINK_AREA.width / 2,
                  m.y - INITIAL_LINK_AREA.height / 2,
                  INITIAL_LINK_AREA.width,
                  INITIAL_LINK_AREA.height
                );
                oAvancarSequencia(item.idItem);
                oRegistrarHistorico();
              } else if (arrastouOSuficiente) {
                /**
                 * Fora do modo sequência não há item alvo: guarda o retângulo
                 * desenhado e pede o ID do item no input rápido. O tamanho
                 * usado será o do arraste, não o padrão.
                 */
                areaPendenteRef.current = { x, y, largura, altura };

                const host = editorAreaRef.current || e.currentTarget;
                const rect = host.getBoundingClientRect();

                setQuickInput({
                  open: true,
                  x: e.clientX - rect.left,
                  y: e.clientY - rect.top,
                  svgX: x + largura / 2,
                  svgY: y + altura / 2,
                  value: '',
                });
              }

              areaStartRef.current = null;
              break;
            }

            /** conclui o arraste da etiqueta */
            case ACTION_STATE.moveRotulo:
              if (rotuloDragRef.current) {
                oReancorarChamada(rotuloDragRef.current);
              }
              oCheckConflict();
              oRegistrarHistorico();
              break;
            case ACTION_STATE.move:
            case ACTION_STATE.moveOne:
              /** atualiza posições do mapeamento OCR */
              if (ocrMappingRef.current && !!ocrMappingRef.current.length) {
                selectedRef.current.forEach((itemSelecionado) => {
                  const itemIndex = ocrMappingRef.current.findIndex(
                    (itemOCR) =>
                      String(itemOCR.attr.id) ===
                      String(itemSelecionado.node.id)
                  );

                  if (itemIndex >= 0) {
                    const { attr, ocr } = ocrMappingRef.current[itemIndex];

                    ocrMappingRef.current[itemIndex] = {
                      attr,
                      ocr: { ...ocr, x: m.x, y: m.y },
                    };
                  }
                });
              }

              /** verifica conflitos */
              oCheckConflict();
              oRegistrarHistorico();
              break;
            default:
              break;
          }

          /** NOVO: clique simples em área vazia → abre input */
          const isLink = isAlvoLink(e.target);
          const { shiftKey, ctrlKey, altKey } = e;

          /**
           * O duplo clique só abre o input rápido fora do modo sequência —
           * nesse modo o gesto de criação é o próprio arraste.
           */
          if (
            !isLink &&
            !modoSequenciaRef.current &&
            !shiftKey &&
            !ctrlKey &&
            !altKey &&
            e.detail === 2
          ) {
            const host = editorAreaRef.current || e.currentTarget;
            const rect = host.getBoundingClientRect();
            setQuickInput({
              open: true,
              x: e.clientX - rect.left,
              y: e.clientY - rect.top,
              svgX: m.x,
              svgY: m.y,
              value: '',
            });
          }

          actionRef.current = null;
          selectingRef.current = false;
          rotuloDragRef.current = null;

          /** desbloqueia movimento da imagem */
          setZoomCanMove(true);
        }
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [
        ACTION_STATE,
        oMousePosSVG,
        oClearSelector,
        oCheckConflict,
        oCriarLinkArea,
        oAvancarSequencia,
        oReancorarChamada,
        isAlvoLink,
        oRegistrarHistorico,
      ]
    );

    const handleRemove = useCallback(() => {
      try {
        /** percorre elementos selecionados */
        selectedRef.current.forEach((s) => {
          /** remove elemento do mapeamento ORC */
          const mappingORCIndex = ocrMappingRef.current.findIndex(
            (m) => m.attr.id === s.node.id
          );

          if (mappingORCIndex !== -1)
            ocrMappingRef.current.splice(mappingORCIndex, 1);

          /** remove elemento do mapeamento principal */
          const mappingIndex = linkMappingRef.current.findIndex(
            (m) => m.id === s.node.id
          );

          if (mappingIndex !== -1)
            linkMappingRef.current.splice(mappingIndex, 1);

          /** verifica o nível para eliminar o elemento pai */
          oRemove(s.node).remove();
        });

        /** verifica associações */
        oCheckAssociation();

        /** verifica conflito */
        oCheckConflict();

        /** registra no histórico de desfazer/refazer */
        oRegistrarHistorico();

        oClearSelection();
      } catch (err) {
        /** erro */
        toast.error(`Ops! Ocorreu um problema. ${err}`);
      }
    }, [
      selectedRef,
      ocrMappingRef,
      oRemove,
      oCheckAssociation,
      oCheckConflict,
      oClearSelection,
    ]);

    const handlePosition = useCallback(
      (x, y) => {
        const { baseVal } = rootRef.current.transform;
        const baseIndex = Array.from(baseVal).findIndex((e) => e.type === 1);

        let transformMatrix = null;
        if (baseIndex >= 0) {
          const { matrix } = baseVal.getItem(baseIndex);
          transformMatrix = matrix;
        }

        if (!transformMatrix)
          transformMatrix = svgRef.current.createSVGMatrix();

        // matrix translate
        transformMatrix.e = rootXRef.current + x;
        transformMatrix.f = rootYRef.current + y;

        rootXRef.current += x;
        rootYRef.current += y;

        const transform = baseVal.createSVGTransformFromMatrix(transformMatrix);
        baseVal.clear();
        baseVal.appendItem(transform);
      },
      [rootRef, svgRef, rootXRef, rootYRef]
    );

    /**
     * ===================================================================
     * CENTRALIZAÇÃO DO DESENHO
     * -------------------------------------------------------------------
     * A conta anterior misturava duas unidades: media svg e root com
     * getBoundingClientRect() (PIXELS DE TELA) e gravava o resultado na
     * translação da matriz do <g> (UNIDADES DO viewBox). Enquanto o <svg>
     * tinha exatamente o tamanho do viewBox em pixels, 1 unidade valia
     * 1 pixel e o erro não aparecia. Com o desenho ocupando toda a área
     * (fluido, escalado pelo viewBox) a razão deixa de ser 1 e o desenho
     * ia parar fora do lugar — foi o que produziu a imagem pequena e
     * jogada no canto.
     *
     * Agora a conta é feita inteira em unidades do viewBox:
     *   - o tamanho da área vem de svg.viewBox.baseVal
     *   - o tamanho e a origem do conteúdo vêm de root.getBBox(), que
     *     ignora a transformação do próprio <g>
     *   - a escala atual do <g> entra na conta
     * ===================================================================
     */
    const handleCenter = useCallback(
      (initial = false) => {
        if (!svgRef.current || !rootRef.current) return;

        const { baseVal } = rootRef.current.transform;
        const baseIndex = Array.from(baseVal).findIndex((e) => e.type === 1);

        let transformMatrix = null;
        if (baseIndex >= 0) {
          if (initial) return;

          const { matrix } = baseVal.getItem(baseIndex);
          transformMatrix = matrix;
        }

        if (!transformMatrix)
          transformMatrix = svgRef.current.createSVGMatrix();

        /** área útil em unidades do viewBox */
        const caixaVisao =
          svgRef.current.viewBox && svgRef.current.viewBox.baseVal;

        const areaLargura =
          caixaVisao && caixaVisao.width
            ? caixaVisao.width
            : Number(svgRef.current.getAttribute('width')) || 0;

        const areaAltura =
          caixaVisao && caixaVisao.height
            ? caixaVisao.height
            : Number(svgRef.current.getAttribute('height')) || 0;

        if (!areaLargura || !areaAltura) return;

        /** conteúdo em unidades próprias, antes da transformação do <g> */
        let conteudo = null;
        try {
          conteudo = rootRef.current.getBBox();
        } catch (err) {
          /** SVG ainda sem geometria renderizada */
          return;
        }

        if (!conteudo || !conteudo.width || !conteudo.height) return;

        const escala = transformMatrix.a || rootScaleRef.current || 1;

        const x =
          (areaLargura - conteudo.width * escala) / 2 - conteudo.x * escala;
        const y =
          (areaAltura - conteudo.height * escala) / 2 - conteudo.y * escala;

        // translate
        transformMatrix.e = x;
        transformMatrix.f = y;

        rootXRef.current = x;
        rootYRef.current = y;

        const transform = baseVal.createSVGTransformFromMatrix(transformMatrix);
        baseVal.clear();
        baseVal.appendItem(transform);
      },
      [svgRef, rootRef]
    );

    /**
     * ===================================================================
     * ENQUADRAR: O DESENHO OCUPANDO TODA A ÁREA, CENTRALIZADO
     * -------------------------------------------------------------------
     * Três coisas somadas, e é isso que o usuário espera do botão
     * "Centralizar":
     *
     *   1. centralizar o conteúdo dentro do viewBox (handleCenter);
     *   2. zerar o pan/zoom acumulado da roda do mouse;
     *   3. dar zoom para o desenho preencher a área.
     *
     * O passo 3 é indispensável: os SVGs de página trazem uma escala
     * própria na transformação do <g> raiz (algo como
     * matrix(.6 0 0 .6 ...)), então o desenho renderiza bem menor que o
     * viewBox e sobrava área vazia mesmo depois de centralizar.
     *
     * IMPORTANTE: o zoom é aplicado na CAMADA DE VISUALIZAÇÃO
     * (react-zoom-pan-pinch, um transform CSS na div que envolve o SVG),
     * nunca na geometria do arquivo. Assim o enquadramento não altera
     * nada do que é serializado em handleConfirmar — nem o desenho, nem a
     * posição dos links, nem o que a Home vai renderizar depois.
     * ===================================================================
     */
    const handleEnquadrar = useCallback(() => {
      /** 1. centraliza o conteúdo dentro do viewBox */
      handleCenter();

      const api = zoomApiRef.current;
      const areaEl = editorAreaRef.current;
      const rootEl = rootRef.current;

      if (!api || !api.setTransform || !areaEl || !rootEl) return;

      /** 2. volta ao estado neutro para medir sem transformação acumulada */
      api.resetTransform(0);

      /**
       * A medição precisa acontecer depois de o navegador aplicar o
       * reset; dois quadros garantem isso sem depender de detalhe
       * interno da biblioteca.
       */
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          if (!editorAreaRef.current || !rootRef.current) return;

          const area = editorAreaRef.current.getBoundingClientRect();
          const conteudo = rootRef.current.getBoundingClientRect();

          if (
            !area.width ||
            !area.height ||
            !conteudo.width ||
            !conteudo.height
          ) {
            return;
          }

          /** 3. escala que faz o desenho preencher a área */
          let fator =
            Math.min(
              area.width / conteudo.width,
              area.height / conteudo.height
            ) * MARGEM_ENQUADRAR;

          fator = Math.max(ZOOM_MIN, Math.min(ZOOM_MAX, fator));

          /** centro do desenho em coordenadas da área, no estado neutro */
          const centroX = conteudo.left + conteudo.width / 2 - area.left;
          const centroY = conteudo.top + conteudo.height / 2 - area.top;

          /** leva esse centro para o centro da área, já na escala nova */
          const x = area.width / 2 - centroX * fator;
          const y = area.height / 2 - centroY * fator;

          api.setTransform(x, y, fator, 200, 'easeOut');
        });
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [handleCenter]);

    const handleLandscape = useCallback(() => {
      const width = 874;
      const height = 614;
      const viewBox = `0 0 ${width} ${height}`;

      svgRef.current.setAttribute('width', width);
      svgRef.current.setAttribute('height', height);
      svgRef.current.setAttribute('viewBox', viewBox);
      svgRef.current.setAttribute('data-guid', 'landscape');

      /** centraliza automaticamente */
      if (pdfTool) {
        handleCenterPdfProcess();
      } else {
        handleCenter();
      }
    }, [handleCenter, handleCenterPdfProcess, pdfTool]);

    const handlePortrait = useCallback(() => {
      const width = 614;
      const height = 874;
      const viewBox = `0 0 ${width} ${height}`;

      svgRef.current.setAttribute('width', width);
      svgRef.current.setAttribute('height', height);
      svgRef.current.setAttribute('viewBox', viewBox);
      svgRef.current.setAttribute('data-guid', 'portrait');

      /** centraliza automaticamente */
      if (pdfTool) {
        handleCenterPdfProcess();
      } else {
        handleCenter();
      }
    }, [handleCenter, handleCenterPdfProcess, pdfTool]);

    const handleScale = useCallback(
      (value) => {
        const { baseVal } = rootRef.current.transform;
        const baseIndex = Array.from(baseVal).findIndex((e) => e.type === 1);

        let transformMatrix = null;
        if (baseIndex >= 0) {
          const { matrix } = baseVal.getItem(baseIndex);
          transformMatrix = matrix;
        }

        if (!transformMatrix)
          transformMatrix = svgRef.current.createSVGMatrix();

        // matrix scale
        transformMatrix.a = rootScaleRef.current + value;
        transformMatrix.d = rootScaleRef.current + value;

        rootScaleRef.current += value;

        const transform = baseVal.createSVGTransformFromMatrix(transformMatrix);
        baseVal.clear();
        baseVal.appendItem(transform);

        /** centraliza automaticamente */
        handleCenter();
      },
      [rootRef, svgRef, rootScaleRef, handleCenter]
    );

    const handleResize = useCallback(() => {
      const currentGuid = svgRef.current.getAttribute('data-guid');
      const currentWidth = svgRef.current.getAttribute('width');
      const currentHeight = svgRef.current.getAttribute('height');

      const width = currentGuid ? currentWidth : 614;
      const height = currentGuid ? currentHeight : 874;
      const dataGuid = currentGuid || 'portrait';

      const viewBox = `0 0 ${width} ${height}`;

      svgRef.current.setAttribute('width', width);
      svgRef.current.setAttribute('height', height);
      svgRef.current.setAttribute('viewBox', viewBox);
      svgRef.current.setAttribute('data-guid', dataGuid);

      /**
       * Garante o ajuste "caber e centralizar". É o padrão do SVG, mas
       * alguns arquivos convertidos trazem preserveAspectRatio="none",
       * que com width/height em 100% distorceria o desenho.
       */
      svgRef.current.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    }, []);

    /** define o tamanho do item para o valor passado */
    const handleLinkScale = useCallback(
      (valueH, valueW, link) => {
        /** define os elementos de texto e formato do item */
        const linkForm = link.childNodes[0];
        const linkText = link.childNodes[1];

        const { id: tipo = null } = linkForm.dataset || {};

        switch (Number(tipo)) {
          case LINK_FORM_TYPES.circle: {
            /** validação */
            const newSize = Number(valueH);
            const dh = newSize - Number(linkForm.getAttribute('r'));
            const xF = Number(linkForm.getAttribute('cx'));
            const yF = Number(linkForm.getAttribute('cy'));

            linkForm.setAttribute('r', newSize);
            linkForm.setAttribute('x', xF - dh / 2);
            linkForm.setAttribute('y', yF - dh / 2);

            /** com o rótulo "nenhum" o link não tem <text> */
            if (linkText) linkText.setAttribute('font-size', `${newSize}px`);
            break;
          }
          case LINK_FORM_TYPES.rect: {
            const newSizeH = Number(valueH);
            const newSizeW = Number(valueW) || 0;

            const currWidth = Number(linkForm.getAttribute('width'));
            const currHeight = Number(linkForm.getAttribute('height'));

            const dh = currHeight - newSizeH;
            const dw = currWidth - newSizeW;
            const xF = Number(linkForm.getAttribute('x'));
            const yF = Number(linkForm.getAttribute('y'));

            linkForm.setAttribute('height', newSizeH);
            linkForm.setAttribute('width', newSizeW);

            linkForm.setAttribute('x', xF + dw / 2);
            linkForm.setAttribute('y', yF + dh / 2);

            /** atualiza tamanho do texto */
            if (linkText) {
              linkText.setAttribute(
                'font-size',
                `${Math.trunc(newSizeH / 2)}px`
              );
            }

            break;
          }
          /**
           * Área: redimensiona mantendo o centro. O rótulo é reposicionado
           * conforme o tipo: o código acompanha o centro da área e a
           * etiqueta permanece onde o usuário deixou, apenas com a linha de
           * chamada reancorada.
           */
          case LINK_FORM_TYPES.area: {
            const limite = LINK_AREA_SIZE_LIMIT;

            const novaH = Math.max(
              limite.min,
              Math.min(limite.max, Number(valueH) || 0)
            );
            const novaW = Math.max(
              limite.min,
              Math.min(limite.max, Number(valueW) || Number(valueH) || 0)
            );

            const currW = Number(linkForm.getAttribute('width'));
            const currH = Number(linkForm.getAttribute('height'));
            const xF = Number(linkForm.getAttribute('x'));
            const yF = Number(linkForm.getAttribute('y'));

            linkForm.setAttribute('width', novaW);
            linkForm.setAttribute('height', novaH);
            linkForm.setAttribute('x', xF + (currW - novaW) / 2);
            linkForm.setAttribute('y', yF + (currH - novaH) / 2);

            const rotuloAtual =
              (link.dataset && link.dataset.rotulo) || opLinkRotulo.CODIGO;

            if (rotuloAtual === opLinkRotulo.CODIGO && linkText) {
              const caixa = getCaixaForma(linkForm);
              linkText.setAttribute('x', caixa.x + caixa.width / 2);
              linkText.setAttribute('y', caixa.y + caixa.height / 2);
            }

            if (rotuloAtual === opLinkRotulo.ETIQUETA) {
              oReancorarChamada(link);
            }

            break;
          }
          case LINK_FORM_TYPES.ocr:
            break;
          default:
            break;
        }

        /** verifica conflito */
        oCheckConflict();
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [LINK_FORM_TYPES, oCheckConflict, oReancorarChamada]
    );

    const handleLink = useCallback(() => {
      const uniq = uniqBy(table, 'idItem');
      uniq.forEach((item) => {
        oLink(item);
      });
      handleOCRLimpar();

      /** registra no histórico de desfazer/refazer */
      oRegistrarHistorico();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [table, oLink, handleOCRLimpar]);

    const handleRotate = useCallback((value) => {
      const { baseVal } = rootRef.current.transform;
      const i = Array.from(baseVal).findIndex((e) => e.type === 4);
      let rotate;

      if (i > 0) {
        rotate = baseVal.getItem(i);
      } else {
        rotate = svgRef.current.createSVGTransform();
        baseVal.appendItem(rotate);
      }

      rootRotateRef.current += value;
      if (rootRotateRef.current >= 360 || rootRotateRef.current < 0)
        rootRotateRef.current = 0;

      rotate.setRotate(
        rootRotateRef.current,
        rootXRef.current,
        rootYRef.current
      );
    }, []);

    /**
     * Nudge: move os links selecionados em passos finos.
     *
     * As setas sem modificador passam a mover a SELEÇÃO; Shift+setas
     * continua movendo a página inteira, como antes.
     */
    const handleNudgeSelecao = useCallback(
      (dx, dy) => {
        if (!selectedRef.current.length) return false;

        selectedRef.current.forEach((element) => {
          transladarLink(element.node, dx, dy);

          const rotuloAtual =
            (element.node.dataset && element.node.dataset.rotulo) ||
            opLinkRotulo.CODIGO;

          if (rotuloAtual === opLinkRotulo.ETIQUETA) {
            oReancorarChamada(element.node);
          }
        });

        oCheckConflict();
        oRegistrarHistorico();

        return true;
      },
      [oCheckConflict, oRegistrarHistorico, oReancorarChamada]
    );

    /** rótulos legíveis das opções de rótulo, usados nos títulos dos botões */
    const LABEL_ROTULO = {
      [opLinkRotulo.CODIGO]: 'código dentro da forma',
      [opLinkRotulo.NENHUM]: 'sem rótulo',
      [opLinkRotulo.ETIQUETA]: 'etiqueta com linha de chamada',
    };

    /** alterna ciclicamente entre os três tipos de rótulo */
    const handleAlternarRotulo = useCallback(() => {
      const ordem = [
        opLinkRotulo.CODIGO,
        opLinkRotulo.NENHUM,
        opLinkRotulo.ETIQUETA,
      ];

      setCurrLinkRotulo((atual) => {
        const proximo = ordem[(ordem.indexOf(atual) + 1) % ordem.length];
        currLinkRotuloRef.current = proximo;
        return proximo;
      });
    }, []);

    /**
     * Liga/desliga o modo sequência. Ao ligar, seleciona automaticamente a
     * geometria de área e o primeiro item pendente; ao desligar, devolve o
     * pan da imagem.
     */
    const handleAlternarModoSequencia = useCallback(() => {
      setModoSequencia((atual) => {
        const proximo = !atual;
        modoSequenciaRef.current = proximo;

        if (proximo) {
          currLinkTypeRef.current = INITIAL_LINK_AREA;
          setCurrLinkType(LINK_FORM_TYPES.area);
          oAvancarSequencia();
        } else {
          itemSequenciaRef.current = null;
          setItemSequencia(null);
          setZoomCanMove(true);
        }

        return proximo;
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [oAvancarSequencia]);

    /** seleciona manualmente o item alvo da sequência */
    const handleSelecionarItemSequencia = useCallback((item) => {
      itemSequenciaRef.current = item || null;
      setItemSequencia(item || null);
    }, []);

    /**
     * ===================================================================
     * MODOS ALTERNADOS POR ATALHO
     * -------------------------------------------------------------------
     * Antes o Alt+Z e o Alt+S existiam SOMENTE como atalho, cada um com
     * "setTimeout(..., 200)" dentro do handler de teclado. Com a tecla
     * repetindo (keydown dispara em série enquanto pressionada), vários
     * timers eram enfileirados, cada um invertendo o estado — o painel
     * piscava e terminava aberto ou fechado de forma imprevisível.
     *
     * Agora a alternância está em um handler único, imediato e sem timer,
     * usado tanto pelo atalho quanto por um botão na barra de ferramentas.
     * ===================================================================
     */

    /** Alt+Z: liga/desliga o modo de zoom da página */
    const handleAlternarZoom = useCallback(() => {
      const proximo = !zoomControlRef.current;

      /** ao SAIR do modo, devolve a página à escala/posição original */
      if (!proximo && zoomResetRef.current && zoomResetRef.current.click) {
        zoomResetRef.current.click();
      }

      zoomControlRef.current = proximo;
      setZoomControl(proximo);

      return proximo;
    }, []);

    /** Alt+S: liga/desliga a edição de tamanho (H/W) dos links */
    const handleAlternarTamanho = useCallback(() => {
      const proximo = !sizeControlRef.current;

      sizeControlRef.current = proximo;
      setSizeControl(proximo);

      return proximo;
    }, []);

    /** legenda de atalhos: botão "?" da barra e teclas "?" / F1 */
    const handleAlternarAtalhos = useCallback(() => {
      const proximo = !atalhosAbertoRef.current;

      atalhosAbertoRef.current = proximo;
      setAtalhosAberto(proximo);

      return proximo;
    }, []);

    /**
     * Remoção dos links selecionados.
     *
     * Usada pelo Del/Backspace e pelo botão da barra. O handleRemove cru
     * não dá retorno visual nenhum: sem seleção ele apenas não faz nada,
     * e o usuário não sabia se o atalho existia ou se havia falhado. Aqui
     * o resultado é sempre informado.
     */
    const handleRemoverSelecao = useCallback(() => {
      const total =
        selectedRef.current && selectedRef.current.length
          ? selectedRef.current.length
          : 0;

      if (!total) {
        toast.info('Selecione um link no desenho para remover.');
        return false;
      }

      handleRemove();

      toast.success(
        total === 1 ? 'Link removido.' : `${total} links removidos.`
      );

      return true;
    }, [handleRemove]);

    /**
     * ===================================================================
     * ATALHOS DE TECLADO
     * -------------------------------------------------------------------
     * Regras aplicadas:
     *
     * 1. O preventDefault NÃO é mais aplicado a toda e qualquer tecla.
     *    Antes, com o desenho em foco, o navegador perdia F5, Ctrl+C e o
     *    próprio Tab. Agora só a tecla efetivamente tratada é consumida.
     *
     * 2. Alt "puro": em teclado ABNT2 o AltGr chega como Ctrl+Alt. Sem a
     *    checagem de !ctrlKey, combinações de AltGr disparavam os modos
     *    por engano.
     *
     * 3. e.repeat é ignorado nos comandos que alternam estado, para a
     *    tecla presa não inverter o modo várias vezes.
     * ===================================================================
     */
    const handleKeyDown = useCallback(
      (e) => {
        /** consome a tecla apenas quando o atalho é realmente tratado */
        const tratado = () => {
          e.preventDefault();
          e.stopPropagation();
        };

        /** Alt sem Ctrl e sem Shift (AltGr do ABNT2 vem como Ctrl+Alt) */
        const somenteAlt = e.altKey && !e.ctrlKey && !e.shiftKey;

        /** legenda: "?" independe do layout do teclado; F1 é o atalho usual */
        if (e.key === '?' || e.keyCode === 112) {
          tratado();
          if (!e.repeat) handleAlternarAtalhos();
          return;
        }

        if (svgRef.current) {
          switch (e.keyCode) {
            /** 17: ctrl */
            case 17:
              break;
            /** 16: shift */
            case 16:
              break;
            /** 18: alt */
            case 18:
              break;
            /**
             * 46: delete | 8: backspace.
             * O Backspace passa a valer porque é a tecla que o usuário
             * tenta naturalmente; sem tratá-la o navegador ainda podia
             * interpretar como "voltar página".
             */
            case 46:
            case 8:
              tratado();
              handleRemoverSelecao();
              break;
            /**
             * 27: esc.
             *
             * Ordem de prioridade: legenda aberta > seleção. Com a legenda
             * aberta o evento é consumido (só ela fecha). Sem legenda, a
             * seleção é limpa e o evento SEGUE subindo de propósito, para
             * a tela poder sair do modo tela cheia no mesmo Esc (ver o
             * listener de window em pages/EditorAI).
             */
            case 27:
              if (atalhosAbertoRef.current) {
                tratado();
                handleAlternarAtalhos();
              } else {
                e.preventDefault();
                oClearSelection();
              }
              break;
            /**
             * 37,38,39,40: setas.
             * Shift+seta continua movendo a PÁGINA (comportamento antigo).
             * Seta sozinha faz o ajuste fino do(s) link(s) selecionado(s);
             * Ctrl+seta usa passo maior. Sem seleção, nada acontece.
             */
            case 37:
              tratado();
              if (e.shiftKey) handlePosition(-10, 0);
              else handleNudgeSelecao(e.ctrlKey ? -5 : -1, 0);
              break;
            case 38:
              tratado();
              if (e.shiftKey) handlePosition(0, -10);
              else handleNudgeSelecao(0, e.ctrlKey ? -5 : -1);
              break;
            case 39:
              tratado();
              if (e.shiftKey) handlePosition(10, 0);
              else handleNudgeSelecao(e.ctrlKey ? 5 : 1, 0);
              break;
            case 40:
              tratado();
              if (e.shiftKey) handlePosition(0, 10);
              else handleNudgeSelecao(0, e.ctrlKey ? 5 : 1);
              break;
            case 83:
              /** Alt+S: edição de tamanho do link */
              if (somenteAlt) {
                tratado();
                if (!e.repeat) handleAlternarTamanho();
              }
              break;
            case 90:
              /** Alt+Z: modo de zoom da página */
              if (somenteAlt) {
                tratado();
                if (!e.repeat) handleAlternarZoom();
              }
              /** Ctrl+Z: desfazer / Ctrl+Shift+Z: refazer */
              if (e.ctrlKey && !e.altKey) {
                tratado();
                if (e.shiftKey) handleRefazer();
                else handleDesfazer();
              }
              break;
            case 89:
              /** Ctrl+Y: refazer */
              if (e.ctrlKey && !e.altKey) {
                tratado();
                handleRefazer();
              }
              break;
            case 65:
              /** Alt+A: liga/desliga o modo sequência */
              if (somenteAlt) {
                tratado();
                if (!e.repeat) handleAlternarModoSequencia();
              }
              break;
            case 187:
              /** Shift+'=' */
              if (e.shiftKey) {
                tratado();
                handleScale(0.1);
              }
              break;
            case 189:
              /** Shift+'-' */
              if (e.shiftKey) {
                tratado();
                handleScale(-0.1);
              }
              break;
            default:
              break;
          }
        }
      },
      [
        handlePosition,
        handleScale,
        handleRemoverSelecao,
        handleNudgeSelecao,
        handleDesfazer,
        handleRefazer,
        handleAlternarModoSequencia,
        handleAlternarZoom,
        handleAlternarTamanho,
        handleAlternarAtalhos,
        oClearSelection,
      ]
    );

    /** limpa referências de controles */
    const handleKeyUp = useCallback(() => {
      if (svgRef.current) {
        selectingRef.current = false;

        if (actionRef.current) {
          actionRef.current = null;
        }

        if (controlRef.current) {
          controlRef.current = null;
        }
      }
    }, [svgRef, actionRef]);

    /**
     * ===================================================================
     * TECLADO: HANDLER SEMPRE ATUAL
     * -------------------------------------------------------------------
     * O elemento <SVG> é memoizado por [editor.pageNum, editor.path] (ver
     * editorSvg mais abaixo). Como consequência, o onKeyDown/onKeyUp
     * fixado no DOM é o da renderização em que a página foi carregada —
     * um fechamento CONGELADO.
     *
     * Era a causa de o Alt+Z não devolver a escala da página: o handler
     * antigo lia um zoomControl que nunca mudava. Todo handler novo
     * dependente de estado sofreria do mesmo problema.
     *
     * A indireção abaixo mantém a identidade estável para o useMemo (o
     * SVG não é reinjetado a cada tecla) e ainda assim executa sempre a
     * versão mais recente do handler.
     * ===================================================================
     */
    const keyDownRef = useRef(handleKeyDown);
    const keyUpRef = useRef(handleKeyUp);

    keyDownRef.current = handleKeyDown;
    keyUpRef.current = handleKeyUp;

    const onKeyDownEstavel = useCallback((e) => {
      if (keyDownRef.current) keyDownRef.current(e);
    }, []);

    const onKeyUpEstavel = useCallback((e) => {
      if (keyUpRef.current) keyUpRef.current(e);
    }, []);

    const handleControlClose = useCallback(
      (control) => {
        switch (control) {
          case 'zoomAnimControl':
            if (zoomControl && zoomResetRef.current) {
              zoomResetRef.current.click();
              setTimeout(() => setZoomControl((state) => !state), 200);
            }
            break;
          case 'sizeAnimControl':
            if (sizeControl) {
              setTimeout(() => setSizeControl((state) => !state), 200);
            }
            break;
          case 'all':
            if (zoomControl && zoomResetRef.current) {
              zoomResetRef.current.click();
              setTimeout(() => setZoomControl((state) => !state), 200);
            }
            if (sizeControl) {
              setTimeout(() => setSizeControl((state) => !state), 200);
            }
            break;
          default:
            break;
        }
      },
      [zoomControl, sizeControl]
    );

    const handleSizeEdit = useCallback(
      (valueH, valueW = 0, incremental = true) => {
        /** controle de alteração de tamanho */
        let newSizeH = 0;
        let newSizeW = 0;

        /** contagem de links alterados */
        let count = 0;

        /** verifica existencia de grupo de seleção */
        const selection = !!(selectedRef && selectedRef.current.length);

        /** altera o tamanho de todos os links conforme necessário */
        linkMappingRef.current.forEach((link) => {
          const isSelected = link.getAttribute('class')
            ? link.getAttribute('class').indexOf('selected') !== -1
            : false;

          /** não altera o tamanho se houver um grupo de seleção e este item não estiver selecionado */
          if (selection && !isSelected) return;

          /** altera apenas os tipos selecionados por padrão */
          if (
            !selection &&
            Number(link.childNodes[0].dataset.id) !== currLinkType
          )
            return;

          /** pega valor do atributo para incremental */
          switch (Number(link.childNodes[0].dataset.id)) {
            case LINK_FORM_TYPES.circle:
              newSizeH = valueH;
              newSizeW = 0;

              /** verifica se o processo é incremental */
              if (incremental)
                newSizeH += Number(link.childNodes[0].getAttribute('r'));

              /** validação */
              if (newSizeH < LINK_SIZE_LIMIT.min)
                newSizeH = LINK_SIZE_LIMIT.min;
              if (newSizeH > LINK_SIZE_LIMIT.max)
                newSizeH = LINK_SIZE_LIMIT.max;

              break;
            case LINK_FORM_TYPES.rect:
              newSizeH = valueH;
              newSizeW = valueW;

              /** atribui mesmo valor de "valueH" + "width" pois no processo incremental não preenche "valueW" */
              if (incremental) {
                const currSizeH = Number(
                  link.childNodes[0].getAttribute('height')
                );
                const currSizeW = Number(
                  link.childNodes[0].getAttribute('width')
                );

                newSizeH += currSizeH;
                newSizeW += currSizeW + valueH;

                /** proporcionalidade com o raio do circulo para situação incremental */
                if (newSizeH < currSizeH) newSizeH -= 1;
                if (newSizeW < currSizeW) newSizeW -= 1;

                if (newSizeH > currSizeH) newSizeH += 1;
                if (newSizeW > currSizeW) newSizeW += 1;
              }

              /** validação  */
              if (Math.trunc(newSizeH / 2) < LINK_SIZE_LIMIT.min) {
                newSizeH = LINK_SIZE_LIMIT.min * 2;
                newSizeW = LINK_SIZE_LIMIT.min * 2;
              }

              if (Math.trunc(newSizeH / 2) > LINK_SIZE_LIMIT.max) {
                newSizeH = LINK_SIZE_LIMIT.max * 2;
              }

              if (Math.trunc(newSizeW / 2) < LINK_SIZE_LIMIT.min)
                newSizeW = newSizeH;

              /** validação de comprimento somente para situação incremental */
              if (Math.trunc(newSizeW / 2) > LINK_SIZE_LIMIT.max) {
                if (incremental) newSizeW = newSizeH;
              }

              break;
            /** área: incremento simétrico em altura e largura */
            case LINK_FORM_TYPES.area: {
              const currH = Number(link.childNodes[0].getAttribute('height'));
              const currW = Number(link.childNodes[0].getAttribute('width'));

              newSizeH = incremental ? currH + Number(valueH) : Number(valueH);
              newSizeW = incremental
                ? currW + Number(valueH)
                : Number(valueW) || Number(valueH);

              newSizeH = Math.max(
                LINK_AREA_SIZE_LIMIT.min,
                Math.min(LINK_AREA_SIZE_LIMIT.max, newSizeH)
              );
              newSizeW = Math.max(
                LINK_AREA_SIZE_LIMIT.min,
                Math.min(LINK_AREA_SIZE_LIMIT.max, newSizeW)
              );
              break;
            }
            default:
              break;
          }

          count += 1;

          handleLinkScale(newSizeH, newSizeW, link, incremental);
        });

        if (!selection && count === linkMappingRef.current.length)
          oChangeDefLinkSize(newSizeH, newSizeW, true);

        /** registra no histórico de desfazer/refazer */
        if (count > 0) oRegistrarHistorico();
      },
      [
        LINK_FORM_TYPES,
        LINK_SIZE_LIMIT,
        currLinkType,
        handleLinkScale,
        oChangeDefLinkSize,
        oRegistrarHistorico,
      ]
    );

    const handleConfirmar = useCallback(async () => {
      const { situacao } = catalogo;

      const confirmacao =
        situacao === opPaginaCatalogoSituacao.CONCLUIDO
          ? window.confirm(
              'Ao confirmar as alterações será necessário republicar o catálogo, deseja continuar?'
            )
          : true;

      if (confirmacao) {
        /** limpa biblioteca de localização OCR antes de salvar */
        handleOCRLimpar();

        /**
         * Remove o retângulo temporário do arraste de área. Ele é auxiliar
         * de edição e não deve ir para o arquivo salvo.
         */
        if (areaDraftRef.current) {
          areaDraftRef.current.remove();
          areaDraftRef.current = null;
        }

        /** carrega o arquivo editado */
        const blob = new Blob([svgRef.current.outerHTML], {
          type: 'image/svg+xml',
        });
        /** fecha controles do editor */
        handleControlClose('all');

        onSave({ svg: blob });
      }
    }, [catalogo, onSave, handleOCRLimpar, handleControlClose]);

    const handleCancelar = useCallback(() => {
      if (window.confirm('Deseja realmente cancelar as alterações?')) {
        setEditor(INITIAL_STATE);
        /** limpa biblioteca de localização OCR */
        handleOCRLimpar();
        /** fecha controles do editor */
        handleControlClose('all');
        setPdfTool(false);
        onCancel();
      }
    }, [INITIAL_STATE, onCancel, handleOCRLimpar, handleControlClose]);

    const loadAutoOCR = useCallback(
      async (idCatalogo, idPagina) => {
        // garante que já temos SVG/root
        if (!rootRef.current || !svgRef.current) return;

        // evita rodar duas vezes para a mesma página
        if (pagRef.current === idPagina) return;
        pagRef.current = idPagina;

        if (onBeforeOCR) {
          onBeforeOCR();
        }

        try {
          // limpa OCR anterior
          handleOCRLimpar();

          // cria o grupo OCR
          const ocrMapper = document.createElementNS(
            rootRef.current.namespaceURI,
            'g'
          );
          ocrMapper.setAttribute('id', 'ocrGroup');
          rootRef.current.appendChild(ocrMapper);
          ocrMapperRef.current = ocrMapper;

          // chama API
          const { data } = await api.get(
            `/editor-associar-autom/${idCatalogo}/pagina/${idPagina}`
          );

          // desenha overlays
          data.forEach((pt, index) => {
            const link = document.createElementNS(
              svgRef.current.namespaceURI,
              'a'
            );
            link.id = String(index);
            // link.setAttribute('x', pt.x);
            link.setAttribute('x', pt.x + 10);
            link.setAttribute('y', pt.y + 5);
            // link.setAttribute('y', pt.y);
            link.setAttribute('class', '');
            link.addEventListener('click', (e) => e.preventDefault());
            ocrMapperRef.current.appendChild(link);

            const linkForm = document.createElementNS(
              svgRef.current.namespaceURI,
              'rect'
            );

            const linkText = document.createElementNS(
              svgRef.current.namespaceURI,
              'text'
            );

            const linkFormWidth = pt.text.length * 6;

            linkForm.setAttribute('x', pt.x);
            // linkForm.setAttribute('x', pt.x);
            linkForm.setAttribute('y', pt.y - 3);
            // linkForm.setAttribute('y', pt.y);
            linkForm.setAttribute('height', '10');
            linkForm.setAttribute('width', `${linkFormWidth}`);
            linkForm.setAttribute(
              'class',
              pt.conf > 0.9 ? 'success' : 'warning'
            );
            linkForm.setAttribute('data-id', LINK_FORM_TYPES.ocr);
            link.appendChild(linkForm);

            linkText.setAttribute('x', pt.x + 5);
            linkText.setAttribute('y', pt.y + 5);
            linkText.setAttribute('font-size', '10');
            linkText.setAttribute(
              'class',
              pt.conf > 0.9 ? 'success' : 'warning'
            );
            linkText.textContent = pt.text;
            link.appendChild(linkText);

            ocrMappingRef.current.push({ attr: link, ocr: pt });
          });
        } catch (err) {
          toast.error(err);
        } finally {
          if (onAfterOCR) {
            onAfterOCR();
          }
        }
      },
      [onBeforeOCR, onAfterOCR, handleOCRLimpar]
    );

    const editorSvg = useMemo(
      () => (
        <SVG
          id={`page-${editor.pageNum}`}
          src={editor.path ? editor.path : ''}
          tabIndex="0"
          useRequestCache={false}
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onKeyDown={onKeyDownEstavel}
          onKeyUp={onKeyUpEstavel}
          loading={() => <span>Loading</span>}
          fallback={() => <span>Selecione a imagem para editar</span>}
          // beforeInjection={(svg) => {
          //   /** atribui component a variáveis */
          //   svgRef.current = svg;
          // }}
          // afterInjection={(err, svg) => {
          //   if (svg) {
          //     /** nó raiz */
          //     rootRef.current = Array.from(svg.childNodes).find(
          //       (e) => e.nodeName === 'svg:g'
          //     );
          //     /** limpa variáveis de alteração */
          //     rootXRef.current = 0;
          //     rootYRef.current = 0;
          //     rootScaleRef.current = 1;
          //     rootRotateRef.current = 0;

          //     /** cria o componente seletor e atribui ao SVG */
          //     const selector = document.createElementNS(
          //       rootRef.current.namespaceURI,
          //       'rect',
          //       rootRef.current
          //     );
          //     selector.setAttribute('id', 'selector');
          //     selector.setAttribute('stroke', '#ccc');
          //     selector.setAttribute('fill', 'rgba(0,0,0,.2)');
          //     rootRef.current.appendChild(selector);

          //     /** mapeamento dos elementos */
          //     linkMappingRef.current = [];
          //     mappingElement(svg.childNodes);

          //     /** verifica associações */
          //     oCheckAssociation();

          //     /** verifica conflitos */
          //     oCheckConflict();

          //     /** adicionar processo de arrastar e soltar no SVG */
          //     svg.ondragover = handleDragOverSVG;
          //     svg.ondrop = handleDropSVG;

          //     /** redimensiona automaticamente para o tamanho padrão */
          //     handleResize();

          //     selectorRef.current = selector;

          //     const { baseVal } = rootRef.current.transform;
          //     const baseIndex = Array.from(baseVal).findIndex(
          //       (e) => e.type === 1
          //     );

          //     if (baseIndex >= 0) {
          //       const { matrix } = baseVal.getItem(baseIndex);

          //       rootXRef.current = matrix.e;
          //       rootYRef.current = matrix.f;
          //       rootScaleRef.current = matrix.a;
          //       // rootRotateRef.current = 0;
          //     }

          //     /** centraliza automaticamente */
          //     handleCenter(true);
          //   }
          // }}
          beforeInjection={(svg) => {
            /** atribui component a variáveis */
            svgRef.current = svg;
            // NOVO: ainda não está pronto
            setSvgReady(false);
          }}
          afterInjection={(err, svg) => {
            if (svg) {
              /** nó raiz */
              rootRef.current = Array.from(svg.childNodes).find(
                (e) => e.nodeName === 'svg:g'
              );
              /** limpa variáveis de alteração */
              rootXRef.current = 0;
              rootYRef.current = 0;
              rootScaleRef.current = 1;
              rootRotateRef.current = 0;

              /** cria o componente seletor e atribui ao SVG */
              const selector = document.createElementNS(
                rootRef.current.namespaceURI,
                'rect',
                rootRef.current
              );
              selector.setAttribute('id', 'selector');
              selector.setAttribute('stroke', '#ccc');
              selector.setAttribute('fill', 'rgba(0,0,0,.2)');
              rootRef.current.appendChild(selector);

              /**
               * Retângulo temporário do arraste que desenha a área de um
               * novo link. É separado do "selector" (usado pelo Ctrl+arraste
               * do OCR) para os dois não interferirem, e é removido antes de
               * salvar em handleConfirmar.
               */
              areaDraftRef.current = null;
              oGetAreaDraft();

              /** mapeamento dos elementos */
              linkMappingRef.current = [];
              mappingElement(svg.childNodes);

              /** verifica associações */
              oCheckAssociation();

              /** verifica conflitos */
              oCheckConflict();

              /** estado inicial do histórico de desfazer/refazer */
              historicoRef.current = [];
              historicoPosRef.current = -1;
              oRegistrarHistorico();

              /** adicionar processo de arrastar e soltar no SVG */
              svg.ondragover = handleDragOverSVG;
              svg.ondrop = handleDropSVG;

              /** redimensiona automaticamente para o tamanho padrão */
              handleResize();

              selectorRef.current = selector;

              const { baseVal } = rootRef.current.transform;
              const baseIndex = Array.from(baseVal).findIndex(
                (e) => e.type === 1
              );

              if (baseIndex >= 0) {
                const { matrix } = baseVal.getItem(baseIndex);

                rootXRef.current = matrix.e;
                rootYRef.current = matrix.f;
                rootScaleRef.current = matrix.a;
                // rootRotateRef.current = 0;
              }

              /** centraliza automaticamente */
              handleCenter(true);

              /**
               * Enquadra depois que o navegador já mediu o SVG injetado.
               *
               * Sem isso o desenho abria pequeno e no canto: o
               * centerOnInit do TransformWrapper roda na montagem, quando
               * o SVG ainda não existe (o react-svg busca o arquivo em
               * seguida), então o pan é calculado sobre conteúdo de
               * tamanho zero. O timeout entrega o reset já com a
               * geometria real disponível.
               */
              setTimeout(() => {
                handleEnquadrar();
              }, 60);

              // 👇 NOVO: assim que o SVG da página estiver pronto, carrega o OCR automático
              if (catalogo?.idCatalogo && pagina?.idPagina) {
                loadAutoOCR(catalogo.idCatalogo, pagina.idPagina);
              }
            }
          }}
          // afterInjection={(err, svg) => {
          //   if (svg) {
          //     /** nó raiz */
          //     rootRef.current = Array.from(svg.childNodes).find(
          //       (e) => e.nodeName === 'svg:g'
          //     );
          //     /** limpa variáveis de alteração */
          //     rootXRef.current = 0;
          //     rootYRef.current = 0;
          //     rootScaleRef.current = 1;
          //     rootRotateRef.current = 0;

          //     /** cria o componente seletor e atribui ao SVG */
          //     const selector = document.createElementNS(
          //       rootRef.current.namespaceURI,
          //       'rect',
          //       rootRef.current
          //     );
          //     selector.setAttribute('id', 'selector');
          //     selector.setAttribute('stroke', '#ccc');
          //     selector.setAttribute('fill', 'rgba(0,0,0,.2)');
          //     rootRef.current.appendChild(selector);

          //     /** mapeamento dos elementos */
          //     linkMappingRef.current = [];
          //     mappingElement(svg.childNodes);

          //     /** verifica associações */
          //     oCheckAssociation();

          //     /** verifica conflitos */
          //     oCheckConflict();

          //     /** adicionar processo de arrastar e soltar no SVG */
          //     svg.ondragover = handleDragOverSVG;
          //     svg.ondrop = handleDropSVG;

          //     /** redimensiona automaticamente para o tamanho padrão */
          //     handleResize();

          //     selectorRef.current = selector;

          //     const { baseVal } = rootRef.current.transform;
          //     const baseIndex = Array.from(baseVal).findIndex(
          //       (e) => e.type === 1
          //     );

          //     if (baseIndex >= 0) {
          //       const { matrix } = baseVal.getItem(baseIndex);

          //       rootXRef.current = matrix.e;
          //       rootYRef.current = matrix.f;
          //       rootScaleRef.current = matrix.a;
          //       // rootRotateRef.current = 0;
          //     }

          //     /** centraliza automaticamente */
          //     handleCenter(true);

          //     // NOVO: agora o SVG está pronto pra receber o OCR automático
          //     setSvgReady(true);
          //   }
          // }}
        />
      ),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [
        editor.pageNum,
        editor.path,
        // handleDropSVG,
        // handleDragOverSVG,
        // handleKeyDown,
        // handleKeyUp,
        // handleMouseDown,
        // handleMouseMove,
        // handleMouseUp,
        // mappingElement,
      ]
    );

    return (
      <Container id="editor" onDragOver={handleDragOver}>
        {/**
         * Barra em uma única linha: nunca quebra, rola na horizontal.
         * As setas e os degradês aparecem só quando há conteúdo
         * escondido do lado correspondente.
         */}
        <ToolBarArea temEsq={barraEsq} temDir={barraDir}>
          {barraEsq && (
            <ToolBarArea.Nav
              type="button"
              title="Ver as ferramentas à esquerda"
              onClick={() => handleRolarBarra(-1)}
            >
              <MdKeyboardArrowLeft size={18} />
            </ToolBarArea.Nav>
          )}

          <ToolBar ref={barraRef}>
            <button title="Salvar" type="submit" onClick={handleConfirmar}>
              <MdDone size={16} />
            </button>
            <button type="button" title="Cancelar" onClick={handleCancelar}>
              <MdClose size={16} />
            </button>
            <button
              type="button"
              title="Remover link selecionado (Del)"
              onClick={handleRemoverSelecao}
            >
              <MdDelete size={16} />
            </button>
            <button type="button" title="Redimensionar" onClick={handleResize}>
              <MdCropFree size={16} />
            </button>
            {/**
             * Os modos de zoom e de tamanho do link existiam apenas por
             * atalho (Alt+Z / Alt+S), sem nenhuma indicação em tela. Os
             * botões abaixo usam os MESMOS handlers do teclado e mostram o
             * estado atual por aria-pressed.
             */}
            <button
              type="button"
              title="Modo zoom da página (Alt+Z)"
              aria-pressed={zoomControl}
              onClick={handleAlternarZoom}
              style={
                zoomControl
                  ? { color: opLinkEstilo.COR, fontWeight: 'bold' }
                  : undefined
              }
            >
              <MdZoomOutMap size={16} />
            </button>
            <button
              type="button"
              title="Editar tamanho do link (Alt+S)"
              aria-pressed={sizeControl}
              onClick={handleAlternarTamanho}
              style={
                sizeControl
                  ? { color: opLinkEstilo.COR, fontWeight: 'bold' }
                  : undefined
              }
            >
              <MdAspectRatio size={16} />
            </button>
            <button
              type="button"
              title="Centralizar e enquadrar o desenho na área"
              onClick={() =>
                pdfTool ? handleCenterPdfProcess() : handleEnquadrar()
              }
            >
              <MdCenterFocusStrong size={16} />
            </button>
            <button type="button" title="Horizontal" onClick={handleLandscape}>
              <MdStayPrimaryLandscape size={16} />
            </button>
            <button type="button" title="Vertical" onClick={handlePortrait}>
              <MdStayPrimaryPortrait size={16} />
            </button>
            <button
              type="button"
              title="Escala +"
              onClick={() =>
                pdfTool ? handleScalePdfProcess(0.1) : handleScale(0.1)
              }
            >
              <MdExposurePlus1 size={16} />
            </button>
            <button
              type="button"
              title="Escala -"
              onClick={() =>
                pdfTool ? handleScalePdfProcess(-0.1) : handleScale(-0.1)
              }
            >
              <MdExposureNeg1 size={16} />
            </button>
            <button
              type="button"
              title="Rotacionar"
              onClick={() => handleRotate(-45)}
            >
              <MdRotateLeft size={16} />
            </button>
            <button
              type="button"
              title="Rotacionar"
              onClick={() => handleRotate(45)}
            >
              <MdRotateRight size={16} />
            </button>
            <button
              type="button"
              title="Posiciona (Esquerda)"
              onClick={() =>
                pdfTool
                  ? handlePositionPdfProcess(-10, 0)
                  : handlePosition(-10, 0)
              }
            >
              <MdKeyboardArrowLeft size={16} />
            </button>
            <button
              type="button"
              title="Posiciona (Abaixo)"
              onClick={() =>
                pdfTool
                  ? handlePositionPdfProcess(0, 10)
                  : handlePosition(0, 10)
              }
            >
              <MdKeyboardArrowDown size={16} />
            </button>
            <button
              type="button"
              title="Posiciona (Acima)"
              onClick={() =>
                pdfTool
                  ? handlePositionPdfProcess(0, -10)
                  : handlePosition(0, -10)
              }
            >
              <MdKeyboardArrowUp size={16} />
            </button>
            <button
              type="button"
              title="Posiciona (Direita)"
              onClick={() =>
                pdfTool
                  ? handlePositionPdfProcess(10, 0)
                  : handlePosition(10, 0)
              }
            >
              <MdKeyboardArrowRight size={16} />
            </button>
            <button type="button" title="Link" onClick={handleLink}>
              <MdLink size={20} />
            </button>
            <button
              type="button"
              title="Link +"
              onClick={() => handleSizeEdit(+1)}
            >
              <MdUnfoldMore size={16} />
            </button>
            <button
              type="button"
              title="Link -"
              onClick={() => handleSizeEdit(-1)}
            >
              <MdUnfoldLess size={16} />
            </button>
            <button
              type="button"
              title="Link círculo"
              disabled={currLinkType === LINK_FORM_TYPES.circle}
              onClick={() => {
                currLinkTypeRef.current = INITIAL_LINK_CIRCLE;
                setCurrLinkType(LINK_FORM_TYPES.circle);
                /** oculta para definir os campos */
                setSizeControl(false);

                oChangeDefLinkSize(0, 0, true);
              }}
            >
              <MdRadioButtonUnchecked size={16} />
            </button>
            <button
              type="button"
              title="Link retângulo"
              disabled={currLinkType === LINK_FORM_TYPES.rect}
              onClick={() => {
                currLinkTypeRef.current = INITIAL_LINK_RECT;
                setCurrLinkType(LINK_FORM_TYPES.rect);
                /** oculta para definir os campos */
                setSizeControl(false);

                oChangeDefLinkSize(0, 0, true);
              }}
            >
              <MdCheckBoxOutlineBlank size={16} />
            </button>
            {/**
             * Área por arraste: forma indicada para esquemas elétricos, em
             * que o link acompanha o contorno real do componente em vez de
             * um marcador de tamanho fixo.
             */}
            <button
              type="button"
              title="Desfazer (Ctrl+Z)"
              disabled={!historicoInfo.podeDesfazer}
              onClick={handleDesfazer}
            >
              <MdUndo size={16} />
            </button>
            <button
              type="button"
              title="Refazer (Ctrl+Y)"
              disabled={!historicoInfo.podeRefazer}
              onClick={handleRefazer}
            >
              <MdRedo size={16} />
            </button>
            <button
              type="button"
              title="Link área: arraste sobre o componente para desenhar o contorno (o ID do item é pedido ao soltar)"
              disabled={currLinkType === LINK_FORM_TYPES.area}
              onClick={() => {
                currLinkTypeRef.current = INITIAL_LINK_AREA;
                setCurrLinkType(LINK_FORM_TYPES.area);
                /** oculta para definir os campos */
                setSizeControl(false);

                oChangeDefLinkSize(
                  INITIAL_LINK_AREA.height,
                  INITIAL_LINK_AREA.width,
                  true
                );
              }}
            >
              <MdCropFree size={16} />
            </button>
            {/** alterna o rótulo aplicado aos novos links */}
            <button
              type="button"
              title={`Rótulo do link: ${LABEL_ROTULO[currLinkRotulo]} (clique para alternar)`}
              onClick={handleAlternarRotulo}
            >
              {currLinkRotulo === opLinkRotulo.ETIQUETA && (
                <MdLabelOutline size={16} />
              )}
              {currLinkRotulo === opLinkRotulo.NENHUM && (
                <MdLabelOff size={16} />
              )}
              {currLinkRotulo === opLinkRotulo.CODIGO && <MdLabel size={16} />}
            </button>
            {/**
             * Modo sequência: com ele ativo, cada arraste sobre o desenho
             * cria a área do próximo item pendente e avança automaticamente.
             */}
            <button
              type="button"
              title={
                modoSequencia
                  ? `Modo sequência ativo (Alt+A)${
                      itemSequencia ? ` - item ${itemSequencia.idItem}` : ''
                    }`
                  : 'Modo sequência: criar links em série por arraste (Alt+A)'
              }
              onClick={handleAlternarModoSequencia}
              style={
                modoSequencia
                  ? { color: opLinkEstilo.COR, fontWeight: 'bold' }
                  : undefined
              }
            >
              <MdPlaylistAddCheck size={18} />
            </button>
            {/**
             * Indicador do modo sequência: quantos itens ainda não têm link e
             * qual é o próximo alvo do arraste.
             */}
            {modoSequencia && (
              <span
                title="Itens sem link nesta página / próximo item do arraste"
                style={{
                  /** não encolhe na barra que rola */
                  flex: '0 0 auto',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 4,
                  padding: '0 8px',
                  whiteSpace: 'nowrap',
                  fontSize: 12,
                  fontWeight: 700,
                  color: opLinkEstilo.COR,
                }}
              >
                {itensPendentes.length} pendente
                {itensPendentes.length === 1 ? '' : 's'}
                {itemSequencia ? ` - próximo: ${itemSequencia.idItem}` : ''}
              </span>
            )}
            <button
              type="button"
              title="OCR - Tradicional"
              onClick={() =>
                handleOCRLocalizar(opEditorAssociarTipoExtracao.TRADICIONAL)
              }
            >
              <MdOutlineFilter1 size={16} />
            </button>
            {process.env.REACT_APP_EXPERIMENTAL_IA_ASSOCIACAO ===
              opSimNao.SIM && (
              <>
                {/* <button
                type="button"
                title="OCR - Easy FAST"
                onClick={() =>
                  handleOCRLocalizar(opEditorAssociarTipoExtracao.EASY_FAST)
                }
              >
                <MdOutlineFilter2 size={16} />
              </button>
              <button
                type="button"
                title="ORC = Easy DEEP"
                onClick={() =>
                  handleOCRLocalizar(opEditorAssociarTipoExtracao.EASY_DEEP)
                }
              >
                <MdOutlineFilter3 size={16} />
              </button> */}
                <button
                  type="button"
                  title="Extração PDF"
                  onClick={() =>
                    handlePDFLocalizar(opEditorAssociarTipoExtracao.PDF)
                  }
                >
                  <MdOutlineFilter2 size={16} />
                </button>
                <button
                  type="button"
                  title="Paddle OCR"
                  onClick={() =>
                    handleOCRLocalizar(opEditorAssociarTipoExtracao.PADDLE_OCR)
                  }
                >
                  <MdOutlineFilter3 size={16} />
                </button>
              </>
            )}
            <button type="button" title="Limpar OCR" onClick={handleOCRLimpar}>
              <MdOutlineLayersClear size={16} />
            </button>
          </ToolBar>

          {barraDir && (
            <ToolBarArea.Nav
              type="button"
              title="Ver as ferramentas à direita"
              onClick={() => handleRolarBarra(1)}
            >
              <MdKeyboardArrowRight size={18} />
            </ToolBarArea.Nav>
          )}

          {/**
           * Legenda de atalhos FORA da área de rolagem, fixa à direita:
           * é o ponto de descoberta de todos os comandos e não pode
           * depender de o usuário rolar a barra até o fim para achá-la.
           */}
          <ToolBarArea.Fixo>
            <button
              type="button"
              title="Atalhos do teclado (? ou F1)"
              aria-pressed={atalhosAberto}
              onClick={handleAlternarAtalhos}
            >
              <MdHelpOutline size={16} />
            </button>
          </ToolBarArea.Fixo>
        </ToolBarArea>

        <Wrapper
        // onMouseDown={handleMouseDown}
        // onMouseMove={handleMouseMove}
        // onMouseUp={handleMouseUp}
        // onKeyDown={handleKeyDown}
        // onKeyUp={handleKeyUp}
        >
          {/**
           * Zoom pela roda do mouse sem precisar alternar para o modo de
           * zoom (Alt+Z).
           *
           * O wrapper deixa de ser desabilitado para que a roda funcione,
           * mas o comportamento observado antes é preservado:
           *  - o pan continua exigindo o modo de zoom ativo
           *    (antes o wrapper inteiro estava desabilitado fora dele);
           *  - o duplo clique nunca dá zoom (antes também não dava, pois
           *    o wrapper estava desabilitado fora do modo de zoom e o
           *    doubleClick estava desabilitado dentro dele) — assim não
           *    concorre com o input rápido de link.
           */}
          <TransformWrapper
            initialScale={1}
            centerOnInit
            centerZoomedOut
            /**
             * minScale abaixo de 1 é necessário para o enquadramento
             * poder reduzir quando o desenho é maior que a área — e de
             * quebra o usuário passa a conseguir afastar com a roda.
             */
            minScale={0.5}
            panning={{ disabled: !zoomCanMove || !zoomControl }}
            wheel={{ step: 0.08 }}
            doubleClick={{ disabled: true }}
            disabled={false}
            onZoom={(target) => {
              zoomScaleRef.current = target.scale;
              return target;
            }}
          >
            {(zoomApi) => {
              /**
               * Guarda a API do zoom para uso fora dos botões (após a
               * injeção do SVG e no botão Centralizar/Enquadrar).
               */
              zoomApiRef.current = zoomApi;

              const { zoomIn, zoomOut, resetTransform } = zoomApi;

              return (
                // if (elementToZoom) {
                //   setTransform(
                //     -Math.abs(elementToZoom.layerX),
                //     -Math.abs(elementToZoom.layerY),
                //     1.5,
                //     1000,
                //     'easeInOutQuad'
                //   );
                // }
                <EditorWrapper ref={editorAreaRef}>
                  {(zoomControl || sizeControl) && (
                    <ControlWrapper show={zoomControl || sizeControl}>
                      {zoomControl && (
                        <Control isVisible={zoomControl} control="zoom">
                          <Control.BtnClose
                            type="button"
                            onClick={() =>
                              handleControlClose(zoomRef && zoomRef.current.id)
                            }
                          >
                            <MdCancel size={16} />
                          </Control.BtnClose>
                          <Control.Animated ref={zoomRef} id="zoomAnimControl">
                            <Control.ZoomBtnAct
                              ref={zoomInRef}
                              type="button"
                              onClick={() => zoomIn()}
                            >
                              <MdZoomIn size={25} />
                            </Control.ZoomBtnAct>
                            <Control.ZoomBtnAct
                              ref={zoomOutRef}
                              type="button"
                              onClick={() => zoomOut()}
                            >
                              <MdZoomOut size={25} />
                            </Control.ZoomBtnAct>
                            <Control.ZoomBtnAct
                              ref={zoomResetRef}
                              type="button"
                              onClick={() => resetTransform()}
                            >
                              <MdYoutubeSearchedFor size={25} />
                            </Control.ZoomBtnAct>
                          </Control.Animated>
                        </Control>
                      )}
                      {sizeControl && (
                        <Control isVisible={sizeControl} control="size">
                          <Control.BtnClose
                            type="button"
                            onClick={() =>
                              handleControlClose(sizeRef && sizeRef.current.id)
                            }
                          >
                            <MdCancel size={16} />
                          </Control.BtnClose>
                          <Control.Animated ref={sizeRef} id="sizeAnimControl">
                            <Form
                              ref={formSizeRef}
                              onSubmit={({ sizeInputH, sizeInputW }) => {
                                handleSizeEdit(
                                  Number(sizeInputH),
                                  Number(sizeInputW),
                                  false
                                );
                              }}
                              autoComplete="off"
                            >
                              <Control.SizeInput>
                                <Input
                                  id="sizeInputH"
                                  name="sizeInputH"
                                  type="number"
                                  placeholder="H"
                                  width={60}
                                  onKeyDown={(e) =>
                                    e.keyCode === 13 &&
                                    formSizeRef.current.submitForm()
                                  }
                                />
                                <Input
                                  id="sizeInputW"
                                  name="sizeInputW"
                                  type="number"
                                  placeholder="W"
                                  width={60}
                                  onKeyDown={(e) =>
                                    e.keyCode === 13 &&
                                    formSizeRef.current.submitForm()
                                  }
                                />
                              </Control.SizeInput>
                            </Form>
                          </Control.Animated>
                        </Control>
                      )}
                    </ControlWrapper>
                  )}

                  {quickInput.open && (
                    <div
                      role="dialog"
                      aria-modal="true"
                      aria-label="Inserir ID do item"
                      tabIndex={-1}
                      style={{
                        position: 'absolute',
                        left: quickInput.x,
                        top: quickInput.y,
                        transform: 'translate(-50%, -150%)',
                        background: '#fff',
                        border: '1px solid #d1d5db',
                        borderRadius: 8,
                        padding: 6,
                        zIndex: 9,
                        boxShadow: '0 2px 8px rgba(0,0,0,.40)',
                      }}
                      // onClick={(e) => e.stopPropagation()}
                    >
                      <input
                        ref={quickInputRef}
                        type="text"
                        placeholder="ID do item…"
                        value={quickInput.value}
                        onMouseDown={(e) => e.stopPropagation()}
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e) => {
                          const v = e.target.value;
                          setQuickInput((s) => ({ ...s, value: v }));
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.stopPropagation();
                            e.preventDefault();
                            const v =
                              (quickInputRef.current &&
                                quickInputRef.current.value) ||
                              quickInput.value;
                            handleQuickInputConfirm(v);
                          } else if (e.key === 'Escape') {
                            e.stopPropagation();
                            e.preventDefault();
                            handleQuickInputCancel();
                          }
                        }}
                        onBlur={() => {
                          setTimeout(() => {
                            handleQuickInputCancel();
                          }, 0);
                        }}
                        style={{
                          width: 140,
                          outline: 'none',
                          border: 'none',
                          padding: '2px 5px',
                          borderRadius: 8,
                        }}
                      />
                    </div>
                  )}

                  {/**
                   * Legenda de atalhos. Renderizada por último dentro do
                   * EditorWrapper para ficar acima do desenho, e apenas
                   * quando aberta — fechada, não ocupa nada.
                   */}
                  {atalhosAberto && (
                    <Atalhos
                      role="dialog"
                      aria-label="Atalhos do teclado e do mouse"
                    >
                      <Atalhos.Header>
                        <strong>Atalhos</strong>
                        <Atalhos.BtnClose
                          type="button"
                          title="Fechar (Esc)"
                          onClick={handleAlternarAtalhos}
                        >
                          <MdClose size={16} />
                        </Atalhos.BtnClose>
                      </Atalhos.Header>

                      <Atalhos.Body>
                        {ATALHOS_EDITOR.map((secao) => (
                          <Atalhos.Grupo key={secao.grupo}>
                            <span>{secao.grupo}</span>
                            {secao.itens.map((atalho) => (
                              <Atalhos.Linha
                                key={`${secao.grupo}-${atalho.texto}`}
                              >
                                <p>{atalho.texto}</p>
                                <div>
                                  {atalho.teclas.map((tecla, indice) => (
                                    <Atalhos.Tecla
                                      key={`${atalho.texto}-${tecla}-${indice}`}
                                    >
                                      {tecla}
                                    </Atalhos.Tecla>
                                  ))}
                                </div>
                              </Atalhos.Linha>
                            ))}
                          </Atalhos.Grupo>
                        ))}
                      </Atalhos.Body>
                    </Atalhos>
                  )}

                  {/**
                   * O wrapper do zoom precisa de tamanho explícito: sem
                   * isso ele se ajusta ao SVG e a área extra conquistada no
                   * layout não vira espaço de trabalho.
                   */}
                  {/**
                   * wrapperStyle E contentStyle em 100%.
                   *
                   * O react-zoom-pan-pinch dimensiona a div externa
                   * (.react-transform-wrapper) mas deixa a interna
                   * (.react-transform-component) no tamanho do conteúdo.
                   * Sem altura definida nela, o "height: 100%" do <svg>
                   * não tem contra o que resolver e o desenho volta ao
                   * tamanho dos atributos do arquivo (614x874) — era o que
                   * fazia sobrar área vazia em volta.
                   */}
                  <TransformComponent
                    wrapperStyle={{ width: '100%', height: '100%' }}
                    contentStyle={{ width: '100%', height: '100%' }}
                  >
                    {editorSvg}
                  </TransformComponent>
                </EditorWrapper>
              );
            }}
          </TransformWrapper>
        </Wrapper>
      </Container>
    );
  }
);

export default EditorArea;

EditorArea.propTypes = {
  catalogo: PropTypes.instanceOf(Object).isRequired,
  pagina: PropTypes.instanceOf(Object),
  itensPagina: PropTypes.arrayOf(Object),
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onBeforeOCR: PropTypes.func,
  onAfterOCR: PropTypes.func,
  onAssociate: PropTypes.func,
  onLinkHighlight: PropTypes.func,
};

EditorArea.defaultProps = {
  pagina: null,
  itensPagina: null,
  onBeforeOCR: null,
  onAfterOCR: null,
  onAssociate: null,
  onLinkHighlight: null,
};
